// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu.show {
  display: block !important;
}

.m-top-0 {
	margin-top: 0
}

.m-top-5 {
	margin-top: 5px
}

.m-top-10 {
	margin-top: 10px
}

.m-top-15 {
	margin-top: 15px
}

.m-top-20 {
	margin-top: 20px
}

.m-top-25 {
	margin-top: 25px
}

.m-top-30 {
	margin-top: 30px
}

.m-top-35 {
	margin-top: 35px
}

.m-top-40 {
	margin-top: 40px
}

.m-top-45 {
	margin-top: 45px
}

.m-top-50 {
	margin-top: 50px
}

.m-top-55 {
	margin-top: 55px
}

.m-top-60 {
	margin-top: 60px
}

.m-top-65 {
	margin-top: 65px
}

.m-top-70 {
	margin-top: 70px
}

.m-top-75 {
	margin-top: 75px
}

.m-top-80 {
	margin-top: 80px
}

.m-top-85 {
	margin-top: 85px
}

.m-top-90 {
	margin-top: 90px
}

.m-top-95 {
	margin-top: 95px
}

.m-top-100 {
	margin-top: 100px
}

.m-top-105 {
	margin-top: 105px
}

.m-top-110 {
	margin-top: 110px
}

.m-top-115 {
	margin-top: 115px
}

.m-top-120 {
	margin-top: 120px
}

.m-top-125 {
	margin-top: 125px
}

.m-top-130 {
	margin-top: 130px
}

.m-top-135 {
	margin-top: 135px
}

.m-top-140 {
	margin-top: 140px
}

.m-top-145 {
	margin-top: 145px
}

.m-top-150 {
	margin-top: 150px
}

.m-right-0 {
	margin-right: 0
}

.m-right-5 {
	margin-right: 5px
}

.m-right-10 {
	margin-right: 10px
}

.m-right-15 {
	margin-right: 15px
}

.m-right-20 {
	margin-right: 20px
}

.m-right-25 {
	margin-right: 25px
}

.m-right-30 {
	margin-right: 30px
}

.m-right-35 {
	margin-right: 35px
}

.m-right-40 {
	margin-right: 40px
}

.m-right-45 {
	margin-right: 45px
}

.m-right-50 {
	margin-right: 50px
}

.m-right-55 {
	margin-right: 55px
}

.m-right-60 {
	margin-right: 60px
}

.m-right-65 {
	margin-right: 65px
}

.m-right-70 {
	margin-right: 70px
}

.m-right-75 {
	margin-right: 75px
}

.m-right-80 {
	margin-right: 80px
}

.m-right-85 {
	margin-right: 85px
}

.m-right-90 {
	margin-right: 90px
}

.m-right-95 {
	margin-right: 95px
}

.m-right-100 {
	margin-right: 100px
}

.m-right-105 {
	margin-right: 105px
}

.m-right-110 {
	margin-right: 110px
}

.m-right-115 {
	margin-right: 115px
}

.m-right-120 {
	margin-right: 120px
}

.m-right-125 {
	margin-right: 125px
}

.m-right-130 {
	margin-right: 130px
}

.m-right-135 {
	margin-right: 135px
}

.m-right-140 {
	margin-right: 140px
}

.m-right-145 {
	margin-right: 145px
}

.m-right-150 {
	margin-right: 150px
}

.m-bottom-0 {
	margin-bottom: 0
}

.m-bottom-5 {
	margin-bottom: 5px
}

.m-bottom-10 {
	margin-bottom: 10px
}

.m-bottom-15 {
	margin-bottom: 15px
}

.m-bottom-20 {
	margin-bottom: 20px
}

.m-bottom-25 {
	margin-bottom: 25px
}

.m-bottom-30 {
	margin-bottom: 30px
}

.m-bottom-35 {
	margin-bottom: 35px
}

.m-bottom-40 {
	margin-bottom: 40px
}

.m-bottom-45 {
	margin-bottom: 45px
}

.m-bottom-50 {
	margin-bottom: 50px
}

.m-bottom-55 {
	margin-bottom: 55px
}

.m-bottom-60 {
	margin-bottom: 60px
}

.m-bottom-65 {
	margin-bottom: 65px
}

.m-bottom-70 {
	margin-bottom: 70px
}

.m-bottom-75 {
	margin-bottom: 75px
}

.m-bottom-80 {
	margin-bottom: 80px
}

.m-bottom-85 {
	margin-bottom: 85px
}

.m-bottom-90 {
	margin-bottom: 90px
}

.m-bottom-95 {
	margin-bottom: 95px
}

.m-bottom-100 {
	margin-bottom: 100px
}

.m-bottom-105 {
	margin-bottom: 105px
}

.m-bottom-110 {
	margin-bottom: 110px
}

.m-bottom-115 {
	margin-bottom: 115px
}

.m-bottom-120 {
	margin-bottom: 120px
}

.m-bottom-125 {
	margin-bottom: 125px
}

.m-bottom-130 {
	margin-bottom: 130px
}

.m-bottom-135 {
	margin-bottom: 135px
}

.m-bottom-140 {
	margin-bottom: 140px
}

.m-bottom-145 {
	margin-bottom: 145px
}

.m-bottom-150 {
	margin-bottom: 150px
}

.m-left-0 {
	margin-left: 0
}

.m-left-5 {
	margin-left: 5px
}

.m-left-10 {
	margin-left: 10px
}

.m-left-15 {
	margin-left: 15px
}

.m-left-20 {
	margin-left: 20px
}

.m-left-25 {
	margin-left: 25px
}

.m-left-30 {
	margin-left: 30px
}

.m-left-35 {
	margin-left: 35px
}

.m-left-40 {
	margin-left: 40px
}

.m-left-45 {
	margin-left: 45px
}

.m-left-50 {
	margin-left: 50px
}

.m-left-55 {
	margin-left: 55px
}

.m-left-60 {
	margin-left: 60px
}

.m-left-65 {
	margin-left: 65px
}

.m-left-70 {
	margin-left: 70px
}

.m-left-75 {
	margin-left: 75px
}

.m-left-80 {
	margin-left: 80px
}

.m-left-85 {
	margin-left: 85px
}

.m-left-90 {
	margin-left: 90px
}

.m-left-95 {
	margin-left: 95px
}

.m-left-100 {
	margin-left: 100px
}

.m-left-105 {
	margin-left: 105px
}

.m-left-110 {
	margin-left: 110px
}

.m-left-115 {
	margin-left: 115px
}

.m-left-120 {
	margin-left: 120px
}

.m-left-125 {
	margin-left: 125px
}

.m-left-130 {
	margin-left: 130px
}

.m-left-135 {
	margin-left: 135px
}

.m-left-140 {
	margin-left: 140px
}

.m-left-145 {
	margin-left: 145px
}

.m-left-150 {
	margin-left: 150px
}

.p-left-0 {
	padding-left: 0
}

.p-left-5 {
	padding-left: 5px
}

.p-left-10 {
	padding-left: 10px
}

.p-left-15 {
	padding-left: 15px
}

.p-left-20 {
	padding-left: 20px
}

.p-left-25 {
	padding-left: 25px
}

.p-left-30 {
	padding-left: 30px
}

.p-left-35 {
	padding-left: 35px
}

.p-left-40 {
	padding-left: 40px
}

.p-left-45 {
	padding-left: 45px
}

.p-left-50 {
	padding-left: 50px
}

.p-left-55 {
	padding-left: 55px
}

.p-left-60 {
	padding-left: 60px
}

.p-left-65 {
	padding-left: 65px
}

.p-left-70 {
	padding-left: 70px
}

.p-left-75 {
	padding-left: 75px
}

.p-left-80 {
	padding-left: 80px
}

.p-left-85 {
	padding-left: 85px
}

.p-left-90 {
	padding-left: 90px
}

.p-left-95 {
	padding-left: 95px
}

.p-left-100 {
	padding-left: 100px
}

.p-left-105 {
	padding-left: 105px
}

.p-left-110 {
	padding-left: 110px
}

.p-left-115 {
	padding-left: 115px
}

.p-left-120 {
	padding-left: 120px
}

.p-left-125 {
	padding-left: 125px
}

.p-left-130 {
	padding-left: 130px
}

.p-left-135 {
	padding-left: 135px
}

.p-left-140 {
	padding-left: 140px
}

.p-left-145 {
	padding-left: 145px
}

.p-left-150 {
	padding-left: 150px
}

.p-right-0 {
	padding-right: 0
}

.p-right-5 {
	padding-right: 5px
}

.p-right-10 {
	padding-right: 10px
}

.p-right-15 {
	padding-right: 15px
}

.p-right-20 {
	padding-right: 20px
}

.p-right-25 {
	padding-right: 25px
}

.p-right-30 {
	padding-right: 30px
}

.p-right-35 {
	padding-right: 35px
}

.p-right-40 {
	padding-right: 40px
}

.p-right-45 {
	padding-right: 45px
}

.p-right-50 {
	padding-right: 50px
}

.p-right-55 {
	padding-right: 55px
}

.p-right-60 {
	padding-right: 60px
}

.p-right-65 {
	padding-right: 65px
}

.p-right-70 {
	padding-right: 70px
}

.p-right-75 {
	padding-right: 75px
}

.p-right-80 {
	padding-right: 80px
}

.p-right-85 {
	padding-right: 85px
}

.p-right-90 {
	padding-right: 90px
}

.p-right-95 {
	padding-right: 95px
}

.p-right-100 {
	padding-right: 100px
}

.p-right-105 {
	padding-right: 105px
}

.p-right-110 {
	padding-right: 110px
}

.p-right-115 {
	padding-right: 115px
}

.p-right-120 {
	padding-right: 120px
}

.p-right-125 {
	padding-right: 125px
}

.p-right-130 {
	padding-right: 130px
}

.p-right-135 {
	padding-right: 135px
}

.p-right-140 {
	padding-right: 140px
}

.p-right-145 {
	padding-right: 145px
}

.p-right-150 {
	padding-right: 150px
}

.p-top-0 {
	padding-top: 0
}

.p-top-5 {
	padding-top: 5px
}

.p-top-10 {
	padding-top: 10px
}

.p-top-15 {
	padding-top: 15px
}

.p-top-20 {
	padding-top: 20px
}

.p-top-25 {
	padding-top: 25px
}

.p-top-30 {
	padding-top: 30px
}

.p-top-35 {
	padding-top: 35px
}

.p-top-40 {
	padding-top: 40px
}

.p-top-45 {
	padding-top: 45px
}

.p-top-50 {
	padding-top: 50px
}

.p-top-55 {
	padding-top: 55px
}

.p-top-60 {
	padding-top: 60px
}

.p-top-65 {
	padding-top: 65px
}

.p-top-70 {
	padding-top: 70px
}

.p-top-75 {
	padding-top: 75px
}

.p-top-80 {
	padding-top: 80px
}

.p-top-85 {
	padding-top: 85px
}

.p-top-90 {
	padding-top: 90px
}

.p-top-95 {
	padding-top: 95px
}

.p-top-100 {
	padding-top: 100px
}

.p-top-105 {
	padding-top: 105px
}

.p-top-110 {
	padding-top: 110px
}

.p-top-115 {
	padding-top: 115px
}

.p-top-120 {
	padding-top: 120px
}

.p-top-125 {
	padding-top: 125px
}

.p-top-130 {
	padding-top: 130px
}

.p-top-135 {
	padding-top: 135px
}

.p-top-140 {
	padding-top: 140px
}

.p-top-145 {
	padding-top: 145px
}

.p-top-150 {
	padding-top: 150px
}

.p-bottom-0 {
	padding-bottom: 0
}

.p-bottom-5 {
	padding-bottom: 5px
}

.p-bottom-10 {
	padding-bottom: 10px
}

.p-bottom-15 {
	padding-bottom: 15px
}

.p-bottom-20 {
	padding-bottom: 20px
}

.p-bottom-25 {
	padding-bottom: 25px
}

.p-bottom-30 {
	padding-bottom: 30px
}

.p-bottom-35 {
	padding-bottom: 35px
}

.p-bottom-40 {
	padding-bottom: 40px
}

.p-bottom-45 {
	padding-bottom: 45px
}

.p-bottom-50 {
	padding-bottom: 50px
}

.p-bottom-55 {
	padding-bottom: 55px
}

.p-bottom-60 {
	padding-bottom: 60px
}

.p-bottom-65 {
	padding-bottom: 65px
}

.p-bottom-70 {
	padding-bottom: 70px
}

.p-bottom-75 {
	padding-bottom: 75px
}

.p-bottom-80 {
	padding-bottom: 80px
}

.p-bottom-85 {
	padding-bottom: 85px
}

.p-bottom-90 {
	padding-bottom: 90px
}

.p-bottom-95 {
	padding-bottom: 95px
}

.p-bottom-100 {
	padding-bottom: 100px
}

.p-bottom-105 {
	padding-bottom: 105px
}

.p-bottom-110 {
	padding-bottom: 110px
}

.p-bottom-115 {
	padding-bottom: 115px
}

.p-bottom-120 {
	padding-bottom: 120px
}

.p-bottom-125 {
	padding-bottom: 125px
}

.p-bottom-130 {
	padding-bottom: 130px
}

.p-bottom-135 {
	padding-bottom: 135px
}

.p-bottom-140 {
	padding-bottom: 140px
}

.p-bottom-145 {
	padding-bottom: 145px
}

.p-bottom-150 {
	padding-bottom: 150px
}

.h-5 {
	height: 5px
}

.h-10 {
	height: 10px
}

.h-15 {
	height: 15px
}

.h-20 {
	height: 20px
}

.h-25 {
	height: 25px
}

.h-30 {
	height: 30px
}

.h-35 {
	height: 35px
}

.h-40 {
	height: 40px
}

.h-45 {
	height: 45px
}

.h-50 {
	height: 50px
}

.h-55 {
	height: 55px
}

.h-60 {
	height: 60px
}

.h-65 {
	height: 65px
}

.h-70 {
	height: 70px
}

.h-75 {
	height: 75px
}

.h-80 {
	height: 80px
}

.h-85 {
	height: 85px
}

.h-90 {
	height: 90px
}

.h-95 {
	height: 95px
}

.h-100 {
	height: 100px
}

.h-105 {
	height: 105px
}

.h-110 {
	height: 110px
}

.h-115 {
	height: 115px
}

.h-120 {
	height: 120px
}

.h-125 {
	height: 125px
}

.h-130 {
	height: 130px
}

.h-135 {
	height: 135px
}

.h-140 {
	height: 140px
}

.h-145 {
	height: 145px
}

.h-150 {
	height: 150px
}

.cart-table .cart-single .remove a,
.color-primary,
.counter.counter--4 .counter_single .value,
.error-wrapper .error-contents p a:hover,
.nav_right_content .cart_module .cart__items .cart_info p span,
.nav_right_content .cart_module .cart__items .items .item_info>a:hover,
.nav_right_content .cart_module .cart__items .items .item_remove span,
.post--card .card-body .post-meta li a:hover,
.pricing .pricing__title h4,
.tab-content.tab--content2 .tab-pane .tab_text_module .tab_text_module__subtitle,
.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link.active,
.team-five .content h6 a:hover,
.timeline1 .happening .happening__period .wrapper .year,
footer.footer--light .widget ul.links li a:hover,
footer.footer4 .footer__small .info_links li a:hover,
footer.footer4.footer--light .footer__small .info_links li a:hover,
footer.footer4.footer--light .footer_menu_items ul li a:hover {
	color: #413aa4
}

.bg-primary,
.dot-light .owl-dot.active span,
.filter-wrapper .filter-sort ul li.active,
.filter-wrapper .filter-sort ul li:hover,
.flip-card .flip-overlay2,
.go_top,
.intro-three:before,
.intro-two,
.nav-circle button:hover,
.nav-circle.nav-circle--light button:hover,
.nav-circle.nav-circle--lighten button:hover,
.nav-pills .nav-item .nav-link.active,
.nav-pills .nav-item .nav-link:hover,
.nav-square button:hover,
.nav-square.nav-square-dark button:hover,
.nav_right_content .cart_module .cart__items .items .item_remove:hover span,
.owl-dots .owl-dot.active span,
.play-btn:hover,
.portfolio-carousel-single figure figcaption .link:hover,
footer.footer4 .social.square ul li a:hover,
footer.footer4.footer--colored {
	background: #413aa4
}

.blog-carousel-one .post-single .post-bottom a:hover,
.card .card-body h6 a:hover,
.card-four .card-body h5:hover a,
.card-product .card-body h6 a:hover,
.color-secondary,
.content--block4 h3 span,
.content-block--12 .highlighted-text .content p span,
.counter.counter--5 .counter_single .value,
.counter.counter--7 .counter_single .value,
.cta--five p span,
.error-wrapper .error-contents p a,
.icon-list2 .icon,
.intro-five h1 span,
.intro-four .intro-four--contents h1 span,
.intro-one h1 span,
.intro-three .intro-three--contents h1 span,
.list-inline-wrapper .list--inline li .icon span,
.nav-tabs .nav-item .nav-link.active,
.number-list li.numbers-roman:before,
.number-list li:before,
.post--card .card-body .post-meta li a,
.project-single .project-info .info-box h6,
.subtext,
.tab.tab--1 .tab_nav .nav .nav-link.active,
.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link.active,
.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link:hover,
.tab.tab--3 .tab_nav3 .nav li a.active,
.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link.active,
.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link:hover,
.tab.tab--7 .tab_nav7 .nav .nav-item .nav-link.active,
.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link.active,
.tab_event .tab_event__module .event_meta p span.la,
.team-five .content h6 a,
.timeline1 .happening .happening__period .wrapper .date,
.timeline2 .happening2 .happening2__period,
.video--one h3 span,
footer .footer__big .widget--latest-news ul li a:hover,
footer.footer--dark .footer__big .text_widget a,
footer.footer2 .widget.twit--widget a,
footer.footer2 .widget.twit--widget span.fab,
footer.footer4.footer--light .footer_menu_items ul li a {
	color: #06b590
}

.bg-secondary,
.bullet_list:before,
.card--team1 .card-body .team-social li a:hover,
.custom-radio-three .custom-control-input:checked~.custom-control-label::after,
.custom-radio-two .custom-control-input:checked~.custom-control-label::after,
.dot-secondary.dot-light .owl-dot.active span,
.event-single .event-date,
.go_top:hover,
.icon-light .content-list .icon-circle span,
.nav-circle button,
.nav-square.nav-square-dark button,
.nav_right_content .cart_module .cart_count,
.owl-dots.dot-secondary .owl-dot.active span,
.portfolio-carousel-single figure figcaption .link,
.pricing .pricing__price,
.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link.active:before,
.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link:hover:before,
.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link.active:before,
.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link:hover:before,
.tab.tab--7 .tab_nav7 .nav .nav-item .nav-link.active:before,
.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link.active:before,
.toggle-switch input:checked+.slider,
footer.footer4.footer--colored .footer--small,
footer.footer4.footer--light .footer__small .social.square li a:hover {
	background: #06b590
}

.color-success {
	color: #35b53e
}

.bg-success {
	background: #35b53e
}

.apply-form .apply-form--header p span,
.blog-single-wrapper .post-pagination .next-post p a,
.blog-single-wrapper .post-pagination .prev-post p a,
.color-info,
.sidebar-post .post-single P span a {
	color: #377dff
}

.bg-info {
	background: #377dff
}

.color-warning,
.twitter-feeds .feed-single .feed-content .tags {
	color: #ffaf00
}

.bg-warning {
	background: #ffaf00
}

.color-danger {
	color: #e23636
}

.bg-danger {
	background: #e23636
}

.color-light,
.nav_right_content .cart_module .cart__items .items .item_remove:hover span,
footer .footer__big .widget--contact_info ul li span.la,
footer.footer--dark .footer__big .text_widget a:hover,
footer.footer2.footer--dark .widget.twit--widget a:hover {
	color: #fff
}

.bg-light,
.event-single {
	background: #fff
}

.blog-carousel-one .post-single .post-bottom a,
.card .card-body h6 a,
.card--eight .card-body h5 a,
.card--ten .card-body h6 a,
.color-dark,
.counter.counter--5 .counter_single .title,
.tab.tab--1 .tab_nav .nav .nav-link,
footer.footer2 .widget.twit--widget a:hover {
	color: #202428
}

.bg-dark,
footer.footer2 .footer__small {
	background: #202428
}

.color-footer-dark-text,
footer.footer--dark,
footer.footer--dark .footer__big .text_widget p,
footer.footer--dark .footer__big .widget ul.links li a,
footer.footer4 .footer4_text,
footer.footer4 .footer__small .info_links li a,
footer.footer4.footer--colored,
footer.footer5.footer--bw,
footer.footer5.footer--bw .footer__big .widget ul.links a {
	color: rgba(255, 255, 255, .5)
}

.bg-footer-dark-text,
footer.footer5.footer--bw .footer__big .widget .widget__title:before {
	background: rgba(255, 255, 255, .5)
}

.color-footer-dark {
	color: #111014
}

.bg-footer-dark,
footer.footer--dark {
	background: #111014
}

.btn-primary {
	box-shadow: 0 10px 20px rgba(65, 58, 164, .2)
}

.btn-secondary {
	box-shadow: 0 10px 20px rgba(6, 181, 144, .2)
}

.btn-success {
	box-shadow: 0 10px 20px rgba(53, 181, 62, .2)
}

.btn-info {
	box-shadow: 0 10px 20px rgba(55, 125, 255, .2)
}

.btn-warning {
	box-shadow: 0 10px 20px rgba(255, 175, 0, .2)
}

.btn-danger {
	box-shadow: 0 10px 20px rgba(226, 54, 54, .2)
}

.btn-light {
	box-shadow: 0 10px 20px rgba(255, 255, 255, .2)
}

.btn-dark {
	box-shadow: 0 10px 20px rgba(32, 36, 40, .2)
}

.outline-thick-primary {
	border: 2px solid rgba(65, 58, 164, .2);
	background: 0 0;
	color: #413aa4
}

.outline-thick-secondary {
	border: 2px solid rgba(6, 181, 144, .2);
	background: 0 0;
	color: #06b590
}

.outline-thick-success {
	border: 2px solid rgba(53, 181, 62, .2);
	background: 0 0;
	color: #35b53e
}

.outline-thick-info {
	border: 2px solid rgba(55, 125, 255, .2);
	background: 0 0;
	color: #377dff
}

.outline-thick-warning {
	border: 2px solid rgba(255, 175, 0, .2);
	background: 0 0;
	color: #ffaf00
}

.outline-thick-danger {
	border: 2px solid rgba(226, 54, 54, .2);
	background: 0 0;
	color: #e23636
}

.outline-thick-light {
	border: 2px solid rgba(255, 255, 255, .2);
	background: 0 0;
	color: #fff
}

.outline-thick-dark {
	border: 2px solid rgba(32, 36, 40, .2);
	background: 0 0;
	color: #202428
}

.checkbox-primary .custom-control-label::before {
	background: #413aa4
}

.checkbox-primary .custom-control-input:checked~.custom-control-label::before {
	background: #413aa4;
	border: 1px solid #413aa4
}

.checkbox-primary .custom-control-input:checked~.custom-control-label::after {
	color: #fff
}

.checkbox-secondary .custom-control-label::before {
	background: #06b590
}

.checkbox-secondary .custom-control-input:checked~.custom-control-label::before {
	background: #06b590;
	border: 1px solid #06b590
}

.checkbox-secondary .custom-control-input:checked~.custom-control-label::after {
	color: #fff
}

.checkbox-success .custom-control-label::before {
	background: #35b53e
}

.checkbox-success .custom-control-input:checked~.custom-control-label::before {
	background: #35b53e;
	border: 1px solid #35b53e
}

.checkbox-success .custom-control-input:checked~.custom-control-label::after {
	color: #fff
}

.checkbox-info .custom-control-label::before {
	background: #377dff
}

.checkbox-info .custom-control-input:checked~.custom-control-label::before {
	background: #377dff;
	border: 1px solid #377dff
}

.checkbox-info .custom-control-input:checked~.custom-control-label::after {
	color: #fff
}

.checkbox-warning .custom-control-label::before {
	background: #ffaf00
}

.checkbox-warning .custom-control-input:checked~.custom-control-label::before {
	background: #ffaf00;
	border: 1px solid #ffaf00
}

.checkbox-warning .custom-control-input:checked~.custom-control-label::after {
	color: #fff
}

.checkbox-danger .custom-control-label::before {
	background: #e23636
}

.checkbox-danger .custom-control-input:checked~.custom-control-label::before {
	background: #e23636;
	border: 1px solid #e23636
}

.checkbox-danger .custom-control-input:checked~.custom-control-label::after {
	color: #fff
}

.checkbox-light .custom-control-label::before {
	background: #fff
}

.checkbox-light .custom-control-input:checked~.custom-control-label::before {
	background: #fff;
	border: 1px solid #fff
}

.checkbox-light .custom-control-input:checked~.custom-control-label::after {
	color: #fff
}

.checkbox-dark .custom-control-label::before {
	background: #202428
}

.checkbox-dark .custom-control-input:checked~.custom-control-label::before {
	background: #202428;
	border: 1px solid #202428
}

.checkbox-dark .custom-control-input:checked~.custom-control-label::after {
	color: #fff
}

.checkbox-outline-primary .custom-control-label:before {
	border: 1px solid #413aa4
}

.checkbox-outline-primary .custom-control-input:checked~.custom-control-label::before {
	border: 1px solid #413aa4
}

.checkbox-outline-primary .custom-control-input:checked~.custom-control-label::after {
	color: #413aa4
}

.checkbox-outline-secondary .custom-control-label:before {
	border: 1px solid #06b590
}

.checkbox-outline-secondary .custom-control-input:checked~.custom-control-label::before {
	border: 1px solid #06b590
}

.checkbox-outline-secondary .custom-control-input:checked~.custom-control-label::after {
	color: #06b590
}

.checkbox-outline-success .custom-control-label:before {
	border: 1px solid #35b53e
}

.checkbox-outline-success .custom-control-input:checked~.custom-control-label::before {
	border: 1px solid #35b53e
}

.checkbox-outline-success .custom-control-input:checked~.custom-control-label::after {
	color: #35b53e
}

.checkbox-outline-info .custom-control-label:before {
	border: 1px solid #377dff
}

.checkbox-outline-info .custom-control-input:checked~.custom-control-label::before {
	border: 1px solid #377dff
}

.checkbox-outline-info .custom-control-input:checked~.custom-control-label::after {
	color: #377dff
}

.checkbox-outline-warning .custom-control-label:before {
	border: 1px solid #ffaf00
}

.checkbox-outline-warning .custom-control-input:checked~.custom-control-label::before {
	border: 1px solid #ffaf00
}

.checkbox-outline-warning .custom-control-input:checked~.custom-control-label::after {
	color: #ffaf00
}

.checkbox-outline-danger .custom-control-label:before {
	border: 1px solid #e23636
}

.checkbox-outline-danger .custom-control-input:checked~.custom-control-label::before {
	border: 1px solid #e23636
}

.checkbox-outline-danger .custom-control-input:checked~.custom-control-label::after {
	color: #e23636
}

.checkbox-outline-light .custom-control-label:before {
	border: 1px solid #fff
}

.checkbox-outline-light .custom-control-input:checked~.custom-control-label::before {
	border: 1px solid #fff
}

.checkbox-outline-light .custom-control-input:checked~.custom-control-label::after {
	color: #fff
}

.checkbox-outline-dark .custom-control-label:before {
	border: 1px solid #202428
}

.checkbox-outline-dark .custom-control-input:checked~.custom-control-label::before {
	border: 1px solid #202428
}

.checkbox-outline-dark .custom-control-input:checked~.custom-control-label::after {
	color: #202428
}

.biz_overlay {
	position: relative;
	height: 100%;
	width: 100%
}

.biz_overlay:before {
	position: absolute;
	height: 100%;
	top: 0;
	left: 0;
	width: 100%;
	content: '';
	z-index: 1;
	background: rgba(0, 0, 0, .3)
}

.biz_overlay.overlay--primary:before {
	background-color: rgba(65, 58, 164, .85)
}

.biz_overlay.overlay--secondary:before {
	background-color: rgba(6, 181, 144, .8)
}

.biz_overlay.overlay--secondary2:before {
	background: rgba(27, 28, 57, .8)
}

.biz_overlay.overlay--dark:before {
	background-color: rgba(32, 36, 40, .6)
}

.biz_overlay.overlay--dark2:before {
	background: rgba(29, 30, 51, .7)
}

.gradient-overlay {
	position: relative
}

.gradient-overlay:before {
	position: absolute;
	content: '';
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background: linear-gradient(140deg, rgba(65, 58, 164, .9) 0, rgba(65, 58, 164, .9) 25%, rgba(6, 181, 144, .9) 100%);
	z-index: 1
}

html {
	font-size: 15px
}

body {
	direction: ltr;
	text-align: left
}

.la.la-search {
	transform: rotateY(-180deg)
}

img {
	max-width: 100%
}

a {
	transition: all .3s ease
}

a:hover {
	color: #06b590
}

sup {
	top: -.66667rem
}

.showcase {
	margin: 4.66667rem 0 4rem 0;
	border-bottom: 1px solid #e4e8ed;
	font-size: 1.6rem;
	line-height: 48px;
	padding: 2rem 0;
	border-radius: 0
}

.showcase h3 {
	color: #202428;
	font-weight: 400;
	margin: 0;
	font-size: 1.46667rem;
	text-align: center
}

.showcase.showcase--title2 {
	background: #fff
}

p {
	line-height: 2rem
}

.sectionbg {
	background: #f5f7fc
}

.bgimage {
	position: relative
}

.bg_image_holder {
	position: absolute;
	height: 100%;
	width: 100%;
	top: 0;
	left: 0;
	background-size: cover !important;
	background-position: 50% 50% !important;
	background-repeat: no-repeat !important;
	z-index: 0;
	transition: opacity .3s linear;
	-webkit-transition: opacity .3s linear;
	opacity: 0;
	overflow: hidden
}

.bg_image_holder img {
	display: none
}

.content_above {
	z-index: 2;
	position: relative
}

ul {
	list-style: none;
	padding: 0
}

.flex-1 {
	flex: 1 1
}

.cardify {
	background: #fff;
	box-shadow: 0 5px 30px rgba(105, 106, 119, .05);
	padding: 2rem
}

.text-box {
	padding: 3rem 3.33333rem
}

.text-box p {
	margin: 0;
	line-height: 2.4rem;
	font-size: 1.46667rem;
	font-weight: 500;
	color: #fff
}

.accordion-styles2 {
	background: #f4f4f4;
	padding: 0 0 5.33333rem 0;
	margin-top: 5.33333rem
}

.alert-types {
	margin: 6.66667rem 0 3.33333rem 0
}

.shadow-types {
	padding: 4.66667rem 0 1.33333rem
}

.shadow-types .showcase-box {
	background: 0 0
}

.shadow-types .showcase-box .showcase-header {
	background: 0 0
}

.shadow-types .showcase-box .showcase-body ul {
	padding: 2.33333rem 2rem;
	background: #fff;
	margin: 0
}

.shadow-types .showcase-box .showcase-body ul li {
	margin-bottom: .8rem;
	visibility: hidden
}

.shadow-types .showcase-box .showcase-body ul li:last-child {
	margin-bottom: 0
}

.shadow-types .showcase-box .showcase-body ul li span {
	min-width: 10rem;
	display: inline-block
}

.shadow-types.shadow-types2 {
	margin-top: 3.33333rem;
	background: #f4f4f4
}

.showcase-box {
	position: relative;
	display: flex;
	flex-direction: column;
	min-width: 0;
	word-wrap: break-word;
	background-color: #fff;
	background-clip: border-box;
	border: 1px solid #e4e8ed;
	border-radius: .25rem;
	margin-bottom: 50px
}

.showcase-box .showcase-header {
	padding: 2rem 3rem;
	margin-bottom: 0;
	background-color: #fff;
	border-bottom: 1px solid #e4e8ed
}

.showcase-box .showcase-header h4,
.showcase-box .showcase-header h5 {
	margin: 0;
	font-size: 1.33333rem;
	font-weight: 400;
	color: #202428
}

.showcase-box .showcase-header p {
	margin: 10px 0 0 0
}

.showcase-box .showcase-body {
	padding: 3rem;
	flex: 1 1 auto
}

.showcase-box:last-child .button-group {
	margin-bottom: 0
}

.buttons-wrapper {
	padding: 70px 0 20px
}

.buttons-wrapper .button-group {
	margin-bottom: -21px
}

.buttons-wrapper .button-group button {
	margin: 0 17px 21px 0
}

.shadow-default {
	box-shadow: 0 5px 15px rgba(32, 36, 40, .1) !important
}

.btn-shadow {
	box-shadow: 0 10px 20px rgba(41, 41, 59, .15) !important
}

.color-group {
	margin: 0 0 40px;
	display: flex
}

.color-group li {
	flex: 1 1
}

.color-group li:first-child span {
	display: block;
	font-size: 14px;
	font-weight: 500;
	color: #fff;
	border-radius: 3px;
	padding: 25px 30px
}

.color-group li:last-child {
	width: 80px;
	margin-left: 55px
}

.color-group li:last-child span {
	display: block;
	margin: 10px 0
}

.color-group.other-colors li:first-child span {
	color: #202428
}

.color-group .bg-light-gray {
	background: #9192a3
}

.color-group .bg-light-default {
	background: #5a6671
}

.color-group .bg-line {
	background: #e4e8ed
}

.color-group .bg-default {
	background: #f5f7fc
}

.color-group .color-default {
	color: #5a6671
}

.color-group .color-light-gray {
	color: #9192a3
}

.bg-gradient {
	background: linear-gradient(to right, #413aa4, #06b590) !important
}

.bg-gradient-corner {
	background: linear-gradient(45deg, #413aa4, #06b590)
}

.color-light-gray {
	color: #9192a3
}

.flip-boxes {
	background: #f5f4f7
}

.section-bg {
	background: #f5f7fc
}

iframe {
	width: 100%
}

.section-padding {
	padding: 7.33333rem 0
}

.section-padding2 {
	padding: 7.33333rem 0 5.33333rem
}

.section-padding3 {
	padding: 6.66667rem 0 1.33333rem 0
}

.section-padding4 {
	padding: 7.33333rem 0 6.33333rem 0
}

.section-padding5 {
	padding: 7.33333rem 0 3.33333rem 0
}

.section-padding-top {
	padding: 7.33333rem 0 0 0
}

.section-padding-sm {
	padding: 6rem 0
}

.section-split {
	position: relative
}

.section-split:before {
	position: absolute;
	content: "";
	width: 50%;
	height: 100%;
	left: 0;
	top: 0;
	background: #f5f7fc
}

.section-split2 {
	position: relative
}

.section-split2:before {
	position: absolute;
	content: "";
	width: 1px;
	height: 100%;
	left: 50%;
	top: 0;
	transform: translateX(-50%);
	background: #e2e1ea
}

.bg-half-gray,
.bg-half-secondary {
	position: relative
}

.bg-half-gray:before,
.bg-half-secondary:before {
	position: absolute;
	content: '';
	width: 100%;
	height: 50%;
	left: 0;
	top: 0
}

.bg-half-secondary:before {
	background: #413aa4
}

.bg-half-gray:before {
	background: #f5f7fc;
	top: auto;
	bottom: 0;
	height: 48%
}

.list-types ul {
	margin-bottom: 2rem
}

.card--team1 .card-body .team-social li a.list-types:hover,
.custom-radio-three .custom-control-input:checked~.list-types.custom-control-label::after,
.custom-radio-two .custom-control-input:checked~.list-types.custom-control-label::after,
.dot-secondary.dot-light .owl-dot.active span.list-types,
.event-single .list-types.event-date,
.icon-light .content-list .icon-circle span.list-types,
.list-types.bg-dark,
.list-types.bg-secondary,
.list-types.bullet_list:before,
.list-types.go_top:hover,
.nav-circle button.list-types,
.nav-square.nav-square-dark button.list-types,
.nav_right_content .cart_module .list-types.cart_count,
.owl-dots.dot-secondary .owl-dot.active span.list-types,
.portfolio-carousel-single figure figcaption .list-types.link,
.pricing .list-types.pricing__price,
.tab.tab--2 .tab_nav2 .nav .nav-item .list-types.nav-link.active:before,
.tab.tab--2 .tab_nav2 .nav .nav-item .list-types.nav-link:hover:before,
.tab.tab--6 .tab_nav2 .nav .nav-item .list-types.nav-link.active:before,
.tab.tab--6 .tab_nav2 .nav .nav-item .list-types.nav-link:hover:before,
.tab.tab--7 .tab_nav7 .nav .nav-item .list-types.nav-link.active:before,
.tab.tab--8 .tab_nav7 .nav .nav-item .list-types.nav-link.active:before,
.toggle-switch input:checked+.list-types.slider,
footer.footer2 .list-types.footer__small,
footer.footer4.footer--colored .list-types.footer--small,
footer.footer4.footer--light .footer__small .social.square li a.list-types:hover {
	padding: 4.66667rem 0 2.33333rem
}

.card--team1 .card-body .team-social li a.list-types:hover ol,
.card--team1 .card-body .team-social li a.list-types:hover ul,
.custom-radio-three .custom-control-input:checked~.list-types.custom-control-label::after ol,
.custom-radio-three .custom-control-input:checked~.list-types.custom-control-label::after ul,
.custom-radio-two .custom-control-input:checked~.list-types.custom-control-label::after ol,
.custom-radio-two .custom-control-input:checked~.list-types.custom-control-label::after ul,
.dot-secondary.dot-light .owl-dot.active span.list-types ol,
.dot-secondary.dot-light .owl-dot.active span.list-types ul,
.event-single .list-types.event-date ol,
.event-single .list-types.event-date ul,
.icon-light .content-list .icon-circle span.list-types ol,
.icon-light .content-list .icon-circle span.list-types ul,
.list-types.bg-dark ol,
.list-types.bg-dark ul,
.list-types.bg-secondary ol,
.list-types.bg-secondary ul,
.list-types.bullet_list:before ol,
.list-types.bullet_list:before ul,
.list-types.go_top:hover ol,
.list-types.go_top:hover ul,
.nav-circle button.list-types ol,
.nav-circle button.list-types ul,
.nav-square.nav-square-dark button.list-types ol,
.nav-square.nav-square-dark button.list-types ul,
.nav_right_content .cart_module .list-types.cart_count ol,
.nav_right_content .cart_module .list-types.cart_count ul,
.owl-dots.dot-secondary .owl-dot.active span.list-types ol,
.owl-dots.dot-secondary .owl-dot.active span.list-types ul,
.portfolio-carousel-single figure figcaption .list-types.link ol,
.portfolio-carousel-single figure figcaption .list-types.link ul,
.pricing .list-types.pricing__price ol,
.pricing .list-types.pricing__price ul,
.tab.tab--2 .tab_nav2 .nav .nav-item .list-types.nav-link.active:before ol,
.tab.tab--2 .tab_nav2 .nav .nav-item .list-types.nav-link.active:before ul,
.tab.tab--2 .tab_nav2 .nav .nav-item .list-types.nav-link:hover:before ol,
.tab.tab--2 .tab_nav2 .nav .nav-item .list-types.nav-link:hover:before ul,
.tab.tab--6 .tab_nav2 .nav .nav-item .list-types.nav-link.active:before ol,
.tab.tab--6 .tab_nav2 .nav .nav-item .list-types.nav-link.active:before ul,
.tab.tab--6 .tab_nav2 .nav .nav-item .list-types.nav-link:hover:before ol,
.tab.tab--6 .tab_nav2 .nav .nav-item .list-types.nav-link:hover:before ul,
.tab.tab--7 .tab_nav7 .nav .nav-item .list-types.nav-link.active:before ol,
.tab.tab--7 .tab_nav7 .nav .nav-item .list-types.nav-link.active:before ul,
.tab.tab--8 .tab_nav7 .nav .nav-item .list-types.nav-link.active:before ol,
.tab.tab--8 .tab_nav7 .nav .nav-item .list-types.nav-link.active:before ul,
.toggle-switch input:checked+.list-types.slider ol,
.toggle-switch input:checked+.list-types.slider ul,
footer.footer2 .list-types.footer__small ol,
footer.footer2 .list-types.footer__small ul,
footer.footer4.footer--colored .list-types.footer--small ol,
footer.footer4.footer--colored .list-types.footer--small ul,
footer.footer4.footer--light .footer__small .social.square li a.list-types:hover ol,
footer.footer4.footer--light .footer__small .social.square li a.list-types:hover ul {
	margin: 0
}

.bg-image {
	background: url(https://snmtechnologies.in/startup/img/list-bg.jpg) center/cover no-repeat;
	padding: 6rem
}

.bg-image ol,
.bg-image ul {
	margin: 0
}

.bg-image.list-types {
	padding: 6rem 0 4rem
}

.bg-gray-light {
	background: #f5f7fc
}

.bg-gradient--light {
	background: linear-gradient(to bottom, #fff, #fbfaff)
}

.hr-divider {
	border-top: 1px solid #e4e8ed;
	height: 1px;
	margin-top: 4rem
}

.hr-divider2 {
	border-top: 1px solid #e4e8ed;
	height: 1px;
	margin: 3.6rem 0 3.53333rem 0
}

.hr-divider3 {
	border-top: 1px solid #d8d9e4;
	height: 1px;
	margin: 2.66667rem 0 5.33333rem 0
}

.hr-divider-gray {
	background: rgba(100, 103, 145, .5);
	width: 100%;
	height: 1px;
	margin: 5.33333rem 0 4.33333rem
}

.hr-line {
	background: #e4e8ed;
	height: 1px
}

.form-elements .form-tabs li {
	margin-left: -1px
}

.form-elements .form-tabs li:first-child a {
	border-radius: 3px 0 0 3px
}

.form-elements .form-tabs li:last-child a {
	border-radius: 0 3px 3px 0
}

.form-elements .form-tabs li a {
	border: 1px solid #e4e8ed;
	padding: 13px 15px;
	color: #5a6671;
	transition: all .3s ease;
	display: block
}

.form-elements .form-tabs li a.active {
	background: #413aa4;
	color: #fff;
	border-color: #413aa4
}

.form-elements .form-tabs li a:hover {
	color: #fff;
	background: #413aa4;
	border-color: #413aa4
}

.tab--3 .tab-content>.tab-pane {
	display: block;
	height: 0;
	visibility: hidden
}

.tab--3 .tab-content>.active {
	height: auto;
	visibility: visible
}

.go_top {
	line-height: 2.66667rem;
	cursor: pointer;
	width: 2.66667rem;
	color: #fff;
	transition: all .3s ease;
	position: fixed;
	box-shadow: 0 4px 4px rgba(0, 0, 0, .1);
	border-radius: 1.66667rem 0 0 1.66667rem;
	right: 0;
	z-index: 111;
	bottom: 30px;
	text-align: center
}

.btn-primary {
	box-shadow: 0 10px 20px rgba(65, 58, 164, .2)
}

.btn-secondary {
	box-shadow: 0 10px 20px rgba(6, 181, 144, .2)
}

.btn-success {
	box-shadow: 0 10px 20px rgba(53, 181, 62, .2)
}

.btn-info {
	box-shadow: 0 10px 20px rgba(55, 125, 255, .2)
}

.btn-warning {
	box-shadow: 0 10px 20px rgba(255, 175, 0, .2)
}

.btn-danger {
	box-shadow: 0 10px 20px rgba(226, 54, 54, .2)
}

.btn-light {
	box-shadow: 0 10px 20px rgba(255, 255, 255, .2)
}

.btn-dark {
	box-shadow: 0 10px 20px rgba(32, 36, 40, .2)
}

.outline-thick-primary {
	border: 2px solid rgba(65, 58, 164, .2);
	background: 0 0;
	color: #413aa4
}

.outline-thick-secondary {
	border: 2px solid rgba(6, 181, 144, .2);
	background: 0 0;
	color: #06b590
}

.outline-thick-success {
	border: 2px solid rgba(53, 181, 62, .2);
	background: 0 0;
	color: #35b53e
}

.outline-thick-info {
	border: 2px solid rgba(55, 125, 255, .2);
	background: 0 0;
	color: #377dff
}

.outline-thick-warning {
	border: 2px solid rgba(255, 175, 0, .2);
	background: 0 0;
	color: #ffaf00
}

.outline-thick-danger {
	border: 2px solid rgba(226, 54, 54, .2);
	background: 0 0;
	color: #e23636
}

.outline-thick-light {
	border: 2px solid rgba(255, 255, 255, .2);
	background: 0 0;
	color: #fff
}

.outline-thick-dark {
	border: 2px solid rgba(32, 36, 40, .2);
	background: 0 0;
	color: #202428
}

.btn {
	text-transform: capitalize;
	font-size: .93333rem;
	font-weight: 500
}

.btn.btn--rounded {
	border-radius: 200px
}

.btn.btn-sm {
	font-size: .86rem
}

.btn.btn-lg {
	font-size: 1rem;
	white-space: normal
}

.btna {
	color: #fff
}

.btn.btn-light {
	box-shadow: 0 10px 20px rgba(41, 41, 59, .15)
}

.btn.btn-outline-light {
	border: 1px solid #e4e8ed;
	color: #e4e8ed
}

.btn.btn-outline-light:hover {
	color: #212529;
	background: #e4e8ed
}

.btn.btn-arrow {
	display: inline-flex;
	align-items: center;
	justify-content: center
}

.btn.btn-arrow i {
	margin-left: .66rem
}

.btn.btn-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap
}

.btn.btn-icon.icon-left i,
.btn.btn-icon.icon-left span {
	margin-right: 6px
}

.btn.btn-icon.icon-right i,
.btn.btn-icon.icon-right span {
	margin-left: 6px
}

.btn.like-btn {
	width: 2.73333rem;
	height: 2.73333rem;
	font-size: 1.2rem;
	color: #06b590;
	border: 1px solid rgba(255, 255, 255, .3);
	border-radius: 50%;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(6, 181, 144, .1)
}

.btn.like-btn:focus {
	outline: 0
}

.btn.like-btn:hover {
	color: #fff;
	background: #06b590
}

.btn.filter-btn {
	font-size: 1rem;
	min-width: auto;
	padding: 0 1.33333rem;
	font-weight: 400;
	text-transform: capitalize;
	box-shadow: none
}

.btn.filter-btn:focus {
	outline: 0;
	box-shadow: none
}

.btn.btn-gradient {
	background: linear-gradient(to right, #413aa4, #06b590);
	color: #fff;
	border: none;
	box-shadow: 0 10px 15px rgba(6, 181, 144, .2)
}

.btn.btn-icon-only {
	padding-left: 1rem;
	padding-right: 1rem;
	font-size: 1.2rem
}

.play-btn-wrapper {
	display: flex;
	align-items: center;
	color: #06b590;
	font-weight: 500;
	margin-left: 1rem
}

.play-btn-wrapper .play-btn {
	margin-right: 1.33333rem
}

.play-btn {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	color: #fff;
	font-size: 2rem;
	transition: all .3s ease;
	position: relative
}

.play-btn .svg {
	width: 1.2rem;
	fill: #fff;
	transition: all .3s ease
}

.play-btn:hover {
	color: #fff
}

.play-btn.play-btn--lg {
	width: 4.66667rem;
	height: 4.66667rem
}

.play-btn.play-btn--sm {
	width: 3.33333rem;
	height: 3.33333rem;
	font-size: 1.53333rem
}

.play-btn.play-btn--sm .svg {
	width: 1rem
}

.play-btn.play-btn-light {
	background: #fff;
	color: #202428
}

.play-btn.play-btn-light:hover {
	background: #06b590;
	color: #fff
}

.play-btn.play-btn-light:hover .svg {
	fill: #fff
}

.play-btn.play-btn-light .svg {
	fill: #06b590
}

.play-btn.play-btn--gesture {
	color: #06b590;
	font-size: 1.86667rem
}

.play-btn.play-btn--gesture:before {
	position: absolute;
	content: '';
	width: 130%;
	height: 130%;
	left: -15%;
	top: -15%;
	background: rgba(6, 181, 144, .15);
	border-radius: 20rem
}

.play-btn.play-btn--gesture:after {
	position: absolute;
	content: '';
	width: 160%;
	height: 160%;
	left: -30%;
	top: -30%;
	background: rgba(6, 181, 144, .05);
	border-radius: 20rem
}

.play-btn.play-btn--gesture:hover {
	background: inherit
}

.play-btn.play-btn--primary {
	background: #413aa4
}

.play-btn.play-btn--secondary {
	background: #06b590
}

.action-btns ul li {
	margin-right: 5px
}

.action-btns ul li:last-child {
	margin-right: 0
}

.action-btns ul li.share-btn {
	position: relative;
	padding-bottom: 1rem
}

.action-btns ul li.share-btn ul {
	position: absolute;
	right: 0;
	top: 4rem;
	display: flex;
	justify-content: center;
	padding: 1rem 2rem;
	background: #fff;
	border-radius: 3px;
	visibility: hidden;
	opacity: 0;
	transition: all .3s ease;
	box-shadow: 0 0 15px rgba(0, 0, 0, .15)
}

.action-btns ul li.share-btn ul:before {
	position: absolute;
	content: '';
	border-bottom: .66667rem solid #fff;
	border-right: .53333rem solid transparent;
	border-left: .53333rem solid transparent;
	right: 1.13333rem;
	bottom: 100%
}

.action-btns ul li.share-btn ul li {
	margin-right: 1rem
}

.action-btns ul li.share-btn ul li:last-child {
	margin-right: 0
}

.action-btns ul li.share-btn ul li a {
	font-size: 1rem;
	color: #06b590;
	transition: all .3s ease
}

.action-btns ul li.share-btn ul li a:hover {
	color: #413aa4
}

.action-btns ul li.share-btn:hover ul {
	opacity: 1;
	visibility: visible
}

.input_with_embed {
	position: relative
}

.input_with_embed .embed_button,
.input_with_embed .embed_icon {
	position: absolute
}

.input_with_embed .embed_icon {
	right: 1.33rem;
	top: 50%;
	transform: translateY(-50%)
}

.input_with_embed .embed_icon button {
	background: 0 0;
	border: 0
}

input.input--rounded {
	border-radius: 13.33333rem
}

.custom-radio {
	margin-bottom: 1rem;
	padding-left: 10px
}

.custom-radio:last-child {
	margin-bottom: 0
}

.custom-radio input:active {
	background: 0 0
}

.custom-radio .custom-control-label {
	padding-left: 2rem;
	position: relative;
	min-width: 100px
}

.custom-radio .custom-control-label:before {
	width: 1.2rem;
	height: 1.2rem;
	background-color: #fff;
	box-shadow: none;
	border: .33333rem solid #cbd0e3;
	top: 1px;
	left: 0
}

.custom-radio .custom-control-label:after {
	width: auto;
	height: auto;
	background-image: none
}

.custom-radio .custom-control-label span {
	position: relative;
	top: 0rem
}
p{font-size: 18px!important;}
.custom-radio .custom-control-input:checked~.custom-control-label::before {
	background: 0 0;
	border-color: #06b590;
	content: "";
	font-family: LineAwesome;
	color: #fff;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: .8rem
}

.custom-control-input:focus~.custom-control-label::before {
	box-shadow: none
}

.custom-radio-two .custom-control-label:before {
	border: .2rem solid #cbd0e3;
	width: 1.2rem;
	height: 1.2rem
}

.custom-radio-two .custom-control-input:checked~.custom-control-label::after {
	width: .4rem;
	height: .4rem;
	border-radius: 20rem;
	left: .4rem;
	top: .46667rem
}

.custom-radio-three .custom-control-label:before {
	border: 1px solid #cbd0e3;
	width: 1.2rem;
	height: 1.2rem
}

.custom-radio-three .custom-control-input:checked~.custom-control-label::after {
	width: .4rem;
	height: .4rem;
	border-radius: 50%;
	left: .4rem;
	top: .46667rem
}

.form-control {
	box-shadow: none;
	resize: none;
	appearance: none
}

@media all and (-ms-high-contrast:none),
(-ms-high-contrast:active) {
	.form-control {
		padding: .5rem 1.2rem 1rem
	}
}

.form-control:focus {
	outline: 0;
	box-shadow: none
}

.form-control::placeholder {
	color: #9192a3
}

.form-control.fc--squared {
	border-radius: 0
}

.form-control.fc--rounded {
	border-radius: 1.66667rem;
	padding-left: 1.66667rem
}

.form-control.fc--solid-bg {
	background: #f5f4f7
}

.form-control.form-outline {
	border: 0 none;
	border-bottom: 1px solid #e4e8ed;
	border-radius: 0;
	padding-left: 0
}

.form-control.form-outline:focus {
	border-bottom-color: #06b590
}

.form-control--color {
	min-height: 3rem;
	padding: .66667rem;
	background: 0 0
}

.form-group {
	margin-bottom: 2rem
}

.form-group:last-child {
	margin-bottom: 0
}

.form-group label {
	color: #202428
}

.range-input:after {
	content: '';
	display: block;
	clear: both
}

.range-input .custom-range {
	appearance: none;
	background: 0 0
}

.range-input .custom-range::-webkit-slider-thumb {
	-webkit-appearance: none;
	width: 1.2rem;
	height: 1.2rem;
	border-radius: 50%;
	border: .33333rem solid #413aa4;
	background: #e3e6ef;
	margin-top: -6px
}

.range-input .custom-range::-webkit-slider-runnable-track {
	background: #e3e6ef;
	height: .4rem;
	width: 100%;
	cursor: pointer
}

.input-group-light .form-control {
	border-radius: 3px !important
}

.input-group-light span {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	z-index: 10;
	font-size: 1.2rem
}

.input-group-light span.icon-left {
	left: 1.33333rem
}

.input-group-light span.icon-left+.form-control {
	padding-left: 3rem
}

.input-group-light span.icon-right {
	right: 1rem
}

.input-group-light span.icon-right+.form-control {
	padding-right: 2.66667rem
}

.checkbox-group .input-group-text {
	line-height: normal;
	padding: 0 .8rem
}

.checkbox-group .input-group-text .custom-control {
	padding-left: 1rem
}

.checkbox-group .custom-checkbox .custom-control-input:checked~.custom-control-label::after {
	padding-left: 1px;
	padding-top: 2px
}

.radio-group .input-group-text {
	line-height: normal;
	padding: 0 .8rem
}

.radio-group .input-group-text .custom-control {
	padding-left: .53333rem
}

.radio-group .custom-control-label {
	padding-left: 0;
	width: 1.46667rem;
	height: 1.53333rem;
	display: flex;
	margin-left: -.46667rem
}

.custom-checkbox {
	margin-bottom: 2.33333rem
}

.custom-checkbox:last-child {
	margin-bottom: 0
}

.custom-checkbox .custom-control-label {
	min-width: 6.66667rem;
	padding-left: 2.33333rem;
	position: relative
}

.custom-checkbox .custom-control-label::before {
	box-shadow: none;
	width: 1.46667rem;
	height: 1.46667rem;
	border-radius: 2px;
	top: 0;
	left: 0
}

.custom-checkbox .custom-control-label::after {
	width: 1.4rem;
	height: 1.4rem;
	top: 0
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
	background-image: none;
	content: "\\f17b";
	font-family: LineAwesome;
	left: 0;
	font-size: .86667rem;
	text-align: center;
	top: 2px;
	font-weight: 600
}

.checkbox-outline .custom-control-label:before {
	background: 0 0
}

.checkbox-outline .custom-control-input:checked~.custom-control-label::before {
	background: 0 0
}

.checkbox-outline .custom-control-input:checked~.custom-control-label::after {
	background-image: none;
	content: "\\f17b";
	font-family: LineAwesome;
	left: 0;
	font-size: .86667rem;
	text-align: center;
	top: 2px;
	font-weight: 600
}

.checkbox-outline-gray .custom-control-label:before {
	border: 1px solid #e4e8ed
}

.checkbox-outline-gray .custom-control-input:checked~.custom-control-label::before {
	border: 1px solid #e4e8ed
}

.checkbox-outline-gray .custom-control-input:checked~.custom-control-label::after {
	color: #5a6671
}

.checkbox-rounded .custom-control-label:before {
	border-radius: 50%
}

.toggle-switch {
	position: relative;
	display: inline-block;
	width: 4rem;
	height: 2rem
}

.toggle-switch input {
	display: none
}

.toggle-switch .slider {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: #cbd0e3;
	transition: all .3s ease;
	cursor: pointer
}

.toggle-switch .slider:before {
	position: absolute;
	content: "";
	height: 1.6rem;
	width: 1.6rem;
	left: .2rem;
	bottom: .2rem;
	background-color: #fff;
	transition: all .3s ease
}

.toggle-switch input:checked+.slider:before {
	transform: translateX(30px)
}

.toggle-switch input:focus+.slider {
	box-shadow: 0 0 1px #2196f3
}

.toggle-switch .slider.round {
	border-radius: 1.66667rem
}

.toggle-switch .slider.round:before {
	border-radius: 50%
}

.toggle-switch-text {
	width: 4.66667rem
}

.toggle-switch-text input:checked+.slider:before {
	transform: translateX(2.66667rem)
}

.toggle-switch-text input:checked+.slider .on {
	visibility: visible;
	opacity: 1
}

.toggle-switch-text input:checked+.slider .off {
	visibility: hidden
}

.toggle-switch-text .slider.round .on {
	visibility: hidden;
	opacity: 0;
	transition: all .3s ease
}

.toggle-switch-text .slider.round .off,
.toggle-switch-text .slider.round .on {
	padding-left: .2rem;
	margin-top: .4rem;
	font-size: .86667rem;
	text-transform: uppercase;
	display: inline-block
}

.toggle-switch-text .slider.round .on {
	padding-left: .66667rem;
	color: #fff
}

.toggle-switch-bordered .slider {
	background: 0 0;
	border: 1px solid #cbd0e3
}

.toggle-switch-bordered .slider:before {
	height: 2rem;
	width: 2rem;
	left: -.06667rem;
	bottom: -.06667rem;
	border: 1px solid #cbd0e3
}

.toggle-switch-bordered input:checked+.slider {
	border-color: #06b590;
	background: 0 0
}

.toggle-switch-bordered input:checked+.slider:before {
	transform: translateX(30px);
	border-color: #06b590
}

select.form-control {
	min-height: 3rem;
	color: #9192a3
}

.select-basic {
	position: relative
}

.select-basic select {
	appearance: none
}

.select-basic:before {
	position: absolute;
	content: "\\f110";
	right: 1rem;
	font-size: .8rem;
	top: 50%;
	transform: translateY(-50%);
	font-family: LineAwesome
}

.form--rounded {
	border-radius: 1.66667rem;
	border: 0 none
}

.input-group-subscribe {
	display: block;
	position: relative;
	border-radius: 3px;
	overflow: hidden
}

.input-group-subscribe input {
	width: 100%;
	border: 0 none;
	padding-left: 4rem;
	padding-right: 7.66667rem;
	height: 4rem
}

.input-group-subscribe button {
	position: absolute;
	right: 0;
	top: 0;
	height: 100%;
	border: 0 none;
	padding: 0 1.66667rem;
	background: #06b590;
	color: #fff;
	cursor: pointer
}

.input-group-subscribe .text-field {
	position: relative
}

.input-group-subscribe .text-field:before {
	position: absolute;
	content: '\\f1c6';
	font-family: LineAwesome;
	left: 1.66667rem;
	top: 50%;
	transform: translateY(-50%);
	font-size: 1.46667rem
}

.input-group-subscribe.subscribe--rounded input {
	border-radius: 2rem
}

.input-group-subscribe.subscribe--rounded button {
	border-radius: 0 2rem 2rem 0
}

select[multiple]::-webkit-scrollbar-track {
	background-color: rgba(32, 36, 40, .05)
}

select[multiple]::-webkit-scrollbar {
	width: 6px;
	background-color: transparent
}

select[multiple]::-webkit-scrollbar-thumb {
	background-color: #e4e8ed;
	border-radius: 5px
}

.form-wrapper .cardify h5 {
	font-weight: 600
}

.select2-container {
	width: 100% !important
}

.select2-container--default .select2-selection--single .select2-selection__arrow b:before {
	position: absolute;
	content: "\\f110";
	right: 1rem;
	font-weight: 400;
	top: 50%;
	transform: translateY(-50%);
	font-family: LineAwesome
}

.select2-container .select2-selection--multiple .select2-selection__rendered {
	display: block;
	width: 100% !important
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
	margin: 5px;
	background: #f1f3f8;
	border: 0;
	color: #9192a3;
	padding: 0 10px
}

.select2-results__options::-webkit-scrollbar-track {
	background-color: rgba(32, 36, 40, .05)
}

.select2-results__options::-webkit-scrollbar {
	width: 6px;
	background-color: transparent
}

.select2-results__options::-webkit-scrollbar-thumb {
	background-color: #e4e8ed;
	border-radius: 5px
}

.custom_select_with_icon .select2-results .select2-results__options .select2-results__option.select2-results__option--highlighted span span.la {
	color: #06b590
}

.custom_select_with_icon .select2-results .select2-results__options .select2-results__option span span.la {
	font-size: 18px;
	display: inline-block;
	vertical-align: middle;
	line-height: inherit;
	margin-right: 4px;
	color: #9192a3
}

.custom-photo-upload {
	position: relative
}

.custom-photo-upload input {
	width: 13.33333rem;
	height: 13.33333rem;
	position: absolute;
	left: 0;
	top: 0;
	opacity: 0;
	margin: 0;
	cursor: pointer
}

.custom-photo-upload .custom-upload-box .image-box {
	width: 13.33333rem;
	height: 13.33333rem;
	border: 1px solid #e4e8ed;
	border-radius: 3px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column
}

.custom-photo-upload .custom-upload-box .image-box .icon {
	font-size: 6.66667rem;
	color: #e4e8ed
}

.custom-photo-upload .custom-upload-box .image-box span {
	color: #9192a3
}

.custom-photo-upload .custom-upload-box .image-box span.file-name {
	text-align: center
}

.custom-photo-upload .custom-upload-box .image-info {
	display: flex;
	justify-content: center;
	flex-direction: column;
	margin-left: 2rem
}

.custom-photo-upload .custom-upload-box .image-info span {
	color: #9192a3
}

.custom-upload {
	position: relative
}

.custom-upload input {
	width: 13.33333rem;
	height: 3.33333rem;
	position: absolute;
	left: 0;
	top: 0;
	opacity: 0;
	margin: 0;
	cursor: pointer
}

.custom-upload .custom-upload-box .upload-info {
	display: flex;
	justify-content: center;
	flex-direction: column;
	margin-left: 2rem
}

.custom-upload .custom-upload-box .upload-info span {
	color: #9192a3
}

textarea.form-control {
	padding-top: 1rem
}

.form-control-lg {
	font-size: 1rem
}

.heading-styles .card-body {
	padding: 3rem 3rem 1.8rem
}

.heading-styles .card-body h1,
.heading-styles .card-body h2,
.heading-styles .card-body h3,
.heading-styles .card-body h4,
.heading-styles .card-body h5,
.heading-styles .card-body h6 {
	color: #202428
}

.sub_heading-group {
	margin-bottom: 2.66rem
}

.sub_heading-group:last-child {
	margin-bottom: 0
}

.sub_heading-group h1,
.sub_heading-group h2,
.sub_heading-group h3,
.sub_heading-group h4,
.sub_heading-group h5,
.sub_heading-group h6 {
	margin-bottom: 1.5rem
}

.sub_heading-group .subHeading-top {
	font-size: 1.33rem;
	font-weight: 500;
	margin-bottom: .4rem
}

.sub_heading-group .subHeading-bottom {
	font-size: 1.2rem;
	margin-bottom: 0
}

.lead {
	line-height: 2.4rem
}

.lead--medium {
	font-size: 1.6rem;
	font-weight: 500;
	line-height: 2.93rem
}

p {
	line-height: 2rem
}

h1,
h2,
h3,
h4,
h5,
h6 {
	font-weight: 600
}

.blockquote {
	border: 1px solid #e4e8ed;
	padding: 2.5rem 3.33333rem;
	border-radius: .3rem;
	margin: 0
}

.blockquote p {
	margin: 0;
	font-size: 1.33rem;
	color: #202428;
	line-height: 2.4rem;
	font-weight: 500
}

.blockquote .quote-author {
	margin-top: 1.66rem
}

.blockquote .quote-author p {
	font-size: 1rem;
	font-weight: 400;
	line-height: 2rem;
	color: #9192a3;
	position: relative;
	display: inline-block;
	padding-left: 3.66667rem
}

.blockquote .quote-author p:before {
	position: absolute;
	content: "";
	width: 2.66667rem;
	height: 2px;
	background: #06b590;
	left: 0;
	top: 50%;
	transform: translateY(-50%)
}

.blockquote .quote-author p span {
	font-weight: 500;
	color: #202428
}

.blockquote.blockquote1 .quote-author {
	text-align: left
}

.blockquote.blockquote-sm p {
	font-size: 1.06667rem;
	line-height: 1.86667rem
}

.blockquote.blockquote-sm .quote-author p {
	padding: 0
}

.blockquote.blockquote-sm .quote-author p:before {
	content: none
}

.blockquote.blockquote-sm .quote-author p span {
	font-size: 1rem
}

.blockquote.blockquote3,
.blockquote.blockquote4 {
	border: 0 none;
	border-radius: 0;
	background: linear-gradient(to right, #413aa4, #06b590)
}

.blockquote.blockquote3 p,
.blockquote.blockquote4 p {
	font-weight: 400;
	color: #fff
}

.blockquote.blockquote3 .quote-author p,
.blockquote.blockquote4 .quote-author p {
	color: rgba(255, 255, 255, .7)
}

.blockquote.blockquote3 .quote-author span,
.blockquote.blockquote4 .quote-author span {
	color: #fff
}

.blockquote.blockquote3 .quote-author {
	text-align: left
}

.blockquote.blockquote1,
.blockquote.blockquote3 {
	position: relative
}

.blockquote.blockquote1:before,
.blockquote.blockquote3:before {
	position: absolute;
	content: "\\f2ce";
	font-family: LineAwesome;
	color: rgba(255, 255, 255, .1);
	font-size: 8rem;
	left: 2.33333rem;
	bottom: .66667rem
}

.quotes-with-image {
	background: linear-gradient(to right, #413aa4, #06b590)
}

.blockquote5 {
	margin-bottom: 0
}

.blockquote5 .strong {
	font-size: 1.46667rem;
	font-weight: 500;
	color: #fff;
	margin-bottom: 2.33333rem;
	line-height: 2.4rem;
	position: relative;
	margin-top: 2.66667rem
}

.blockquote5 .strong:before {
	position: absolute;
	content: "\\f2cd";
	font-family: LineAwesome;
	font-size: 10rem;
	color: rgba(255, 255, 255, .1);
	left: 0;
	top: -1rem
}

.blockquote5 p {
	color: rgba(255, 255, 255, .8)
}

.blockquote5 .author-sign {
	font-size: 2.33333rem;
	font-family: Allura, cursive;
	color: #fff;
	display: block;
	margin-top: 2rem
}

.hr {
	margin: 5.33333rem 0
}

.accordion_one,
.accordion_two {
	box-shadow: 0 5px 10px rgba(105, 106, 119, .05);
	background: #fff;
	padding: 2.66667rem;
	border: 1px solid #e4e8ed
}

.accordion_one .accordion-single,
.accordion_two .accordion-single {
	border-bottom: 1px solid #e4e8ed
}

.accordion_one .accordion-single:first-child,
.accordion_two .accordion-single:first-child {
	padding-top: 0
}

.accordion_one .accordion-single:first-child h6 a,
.accordion_two .accordion-single:first-child h6 a {
	padding-top: 0
}

.accordion_one .accordion-single:first-child h6 a[aria-expanded=true]:before,
.accordion_two .accordion-single:first-child h6 a[aria-expanded=true]:before {
	top: 10%;
	transform: translateY(-10%)
}

.accordion_one .accordion-single:first-child h6 a[aria-expanded=false]:before,
.accordion_two .accordion-single:first-child h6 a[aria-expanded=false]:before {
	top: 10%;
	transform: translateY(-10%)
}

.accordion_one .accordion-single h6 a,
.accordion_two .accordion-single h6 a {
	color: #202428;
	display: block;
	position: relative;
	padding: 1.33rem 2rem 1rem 0;
	font-size: 1.06667rem;
	font-weight: 500;
	cursor: pointer
}

.accordion_one .accordion-single h6 a[aria-expanded=true]:before,
.accordion_two .accordion-single h6 a[aria-expanded=true]:before {
	position: absolute;
	content: '\\f110';
	font-family: LineAwesome;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	color: #9192a3;
	font-size: .93333rem
}

.accordion_one .accordion-single h6 a[aria-expanded=false]:before,
.accordion_two .accordion-single h6 a[aria-expanded=false]:before {
	position: absolute;
	content: '\\f113';
	font-family: LineAwesome, sans-serif;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	font-size: .93333rem;
	color: #9192a3
}

.accordion_two {
	box-shadow: 0 5px 10px rgba(105, 106, 119, .05);
	padding: 3rem;
	border-radius: .3rem
}

.accordion_two .accordion-single h6 a[aria-expanded=true]:before {
	content: '\\f28e';
	color: #9192a3
}

.accordion_two .accordion-single h6 a[aria-expanded=false]:before {
	content: '\\f2c2'
}

.accordion_three .accordion-single {
	margin-bottom: 5px
}

.accordion_three .accordion-heading h6 a {
	display: block;
	padding: 1rem 2.66667rem 1rem 2rem;
	background: #fff;
	color: #202428;
	position: relative;
	transition: all .3s ease;
	line-height: 1.46667rem;
	font-size: 1rem;
	font-weight: 500
}

.accordion_three .accordion-heading h6 a[aria-expanded=true] {
	background: #06b590;
	color: #fff
}

.accordion_three .accordion-heading h6 a[aria-expanded=true]:before {
	content: '\\f28e';
	color: #fff
}

.accordion_three .accordion-heading h6 a:before {
	position: absolute;
	content: '\\f2c2';
	font-family: LineAwesome;
	right: 2rem;
	top: 50%;
	transform: translateY(-50%);
	color: #9192a3
}

.accordion_three .accordion-contents {
	padding: 1.33rem 2rem .66rem
}

.accordion_three .collapsed.bg-gray-light {
	background: #f5f4f7
}

.accordion_four .accordion-single {
	margin-bottom: 5px
}

.accordion_four .accordion-heading h6 a {
	display: flex;
	align-items: center;
	padding: 1rem 2.66667rem 1rem 2rem;
	background: #fff;
	color: #202428;
	position: relative;
	transition: all .3s ease;
	line-height: 1.46667rem;
	font-size: 1rem;
	font-weight: 500
}

.accordion_four .accordion-heading h6 a[aria-expanded=true] {
	background: #06b590;
	color: #fff
}

.accordion_four .accordion-heading h6 a[aria-expanded=true]:before {
	content: '\\f28e';
	color: #fff
}

.accordion_four .accordion-heading h6 a[aria-expanded=true] i {
	color: #fff
}

.accordion_four .accordion-heading h6 a:before {
	position: absolute;
	content: '\\f2c2';
	font-family: LineAwesome;
	right: 2rem;
	top: 50%;
	transform: translateY(-50%);
	color: #9192a3
}

.accordion_four .accordion-heading h6 a i {
	font-size: 1.4rem;
	color: #06b590;
	margin-right: 1rem;
	transition: all .3s ease
}

.accordion_four .accordion-contents {
	padding: 1.33rem 2rem .66rem
}

.accordion_four .collapsed.bg-gray-light {
	background: #f5f4f7
}

.alert-group .alert:last-child {
	margin-bottom: 0
}

.alert {
	border: 0 none
}

.alert strong {
	font-weight: 500;
	font-size: 1.06rem
}

.alert a {
	color: inherit;
	font-weight: 500;
	font-size: 1.06rem
}

.alert p {
	margin: 0
}

.alert i.la {
	padding-right: .66rem;
	font-size: 1.2rem;
	position: relative;
	top: 2px
}

.alert.alert-outline {
	background: 0 0;
	border: 1px solid
}

.alert.alert-dismissible .close {
	top: 50%;
	transform: translateY(-50%);
	right: 2rem;
	padding: 0
}

.alert.alert-dismissible .close:focus {
	outline: 0
}

.card {
	border-radius: .26667rem;
	overflow: hidden
}

.card figure {
	margin: 0
}

.card .card-body .card-title {
	margin-bottom: 25px
}

.card .card-body h6 {
	margin-bottom: 0;
	line-height: 1.86667rem
}

.card .card-body h4 a:hover {
	color: #413aa4
}

.card .card-footer {
	padding: 1.66667rem 2rem
}

.card .card-footer ul {
	margin: 0
}

.card.card-shadow {
	box-shadow: 0 5px 20px rgba(105, 106, 119, .05)
}

.card.card--dark {
	background: #fff
}

.card.card--dark .card-header {
	background: inherit;
	padding: 1.53333rem 2rem 2rem
}

.card.card--dark .card-header h5 {
	margin: 0
}

.card.card--sidebar .card-header {
	padding: 2rem
}

.card.card--sidebar .card-header h4 {
	margin: 0
}

.card.card--sidebar .card-body {
	padding: 2rem 2rem 3.33333rem
}

.card-one {
	margin-bottom: 2rem
}

.card-one figure {
	position: relative
}

.card-one figure figcaption {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background: rgba(6, 181, 144, .8);
	transition: all .3s ease;
	display: flex;
	justify-content: center;
	align-items: center;
	opacity: 0;
	visibility: hidden
}

.card-one figure figcaption a {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 3.33333rem;
	height: 3.33333rem;
	background: #fff;
	border-radius: 50%;
	font-size: 1.2rem;
	transition: all .3s ease;
	transform: scale(1.5)
}

.card-one figure figcaption a:hover {
	background: #413aa4;
	color: #fff
}

.card-one .card-subtitle {
	margin: 0 0 .66667rem 0;
	line-height: 1
}

.card-one:hover figure figcaption {
	opacity: 1;
	visibility: visible
}

.card-one:hover figure figcaption a {
	transform: scale(1)
}

.card-two .card-footer ul {
	display: flex;
	flex-wrap: wrap
}

.card-two .card-footer ul li {
	color: #9192a3;
	padding-right: 1rem;
	margin-right: 1rem;
	position: relative
}

.card-two .card-footer ul li:before {
	position: absolute;
	content: '|';
	right: 0;
	top: 0;
	color: #e4e8ed
}

.card-two .card-footer ul li:last-child {
	margin-right: 0
}

.card-two .card-footer ul li:last-child:before {
	content: none
}

.card-two .card-footer ul li a {
	color: #9192a3
}

.card-text,
.card-three,
.card-video {
	margin-bottom: 2rem !important
}

.card-text .card-subtitle,
.card-three .card-subtitle,
.card-video .card-subtitle {
	margin: 0 0 .66667rem 0
}

.card-text .card-text,
.card-three .card-text,
.card-video .card-text {
	margin-top: 1rem
}

.card-video figure {
	position: relative
}

.card-video figure figcaption {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background: rgba(32, 36, 40, .2);
	display: flex;
	justify-content: center;
	align-items: center
}

.card-video figure figcaption a {
	display: inline-flex;
	width: 3rem;
	height: 3rem;
	background: #fff;
	color: #06b590;
	border-radius: 50%;
	border: 2px solid transparent;
	justify-content: center;
	align-items: center
}

.card-video figure figcaption a .svg {
	width: .86667rem;
	fill: #06b590;
	transition: all .3s ease
}

.card-video figure figcaption a:hover {
	background: #06b590
}

.card-video figure figcaption a:hover .svg {
	fill: #fff
}

.card-text .card-body h5 {
	margin: 0 0 2rem 0
}

.card-text:last-child {
	margin-bottom: 0 !important
}

.card-four {
	margin-bottom: 2rem
}

.card-four .card-body .card-subtitle {
	margin-bottom: 4px
}

.card-four .card-body h5 {
	margin-bottom: 1.33rem
}

.card-four .card-body h5 a {
	color: #202428
}

.card-four .card-body .card-text {
	margin-bottom: 1.6rem
}

.card-product {
	margin-bottom: 2rem;
	position: relative
}

.card-product figure {
	position: relative;
	overflow: hidden
}

.card-product figure figcaption {
	position: absolute;
	width: 100%;
	left: 0;
	bottom: -76px;
	background: #413aa4;
	transition: all .3s ease;
	opacity: 0
}

.card-product figure figcaption ul {
	margin: 0;
	padding: .8rem 0
}

.card-product figure figcaption ul li:last-child {
	margin-left: .66rem
}

.card-product figure figcaption ul a.btn--rounded {
	border-color: rgba(255, 255, 255, .3);
	color: #fff
}

.card-product figure figcaption ul .like-btn {
	position: relative
}

.card-product figure figcaption ul .like-btn i {
	z-index: 2
}

.card-product figure figcaption ul .like-btn:hover {
	color: #413aa4;
	background: #fff
}

.card-product .card-body {
	text-align: center;
	padding: 1.66667rem 2rem
}

.card-product .card-body h6 {
	margin-bottom: 5px
}

.card-product .card-body h6 a {
	color: #202428;
	transition: all .3s ease
}

.card-product .card-body .prices {
	margin-top: .66667rem
}

.card-product .card-body .prices .product-price {
	font-size: 1.33rem;
	font-weight: 600;
	line-height: 1.2rem;
	display: inline-block
}

.card-product .card-body .prices .old-price {
	font-weight: 500;
	display: inline-block;
	margin-right: 7px;
	color: #9192a3;
	text-decoration: line-through
}

.card-product:hover figure figcaption {
	opacity: 1;
	bottom: 0
}

.card-product .badge {
	position: absolute;
	left: .66rem;
	top: .66rem;
	padding: 6px 10px;
	font-size: .8rem;
	font-weight: 500
}

.card-six .card-body h5 {
	margin-bottom: 1.33333rem
}

.card-six .card-body h5 a {
	color: #202428;
	transition: all .3s ease
}

.card-six .card-body h5 a:hover {
	color: #06b590
}

.card--seven .card-body {
	padding-bottom: 2rem
}

.card--seven .card-body h6 {
	margin-bottom: 1rem
}

.card--seven .card-body h6 a {
	transition: all .3s ease
}

.card--seven .card-body p {
	margin-bottom: 0
}

.card--seven .card-body .btn {
	margin-top: 1.66667rem
}

.card--seven:hover .card-body h5 a {
	color: #06b590
}

.card--eight .card-body {
	padding-bottom: 2rem
}

.card--eight .card-body h5 {
	margin-bottom: 1rem
}

.card--eight .card-body h5 a {
	transition: all .3s ease
}

.card--eight .card-body h5 a:hover {
	color: #06b590
}

.card--eight .card-body p {
	margin-bottom: 0
}

.card--eight .card-body .btn {
	margin-top: 1.66667rem
}

.card--ten {
	margin-bottom: 4.66667rem
}

.card--ten figure {
	margin-bottom: 0
}

.card--eleven {
	position: relative;
	border: 0 none;
	overflow: hidden
}

.card--eleven figure img {
	border-radius: .33333rem
}

.card--eleven .card-body {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	min-height: 100px;
	background: rgba(65, 58, 164, .7);
	visibility: visible;
	opacity: 1;
	transition: all .3s ease;
	padding: 1.33333rem 2rem;
	transition: all .3s ease
}

.card--eleven .card-body .card-contents .content-top {
	display: flex;
	text-align: left;
	align-items: center
}

.card--eleven .card-body .card-contents .content-top span {
	font-size: 2.4rem;
	color: #fff;
	margin-right: 1rem
}

.card--eleven .card-body .card-contents .content-top h6 {
	margin-bottom: 0
}

.card--eleven .card-body .card-contents .content-bottom {
	max-height: 0;
	transition: .5s ease;
	overflow: hidden
}

.card--eleven .card-body .card-contents .content-bottom p {
	margin-top: 1rem
}

.card--eleven .card-body h6 {
	color: #fff;
	margin-bottom: 0
}

.card--eleven .card-body p {
	color: rgba(255, 255, 255, .9);
	margin-bottom: 2rem
}

.card--eleven:hover .card-body {
	min-height: 100%
}

.card--eleven:hover .card-body .card-contents {
	position: absolute;
	width: 100%;
	left: 0;
	top: 50%;
	transform: translateY(-50%);
	padding: 0 2.66667rem
}

.card--eleven:hover .card-body .card-contents .content-top {
	display: block;
	text-align: center
}

.card--eleven:hover .card-body .card-contents .content-top span {
	display: none
}

.card--eleven:hover .card-body .card-contents .content-top h5 {
	margin-bottom: 2rem
}

.card--eleven:hover .card-body .card-contents .content-bottom {
	max-height: 300px
}

.card-twelve {
	border: 0 none;
	border-radius: 3px;
	box-shadow: 0 5px 30px rgba(105, 106, 119, .1)
}

.card-twelve .card-body {
	padding-bottom: 2rem
}

.card-twelve .card-body .step {
	display: block;
	font-size: 2.4rem;
	font-weight: 500;
	color: #06b590;
	line-height: 1
}

.card-twelve .card-body h6 {
	margin: 1rem 0;
	color: #202428
}

.card-twelve .card-body p {
	margin-bottom: 1.6rem
}

.card--fourteen {
	position: relative;
	border: 0 none
}

.card--fourteen:hover .card-body {
	visibility: visible;
	opacity: 1;
	bottom: 0
}

.card--fourteen figure {
	position: relative;
	border-radius: 4px;
	overflow: hidden
}

.card--fourteen .card-body {
	position: absolute;
	bottom: -50px;
	left: 0;
	width: 100%;
	background: rgba(55, 125, 255, .9);
	visibility: hidden;
	opacity: 0;
	transition: all .3s ease;
	padding: 1rem 2rem;
	transition: all .3s ease;
	border-radius: 0 0 4px 4px
}

.card--fourteen .card-body .card-contents .content-top h6 {
	margin-bottom: 0
}

.card--fourteen .card-body .card-contents .content-top h6 a {
	color: #fff
}

.card--fourteen .card-body .card-contents .content-top span {
	color: rgba(255, 255, 255, .8);
	margin-bottom: .33333rem;
	display: block
}

.card--testimonial {
	padding: 2rem;
	position: relative;
	z-index: 1
}

.card--testimonial:before {
	position: absolute;
	content: "\\f2ce";
	right: 2rem;
	top: 2rem;
	color: rgba(65, 58, 164, .1);
	font-size: 5.33333rem;
	font-family: LineAwesome;
	line-height: 1;
	z-index: -1
}

.card--testimonial .author {
	align-items: center
}

.card--testimonial .author .author-spec {
	margin-left: 1rem
}

.card--testimonial .author .author-spec h6 {
	margin-bottom: .53333rem
}

.card--testimonial .content {
	margin-top: 1.33333rem
}

.card--testimonial .content p {
	margin: 0
}

.card--testimonial2 {
	margin-bottom: 2rem;
	border: 1px solid #f3f3f3 !important
}

.card--testimonial2 .card-body h6 {
	padding-top: 18px;
	color: #202428
}

.card--testimonial2 .ratings {
	margin: .33333rem 0 1rem 0;
	display: flex;
	justify-content: center
}

.card--testimonial2 .ratings span {
	margin: 0 1px 0 0
}

.card--testimonial2 .ratings span:last-child {
	margin--right: 0
}

.card--testimonial2 .author-spec {
	margin-top: 1.33333rem;
	margin-bottom: 0
}

.card--testimonial2 .author-spec strong {
	font-weight: 500;
	color: #202428
}

.team-carousel-one .nav-square {
	visibility: hidden;
	opacity: 0;
	transition: all .3s ease
}

.team-carousel-one:hover .nav-square {
	visibility: visible;
	opacity: 1
}

.card--team1 {
	border: 1px solid #f3f3f3 !important
}

.card--team1 .card-body {
	padding: 2rem
}

.card--team1 .card-body h6 {
	margin: 1.33333rem 0 .66667rem 0
}

.card--team1 .card-body .team-designation {
	padding: 0 1rem;
	line-height: 2rem;
	display: inline-block;
	background: rgba(6, 181, 144, .1);
	border-radius: 3px;
	color: #06b590
}

.card--team1 .card-body .team-social {
	margin: 1.66667rem 0 0 0
}

.card--team1 .card-body .team-social li {
	margin-right: .66667rem
}

.card--team1 .card-body .team-social li:last-child {
	margin-right: 0
}

.card--team1 .card-body .team-social li a {
	color: rgba(145, 146, 163, .7);
	font-size: .93333rem;
	width: 2.26667rem;
	height: 2.26667rem;
	border-radius: 20rem;
	background: rgba(245, 247, 252, .5);
	display: flex;
	align-items: center;
	justify-content: center
}

.card--team1 .card-body .team-social li a:hover {
	color: #fff
}

.card--team2 {
	border-radius: 0;
	border: 0 none
}

.card--team2 figure {
	position: relative;
	overflow: hidden;
	margin-bottom: .66667rem
}

.card--team2 figure figcaption {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background: #413aa4;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	opacity: 0;
	visibility: hidden;
	transform: scale(.9);
	transition: .4s ease
}

.card--team2 figure figcaption .team-social {
	margin: 0 0 2.66667rem 0
}

.card--team2 figure figcaption .team-social li {
	margin-right: 1.33333rem
}

.card--team2 figure figcaption .team-social li:last-child {
	margin-right: 0
}

.card--team2 figure figcaption .team-social li a {
	color: #fff;
	font-size: 1.06667rem
}

.card--team2 figure figcaption .btn-outline-light {
	color: #fff
}

.card--team2 .card-body {
	padding: 1rem;
	text-align: center
}

.card--team2 .card-body h6 {
	color: #fff;
	margin-bottom: .33333rem
}

.card--team2 .card-body span {
	color: rgba(255, 255, 255, .7)
}

.card--team2:hover figure figcaption {
	opacity: 1;
	visibility: visible;
	transform: scale(1)
}

.card--team3 {
	border: 0 none;
	box-shadow: 0 5px 20px rgba(105, 106, 119, .05);
	border-radius: 4px;
	overflow: hidden;
	margin-bottom: 2rem
}

.card--team3 .card__thumbnail img {
	width: 100%
}

.card--team3 .card-body {
	padding: 1.6rem 2rem
}

.card--team3 .card-body>p {
	margin-bottom: 25px
}

.card--team3 .card-body h6 {
	margin-bottom: .33333rem;
	color: #202428
}

.card--team3 .card-body .subtitle {
	display: block;
	margin-bottom: 1rem;
	font-size: .93333rem;
	color: #9192a3
}

.card.card--team4 {
	margin-bottom: 2rem;
	flex-direction: row;
	align-items: center
}

.card.card--team4 .team-image {
	flex: none
}

.card.card--team4 .team-info h6 {
	margin-bottom: 5px
}

.card.card--team4 .team-info h6 a {
	transition: all .3s ease
}

.card.card--team4 p {
	margin: 0
}

.card.card--team4:hover .team-info h5 a {
	color: #413aa4
}

.post--card {
	transition: all .3s ease;
	box-shadow: 0 5px 20px rgba(105, 106, 119, .05)
}

.post--card .card-body h6 {
	margin: 0 0 .66667rem 0
}

.post--card .card-body h6 a {
	color: #202428;
	transition: all .3s ease
}

.post--card .card-body h6 a:hover {
	color: #413aa4
}

.post--card .card-body .post-meta {
	margin-bottom: 1rem
}

.post--card .card-body .post-meta li {
	color: #9192a3;
	margin-right: 1rem
}

.post--card .card-body .post-meta li:last-child {
	margin-right: 0
}

.post--card .card-body p {
	margin-bottom: 0
}

.post--card2 figure {
	padding: 1.33333rem 1.33333rem 0;
	position: relative
}

.post--card2 figure figcaption {
	position: absolute;
	left: 2.66667rem;
	bottom: 1.33333rem
}

.post--card2 figure figcaption a {
	width: 2.66667rem;
	height: 2.66667rem;
	border-radius: 50%;
	background: #e23636;
	color: #fff;
	display: flex;
	justify-content: center;
	align-items: center
}

.post--card2 .card-body h5 {
	margin-bottom: .66667rem
}

.post--card2 .card-body .post-meta {
	padding-bottom: 1.33333rem;
	margin-bottom: 1.33333rem;
	border-bottom: 1px solid #e4e8ed;
	flex-wrap: wrap
}

.post--card2 .card-body .post-meta li a {
	color: #202428;
	transition: all .3s ease
}

.post--card2 .card-body .post-meta li a:hover {
	color: #413aa4
}

.post--card2.post--card3 figure {
	padding: 0
}

.post--card2.post--card3 figure figcaption {
	left: 1.33333rem
}

.post--card2.post--card3 .card-body h6 {
	margin-bottom: .66667rem;
	line-height: 1.86667rem
}

.post--card2.post--card3 .card-body .post-meta {
	padding-bottom: 1.2rem;
	margin-bottom: .8rem
}

.card--rounded {
	border-radius: .53333rem
}

.card--team1,
.card--team2,
.card-style-eight .card--eight,
.card-style-eleven .card--eleven,
.card-style-fourteen .card--fourteen,
.card-style-nine .card--nine,
.card-style-seven .card--seven,
.card-style-twelve .card-twelve,
.card-style-two .card-two,
.post--card1 .post--card {
	margin-bottom: 2rem
}

.post--card4 {
	box-shadow: 0 5px 30px rgba(105, 106, 119, .1);
	border: 0 none;
	margin-bottom: 2rem
}

.post--card4:hover {
	border: 0 none
}

.post--card4 .card-body .post-meta {
	margin-bottom: 0
}

.divider h1,
.divider h2 {
	margin-bottom: .33333rem
}

.divider .divider-split {
	display: inline-block;
	width: 5.66rem;
	height: .33333rem;
	position: relative
}

.divider .divider-split:before {
	position: absolute;
	content: '';
	width: 4rem;
	height: 100%;
	left: 0;
	top: 0;
	background: #413aa4;
	border-radius: 3.33333rem
}

.divider .divider-split:after {
	position: absolute;
	content: '';
	width: 1rem;
	height: 100%;
	right: 0;
	top: 0;
	background: #413aa4;
	border-radius: 3.33333rem
}

.divider .divider-straight {
	display: inline-block;
	width: 4.66rem;
	height: .33333rem;
	background: #413aa4;
	border-radius: 50px
}

.divider .divider-line {
	display: block;
	height: 1px;
	background: #e4e8ed
}

.divider p {
	margin: 1rem 0 0 0;
	font-size: 18px
}

.divider.text-center p {
	max-width: 40rem
}

.divider.divider-light {
	margin-bottom: 3.13333rem
}

.divider.divider-light .divider-split:before {
	background: #fff
}

.divider.divider-light .divider-split:after {
	background: #fff
}

.divider.divider-simple h3 {
	margin-bottom: 1rem
}

.divider.divider-simple h2 {
	margin-bottom: 1.33333rem
}

.section-title-simple {
	width: 40rem;
	margin: 0 auto;
	text-align: center
}

.section-title-simple h1 {
	margin-bottom: 20px
}

.subtext {
	font-size: 1.33333rem;
	font-weight: 600;
	display: block;
	margin-bottom: .33333rem
}

.section-title-primary {
	text-align: center;
	margin-bottom: 3rem
}

.section-title-primary h3 {
	color: #202428;
	margin: 0 0 1rem;
	line-height: 2.93333rem
}

.section-title-primary p {
	color: #202428;
	margin: 0
}

.flip-card {
	margin-bottom: 2rem
}

.flip-card .flip-wrapper {
	perspective: 1000px;
	transform: perspective(1000px);
	transform-style: preserve-3d;
	position: relative;
	width: 100%;
	min-height: 22rem
}

.flip-card .flip-back,
.flip-card .flip-front {
	width: 100%;
	height: 100%;
	border-radius: .33333rem;
	box-shadow: 0 5px 10px rgba(105, 106, 119, .05)
}

.flip-card .flip-front {
	transition: transform .6s cubic-bezier(.5, .3, .3, 1);
	overflow: hidden;
	position: absolute;
	top: 0;
	backface-visibility: hidden;
	-webkit-filter: blur(0);
	transform: rotateY(0);
	transform-style: preserve-3d;
	z-index: 1
}

.flip-card .flip-back {
	transition: transform .6s cubic-bezier(.5, .3, .3, 1);
	overflow: hidden;
	position: absolute;
	top: 0;
	backface-visibility: hidden;
	-webkit-filter: blur(0);
	transform: rotateY(180deg);
	transform-style: preserve-3d;
	z-index: 1
}

.flip-card .flip-wrapper:hover .flip-front {
	transform: rotateY(-180deg);
	transform-style: preserve-3d
}

.flip-card .flip-wrapper:hover .flip-back {
	transform: rotateY(0);
	transform-style: preserve-3d
}

.flip-card .flip-wrapper:hover .front-contents {
	transform: translateY(-50%) translateX(-650px) scale(1);
	transform-style: preserve-3d
}

.flip-card .flip-wrapper:hover .back-contents {
	transform: translateY(-50%) translateX(0) translateZ(0) scale(1);
	transform-style: preserve-3d
}

.flip-card .back-contents,
.flip-card .front-contents {
	text-align: center;
	padding: 0 3rem;
	position: relative;
	top: 50%;
	transition: transform .6s cubic-bezier(.5, .3, .3, 1);
	transform-style: preserve-3d;
	z-index: 2
}

.flip-card .back-contents h6,
.flip-card .front-contents h6 {
	line-height: 2rem;
	margin-bottom: 1rem
}

.flip-card .front-contents {
	transform: translateY(-50%) translateX(0) scale(1)
}

.flip-card .front-contents span {
	font-size: 4rem
}

.flip-card .back-contents {
	transform: translateY(-50%) translateX(650px) translateZ(60px) scale(.88)
}

.flip-card .back-contents p {
	color: rgba(255, 255, 255, .6)
}

.flip-card .back-contents .btn {
	margin-top: 1.66rem
}

.flip-card .flip-overlay,
.flip-card .flip-overlay2 {
	display: block;
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0
}

.flip-card .flip-overlay {
	background: #fff
}

.icon-box span {
	font-size: 2.66667rem;
	margin-bottom: 1.33333rem;
	display: inline-block;
	line-height: 1
}

.icon-box h6 {
	margin-bottom: 1.13333rem
}

.icon-box p {
	margin: 0
}

.icon-box-one,
.icon-box-two {
	margin-bottom: 3.33333rem
}

.icon-box-two h5 {
	font-weight: 500
}

.icon-box-three {
	margin-bottom: 2rem;
	background: #fff;
	border-radius: .3rem;
	box-shadow: 0 5px 10px rgba(105, 106, 119, .05);
	padding: 3rem 2rem;
	position: relative
}

.icon-box-three:before {
	position: absolute;
	content: "";
	width: 100%;
	height: 3px;
	background: #413aa4;
	left: 0;
	bottom: 0;
	margin: 0;
	visibility: hidden;
	transition: .5s ease;
	border-radius: 0 0 6px 6px;
	transform: scale(0)
}

.icon-box-three:hover:before {
	transform: scale(1);
	visibility: visible
}

.icon-box-three h6 {
	margin-bottom: 1.13333rem
}

.icon-box-three p {
	margin-bottom: 0
}

.icon-rounded-lg {
	display: inline-flex;
	width: 5.33333rem;
	height: 5.33333rem;
	background: #413aa4;
	font-size: 2.4rem;
	justify-content: center;
	align-items: center;
	color: #fff;
	border-radius: 50%;
	margin-bottom: 2rem
}

.icon-box-four {
	margin-bottom: 3.33333rem
}

.icon-box-four .box-icon {
	margin-right: 2rem
}

.icon-box-four .box-content h6 {
	margin: 0 0 1.13333rem 0;
	color: #202428
}

.icon-box-four .box-content p {
	margin: 0
}

.icon-box-four:hover .icon-rounded-sm {
	background: #06b590
}

.icon-rounded-sm,
.icon-square-sm {
	display: inline-flex;
	width: 4rem;
	height: 4rem;
	background: #413aa4;
	font-size: 2rem;
	justify-content: center;
	align-items: center;
	color: #fff;
	transition: all .3s ease
}

.icon-rounded-sm {
	border-radius: 50%;
	margin-bottom: 1.33333rem
}

.icon-square-sm {
	border-radius: 4px
}

.icon-box-five {
	padding: 2.66rem;
	transition: all .3s ease
}

.icon-box-five .icon-rounded-sm {
	background: #06b590
}

.icon-box-five h6 {
	transition: all .3s ease;
	margin-bottom: 1.13333rem;
	color: #202428
}

.icon-box-five p {
	margin-bottom: 2.33rem
}

.icon-box-five:hover {
	background: #fff;
	box-shadow: 0 5px 30px rgba(105, 106, 119, .1)
}

.icon-box-five:hover .icon-rounded-sm {
	background: #413aa4
}

.icon-box-five:hover h5 {
	color: #413aa4
}

.icon-box-five:hover .btn:hover {
	background: #413aa4;
	border-color: #413aa4
}

.icon-box-four h6 {
	color: #202428
}

.icon-box-four .icon-square-sm {
	margin-bottom: 2.33rem
}

.icon-box-four:hover .icon-square-sm {
	background: #06b590
}

.icon-box-eight {
	margin-bottom: 3.33333rem
}

.icon-box-eight h6 {
	margin: 0 0 1.13333rem 0;
	color: #202428
}

.icon-box-eight .icon-square-sm {
	background: 0 0;
	border: 1px solid #06b590;
	color: #06b590;
	margin-bottom: 2.33rem
}

.icon-box-eight p {
	margin-bottom: 0
}

.icon-box-eight:hover .icon-square-sm {
	background: #06b590;
	border-color: #06b590;
	color: #fff
}

.icon-box-nine {
	margin-bottom: 2rem;
	background: #fff;
	border-radius: .3rem;
	box-shadow: 0 5px 10px rgba(105, 106, 119, .05);
	padding: 2rem 1.5rem
}

.icon-box-nine .icon-rounded-sm {
	background: 0 0;
	border: 1px solid rgba(6, 181, 144, .2);
	color: #06b590
}

.icon-box-nine h6 {
	margin: 0
}

.icon-box-nine p {
	margin: 1rem 0 0 0
}

.icon-box-nine:hover .icon-rounded-sm {
	background: #06b590;
	border-color: #06b590;
	color: #fff
}

.icon-box-img {
	border: 1px solid #e4e8ed;
	padding: 3rem 2rem;
	transition: all .3s ease;
	margin-bottom: 2rem
}

.icon-box-img .svg {
	width: 5.33333rem;
	margin-bottom: 1.33rem
}

.icon-box-img h6 {
	margin-bottom: 1.13333rem
}

.icon-box-img p {
	margin-bottom: 0
}

.icon-box-img h6,
.icon-box-img p {
	transition: all .3s ease
}

.icon-box-img:hover {
	box-shadow: 0 5px 10px rgba(105, 106, 119, .05)
}

.icon-box-img2 {
	margin-bottom: 5.33rem
}

.icon-box-img2 .box-icon {
	margin-right: 2rem
}

.icon-box-img2 .box-icon .svg {
	width: 4.66667rem
}

.icon-box-img2 .box-content h6 {
	margin: 0 0 1.13333rem 0
}

.icon-box-img2 .box-content p {
	margin: 0
}

.icon-box-rtl {
	margin-bottom: 4rem
}

.icon-box-rtl .box-icon {
	margin-left: 2rem
}

.icon-box-rtl h5 {
	margin-bottom: 1.13333rem
}

.icon-box-rtl:hover .icon-square-sm {
	background: #06b590
}

.icon-box-13 {
	margin-bottom: 2rem;
	padding: 3.33333rem;
	border: 1px solid #e4e8ed
}

.icon-box-13>span {
	font-size: 3.2rem
}

.icon-box-fourteen {
	margin-bottom: 2rem
}

.icon-box-fourteen .icon-rounded {
	font-size: 2.4rem;
	width: 4.66667rem;
	height: 4.66667rem;
	border-radius: 1.6rem;
	color: #fff;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 2rem;
	transition: all .3s ease
}

.icon-box-fourteen:hover .icon-rounded {
	background: #413aa4 !important
}

.icon-box-15 {
	border: 1px solid #e4e8ed;
	padding: 3.33333rem 1.86667rem;
	background: #fff;
	transition: all .3s ease;
	margin-bottom: 2rem
}

.icon-box-15 img {
	margin-bottom: 2.66667rem
}

.icon-box-15 h6 {
	color: #202428;
	margin-bottom: 1.33333rem
}

.icon-box-15:hover {
	border-color: transparent;
	box-shadow: 0 10px 30px rgba(105, 106, 119, .15);
	margin-top: -5px;
	margin-bottom: 5px
}

ul {
	margin: 0
}

.list-item {
	display: flex;
	align-items: flex-start
}

.arrow-list1 {
	font-weight: 500;
	margin-bottom: .45rem;
	vertical-align: middle
}

.arrow-list1:last-child {
	margin-bottom: 0
}

.arrow-list1:before {
	content: "\\f121";
	font-family: Lineawesome, sans-serif;
	margin-right: 10px
}

.arrow-list2,
.arrow-list3,
.arrow-list5 {
	margin-bottom: .8rem
}

.arrow-list2:last-child,
.arrow-list3:last-child,
.arrow-list5:last-child {
	margin-bottom: 0
}

.arrow-list2 span,
.arrow-list3 span,
.arrow-list5 span {
	width: 1.4rem;
	height: 1.4rem;
	border-radius: 50%;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: .66667rem;
	margin-right: .86rem;
	color: #413aa4
}

.arrow-list2 span,
.arrow-list5 span {
	background: rgba(65, 58, 164, .1)
}

.arrow-list3 span {
	background: #413aa4;
	color: #fff
}

.arrow-list4 {
	margin-bottom: .66rem;
	position: relative;
	padding-left: 18px
}

.arrow-list4:before {
	position: absolute;
	content: '\\f186';
	font-family: LineAwesome;
	left: 0;
	top: 2px;
	font-size: .8rem
}

.arrow-list4:last-child {
	margin-bottom: 0
}

.arrow-list4 span {
	color: #9192a3;
	padding-right: .33333rem
}

.arrow-list5 {
	font-weight: 500
}

.content-list {
	margin-bottom: 2.66667rem
}

.content-list:last-child {
	margin-bottom: 0
}

.content-list .icon {
	margin-right: 1rem;
	font-size: 2rem;
	line-height: 1
}

.content-list h6 {
	margin-bottom: .46667rem
}

.content-list p {
	margin-bottom: 0
}

.content-list .icon-circle {
	margin-right: 2rem
}

.content-list .icon-circle span {
	width: 4rem;
	height: 4rem;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #f5f4f7;
	font-size: 1.73rem;
	transition: all .3s ease
}

.content-list:hover .icon-circle span {
	background: #06b590;
	color: #fff
}

.icon-light {
	margin-bottom: 0
}

.icon-light .content-list .icon-circle span {
	color: #fff
}

.icon-light .content-list:hover .icon-circle span {
	background: #06b590;
	color: #fff
}

.text-list {
	margin-bottom: 2rem
}

.text-list:last-child {
	margin-bottom: 0
}

.text-list h5,
.text-list h6 {
	color: #202428;
	margin-bottom: 1.2rem
}

.text-list p {
	margin-bottom: 0
}

.text-list .sub-text {
	font-size: 1.2rem;
	font-weight: 400;
	display: block;
	margin-bottom: .66rem
}

.image-list {
	margin-bottom: 2.33333rem
}

.image-list:last-child {
	margin-bottom: 0
}

.image-list .img {
	margin-right: 1.66rem
}

.image-list .img img {
	border-radius: 50%
}

.image-list h6 {
	margin-bottom: .66rem;
	color: #202428
}

.image-list .sub-text {
	margin-bottom: 1rem;
	display: block;
	color: #9192a3
}

.image-list p {
	margin: 0
}

.bullet_list {
	position: relative;
	padding-left: 1.66rem;
	margin-bottom: .66rem
}

.bullet_list:last-child {
	margin-bottom: 0
}

.bullet_list:before {
	position: absolute;
	content: "";
	width: 7px;
	height: 7px;
	border-radius: 50%;
	left: 0;
	top: 6px
}

.bullet_list strong {
	font-weight: 500
}

.bullet_list p {
	margin: 0
}

.bullet_list.bullet_list--three {
	margin-bottom: 1.66667rem
}

.bullet_list.bullet_list--three:last-child {
	margin-bottom: 0
}

.checklist {
	margin-bottom: .66667rem;
	display: flex;
	align-items: center
}

.checklist:last-child {
	margin-bottom: 0
}

.checklist span {
	font-size: 1rem;
	font-weight: 700;
	margin-right: .93rem
}

.checklist.checklist-light {
	color: #fff;
	display: flex;
	align-items: center
}

.checklist.checklist-light .svg {
	width: 1.2rem;
	fill: #fff
}

.checklist.checklist-light span {
	font-weight: 400;
	margin-left: .8rem
}

.blog-carousel-one .post-single .post-bottom a.checklist.checklist-light .svg,
.card .card-body h6 a.checklist.checklist-light .svg,
.card--eight .card-body h5 a.checklist.checklist-light .svg,
.card--ten .card-body h6 a.checklist.checklist-light .svg,
.checklist.checklist-light.color-dark .svg,
.counter.counter--5 .counter_single .checklist.checklist-light.title .svg,
.tab.tab--1 .tab_nav .nav .checklist.checklist-light.nav-link .svg,
footer.footer2 .widget.twit--widget a.checklist.checklist-light:hover .svg {
	fill: #202428
}

.checklist .svg {
	margin-right: 8px;
	width: .8rem
}

@media all and (-ms-high-contrast:none),
(-ms-high-contrast:active) {
	.checklist .svg {
		height: 12px
	}
}

.checklist.icon-primary .svg .st0 {
	fill: #413aa4
}

.checklist.icon-secondary .svg .st0 {
	fill: #06b590
}

.checklist.icon-light .svg .st0 {
	fill: #fff
}

.checklist.icon-dark .svg .st0 {
	fill: #202428
}

.checklist-three {
	display: flex;
	align-items: center;
	margin-bottom: .66667rem;
	font-weight: 500
}

.checklist-three:last-child {
	margin-bottom: 0
}

.checklist-three .svg {
	width: .8rem
}

@media all and (-ms-high-contrast:none),
(-ms-high-contrast:active) {
	.checklist-three .svg {
		height: 12px
	}
}

.checklist-three .svg .st0 {
	fill: #06b590
}

.checklist-three span {
	margin-left: .66667rem
}

.checklist-three.checklist-light span {
	color: #fff;
	font-weight: 400
}

.checklist-three.checklist-light .svg .st0 {
	fill: #fff
}

.icon-list {
	margin-bottom: 1rem
}

.icon-list:last-child {
	margin-bottom: 0
}

.icon-list span {
	font-size: 1.33rem;
	padding-right: .66rem;
	line-height: 0
}

.icon-list strong {
	font-weight: 500;
	color: #202428;
	margin-right: 1rem
}

.icon-list.list-light {
	color: rgba(255, 255, 255, .5)
}

.icon-list.list-light strong {
	color: #fff
}

.icon-list2 {
	margin-bottom: 2rem
}

.icon-list2:last-child {
	margin-bottom: 0
}

.icon-list2 .icon {
	font-size: 1.8rem;
	line-height: 1;
	margin-right: 1rem
}

.icon-list2 h6 {
	margin-bottom: .6rem;
	color: #202428;
	font-weight: 500;
	font-size: 1.13333rem
}

.icon-list2 .sub-text {
	color: #9192a3
}

.icon-list2.list-light h6 {
	color: #fff
}

.icon-list--two .icon-list {
	display: flex
}

.number-list {
	list-style: none;
	counter-reset: li;
	padding: 0
}

.number-list li {
	counter-increment: li;
	margin-bottom: .66rem;
	position: relative;
	padding-left: 2rem
}

.number-list li:last-child {
	margin-bottom: 0
}

.number-list li:before {
	content: counter(li);
	display: inline-block;
	width: 1em;
	text-align: right;
	direction: rtl;
	position: absolute;
	left: 0;
	top: 0;
	font-weight: 500
}

.number-list li.numbers-decimal-zero:before {
	content: counter(li, decimal-leading-zero);
	color: #202428
}

.number-list li.numbers-decimal-zero.list-light:before {
	color: #fff
}

.number-list li.numbers-roman:before {
	content: counter(li, lower-roman)
}

.number-list li.list-light {
	color: rgba(255, 255, 255, .7)
}

.process-list {
	margin: 0
}

.process-list li {
	margin-bottom: 2rem
}

.process-list li:last-child {
	margin-bottom: 0
}

.process-list li:last-child .number span:before {
	content: none
}

.process-list li:hover .number span {
	background: #06b590;
	color: #fff
}

.process-list .number {
	margin-right: 2rem
}

.process-list .number.gray-bg span {
	background: rgba(6, 181, 144, .1)
}

.process-list .number span {
	width: 4.53333rem;
	height: 4.53333rem;
	background: #fff;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.6rem;
	font-weight: 600;
	color: #06b590;
	position: relative;
	transition: all .3s ease
}

.process-list .content h6 {
	margin-bottom: .66667rem;
	color: #202428;
	font-weight: 600
}

.process-list .content p {
	margin: 0
}

.list-inline-wrapper {
	box-shadow: 0 5px 30px rgba(41, 41, 59, .1)
}

.list-inline-wrapper .list--inline {
	margin: 0;
	justify-content: space-between;
	flex-wrap: wrap
}

.list-inline-wrapper .list--inline li {
	margin-bottom: 2rem;
	flex: 1 1
}

.list-inline-wrapper .list--inline li .icon {
	margin-right: 1rem
}

.list-inline-wrapper .list--inline li .icon span {
	font-size: 3.33333rem;
	display: block;
	line-height: 2rem
}

.list-inline-wrapper .list--inline li .contents h6 {
	font-weight: 600;
	color: #202428;
	margin: 0 0 5px
}

.list-count {
	margin-bottom: 1rem
}

.list-count:last-child {
	margin-bottom: 0
}

.list-count span {
	color: #202428;
	transition: all .3s ease
}

.list-count .count {
	min-width: 3rem;
	height: 1.66667rem;
	border-radius: 1.66667rem;
	background: #f5f7fc;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all .3s ease
}

.list-count a:hover span {
	color: #413aa4
}

.list-count a:hover .count {
	color: #fff;
	background: #413aa4
}

.progress-wrapper {
	margin-bottom: 2rem
}

.progress-wrapper:last-child {
	margin-bottom: 0
}

.progress-wrapper .labels {
	margin-bottom: .66rem
}

.progress-wrapper .labels span {
	color: #202428
}

.progress-wrapper .labels span:last-child {
	font-weight: 600
}

.progress-wrapper .progress {
	box-shadow: none
}

.progress-wrapper .progress .progress-bar {
	border-radius: .25rem
}

.progress-dark {
	padding: 2.33rem 2.66rem;
	background: #202428
}

.progress-dark .labels span {
	color: #fff
}

.progress-dark .progress {
	background: #414144
}

.pagination-area .pagination .page-item:first-child .page-link,
.pagination-area .pagination .page-item:last-child .page-link {
	color: #5a6671
}

.pagination-area .pagination .page-item:first-child .page-link {
	border-top-left-radius: .2rem;
	border-bottom-left-radius: .2rem
}

.pagination-area .pagination .page-item:last-child .page-link {
	border-top-right-radius: .2rem;
	border-bottom-right-radius: .2rem
}

.pagination-area .pagination .page-item.active .page-link {
	color: #fff;
	background: #413aa4;
	border-color: #413aa4
}

.pagination-area .pagination .page-item.active .page-link:hover {
	background: #413aa4
}

.pagination-area .pagination .page-link {
	color: #202428
}

.pagination-area .pagination .page-link:hover {
	background: #fff;
	border-color: #413aa4
}

.pagination-area .pagination .page-link:focus {
	box-shadow: none
}

.pagination-area .pagination.pagination-rounded .page-item {
	margin-right: .66rem
}

.pagination-area .pagination.pagination-rounded .page-item:last-child {
	margin-right: 0
}

.pagination-area .pagination.pagination-rounded .page-link {
	border-radius: 50% !important;
	width: 2.66667rem;
	height: 2.66667rem;
	padding: 0;
	display: flex;
	justify-content: center;
	align-items: center
}

.table-styles {
	background: #f4f4f4
}

.table-secondary--darken {
	background: #06b590
}

.table-secondary--darken th,
.table-secondary--darken tr {
	color: #fff
}

.table {
	margin-bottom: 0
}

.table td,
.table th {
	padding: 1.33333rem 2rem;
	vertical-align: middle
}

.table th {
	font-weight: 500
}

.table thead th {
	border: 0 none
}

.table tbody {
	background: #fff
}

.table tbody th {
	color: #202428
}

.table.table-one {
	border: 1px solid #e4e8ed
}

.table.table-two thead th {
	font-size: 1.2rem;
	color: #202428
}

.table.table-two tbody tr:first-child td,
.table.table-two tbody tr:first-child th {
	border-top: 0 none
}

.table.table-two tbody tr:last-child td,
.table.table-two tbody tr:last-child th {
	border-bottom: 1px solid #e4e8ed
}

.table.table-two tbody th {
	padding: 1.66rem 1.66rem 1.66rem 0
}

.table .table-gray {
	background: #f5f5f7
}

.line-chart_wrap h6 {
	font-weight: 600;
	color: #202428;
	margin-bottom: 2.66667rem
}

.legend ul {
	margin-top: 1.33333rem;
	margin-bottom: 0
}

.legend ul li {
	display: inline-block;
	margin-right: 1.33333rem
}

.legend ul li:last-child {
	margin-right: 0
}

.legend ul li span {
	width: .8rem;
	height: .8rem;
	display: inline-block;
	border-radius: 2px;
	margin-right: .46667rem
}

.legend.legend-list {
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%)
}

.legend.legend-list ul li {
	display: block
}

.pie-chart {
	position: relative
}

.block-full-width,
.block-full-width2 {
	min-height: 37.66667rem;
	position: relative;
	display: flex;
	align-items: center;
	background: #f2f2f2
}

@media all and (-ms-high-contrast:none),
(-ms-high-contrast:active) {

	.block-full-width,
	.block-full-width2 {
		padding-top: 30px
	}
}

.block-full-width .img,
.block-full-width2 .img {
	position: absolute;
	left: 0;
	top: 0;
	width: 50%;
	height: 100%
}

.block-full-width2 {
	background: 0 0
}

.block-full-width2 .img {
	position: absolute;
	right: 0;
	left: auto;
	top: 0;
	width: 50%;
	height: 100%
}

.feature-boxes .icon-box-nine {
	margin-bottom: 2rem
}

.section-feature-boxes {
	overflow: hidden
}

.section-feature-boxes .container {
	position: relative
}

.section-feature-boxes .section-img {
	position: absolute;
	left: 0;
	top: 50%;
	transform: translateY(-50%)
}

.section-feature-boxes .feature-boxes {
	margin-bottom: -30px
}

.content--block3 .content_block3_wrapper {
	padding-bottom: 4.66667rem
}

.content--block3 .content_block3_wrapper:last-child {
	padding-bottom: 0
}

.content--block3 .content_block3_wrapper+.content_block3_wrapper {
	padding-top: 4.66667rem
}

.content--block3 .content_block3_wrapper:nth-child(2n+2) {
	flex-direction: row-reverse
}

@media (min-width:992px) {
	.content--block3 .content_block3_wrapper:nth-child(2n+2) .offset-lg-1 {
		margin-left: 0;
		margin-right: 8.33333%
	}
}

.content--block3 .content_block3_wrapper+.content_block3_wrapper {
	border-top: 1px solid #e4e8ed
}

.content--block3 h4 {
	color: #202428
}

.content-block--12 {
	position: relative
}

.content-block--12 .counter-wrapper {
	position: relative
}

.content-block--12 .counter-wrapper .counter--alt {
	padding: 6.06667rem 0 11.33333rem
}

.content-block--12 .clients-logo {
	padding: 13.33333rem 0 6.66667rem
}

.content-block--12 .highlighted-text {
	position: absolute;
	width: 100%;
	left: 0;
	bottom: 0;
	transform: translateY(50%);
	z-index: 1
}

.content-block--12 .highlighted-text .content {
	background: #fff;
	box-shadow: 0 5px 30px rgba(105, 106, 119, .1);
	min-height: 14.66667rem;
	padding: 0 6.66667rem
}

@media all and (-ms-high-contrast:none),
(-ms-high-contrast:active) {
	.content-block--12 .highlighted-text .content {
		height: 220px
	}
}

.content-block--12 .highlighted-text .content p {
	font-size: 1.6rem;
	line-height: 2.93333rem;
	color: #202428;
	font-weight: 600;
	margin-bottom: 0
}

.content-block--15 {
	padding: 6.8rem 0 7.33333rem;
	background: linear-gradient(to bottom, #fff, #f8f7fd)
}

.content-block--15 .section-title {
	text-align: center;
	margin-bottom: 2.33333rem
}

.content-block--15 .section-title h2 {
	color: #202428
}

.content-block--15 .section-title p {
	color: #202428
}

.content-block--15 .content-desc h4 {
	color: #202428
}

.content-block--6 {
	background: #fff
}

.content--block8 h4 {
	margin-bottom: 20px
}

.section_title h1 {
	font-weight: 600;
	margin-bottom: 3.46667rem
}

.section_title .section_title_underline {
	width: 70px;
	background: #413aa4;
	display: inline-block;
	height: 5px;
	border-radius: 10px
}

.contact-split {
	position: relative;
	height: 720px
}

.contact-split .g-maps {
	position: absolute;
	height: 100%;
	left: 0;
	top: 0;
	width: 50%
}

.contact-split .g-maps #map2 {
	height: 100%
}

.contact-split .g-maps .map-top {
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	background: #fff;
	padding: 55px 40px;
	border-radius: 8px 0 0 8px;
	box-shadow: 0 5px 30px rgba(41, 41, 59, .1)
}

.contact-split .g-maps .map-top ul {
	margin: 0
}

.filter-wrapper .filter-sort {
	margin-bottom: 50px;
	display: flex;
	justify-content: center
}

.filter-wrapper .filter-sort ul {
	display: inline-block;
	justify-content: center;
	background: #fff;
	box-shadow: 0 5px 30px rgba(105, 106, 119, .1);
	border-radius: 1.66667rem;
	margin: 0
}

.filter-wrapper .filter-sort ul li {
	float: left;
	color: #202428;
	font-weight: 400;
	line-height: 3.33333rem;
	padding: 0 1.66667rem;
	cursor: pointer;
	transition: all .3s ease;
	border-radius: 1.66667rem
}

.filter-wrapper .filter-sort ul li.active,
.filter-wrapper .filter-sort ul li:hover {
	color: #fff
}

.filter-wrapper .filter-sort2 ul {
	padding-bottom: 1.33333rem;
	margin-bottom: 3.33333rem;
	border-bottom: 1px solid #e4e8ed;
	display: flex;
	flex-wrap: wrap;
	justify-content: center
}

.filter-wrapper .filter-sort2 ul li {
	margin-right: 2.33333rem;
	color: #202428;
	font-weight: 500;
	cursor: pointer;
	transition: all .3s ease
}

.filter-wrapper .filter-sort2 ul li.active,
.filter-wrapper .filter-sort2 ul li:hover {
	color: #06b590
}

.filter-wrapper .filter-sort2 ul li:last-child {
	margin-right: 0
}

.event-single {
	margin-bottom: 130px;
	height: 13.33333rem;
	align-items: center;
	box-shadow: 0 5px 30px rgba(105, 106, 119, .05)
}

.event-single .event-date {
	width: 15.33333rem;
	align-self: stretch;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex: 1 1
}

.event-single .event-date h1 {
	color: #fff;
	margin-bottom: 0
}

.event-single .event-date .month {
	font-size: 1.2rem;
	color: #fff
}

.event-single .event-date .year {
	display: block;
	font-size: 2rem;
	font-weight: 600;
	color: #fff
}

.event-single .event-info {
	padding: 2.33333rem 2.66667rem;
	display: flex;
	background-color: #fff;
	align-items: center;
	flex: 3 1;
	flex-wrap: wrap
}

.event-single .event-info h5 {
	margin-bottom: 1rem
}

.event-single .event-info h5 a {
	color: #202428;
	transition: all .3s ease
}

.event-single .event-info h5 a:hover {
	color: #413aa4
}

.event-single .event-info .view-btn {
	margin-left: auto
}

.social ul li {
	margin-right: .66667rem
}

.social ul li:last-child {
	margin-right: 0
}

.social ul li a {
	line-height: 2.53333rem;
	width: 2.53333rem;
	display: inline-block;
	text-align: center;
	border-radius: 33.33333rem;
	background: #29292d;
	color: #fff
}

.social ul li a span {
	font-size: .86667rem
}

.social ul li a:hover {
	background-color: #413aa4;
	color: #fff
}

.social.social--small ul li a {
	line-height: 2.53333rem;
	width: 2.53333rem;
	transition: all .3s ease
}

.social.social--small ul li a span {
	color: #fff;
	transition: all .3s ease
}

.social.social--small ul li a:hover span {
	color: #fff
}

.social.square ul li a {
	border-radius: 0;
	background: 0 0;
	border: 1px solid #e4e8ed
}

.social.social--gray ul li a {
	background: #f5f4f7 !important;
	color: #5a6671
}

.social.social--gray ul li a span {
	transition: all .3s ease;
	color: #9192a3
}

.social.social--gray ul li a:hover {
	color: #fff;
	background: #413aa4
}

.social.social--gray ul li a:hover span {
	color: #fff
}

.social.social--colored ul li a.facebook {
	background: #3b5998
}

.social.social--colored ul li a.twitter {
	background: #47adfa
}

.social.social--colored ul li a.linkedin {
	background: #0677b4
}

.social.social--colored ul li a.gplus {
	background: #dd4b39
}

.social.social--colored ul li a.pinterest {
	background: #bc091b
}

.social-basic ul li {
	margin-right: 1.66667rem
}

.social-basic ul li:last-child {
	margin-right: 0
}

.social-basic ul li a {
	color: rgba(32, 36, 40, .5);
	transition: all .3s ease
}

.social-basic ul li a:hover {
	color: #06b590
}

.social-basic .rounded-circle li {
	margin-right: .66667rem
}

.social-basic .rounded-circle li a {
	width: 2.13333rem;
	height: 2.13333rem;
	border-radius: 50%;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: .8rem;
	color: rgba(90, 102, 113, .6)
}

.social-basic.icon-light li a {
	background: #fff;
	color: rgba(90, 102, 113, .6)
}

.social-basic.icon-light li a:hover {
	background: #413aa4;
	color: #fff
}

.social-basic.icon-grey li a {
	background: rgba(65, 58, 164, .06)
}

.social-basic.icon-grey li a:hover {
	background: #413aa4;
	color: #fff
}

.social-btns {
	flex-wrap: wrap
}

.social-btns li {
	margin-right: 1.33333rem
}

.social-btns li:last-child {
	margin-right: 0
}

.social-btns .btn {
	color: #fff
}

.social-btns .btn span {
	padding-right: .53333rem
}

.social-btns .btn-facebook {
	background: #3b5998
}

.social-btns .btn-twitter {
	background: #47adfa
}

.social-btns .btn-linkedin {
	background: #0677b4
}

.social-btns .btn-gplus {
	background: #dd4b39
}

.shadow-lg-2 {
	box-shadow: 0 5px 30px rgba(105, 106, 119, .1) !important
}

.shadow_lg--bgwhite {
	box-shadow: 0 5px 30px rgba(41, 41, 59, .1)
}

.shadow_lg2--bgwhite {
	box-shadow: 0 10px 30px rgba(41, 41, 59, .1)
}

.top_bar {
	min-height: 3.33333rem
}

.top_bar .infos .infos--single+.infos--single {
	margin-left: 2rem
}

.top_bar .infos .infos--single span {
	color: #413aa4;
	font-size: 1.8rem;
	margin-right: 11px;
	margin-top: 3px
}

.top_bar .infos .infos--single .info {
	line-height: 1.7rem
}

.top_bar .infos .infos--single .info p {
	margin: 0;
	font-size: 1.1rem;
	font-weight: 500;
	color: #202428
}

.top_bar .infos .infos--single .info small {
	font-size: 15px;
	color: #9192a3
}

.top_bar ul {
	list-style: none;
	margin: 0;
	padding: 0
}

.top_bar .top_bar--lang {
	cursor: pointer
}

.top_bar .top_bar--lang .dropdown .dropdown-menu {
	min-width: 150px
}

.top_bar .top_bar--lang .dropdown .lang_flag {
	margin: 0 10px
}

.top_bar .top_bar--lang .dropdown .dropdown-item img {
	margin-right: 12px
}

.top_bar .top_bar--lang .dropdown .lang {
	color: rgba(255, 255, 255, .6);
	text-transform: uppercase
}

.top_bar .top_bar--lang .dropdown span.la {
	color: rgba(255, 255, 255, .6);
	font-size: .86667rem
}

.top_bar .top_bar--info li {
	display: inline-block;
	color: rgba(255, 255, 255, .8)
}

.top_bar .top_bar--info li span {
	margin-right: 8px;
	font-size: 20px;
	display: inline-block;
	vertical-align: middle;
	color: rgba(255, 255, 255, .6)
}

.top_bar .top_bar--info li p {
	display: inline-block;
	margin: 0;
	vertical-align: middle;
	color: rgba(255, 255, 255, .6)
}

.top_bar .top_bar--info li+li {
	margin-left: 2rem
}

.top_bar .top_bar--social ul li {
	display: inline-block;
	line-height: 3.6rem;
	border-left: 1px solid rgba(255, 255, 255, .1)
}

.top_bar .top_bar--social ul li:last-child {
	border-right: 1px solid rgba(255, 255, 255, .1)
}

.top_bar .top_bar--social ul li a {
	color: rgba(255, 255, 255, .6);
	font-size: 15px;
	padding: 0 20px
}

.top_bar .top_bar--social ul li a:hover {
	color: #fff
}

.top_bar.top--bar2 .top_bar--info li {
	color: rgba(255, 255, 255, .3)
}

.top_bar.top--bar2 .top_bar--social ul li {
	border: 0
}

.top_bar.top--bar2 .top_bar--social ul li a {
	padding: 0 11px;
	color: rgba(255, 255, 255, .6)
}

.top_bar.top--bar2 .top_bar--social ul li a:hover {
	color: #fff
}

.top_bar.top--bar3,
.top_bar.top--bar4 {
	padding: 1.33333rem 0
}

.top_bar.top--bar4 .infos .infos--single p {
	color: #202428
}

.menu_area {
	box-shadow: .33333rem 0 1.33333rem rgba(87, 87, 87, .1);
	position: relative
}

.menu_area.bgimage:before {
	content: '';
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	z-index: 1;
	background: rgba(12, 13, 32, .8)
}

.menu_area .nav_right_content .nav_right_module+.nav_right_module {
	padding-left: 1.6rem
}

.menu_area .nav_right_content .nav_right_module:last-child {
	padding-right: 0
}

.menu_area .navbar {
	padding: 1rem
}

.menu_area .navbar.navbar-primary .navbar-toggler {
	color: #fff
}

.menu_area .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before {
	color: #928d8d
}

.menu_area .navbar.navbar-bg .navbar-nav .nav-item.dropdown .nav-link:before {
	color: #ededed
}

.menu_area .navbar .navbar-nav .nav-item {
	position: relative
}

.menu_area .navbar .navbar-nav .nav-item .dropdown-menu .dropdown-item {
	font-size: 15px
}

.menu_area .navbar .navbar-nav .nav-item.has_mega-lg {
	position: static
}

.menu_area .navbar .navbar-nav .nav-item:hover .mega-menu {
	visibility: visible;
	opacity: 1;
	top: 4.53333rem
}

.menu_area .navbar .navbar-nav .nav-item:hover .mega-menu-lg {
	top: 5.6rem
}

.menu_area .navbar .navbar-nav .nav-item .nav-link:after {
	position: absolute;
	width: 100%;
	content: '';
	height: 1rem;
	bottom: -1.06667rem;
	left: 0
}

@media (min-width:992px) {
	.menu_area .navbar .navbar-nav .nav-item.dropdown .dropdown-menu {
		display: block;
		top: 6.66667rem !important;
		border-radius: 0;
		transition: all .3s ease;
		box-shadow: 0 0 30px rgba(41, 41, 59, .1);
		opacity: 0;
		visibility: hidden;
		padding: 2rem
	}

	.menu_area .navbar .navbar-nav .nav-item.dropdown .dropdown-menu .dropdown-item {
		padding: 0 0 1rem
	}

	.menu_area .navbar .navbar-nav .nav-item.dropdown .dropdown-menu .dropdown-item:last-child {
		padding: 0
	}

	.menu_area .navbar .navbar-nav .nav-item.dropdown:hover .dropdown-menu {
		top: 4.66667rem !important;
		opacity: 1;
		visibility: visible
	}
}

.menu_area .navbar .navbar-nav .nav-item.dropdown .nav-link {
	position: relative
}

.menu_area .navbar .navbar-nav .nav-item.dropdown .nav-link:before {
	position: absolute;
	content: '\\f110';
	font-size: .66667rem;
	font-family: LineAwesome;
	color: rgba(0, 0, 0, .5);
	right: 0;
	top: 50%;
	transform: translateY(-50%)
}

.menu_area .navbar.navbar-primary {
	padding: .66667rem 1.8rem;
	background: #413aa4;
	border-radius: 4px
}

.menu_area .navbar.navbar-primary .navbar-nav .nav-link {
	color: #fff
}

.menu_area .navbar.navbar-primary .nav_right_content .nav_right_module>span.la {
	color: #fff
}

.menu_area .navbar.navbar-primary .nav_right_content .social_module ul li a {
	color: rgba(255, 255, 255, .5)
}

.menu_area .navbar.navbar-primary .nav_right_content .social_module ul li a:hover {
	color: #fff
}

.menu_area .navbar-nav .nav-link {
	font-weight: 500;
	text-transform: capitalize;
	padding: 1.2rem 1rem
}

.menu_area.menu1 {
	background: #fff
}

.menu_area.menu3 {
	background: #202428
}

.menu_area.menu3 .nav_right_content .cart_module {
	border-right: 1px solid rgba(255, 255, 255, .3)
}

.menu_area.menu3 .nav_right_content .cart_module .cart_count {
	left: 50%;
	transform: translate(-50%)
}

.menu_area.menu3 .nav_right_content .nav_right_module {
	padding: 0 1.6rem
}

.menu_area.menu3 .nav_right_content .nav_right_module:last-child {
	padding-right: 0
}

.menu_area.menu3 .nav_right_content .nav_right_module .cart__icon span.la,
.menu_area.menu3 .nav_right_content .nav_right_module .la.search_trigger {
	color: rgba(255, 255, 255, .7)
}

.menu_area.menu4 {
	box-shadow: 0 .33333rem 1.33333rem rgba(87, 87, 87, .1);
	border-top: 1px solid #e4e8ed
}

.menu_area.menu4 .nav_right_content .nav_right_module {
	padding: 0 1.6rem
}

.menu_area.menu4 .nav_right_content .nav_right_module+.nav_right_module {
	border-left: 1px solid #e4e8ed
}

.menu_area.menu4 .nav_right_content .nav_right_module:last-child {
	padding-right: 0
}

.menu_area.menu5 {
	border-bottom: 1px solid rgba(255, 255, 255, .12)
}

.menu_area.menu5 .navbar {
	padding: 0
}

.menu_area.menu5 .nav_right_content .search_module {
	line-height: 6rem;
	padding: 0 .66667rem;
	color: #fff;
	font-size: 1.66667rem
}

.menu_area.menu5 .nav_right_content .search_module span {
	font-size: 1.46667rem
}

.menu_area.menu5 .nav_right_content .language_module {
	padding: 0 1.33333rem;
	cursor: pointer
}

.menu_area.menu5 .nav_right_content .language_module .dropdown .lang {
	text-transform: uppercase;
	color: rgba(255, 255, 255, .5)
}

.menu_area.menu5 .nav_right_content .language_module .dropdown .lang_flag {
	padding: 0 .66667rem
}

.menu_area.menu5 .nav_right_content .language_module .dropdown span.la {
	color: rgba(255, 255, 255, .5);
	font-size: .86667rem
}

.menu_area.menu5 .nav_right_content .language_module .dropdown .dropdown-menu .dropdown-item img {
	margin-right: .66667rem
}

.menu_area.menu7 {
	box-shadow: 0 0 0
}

.menu_area.menu7 .navbar .navbar-nav .nav-item.dropdown .nav-link:before {
	color: #fff
}

@media (min-width:992px) {
	.menu_area .mega-menu {
		position: absolute;
		box-shadow: 0 0 30px rgba(41, 41, 59, .1);
		background: #fff;
		width: 46.66667rem;
		left: -2.66667rem;
		top: 6.66667rem;
		z-index: 10;
		transition: all .3s ease;
		opacity: 0;
		visibility: hidden
	}
}

.menu_area .mega-menu ul {
	padding: 2.66667rem;
	flex: 1 1
}

.menu_area .mega-menu ul li {
	margin-bottom: 1rem
}

.menu_area .mega-menu ul li:last-child {
	margin-bottom: 0
}

.menu_area .mega-menu ul li h6 {
	color: #202428;
	font-weight: 500;
	margin-bottom: 1.33333rem
}

.menu_area .mega-menu ul li a {
	color: inherit;
	font-size: 15px
}

.menu_area .mega-menu ul li a:hover {
	color: #413aa4
}

.menu_area .mega-menu ul li+li h6 {
	margin-top: 2rem
}

@media (min-width:992px) {
	.menu_area .mega-menu.mega-menu-lg {
		width: 100%;
		left: 0
	}
}

.menu6 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link,
.menu7 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link,
.menu8 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link {
	color: #fff
}

.menu6 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before,
.menu7 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before,
.menu8 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before {
	color: rgba(255, 255, 255, .5)
}

.menu6 .navbar-dark .nav_right_content .cart_module .cart__icon span.la,
.menu6 .navbar-dark .nav_right_content .search_module>span,
.menu6 .navbar-dark .navbar-toggler,
.menu7 .navbar-dark .nav_right_content .cart_module .cart__icon span.la,
.menu7 .navbar-dark .nav_right_content .search_module>span,
.menu7 .navbar-dark .navbar-toggler,
.menu8 .navbar-dark .nav_right_content .cart_module .cart__icon span.la,
.menu8 .navbar-dark .nav_right_content .search_module>span,
.menu8 .navbar-dark .navbar-toggler {
	color: #fff
}

.navbar-bg .navbar-nav .nav-link {
	color: rgba(255, 255, 255, .7)
}

.navbar-bg .navbar-nav .nav-link:hover {
	color: #fff
}

.navbar-bg .nav_right_content .nav_right_module .input-group-light span.icon-left .la {
	color: #5a6671
}

.navbar-bg .nav_right_content .nav_right_module .search_trigger,
.navbar-bg .nav_right_content .nav_right_module span.la-la-angle-down {
	color: rgba(255, 255, 255, .7)
}

.navbar-bg .nav_right_content .nav_right_module .search_trigger:hover,
.navbar-bg .nav_right_content .nav_right_module span.la-la-angle-down:hover {
	color: #fff
}

@media (max-width:991.98px) {
	.navbar.navbar-dark .navbar-toggler {
		color: #fff
	}

	.navbar .navbar-toggler {
		padding: .33333rem .66667rem;
		font-size: 1.66667rem;
		color: #413aa4;
		box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		border: 1px solid #f2f2f2
	}

	.navbar .navbar-brand {
		width: 25%;
		margin: 0
	}

	.navbar .navbar-brand img {
		max-width: 100%
	}

	.navbar .navbar-collapse {
		position: absolute;
		top: 100%;
		left: 0;
		background: #fff;
		width: 100%;
		z-index: 100;
		max-height: 300px;
		overflow: scroll;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .1)
	}
}

.nav_right_content ul {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex
}

.nav_right_content .cart_module {
	position: relative
}

.nav_right_content .cart_module .cart__icon {
	position: relative
}

.nav_right_content .cart_module:hover .cart__items {
	opacity: 1;
	visibility: visible;
	top: 100%
}

.nav_right_content .cart_module .cart__items {
	position: absolute;
	right: -20px;
	min-width: 350px;
	transition: all .3s ease;
	z-index: 2;
	background: #fff;
	visibility: hidden;
	opacity: 0;
	top: calc(100% + 20px)
}

.nav_right_content .cart_module .cart__items .items {
	display: flex;
	align-items: center;
	padding: 15px 25px;
	border-bottom: 1px solid #e4e8ed
}

.nav_right_content .cart_module .cart__items .items .item_thumb {
	margin-right: 15px
}

.nav_right_content .cart_module .cart__items .items .item_info {
	margin-right: 10px
}

.nav_right_content .cart_module .cart__items .items .item_info>a {
	color: #202428;
	line-height: 1.53333rem;
	display: inline-block;
	margin-bottom: 10px
}

.nav_right_content .cart_module .cart__items .items .item_info span {
	font-weight: 500
}

.nav_right_content .cart_module .cart__items .items .item_remove {
	display: inline-block;
	transition: initial
}

.nav_right_content .cart_module .cart__items .items .item_remove span {
	font-size: 14px;
	line-height: 30px;
	width: 2rem;
	background: #f4f4f4;
	text-align: center;
	border-radius: 50%
}

.nav_right_content .cart_module .cart__items .cart_info {
	padding: 20px 25px
}

.nav_right_content .cart_module .cart__items .cart_info p {
	margin-bottom: 15px
}

.nav_right_content .cart_module .cart__items .cart_info p span {
	font-weight: 500;
	font-size: 18px
}

.nav_right_content .cart_module .cart__items .cart_info a+a {
	margin-left: 10px
}

.nav_right_content .cart_module span.la {
	font-size: 1.66667rem;
	color: #202428
}

.nav_right_content .cart_module .cart_count {
	position: absolute;
	top: -.93333rem;
	left: 3px;
	display: inline-block;
	line-height: 1.33333rem;
	width: 1.2rem;
	text-align: center;
	font-size: .8rem;
	color: #fff;
	border-radius: 13.33333rem
}

.nav_right_content .search_module {
	position: relative;
	z-index: 3
}

.nav_right_content .search_module .search_area {
	position: absolute;
	width: 300px;
	right: -10px;
	opacity: 0;
	visibility: hidden;
	padding: 10px;
	transition: all .3s ease;
	top: calc(100% + 40px);
	background: #fff;
	border-radius: 4px;
	box-shadow: 0 5px 30px rgba(105, 106, 119, .2)
}

.nav_right_content .search_module .search_area .input-group-light span.icon-left .la {
	transform: rotate(0);
	color: #969696
}

.nav_right_content .search_module .search_area.active {
	top: calc(100% + 19px);
	opacity: 1;
	visibility: visible
}

.nav_right_content .search_module .search_area .search_field {
	border: 0
}

.nav_right_content .search_module>span {
	font-size: 1.33333rem;
	color: #202428;
	cursor: pointer;
	line-height: 2rem
}

.nav_right_content .social_module ul li {
	padding: 0 .66667rem
}

.nav_right_content .social_module ul li a {
	color: #9192a3
}

.nav_right_content .social_module ul li a:hover {
	color: #413aa4
}

@media (max-width:1199.98px) {
	.nav_right_content .search_module {
		padding: 0 .6rem 0 .33333rem
	}
}

.modal.search_modal {
	background: rgba(255, 255, 255, .9)
}

.modal.search_modal .searc__field input {
	background: 0 0;
	border: 2px solid rgba(255, 255, 255, .36);
	color: #fff;
	padding: 1.2rem 1.55rem
}

.modal.search_modal .searc__field input::placeholder {
	color: rgba(255, 255, 255, .5)
}

.modal.search_modal .input_with_embed button {
	font-size: 1.6rem;
	color: rgba(255, 255, 255, .54);
	cursor: pointer;
	transition: .3s
}

.modal.search_modal .input_with_embed button:hover {
	color: #fff
}

.modal.search_modal .modal-body {
	padding: 2.68rem 3.34rem
}

.modal .modal-dialog.modal--fullwidth {
	max-width: 1140px
}

.modal .modal-dialog .modal-content.transparent {
	background: #413aa4;
	box-shadow: 0 .5rem 1.33rem rgba(65, 58, 164, .5);
	border: 0
}

.breadcrumb .breadcrumb-item+.breadcrumb-item::before {
	padding: 0 8px;
	font-size: .8rem
}

.breadcrumb li {
	font-size: 14px
}

.breadcrumb li a {
	color: #202428;
	font-weight: 500
}

.breadcrumb li a span {
	margin-right: 5px
}

.breadcrumb li a:hover {
	color: #413aa4
}

.breadcrumb li::before {
	font-family: LineAwesome, Poppins, sans-serif
}

.breadcrumb_area .page_title {
	line-height: 4.8rem;
	font-weight: 600
}

.breadcrumb_area.breadcrumb1 {
	padding: 3rem 0;
	background: #f5f7fc
}

.breadcrumb_area.breadcrumb1 .page_title {
	margin: 0;
	text-transform: capitalize;
	color: #202428
}

.breadcrumb_area.breadcrumb2 {
	padding-top: 7.1rem
}

.breadcrumb_area.breadcrumb2 .page_title {
	color: #fff;
	margin-bottom: 5.6rem;
	text-align: center;
	width: 50rem;
	line-height: 3.6rem
}

.breadcrumb_area.breadcrumb2 .breadcrumb li {
	color: rgba(255, 255, 255, .5)
}

.breadcrumb_area.breadcrumb2 .breadcrumb li a {
	color: #fff
}

.breadcrumb_area.breadcrumb2 .breadcrumb li a:hover {
	color: #06b590
}

.breadcrumb_area.breadcrumb-colored .page_title,
.breadcrumb_area.breadcrumb-gradient .page_title {
	color: #fff
}

.breadcrumb_area.breadcrumb-colored .breadcrumb li a,
.breadcrumb_area.breadcrumb-gradient .breadcrumb li a {
	color: #fff
}

.breadcrumb_area.breadcrumb-colored .breadcrumb-item+.breadcrumb-item::before,
.breadcrumb_area.breadcrumb-colored .breadcrumb-item.active,
.breadcrumb_area.breadcrumb-gradient .breadcrumb-item+.breadcrumb-item::before,
.breadcrumb_area.breadcrumb-gradient .breadcrumb-item.active {
	color: rgba(255, 255, 255, .5)
}

.breadcrumb3 {
	padding: 6.26667rem 0 10.46667rem
}

.breadcrumb3 .breadcrumb_wrapper .subtext {
	font-size: 2rem
}

.breadcrumb3 .breadcrumb_wrapper .page_title {
	width: 33.33333rem;
	margin: 0 auto;
	color: #fff;
	text-align: center;
	line-height: 3.6rem
}

.breadcrumb3 .breadcrumb_wrapper .breadcrumb {
	margin-top: 5.33333rem
}

.breadcrumb3 .breadcrumb_wrapper .breadcrumb li a {
	color: #fff
}

footer {
	background: #f4f4f4
}

footer .footer__big {
	padding: 7.33333rem 0 3.33333rem
}

footer .footer__big .text_widget p {
	line-height: 2rem;
	margin-bottom: 1.33333rem
}

footer .footer__big .text_widget p .address,
footer .footer__big .text_widget p .mail,
footer .footer__big .text_widget p .tel {
	display: block;
	color: #5a6671
}

footer .footer__big .text_widget p .mail:hover,
footer .footer__big .text_widget p .tel:hover {
	color: #06b590
}

footer .footer__big .text_widget .footer_logo {
	margin-bottom: 2rem
}

footer .footer__big .widget {
	margin-bottom: 4rem
}

footer .footer__big .widget .widget__title {
	font-size: 1.06667rem;
	text-transform: uppercase;
	line-height: normal;
	font-weight: 600;
	position: relative
}

footer .footer__big .widget .widget__title2 {
	font-size: 1.13333rem;
	color: #202428
}

footer .footer__big .widget .widget__social {
	margin-top: 30px
}

footer .footer__big .widget.subcribe--widget .subscribe_form .embed_icon {
	font-size: 1.33333rem;
	color: #5a6671
}

footer .footer__big .widget.subcribe--widget .subscribe_form input {
	width: 100%;
	font-size: 1rem;
	color: #9192a3;
	outline: 0;
	padding-left: 1.4rem;
	padding-right: 1rem
}

footer .footer__big .widget ul.links li {
	margin-bottom: .66667rem
}

footer .footer__big .widget ul.links li:last-child {
	margin-bottom: 0
}

footer .footer__big .widget ul.links li a {
	color: #5a6671
}

footer .footer__big .widget ul.links li a:hover {
	color: #06b590
}

footer .footer__big .widget--contact_info ul li {
	display: flex;
	margin-bottom: 31px
}

footer .footer__big .widget--contact_info ul li span.la {
	font-size: 28px;
	margin-right: 12px
}

footer .footer__big .widget--contact_info ul li .info p {
	margin: 0;
	color: #fff;
	font-size: 1.06667rem;
	line-height: 26px
}

footer .footer__big .widget--contact_info ul li .info small {
	font-size: 14px
}

footer .footer__big .widget--latest-news ul li {
	margin-bottom: 20px
}

footer .footer__big .widget--latest-news ul li small {
	font-size: 1rem;
	display: block;
	line-height: 30px
}

footer .footer__big .widget--latest-news ul li a {
	color: #fff;
	font-weight: 500;
	line-height: 28px
}

footer .footer__small {
	background: #000
}

footer .footer__small p {
	color: rgba(255, 255, 255, .6);
	margin: 0;
	padding: 30px 0
}

footer .footer__small a {
	color: #06b590
}

footer .footer__bottom .footer__bottom-content {
	border-top: 1px solid #eaeaea;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 2.33333rem 0
}

footer .footer__bottom .footer__bottom-content p {
	margin: 0
}

footer .footer__bottom .footer__bottom-content p>a {
	color: #06b590
}

footer .footer__bottom .footer__bottom-content .social-basic li a {
	color: #9192a3
}

footer .footer__bottom .footer__bottom-content .social-basic li a:hover {
	color: #06b590
}

footer.footer--dark .footer__big .text_widget p a,
footer.footer--dark .footer__big .text_widget p span {
	color: rgba(255, 255, 255, .5)
}

footer.footer--dark .footer__big .widget.subcribe--widget p {
	color: rgba(255, 255, 255, .5)
}

footer.footer--dark .footer__big .widget .widget__title {
	color: #fff
}

footer.footer--dark .footer__big .widget ul.links li a:hover {
	color: #06b590
}

footer.footer--light .widget__social .social ul li a {
	background: #fff
}

footer.footer--light .widget__social .social ul li a span {
	color: #9192a3
}

footer.footer--light .widget__social .social ul li a:hover {
	background: #413aa4
}

footer.footer--light .widget__social .social ul li a:hover span {
	color: #fff
}

footer.footer--light .widget--contact_info ul li .info p {
	color: #202428;
	font-weight: 500
}

footer.footer--light .widget--latest-news ul li a {
	color: #202428
}

footer.footer2.footer--light {
	background: #fff
}

footer.footer2.footer--light .widget.twit--widget .user .name {
	color: #06b590
}

footer.footer2.footer--light .widget.twit--widget .user .name+span {
	color: #9192a3
}

footer.footer2.footer--light .footer__small {
	background: #fff;
	border-top: 1px solid #e4e8ed
}

footer.footer2.footer--light .footer__small p {
	color: #5a6671
}

footer.footer2 .widget.twit--widget .user {
	margin-top: 14px
}

footer.footer2 .widget.twit--widget .user .name {
	color: #fff
}

footer.footer2 .widget.twit--widget .user .name+span:before {
	content: "-";
	margin: 0 3px
}

footer.footer2 .widget.twit--widget a {
	display: inline-block
}

footer.footer2 .widget.twit--widget span.fab {
	margin-right: 12px;
	font-size: 18px
}

footer.footer2 .widget.twit--widget .twit_wrapper>span {
	position: relative;
	top: .46667rem
}

footer.footer2 .footer__small p {
	color: rgba(255, 255, 255, .7)
}

footer.footer2 .footer__small p a:hover {
	color: #fff
}

footer.footer3 .footer__small {
	background: #e4e8ed
}

footer.footer3 .footer__small p {
	color: #5a6671
}

footer.footer4 .footer__big {
	padding: 7.33333rem 0
}

footer.footer4 .footer_menu_items ul li {
	padding: .94rem
}

footer.footer4 .footer_menu_items ul li a {
	line-height: 2.14rem;
	color: rgba(255, 255, 255, .5)
}

footer.footer4 .footer_menu_items ul li a:hover {
	color: #fff
}

footer.footer4 .footer__small .info_links li+li {
	margin-left: 17px
}

footer.footer4 .footer__small .info_links:before {
	content: '|';
	margin: 0 30px;
	color: rgba(255, 255, 255, .2)
}

footer.footer4 .footer_menu_items {
	background: rgba(255, 255, 255, .1)
}

footer.footer4 .footer__small {
	padding: 1.66667rem 0;
	border-top: 1px solid rgba(255, 255, 255, .1)
}

footer.footer4 .footer__small p,
footer.footer4 .footer__small ul {
	padding: 0;
	margin: 0
}

footer.footer4 .social.square ul li a {
	border: 1px solid rgba(255, 255, 255, .2)
}

footer.footer4 .social.square ul li a:hover {
	border-color: transparent
}

footer.footer4.footer--light .footer4_text {
	color: #5a6671
}

footer.footer4.footer--light .footer_menu_items {
	background: #fff
}

footer.footer4.footer--light .footer__small {
	background: #fff
}

footer.footer4.footer--light .footer__small p {
	color: #5a6671
}

footer.footer4.footer--light .footer__small .info_links li a {
	color: #5a6671
}

footer.footer4.footer--light .footer__small .social.square li a {
	color: #9192a3;
	border-color: #e4e8ed
}

footer.footer4.footer--light .footer__small .social.square li a:hover {
	color: #fff;
	border-color: transparent
}

footer.footer4 .footer4_text {
	margin: 3.33rem 0 4.66rem;
	line-height: 2rem
}

footer.footer5.footer--bw .footer__big {
	background: #111115
}

footer.footer5.footer--bw .footer__big .text_widget a {
	color: #fff
}

footer.footer5.footer--bw .footer__big .text_widget a:hover {
	color: #413aa4
}

footer.footer5.footer--bw .footer__big .widget ul.links a:hover {
	color: #fff
}

footer.footer5.footer--bw .footer__big .widget .widget__title {
	color: #fff
}

footer.footer5.footer--bw .footer_small {
	background: #000
}

footer.footer--light-gradient {
	background: linear-gradient(to bottom, #fbfbfd, #f2f1fa)
}

footer.footer6 {
	position: relative;
	overflow: hidden;
	padding-top: 4.33333rem
}

footer.footer6:before {
	position: absolute;
	content: "";
	width: 180%;
	height: 150%;
	background: #fff;
	left: -40%;
	top: -137%;
	border-radius: 50%
}

footer.footer6.footer--dark .widget .widget__title2 {
	color: #fff
}

footer.footer6.footer--dark .footer__bottom .footer__bottom-content {
	border-color: rgba(255, 255, 255, .1)
}

footer.footer7 {
	position: relative;
	overflow: hidden;
	background: url(https://snmtechnologies.in/startup/img/shape-wave3.png) center/100% 100% no-repeat;
	padding-top: 4.66667rem
}

footer.footer7.footer--dark .widget .widget__title2 {
	color: #fff
}

footer.footer7.footer--dark .footer__bottom .footer__bottom-content {
	border-color: rgba(255, 255, 255, .1)
}

.pricing {
	text-align: center;
	padding: 30px;
	margin-bottom: 2rem
}

.pricing .pricing__title h4 {
	line-height: 2rem;
	margin-bottom: 0;
	font-weight: 600
}

.pricing .pricing__title span {
	color: #9192a3;
	line-height: 1.8rem;
	display: inline-block
}

.pricing .pricing__price p {
	font-size: 3.33rem;
	font-weight: 600;
	color: #fff;
	margin-bottom: 0;
	line-height: 4.93333rem;
	display: flex;
	align-items: center;
	justify-content: center
}

.pricing .pricing__price p sup {
	font-size: 1.63rem
}

.pricing .pricing__price p small {
	font-size: 1rem;
	position: relative;
	top: .53333rem
}

.pricing.pricing--1 {
	border-radius: 6px;
	padding: 36px 30px 40px;
	background: #fff
}

.pricing.pricing--1 .pricing__title {
	margin-bottom: 2rem
}

.pricing.pricing--1 .pricing__title h4 {
	font-size: 1.6rem
}

.pricing.pricing--1 .pricing__price {
	max-width: 231px;
	margin: 0 auto
}

.pricing.pricing--1 .pricing__price p {
	margin: 0
}

.pricing.pricing--1 .pricing__features {
	padding: 2rem 0
}

.pricing.pricing--1 .pricing__features ul {
	margin: 0
}

.pricing.pricing--1 .pricing__features ul li {
	margin-bottom: 1rem
}

.pricing.pricing--1 .pricing__features ul li:last-child {
	margin-bottom: 0
}

.pricing.pricing--2 {
	background: #fff;
	padding: 0
}

.pricing.pricing--2 .pricing__features_list {
	text-align: left;
	padding: 5.86rem 3.33rem 3.33rem
}

.pricing.pricing--2 .pricing__features_list P {
	margin: 0
}

.pricing.pricing--2 .pricing__features_list ul.list {
	margin-top: 63px
}

.pricing.pricing--2 .pricing__features_list ul.list li {
	line-height: 3.2rem;
	font-weight: 500;
	color: #202428;
	border-bottom: 1px solid #e4e8ed
}

.pricing.pricing--2 .pricing__features_list ul.list li:first-child {
	border-top: 1px solid #e4e8ed
}

.pricing.pricing--2 .pricing__wrapper {
	flex: 2 1;
	flex-wrap: wrap
}

.pricing.pricing--2 .pricing__wrapper .pricing_option {
	padding: 3.2rem 2rem 3.33rem;
	flex-basis: 0;
	flex-grow: 1;
	transition: all .3s ease
}

.pricing.pricing--2 .pricing__wrapper .pricing_option .pricing__title {
	margin-bottom: 22px
}

.pricing.pricing--2 .pricing__wrapper .pricing_option ul.favail {
	margin-bottom: 2.66rem
}

.pricing.pricing--2 .pricing__wrapper .pricing_option ul.favail li {
	line-height: 3.2rem;
	border-bottom: 1px solid #e4e8ed
}

.pricing.pricing--2 .pricing__wrapper .pricing_option ul.favail li:first-child {
	border-top: 1px solid #e4e8ed
}

.pricing.pricing--2 .pricing__wrapper .pricing_option ul.favail li i {
	font-size: 18px
}

.pricing.pricing--2 .pricing__wrapper .pricing_option ul.favail li i.la-close {
	color: #e23636
}

.pricing.pricing--2 .pricing__wrapper .pricing_option:hover {
	box-shadow: 0 5px 30px rgba(41, 41, 59, .1)
}

.pricing.pricing--2 .pricing__wrapper .pricing__price {
	margin-bottom: 2.66rem
}

.timeline1 .happening:hover .happening__period .wrapper:before {
	border-color: #06b590
}

.timeline1 .happening:hover .happening__period .wrapper:after {
	background: rgba(6, 181, 144, .1)
}

.timeline1 .happening .happening__period {
	text-align: center;
	position: relative
}

.timeline1 .happening .happening__period:before {
	content: "";
	position: absolute;
	height: 100%;
	width: 1px;
	background: #e2e1ea;
	right: -41px;
	top: 0
}

.timeline1 .happening .happening__period .wrapper {
	background: #fff;
	padding: 0;
	margin-top: 0;
	position: relative;
	min-height: 8.33333rem;
	display: flex;
	flex-direction: column;
	justify-content: center
}

.timeline1 .happening .happening__period .wrapper:before {
	content: "";
	position: absolute;
	transition: .3s;
	height: 10px;
	width: 10px;
	background: #fff;
	border-radius: 200px;
	right: -60.5px;
	z-index: 1;
	border: 2px solid #afb0c3;
	top: 50%;
	transform: translateY(-50%)
}

.timeline1 .happening .happening__period .wrapper:after {
	position: absolute;
	content: '';
	width: 20px;
	height: 20px;
	border-radius: 200px;
	right: -65.5px;
	z-index: 1;
	top: 50%;
	transform: translateY(-50%);
	transition: .3s
}

.timeline1 .happening .happening__period .wrapper .date {
	margin: 10px 0 0 0;
	line-height: normal
}

.timeline1 .happening .happening__period .wrapper .year {
	font-size: 2.42rem;
	font-weight: 600;
	line-height: normal;
	margin: 0
}

.timeline1 .happening .happening__desc {
	padding: 0 0 3.33333rem;
	position: relative
}

.timeline1 .happening .happening__desc .happening_title {
	color: #202428;
	line-height: 3.2rem;
	margin-bottom: .66rem;
	margin-top: -10px
}

.timeline1 .happening p {
	margin-bottom: 0
}

.timeline1 .happening:last-child .happening__desc {
	padding-bottom: 0
}

.timeline2 {
	position: relative
}

.timeline2:before {
	content: '';
	height: 100%;
	width: 1px;
	background: #e4e8ed;
	position: absolute;
	left: 0
}

.timeline2 .happening2 {
	padding-bottom: 2.66667rem;
	padding-left: 3.2rem;
	position: relative
}

.timeline2 .happening2:last-child {
	padding-bottom: 0
}

.timeline2 .happening2:before {
	content: '';
	position: absolute;
	width: 12px;
	top: 43px;
	height: 12px;
	border-radius: 200px;
	border: 2px solid #afb0c3;
	background: #fff;
	left: 0;
	transform: translateX(-50%)
}

.timeline2 .happening2:hover:before {
	border-color: #06b590
}

.timeline2 .happening2 .happening2__period {
	font-size: 1rem;
	margin: 0;
	font-weight: 600;
	line-height: normal
}

.timeline2 .happening2 .happening2__title {
	color: #202428;
	font-weight: 500;
	line-height: 3.2rem;
	margin-bottom: 0
}

.timeline2 .happening2 p {
	margin-bottom: 0
}

.arabic {
	font-size: 1.46667rem
}

.counter.counter--1,
.counter.counter--2 {
	padding: 6.33333rem 0
}

.counter.counter--3 {
	padding: 7.33333rem 0
}

.counter.counter--3 .counter_single .title {
	color: rgba(255, 255, 255, .7)
}

.counter.counter--4 .counter_single .title {
	color: #5a6671
}

.counter.counter--5 {
	padding: 8rem 0 6rem
}

.counter.counter--5 .counter_single {
	padding: 3rem 0;
	border-radius: 4px;
	background: #fff;
	margin-bottom: 2rem
}

.counter.counter--5 .counter_single .value {
	margin-bottom: .33rem
}

.counter.counter--5 .counter_single .title {
	font-weight: 500
}

.counter.counter--6 {
	padding: 7.66667rem 0
}

.counter.counter--6 .icon span {
	color: #fff
}

.counter.counter--6 .title {
	color: rgba(255, 255, 255, .7)
}

.counter.counter--7 {
	padding: 6.66667rem 0 4.66667rem
}

.counter.counter--7 .counter_left_content h4 {
	color: #fff;
	font-size: 2.4rem;
	font-weight: 600
}

.counter.counter--7 .counter_left_content p {
	color: #fff
}

.counter.counter--7 .counter_single {
	background: #fff;
	padding: 1.93333rem 0;
	margin-bottom: 30px;
	border-radius: 6px
}

.counter.counter--7 .counter_single .title {
	color: #202428;
	font-weight: 500
}

.counter_single {
	text-align: center
}

.counter_single p {
	margin: 0
}

.counter_single .icon {
	padding-bottom: 2.33rem
}

.counter_single .icon span {
	color: #fff;
	font-size: 3.47rem
}

.counter_single .value {
	font-size: 3.2rem;
	line-height: 3.66rem;
	font-weight: 600;
	color: #fff;
	margin-bottom: 0
}

.counter_single .title {
	color: #fff
}

.shadow-lg-2 {
	box-shadow: 0 5px 30px rgba(105, 106, 119, .1) !important
}

.shadow_lg--bgwhite {
	box-shadow: 0 5px 30px rgba(41, 41, 59, .1)
}

.shadow_lg2--bgwhite {
	box-shadow: 0 10px 30px rgba(41, 41, 59, .1)
}

.dot-light,
.owl-dots {
	text-align: center;
	margin-top: 2rem
}

.dot-light .owl-dot,
.owl-dots .owl-dot {
	display: inline-block;
	margin-right: .66667rem
}

.dot-light .owl-dot:last-child,
.owl-dots .owl-dot:last-child {
	margin-right: 0
}

.dot-light .owl-dot:focus,
.owl-dots .owl-dot:focus {
	outline: 0
}

.dot-light .owl-dot span,
.owl-dots .owl-dot span {
	width: .8rem;
	height: .8rem;
	border-radius: 20rem;
	background: rgba(65, 58, 164, .3);
	display: inline-block
}

.dot-secondary.dot-light .owl-dot span,
.owl-dots.dot-secondary .owl-dot span {
	border: 0 none;
	background: rgba(6, 181, 144, .2)
}

.dot-light .owl-dot span {
	border: 1px solid #fff
}

.dot-light .owl-dot.active span {
	background: #fff
}

.nav-circle button {
	width: 3.06667rem;
	height: 3.06667rem;
	border-radius: 50%;
	font-size: 1.2rem;
	color: #fff;
	border: 0 none;
	cursor: pointer;
	transition: all .3s ease
}

.nav-circle button:focus {
	outline: 0
}

.nav-circle .owl-prev {
	margin-left: -4rem;
	position: absolute;
	left: 0;
	top: 50%;
	transform: translateY(-50%)
}

.nav-circle .owl-next {
	margin-right: -4rem;
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%)
}

.nav-circle.nav-circle--light button {
	width: 2.66667rem;
	height: 2.66667rem;
	background: #fff;
	color: #9192a3;
	box-shadow: 0 5px 30px rgba(41, 41, 59, .1)
}

.nav-circle.nav-circle--light button:hover {
	color: #fff
}

.nav-circle.nav-circle--lighten button {
	width: 2.66667rem;
	height: 2.66667rem;
	background: rgba(255, 255, 255, .1);
	color: #fff;
	box-shadow: 0 5px 30px rgba(41, 41, 59, .1);
	font-size: .86667rem
}

.nav-circle.nav-circle--lighten button:hover {
	color: #fff
}

.nav-square button {
	width: 2.66667rem;
	height: 2.66667rem;
	color: #fff;
	font-size: 1.06667rem;
	background: rgba(255, 255, 255, .4);
	border: 0 none;
	transition: all .3s ease;
	cursor: pointer
}

.nav-square button:focus {
	outline: 0
}

.nav-square .owl-prev {
	position: absolute;
	left: 0;
	top: 50%;
	transform: translateY(-50%)
}

.nav-square .owl-next {
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%)
}

.nav-square.nav-square-dark button {
	border-radius: 3px
}

.nav-square.nav-square-dark .owl-prev {
	margin-left: -5px
}

.nav-square.nav-square-dark .owl-next {
	margin-right: -5px
}

.carousel-one .carousel-one-single {
	text-align: center
}

.carousel-one .carousel-one-single figure {
	margin-bottom: 2rem
}

.carousel-one .carousel-one-single figure img {
	border-radius: 5px
}

.carousel-one .carousel-one-single h6 {
	margin-bottom: 1rem
}

.carousel-one .carousel-one-single h6 a {
	color: #202428
}

.carousel-one .carousel-one-single h6 a:hover {
	color: #06b590
}

.carousel-one .carousel-one-single p {
	margin-bottom: 0
}

.carousel-three {
	position: relative
}

.carousel-three .carousel-single {
	padding: 1rem
}

.carousel-four .carousel-single {
	padding: 1rem
}

.portfolio-carousel .dot-circle,
.portfolio-carousel .dot-light {
	margin-top: 2rem
}

.portfolio-carousel-single {
	margin-bottom: 2rem;
	overflow: hidden
}

.portfolio-carousel-single figure {
	position: relative;
	margin: 0
}

.portfolio-carousel-single figure figcaption {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background: rgba(28, 28, 38, .85);
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	visibility: hidden;
	opacity: 0;
	transition: all .3s ease
}

.portfolio-carousel-single figure figcaption h5 {
	margin-bottom: 1rem;
	color: #fff
}

.portfolio-carousel-single figure figcaption h5,
.portfolio-carousel-single figure figcaption span {
	transform: scale(1.3);
	transition: all .3s ease
}

.portfolio-carousel-single figure figcaption .link {
	position: absolute;
	right: -3.33333rem;
	top: -3.33333rem;
	width: 3.33333rem;
	height: 3.33333rem;
	color: #fff;
	font-size: 1.6rem;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 0 0 0 3px;
	transition: all .3s ease
}

.portfolio-carousel-single figure:hover figcaption {
	opacity: 1;
	visibility: visible
}

.portfolio-carousel-single figure:hover figcaption h5,
.portfolio-carousel-single figure:hover figcaption span {
	transform: scale(1)
}

.portfolio-carousel-single figure:hover figcaption .link {
	top: 0;
	right: 0
}

.image-carousel-one figure {
	margin: 0
}

.image-carousel-one .nav-circle .owl-prev {
	margin-left: 2rem
}

.image-carousel-one .nav-circle .owl-next {
	margin-right: 2rem
}

.image-carousel-two .carousel-single figure img {
	width: 100%
}

.image-carousel-two .dot-light,
.image-carousel-two .owl-dots {
	margin-top: 1.06667rem
}

.testimonial-carousel-one .carousel-single {
	text-align: center
}

.testimonial-carousel-one .carousel-single img {
	width: auto;
	margin: 0 auto
}

.testimonial-carousel-one .carousel-single h6 {
	margin: 1.33333rem 0 .66667rem 0;
	color: #202428
}

.testimonial-carousel-one .carousel-single .sub-text {
	color: #06b590;
	display: block;
	margin-bottom: 1.33333rem
}

.testimonial-carousel-one .carousel-single p {
	font-size: 1.2rem;
	line-height: 2.26667rem;
	margin: 0
}

.carousel-bg .bg_image_holder:before {
	position: absolute;
	content: "";
	background: rgba(27, 28, 57, .8);
	width: 100%;
	height: 100%;
	left: 0;
	top: 0
}

.testimonial-carousel-three .nav-circle {
	visibility: hidden;
	opacity: 0;
	transition: all .3s ease
}

.testimonial-carousel-three:hover .nav-circle {
	visibility: visible;
	opacity: 1
}

.testimonial-carousel-three .carousel-single {
	padding: 1rem
}

.testimonial-carousel-three .carousel-single .card img {
	width: auto;
	margin: 0 auto
}

.tc-four-wrapper.bg-grey {
	background: #f4f4f4
}

.tc-four-wrapper.bg-grey .testimonial-carousel-four .carousel-single .author-spec strong {
	color: #202428
}

.tc-four-wrapper.bg-grey .testimonial-carousel-four .carousel-single .author-text:before {
	color: #ededef
}

.tc-four-wrapper.bg-grey .testimonial-carousel-four .carousel-single .author-text p {
	color: #5a6671
}

.tc-four-wrapper.bg-grey .testimonial-carousel-four .nav-square button {
	background: #e1e1e7;
	color: #202428
}

.testimonial-carousel-four {
	padding: 7.33333rem 0 6.93333rem
}

.testimonial-carousel-four .carousel-single img {
	width: auto;
	margin: 0 auto
}

.testimonial-carousel-four .carousel-single .author-spec {
	margin: 1.33333rem 0 0 0
}

.testimonial-carousel-four .carousel-single .author-spec strong {
	font-weight: 500;
	color: #fff;
	font-size: 1.2rem
}

.testimonial-carousel-four .carousel-single .author-spec span {
	font-size: 1.2rem;
	color: rgba(255, 255, 255, .6)
}

.testimonial-carousel-four .carousel-single .author-spec p {
	margin: 0
}

.testimonial-carousel-four .carousel-single .author-text {
	width: 50rem;
	margin: 0 auto;
	padding-top: 3.33333rem;
	position: relative
}

.testimonial-carousel-four .carousel-single .author-text:before {
	position: absolute;
	content: "\\f2ce";
	font-family: LineAwesome;
	font-size: 10rem;
	color: rgba(255, 255, 255, .05);
	left: 50%;
	top: 0;
	line-height: .8;
	transform: translateX(-50%);
	z-index: -1
}

.testimonial-carousel-four .carousel-single .author-text p {
	font-size: 1.2rem;
	color: rgba(255, 255, 255, .7);
	line-height: 2.26667rem;
	margin: 0
}

.testimonial-carousel-four .nav-circle .owl-prev {
	margin-left: 0
}

.testimonial-carousel-four .nav-circle .owl-next {
	margin-right: 0
}

.testimonial-carousel-four .nav-circle .owl-next,
.testimonial-carousel-four .nav-circle .owl-prev {
	background: rgba(255, 255, 255, .05);
	font-size: .86667rem;
	color: #fff
}

.testimonial-carousel-four .nav-circle .owl-next:hover,
.testimonial-carousel-four .nav-circle .owl-prev:hover {
	background: #fff;
	color: #202428
}

.testimonial-carousel-five .carousel-single {
	padding: 1rem
}

.testimonial-carousel-five .carousel-single .author-text {
	box-shadow: 0 5px 30px rgba(105, 106, 119, .1);
	padding: 2.66667rem 2.66667rem;
	position: relative
}

.testimonial-carousel-five .carousel-single .author-text:before {
	position: absolute;
	content: "";
	border-right: 1.33333rem solid transparent;
	border-left: 1.33333rem solid transparent;
	border-top: 1.33333rem solid #fff;
	bottom: -1.33333rem;
	left: 4.66667rem
}

.testimonial-carousel-five .carousel-single .author-text p {
	margin-bottom: 0
}

.testimonial-carousel-five .carousel-single .author-spec {
	margin-top: 2.66667rem;
	margin-left: 3.33333rem;
	align-items: center
}

.testimonial-carousel-five .carousel-single .author-spec .author-img {
	margin-right: 1.33333rem
}

.testimonial-carousel-five .carousel-single .author-spec .author-desc h6 {
	margin: 0 0 5px 0;
	color: #202428
}

.testimonial-carousel-five .nav-square-dark {
	top: 40%
}

.testimonial-carousel-five .nav-square-dark .owl-prev {
	margin-left: 1rem
}

.testimonial-carousel-five .nav-square-dark .owl-next {
	margin-right: 1rem
}

.testimonial-carousel-six-wrapper {
	background: url(https://snmtechnologies.in/startup/img/shape-wave.png);
	background-size: cover;
	background-repeat: no-repeat;
	padding: 3.2rem 0 6.93333rem 0
}

.testimonial-carousel-six {
	position: relative
}

.testimonial-carousel-six:before {
	position: absolute;
	content: '\\f2ce';
	font-family: LineAwesome;
	font-size: 13.33333rem;
	color: rgba(6, 181, 144, .1);
	left: 100px;
	top: 50%;
	transform: translateY(-50%)
}

.testimonial-carousel-six .carousel-single {
	text-align: center
}

.testimonial-carousel-six .carousel-single img {
	display: inline-block;
	width: auto
}

.testimonial-carousel-six .carousel-single h5 {
	color: #202428;
	margin: 1.33333rem 0 .66667rem
}

.testimonial-carousel-six .carousel-single p {
	margin: 2rem 0 0 0
}

.team-carousel-one .carousel-single {
	padding: 1rem
}

.team-carousel-one .carousel-single img {
	width: auto;
	margin: 0 auto
}

.team-carousel-two .dot-light,
.team-carousel-two .owl-dots {
	margin-top: 1.33333rem
}

.team-carousel-three {
	background: #fff;
	border-radius: .26667rem
}

.team-carousel-three .carousel-single {
	display: flex;
	flex-wrap: wrap
}

.team-carousel-three .carousel-single .team-img {
	width: 45%
}

.team-carousel-three .carousel-single .team-img img {
	border-radius: .26667rem 0 0 .26667rem
}

.team-carousel-three .carousel-single .team-desc {
	width: 55%;
	display: flex;
	justify-content: center;
	flex-direction: column;
	padding: 0 3.33333rem
}

.team-carousel-three .carousel-single .team-desc h5 {
	color: #202428;
	margin: 0 0 .53333rem
}

.team-carousel-three .carousel-single .team-desc span {
	color: #9192a3
}

.team-carousel-three .carousel-single .team-desc p {
	margin: 1rem 0 2rem 0
}

.team-carousel-three .nav-circle .owl-prev {
	margin-left: -1.33333rem;
	visibility: hidden;
	opacity: 0;
	transition: all .3s ease
}

/* Add this to your styles */
.logo-carousel {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  text-align: center;
}

.logo-carousel .logo-item:hover {
  filter: grayscale(0%) !important;
  opacity: 1 !important;
}

/* Optional: Add a subtle heading like in your reference image */
.logo-carousel h3 {
  font-weight: 300;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 30px;
  color: #333;
  font-size: 14px;
}
.faicons{float: left;margin:14px;}
.team-carousel-three .nav-circle .owl-next {
	margin-right: -1.33333rem;
	visibility: hidden;
	opacity: 0;
	transition: all .3s ease
}

.team-carousel-three:hover .nav-circle .owl-next,
.team-carousel-three:hover .nav-circle .owl-prev {
	visibility: visible;
	opacity: 1;
	transition: all .3s ease
}

.logo-carousel-one .carousel-single img,
.logo-carousel-two .carousel-single img {
	width: auto;
	margin: 0 auto
}

.logo-carousel-one .owl-stage,
.logo-carousel-two .owl-stage {
	display: flex;
	align-items: center
}

.logo-carousel {
	padding: 7.33333rem 0 7rem
}

.logo-carousel .content-left h1 {
	line-height: 3.73333rem
}

.logo-carousel-two .logo-box {
	background: #fff;
	margin-bottom: 2rem;
	min-height: 8rem;
	padding-top:20px;
	display: flex;
	align-items: center;
	box-shadow: 0 5px 30px rgba(105, 106, 119, .05)
}

@media all and (-ms-high-contrast:none),
(-ms-high-contrast:active) {
	.logo-carousel-two .logo-box {
		height: 8rem
	}
}

.logo-carousel-two .logo-box:last-child {
	margin-bottom: 0
}

.logo-carousel-three .carousel-single {
	min-height: 8rem
}

.logo-carousel-three .carousel-single .logo-box {
	border: 1px solid #e4e8ed;
	height: 8rem;
	display: flex;
	justify-content: center;
	align-items: center
}

.logo-carousel-three .carousel-single .logo-box img {
	width: auto
}

.logo-carousel-three .nav-square-dark {
	visibility: hidden;
	opacity: 0;
	transition: all .3s ease
}

.logo-carousel-three .nav-square-dark .owl-prev {
	margin-left: -1.33333rem
}

.logo-carousel-three .nav-square-dark .owl-next {
	margin-right: -1.33333rem
}

.logo-carousel-three:hover .nav-square-dark {
	visibility: visible;
	opacity: 1
}

.blog-carousel-one .post-single .post-meta ul {
	display: flex;
	align-items: center
}

.blog-carousel-one .post-single .post-meta ul li {
	margin-right: 1rem
}

.blog-carousel-one .post-single .post-meta ul li:last-child {
	margin-right: 0
}

.blog-carousel-one .post-single .post-meta ul li span {
	padding: 0 1rem;
	line-height: 2rem;
	display: inline-block;
	color: #fff;
	border-radius: 2px
}

.blog-carousel-one .post-single h6 {
	margin: 1.33333rem 0 1.06667rem 0
}

.blog-carousel-one .post-single h6 a:hover {
	color: #06b590
}

.blog-carousel-one .post-single .post-bottom {
	margin: 1.66667rem 0 0 0;
	padding-top: 2rem;
	border-top: 1px solid #e4e8ed;
	display: flex;
	align-items: center
}

.blog-carousel-one .post-single .post-bottom img {
	width: auto;
	margin-right: .66667rem
}

.logo-grid-one {
	box-shadow: 0 5px 30px rgba(41, 41, 59, .1);
	overflow: hidden
}

.logo-grid-one ul {
	margin-right: -1px;
	margin-bottom: -1px
}

.logo-grid-one li {
	width: 25%;
	border-right: 1px solid #dee2e6;
	border-bottom: 1px solid #dee2e6;
	background: #fff;
	min-height: 13.33333rem
}

.logo-grid-one li figure {
	margin: 0
}

.logo-carousel-dark .single-slide img {
	width: auto
}

.logo-grid-two .grid-single {
	background: #fff;
	margin-bottom: 2rem;
	min-height: 10rem
}

@media all and (-ms-high-contrast:none),
(-ms-high-contrast:active) {
	.logo-grid-two .grid-single {
		height: 10rem
	}
}

.logo-grid-three ul {
	margin: 0
}

.logo-grid-three li {
	width: 25%;
	border: 1px solid #dee2e6;
	background: #fff;
	min-height: 13.33333rem;
	margin-right: -1px;
	margin-bottom: -1px
}

.logo-grid-three li figure {
	margin: 0
}

.logo-details-wrapper {
	padding: 6rem 0 0
}

.logo-details {
	box-shadow: 0 5px 10px rgba(105, 106, 119, .05);
	background: #fff;
	padding: 7rem 3rem 2rem;
	margin-bottom: 7.33333rem;
	margin-top: .66667rem;
	position: relative;
	border-radius: .26667rem
}

.logo-details .logo {
	box-shadow: 0 5px 30px rgba(105, 106, 119, .1);
	height: 10.66667rem;
	width: 18.66667rem;
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	left: 50%;
	top: 0;
	transform: translate(-50%, -50%);
	background: #fff;
	border-radius: .26667rem
}

.logo-details h5 {
	color: #202428;
	margin-bottom: .33333rem
}

.logo-details .sub-title {
	display: block;
	margin-bottom: .8rem
}

.logo-details p {
	margin: 0
}

.logo-carousel-four .owl-stage {
	display: flex;
	align-items: center;
	justify-content: space-between
}

.logo-carousel-four .carousel-single {
	text-align: center
}

.logo-carousel-four .carousel-single img {
	display: inline-block;
	width: auto
}

.dropdown .dropdown-toggle:focus {
	box-shadow: none !important
}

.dropdown .dropdown-caret {
	display: inline-block;
	padding-left: 1rem
}

.dropdown .dropdown-menu {
	top: .66667rem !important;
	min-width: 16.66667rem;
	margin: 0;
	padding: 0;
	box-shadow: 0 5px 30px rgba(41, 41, 59, .1);
	border: 0 none
}

.dropdown .dropdown-menu .dropdown-item:hover {
	background: 0 0;
	color: #413aa4;
	border-radius: 0
}

.dropdown .dropdown--btn .dropdown-item:hover {
	background: #413aa4;
	color: #fff;
	border-radius: .2rem
}

.dropdown .dropdown--text .dropdown-text-item {
	padding: 30px;
	margin: 0
}

.gallery-image-view .portfolio-carousel-single {
	margin-bottom: .66667rem
}

.gallery-image-view .portfolio-carousel-single img {
	width: auto
}

.gallery-image-view .carousel-thumbs ul {
	margin: 0
}

.gallery-image-view .carousel-thumbs ul li {
	margin: 0 .33333rem
}

.gallery-image-view .image-view-carousel .carousel-single figure img {
	width: 100%
}

.gallery-fullwidth .portfolio-carousel-single {
	width: 25%
}

.price-filter {
	margin-top: 10px
}

.range-slider .slider-range {
	background: #e4e8ed;
	border-radius: 1.66667rem;
	height: .4rem;
	max-width: 13.33333rem
}

.range-slider .slider-range .ui-slider-range {
	background: #413aa4
}

.range-slider .slider-range .ui-slider-handle {
	width: 1.2rem;
	height: 1.2rem;
	border: .26667rem solid #413aa4;
	background: #fff;
	border-radius: 50%;
	top: -.4rem;
	cursor: pointer
}

.range-slider .slider-range .ui-slider-handle:focus {
	outline: 0
}

.range-slider p {
	margin: 1.66667rem 0 0 0
}

.range-slider .amounts {
	border: 0 none;
	margin-left: 1.33333rem;
	color: #5a6671;
	font-size: 1.06667rem;
	width: 6rem;
	background: 0 0
}

.range-slider-dark .slider-range {
	background: rgba(65, 58, 164, .2)
}

.video-single figure {
	position: relative;
	margin: 0
}

.video-single figure .v_img {
	position: relative
}

.video-single figure .v_img:before {
	position: absolute;
	content: '';
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background: rgba(15, 15, 30, .2)
}

.video-single figure figcaption {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%
}

.video-overlay figcaption {
	background: rgba(32, 36, 40, .3)
}

.video-banner {
	padding: 5rem 2rem;
	overflow: hidden
}

.video-banner div a {
	color: #fff;
	font-weight: 500;
	font-size: 1.33333rem;
	display: flex;
	justify-content: center;
	align-items: center
}

.video-banner div a .play-btn {
	margin-right: 2rem
}

.video-bg {
	padding: 7.33333rem 0
}

.video-bg.overlay:before {
	background: rgba(27, 28, 57, .8)
}

.video-bg .content_above a {
	color: #fff;
	font-weight: 500;
	font-size: 1.6rem;
	display: flex;
	justify-content: center;
	align-items: center
}

.cta--one .sub-heading {
	font-size: 1.6rem;
	font-weight: 500
}

.cta--one h2 {
	color: #fff;
	margin: 1.33333rem 0 3.33333rem;
	line-height: 3.2rem;
	font-weight: 500
}

.splitted-banner {
	padding: 10rem 0;
	position: relative;
	overflow: hidden
}

.splitted-banner .split-bg {
	position: absolute;
	width: 53%;
	height: 46.66667rem;
	left: 0;
	top: 50%;
	transform: translateY(-50%);
	background: #06b590;
	z-index: 1;
	height: 100%
}

.splitted-banner .split-bg:before {
	position: absolute;
	content: '';
	height: 150%;
	width: 26.66667rem;
	right: -28.66667rem;
	top: 50%;
	transform: translateY(-50%);
	box-shadow: -6.66667rem 0 0 #06b590;
	border-radius: 50%
}

.splitted-banner h1 {
	color: #fff
}

.splitted-banner .btns a {
	margin-right: 2rem
}

.splitted-banner .btns a:last-child {
	margin-right: 0
}

.subscribe-wrapper {
	padding: 6.33333rem 0
}

.subscribe-wrapper h2 {
	color: #fff;
	margin: 0 0 1rem 0
}

.subscribe-wrapper p {
	font-size: 1.13333rem;
	color: rgba(255, 255, 255, .7);
	margin-bottom: 2.33333rem
}

.subscribe-wrapper .subscribe-form button {
	margin-left: 2rem
}

.subscribe--two {
	position: relative;
	background: linear-gradient(140deg, #413aa4 0, #413aa4 25%, #06b590 100%);
	padding-bottom: 10rem;
	overflow: hidden
}

.subscribe--two:before {
	position: absolute;
	content: '';
	width: 100%;
	height: 5.06667rem;
	left: 0;
	bottom: 0;
	background: url(https://snmtechnologies.in/startup/img/sb2.html);
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center
}

.subscribe-six,
.subscribe-three {
	box-shadow: 0 5px 30px rgba(105, 106, 119, .05);
	padding: 4rem 0;
	position: relative;
	z-index: 1
}

.subscribe-six h4,
.subscribe-three h4 {
	margin: 0
}

.subscribe-six .subscribe-form--inline input,
.subscribe-three .subscribe-form--inline input {
	background: #f4f4f4
}

.subscribe-six .subscribe-form--inline button,
.subscribe-three .subscribe-form--inline button {
	margin-left: 2rem
}

.subscribe-four {
	padding: 8.66667rem 0
}

.subscribe-four h3 {
	margin: 0 0 .53333rem 0;
	color: #fff
}

.subscribe-four p {
	margin: 0;
	color: rgba(255, 255, 255, .7);
	font-size: 1.2rem
}

.subscribe-four form .input-group-subscribe button {
	background: #413aa4
}

.subscribe--five h2 {
	color: #fff;
	margin-bottom: 1rem
}

.subscribe--five p {
	color: #fff;
	font-size: 1.13333rem;
	margin-bottom: 2.4rem
}

.subscribe--five .subscribe-form-two .form-control {
	padding-top: .33333rem;
	padding-bottom: .33333rem;
	height: 4rem
}

.subscribe--five .subscribe-form-two .btn {
	line-height: 2.66667rem;
	right: .33333rem
}

.subscribe-seven {
	padding: 7.66667rem 0;
	background: url(https://snmtechnologies.in/startup/img/map-bg.png);
	background-repeat: no-repeat;
	background-position: center
}

.subscribe-form-two>div {
	position: relative
}

.subscribe-form-two .form-control {
	height: 4.66667rem;
	box-shadow: 0 10px 30px rgba(105, 106, 119, .15);
	border: 0 none;
	border-radius: .2rem;
	padding-right: 12.33333rem;
	padding-left: 2rem
}

.subscribe-form-two .btn {
	position: absolute;
	right: 1rem;
	top: 50%;
	transform: translateY(-50%);
	box-shadow: none
}

.subscribe-contents h2 {
	line-height: 3.2rem;
	color: #202428;
	font-size: 1.6rem
}

.subscribe-contents h2 span {
	color: #06b590;
	font-size: 2.4rem
}

.subscribe-contents img {
	margin-top: 4.66667rem
}

.subscribe-eight {
	padding: 6.33333rem 0 7.33333rem
}

.twitter-feeds {
	padding: 7rem 0 7.2rem
}

.twitter-feeds .feed-single .feed-header {
	margin-bottom: 2.66667rem
}

.twitter-feeds .feed-single .feed-header span i {
	font-size: 2rem;
	color: #fff
}

.twitter-feeds .feed-single .feed-header .user {
	color: #fff
}

.twitter-feeds .feed-single .feed-header .time {
	color: rgba(255, 255, 255, .5)
}

.twitter-feeds .feed-single .feed-header p {
	margin: 0
}

.twitter-feeds .feed-single .feed-content {
	width: 48.66667rem;
	margin: 0 auto
}

.twitter-feeds .feed-single .feed-content p {
	font-size: 1.2rem;
	line-height: 2.13333rem;
	color: rgba(255, 255, 255, .7);
	margin-bottom: 1.33333rem
}

.twitter-feeds .feed-single .feed-content .twit-link {
	color: #fff
}

.twitter-feeds .feed-single .feed-content .twit-link:hover {
	color: #202428
}

.twitter-feeds--light .feed-single .feed-header .user {
	color: #413aa4
}

.twitter-feeds--light .feed-single .feed-header .time {
	color: rgba(32, 36, 40, .5)
}

.twitter-feeds--light .feed-single .feed-header span i {
	color: #06b590
}

.twitter-feeds--light .feed-single .feed-content p {
	color: inherit
}

.twitter-feeds--light .feed-single .feed-content .twit-link {
	color: #06b590
}

.follow-btn .btn {
	text-transform: capitalize;
	display: inline-flex;
	align-items: center
}

.follow-btn .btn i {
	font-size: 1.2rem;
	margin-right: .66667rem
}

.cta-wrapper {
	padding: 6.86667rem 0 7.33333rem
}

.cta-wrapper-sm {
	padding: 4rem 0
}

.cta--two {
	position: relative;
	overflow: hidden;
	padding: 6.86667rem 0 10rem
}

.cta--two:after {
	position: absolute;
	content: '';
	width: 100%;
	height: 5.06667rem;
	left: 0;
	bottom: 0;
	background: url(https://snmtechnologies.in/startup/img/sb2.html);
	background-repeat: no-repeat;
	background-size: cover;
	background-position: bottom;
	transform: rotateY(-180deg) translateY(.8%);
	z-index: 1
}

.cta--two .cta-content p {
	color: #fff;
	font-size: 2.4rem;
	line-height: 3.6rem;
	font-weight: 600;
	margin: 0
}

.cta--two .action-btn {
	text-align: right
}

.cta--eight .action-btn,
.cta--five .action-btn,
.cta--four .action-btn,
.cta--seven .action-btn,
.cta--six .action-btn {
	text-align: right
}

.cta--three .cta-content p {
	color: #fff;
	font-size: 2.4rem;
	line-height: 3.66667rem;
	font-weight: 600;
	margin: 0 0 3rem
}

.cta--four .cta-content h1 {
	color: #fff;
	font-weight: 600
}

.cta--four .cta-content p {
	color: rgba(255, 255, 255, .8);
	font-size: 1.2rem;
	line-height: 2.26667rem
}

.cta--four .cta-content .phone {
	font-size: 2.4rem;
	display: block;
	color: #fff;
	margin-bottom: 3rem;
	font-weight: 600
}

.cta--five {
	box-shadow: 0 5px 30px rgba(41, 41, 59, .1)
}

.cta--five p {
	font-size: 2rem;
	color: #202428;
	font-weight: 600
}

.cta--six p {
	font-weight: 600;
	font-size: 2rem
}

.cta--seven {
	font-weight: 600;
	font-size: 2.4rem
}

.cta--seven p {
	font-weight: 600;
	font-size: 2rem
}

.cta--eight h1 {
	line-height: 3.66667rem
}

.cta--nine {
	position: relative;
	overflow: hidden
}

.cta--nine .cta--none-contents {
	position: relative
}

.cta--nine .cta--none-contents:before {
	position: absolute;
	content: '';
	width: 25.13333rem;
	height: 55.53333rem;
	right: 0;
	top: 0;
	background: rgba(255, 255, 255, .03);
	border-radius: 5.33333rem;
	transform: rotate(-45deg) translateX(82%)
}

.cta--nine .cta--none-contents:after {
	position: absolute;
	content: '';
	width: 33.33333rem;
	height: 55.53333rem;
	right: 0;
	top: 0;
	background: rgba(255, 255, 255, .03);
	border-radius: 5.33333rem;
	transform: rotate(-45deg) translate(59%, 20%)
}

.cta--nine.cta-wrapper {
	padding-top: 4.66667rem
}

.cta--nine h3 {
	color: #fff;
	font-weight: 300;
	line-height: 3.06667rem;
	font-size: 29px
}

.cta--nine h3 span {
	font-weight: 600
}

.cta--nine:before {
	position: absolute;
	content: "";
	width: 180%;
	height: 150%;
	background: #fff;
	left: -40%;
	top: 87%;
	border-radius: 50%
}

.process-one {
	display: flex;
	flex-wrap: wrap;
	margin-left: -1rem;
	margin-right: -1rem
}

.process-one .process-single {
	width: 25%;
	margin-bottom: 4.66667rem;
	padding: 0 1rem
}

.process-one .process-single:nth-child(2n+1) .icon:before {
	content: url(https://snmtechnologies.in/startup/img/arrow-up.png)
}

.process-one .process-single .icon {
	width: 9.33333rem;
	height: 9.33333rem;
	border-radius: 50%;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 auto 2rem
}

.process-one .process-single .icon.gray-bg {
	background: rgba(6, 181, 144, .1)
}

.process-one .process-single .icon.light-bg {
	background: #fff
}

.process-one .process-single .icon .icon-la {
	font-size: 3.2rem;
	color: #06b590
}

.process-one .process-single .icon .step {
	position: absolute;
	width: 2.33333rem;
	height: 2.33333rem;
	border-radius: 50%;
	background: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #202428;
	font-weight: 500;
	left: 0;
	top: 0;
	box-shadow: 0 5px 30px rgba(105, 106, 119, .1)
}

.process-one .process-single .icon:before {
	position: absolute;
	content: url(https://snmtechnologies.in/startup/img/arrow-down.png);
	right: -90%;
	top: 50%;
	transform: translateY(-50%)
}

.process-one .process-single h6 {
	margin-bottom: 1rem
}

.process-one .process-single p {
	margin: 0
}

.process-one .process-single:last-child,
.process-one .process-single:nth-child(4n) {
	margin-right: 0
}

.process-one .process-single:last-child .icon:before,
.process-one .process-single:nth-child(4n) .icon:before {
	content: none
}

.process-three {
	background: #fff;
	box-shadow: 0 5px 30px rgba(105, 106, 119, .1);
	padding: 1.73333rem 2rem 1.6rem
}

.process-three span {
	display: block;
	font-size: 2.33333rem;
	font-weight: 400;
	color: #06b590;
	margin-bottom: 1.2rem;
	line-height: 1
}

.process-three h6 {
	margin-bottom: 1.2rem
}

.process-three p {
	margin: 0
}

.team-four {
	transition: all .3s ease;
	box-shadow: 0 5px 20px rgba(105, 106, 119, .05)
}

.team-four .subtitle {
	margin-bottom: 1.33333rem;
	display: inline-block;
	font-size: .93333rem
}

.team-four img {
	border-radius: .26667rem .26667rem 0 0;
	transition: all .3s ease
}

.team-four .content {
	padding: 1.8rem 2rem 2rem;
	border-radius: 0 0 .26667rem .26667rem;
	transition: all .3s ease;
	background: #fff
}

.team-four .content h6 {
	margin-bottom: .66667rem;
	font-size: 1.06667rem
}

.team-five .content {
	margin-top: 1.66667rem
}

.team-five .content h6 {
	margin-bottom: .66667rem
}

.team-five .content span {
	display: block
}

.counter.counter--4 .counter_single .team-five .content span.value,
.nav_right_content .cart_module .cart__items .cart_info p .team-five .content span,
.nav_right_content .cart_module .cart__items .items .item_remove .team-five .content span,
.tab-content.tab--content2 .tab-pane .tab_text_module .team-five .content span.tab_text_module__subtitle,
.tab.tab--8 .tab_nav7 .nav .nav-item .team-five .content span.nav-link.active,
.team-five .content .counter.counter--4 .counter_single span.value,
.team-five .content .nav_right_content .cart_module .cart__items .cart_info p span,
.team-five .content .nav_right_content .cart_module .cart__items .items .item_remove span,
.team-five .content .tab-content.tab--content2 .tab-pane .tab_text_module span.tab_text_module__subtitle,
.team-five .content .tab.tab--8 .tab_nav7 .nav .nav-item span.nav-link.active,
.team-five .content .timeline1 .happening .happening__period .wrapper span.year,
.team-five .content span.color-primary,
.timeline1 .happening .happening__period .wrapper .team-five .content span.year {
	font-weight: 500
}

.faq-single {
	margin-bottom: 40px
}

.faq-single h6 {
	margin-bottom: .66667rem
}

.faq-single p {
	margin: 0
}

.event-sidebar {
	border: 1px solid #e4e8ed
}

.widget-wrapper .widget-default {
	border-radius: .26667rem;
	border: 1px solid #e4e8ed;
	margin-bottom: 2rem
}

.widget-wrapper .widget-header .widget-title {
	margin: 0;
	border-bottom: 1px solid #e4e8ed;
	padding: 1.33333rem 2rem 1.33333rem 2rem
}

.widget-wrapper .widget-content {
	padding: 2rem 2rem 2rem
}

.widget-wrapper .widget-shadow {
	background: #fff;
	box-shadow: 0 5px 10px rgba(105, 106, 119, .05);
	border-radius: .4rem
}

.signup-widget .form-group {
	margin-bottom: 1.33333rem
}

.signup-widget .form-group:last-child {
	margin-bottom: 0
}

.search-widget {
	margin-bottom: 2rem
}

.search-widget .input-group {
	position: relative
}

.search-widget .input-group input {
	width: 100%;
	border-radius: 1.66667rem;
	background: #f5f4f7;
	border: 0 none;
	height: 3.33333rem;
	padding: 0 4rem 0 1.66667rem
}

.search-widget .input-group input:focus {
	outline: 0
}

.search-widget .input-group button {
	padding: 0 1.33333rem;
	border-radius: 1.66667rem;
	position: absolute;
	right: 0;
	top: 0;
	height: 3.33333rem;
	background: 0 0;
	border: 0;
	cursor: pointer
}

.category-widget ul {
	margin-top: -6px
}

.category-widget ul li a {
	color: #202428;
	transition: all .3s ease
}

.category-widget ul li a:hover {
	color: #413aa4
}

.sidebar-post .post-single {
	margin-bottom: 1.66667rem
}

.sidebar-post .post-single:last-child {
	margin-bottom: 0
}

.sidebar-post .post-single img {
	border-radius: 3px
}

.sidebar-post .post-single P {
	margin: 0 0 0 1rem
}

.sidebar-post .post-single P span {
	display: block;
	line-height: 1.46667rem
}

.sidebar-post .post-single .post-title {
	margin-top: .66667rem;
	display: block;
	font-weight: 500;
	color: #202428
}

.tags-widget ul {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: -10px
}

.tags-widget ul li {
	margin-right: .66667rem;
	margin-bottom: .66667rem
}

.tags-widget ul li:last-child {
	margin-right: 0
}

.tags-widget ul li a {
	line-height: 1.73333rem;
	display: block;
	border: 1px solid #e4e8ed;
	border-radius: 3px;
	padding: 2px .66667rem;
	transition: all .3s ease;
	color: #5a6671;
	font-size: .86667rem
}

.tags-widget ul li a:hover {
	color: #fff;
	background: #413aa4;
	border-color: #413aa4
}

.addresses_carousel .adress img {
	max-width: 100%;
	width: auto;
	display: inline-block
}

.addresses_carousel .dot-light,
.addresses_carousel .owl-dots {
	margin-top: 0
}

.adress {
	padding: 0 2rem;
	margin-bottom: 3.33333rem
}

.adress .nam {
	margin-top: 1.66667rem;
	font-size: 1.2rem;
	color: #202428;
	margin-bottom: .66667rem;
	font-weight: 600
}

.adress img {
	max-width: 100%;
	width: auto;
	display: inline-block
}

.adress p {
	margin: 0
}

.adress {
	text-align: center
}

.map#map1,
.map#map3,
.map#map4 {
	height: 400px
}

.map#map2 {
	height: 500px
}

footer {
	background: #f4f4f4
}

footer .footer__big {
	padding: 7.33333rem 0 3.33333rem
}

footer .footer__big .text_widget p {
	line-height: 2rem;
	margin-bottom: 1.33333rem
}

footer .footer__big .text_widget p .address,
footer .footer__big .text_widget p .mail,
footer .footer__big .text_widget p .tel {
	display: block;
	color: #5a6671
}

footer .footer__big .text_widget p .mail:hover,
footer .footer__big .text_widget p .tel:hover {
	color: #06b590
}

footer .footer__big .text_widget .footer_logo {
	margin-bottom: 2rem
}

footer .footer__big .widget {
	margin-bottom: 4rem
}

footer .footer__big .widget .widget__title {
	font-size: 1.06667rem;
	text-transform: uppercase;
	line-height: normal;
	font-weight: 600;
	position: relative
}

footer .footer__big .widget .widget__title2 {
	font-size: 1.13333rem;
	color: #202428
}

footer .footer__big .widget .widget__social {
	margin-top: 30px
}

footer .footer__big .widget.subcribe--widget .subscribe_form .embed_icon {
	font-size: 1.33333rem;
	color: #5a6671
}

footer .footer__big .widget.subcribe--widget .subscribe_form input {
	width: 100%;
	font-size: 1rem;
	color: #9192a3;
	outline: 0;
	padding-left: 1.4rem;
	padding-right: 1rem
}

footer .footer__big .widget ul.links li {
	margin-bottom: .66667rem
}

footer .footer__big .widget ul.links li:last-child {
	margin-bottom: 0
}

footer .footer__big .widget ul.links li a {
	color: #5a6671
}

footer .footer__big .widget ul.links li a:hover {
	color: #06b590
}

footer .footer__big .widget--contact_info ul li {
	display: flex;
	margin-bottom: 31px
}

footer .footer__big .widget--contact_info ul li span.la {
	font-size: 28px;
	margin-right: 12px
}

footer .footer__big .widget--contact_info ul li .info p {
	margin: 0;
	color: #fff;
	font-size: 1.06667rem;
	line-height: 26px
}

footer .footer__big .widget--contact_info ul li .info small {
	font-size: 14px
}

footer .footer__big .widget--latest-news ul li {
	margin-bottom: 20px
}

footer .footer__big .widget--latest-news ul li small {
	font-size: 1rem;
	display: block;
	line-height: 30px
}

footer .footer__big .widget--latest-news ul li a {
	color: #fff;
	font-weight: 500;
	line-height: 28px
}

footer .footer__small {
	background: #000
}

footer .footer__small p {
	color: rgba(255, 255, 255, .6);
	margin: 0;
	padding: 30px 0
}

footer .footer__small a {
	color: #06b590
}

footer .footer__bottom .footer__bottom-content {
	border-top: 1px solid #eaeaea;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 2.33333rem 0
}

footer .footer__bottom .footer__bottom-content p {
	margin: 0
}

footer .footer__bottom .footer__bottom-content p>a {
	color: #06b590
}

footer .footer__bottom .footer__bottom-content .social-basic li a {
	color: #9192a3
}

footer .footer__bottom .footer__bottom-content .social-basic li a:hover {
	color: #06b590
}

footer.footer--dark .footer__big .text_widget p a,
footer.footer--dark .footer__big .text_widget p span {
	color: rgba(255, 255, 255, .5)
}

footer.footer--dark .footer__big .widget.subcribe--widget p {
	color: rgba(255, 255, 255, .5)
}

footer.footer--dark .footer__big .widget .widget__title {
	color: #fff
}

footer.footer--dark .footer__big .widget ul.links li a:hover {
	color: #06b590
}

footer.footer--light .widget__social .social ul li a {
	background: #fff
}

footer.footer--light .widget__social .social ul li a span {
	color: #9192a3
}

footer.footer--light .widget__social .social ul li a:hover {
	background: #413aa4
}

footer.footer--light .widget__social .social ul li a:hover span {
	color: #fff
}

footer.footer--light .widget--contact_info ul li .info p {
	color: #202428;
	font-weight: 500
}

footer.footer--light .widget--latest-news ul li a {
	color: #202428
}

footer.footer2.footer--light {
	background: #fff
}

footer.footer2.footer--light .widget.twit--widget .user .name {
	color: #06b590
}

footer.footer2.footer--light .widget.twit--widget .user .name+span {
	color: #9192a3
}

footer.footer2.footer--light .footer__small {
	background: #fff;
	border-top: 1px solid #e4e8ed
}

footer.footer2.footer--light .footer__small p {
	color: #5a6671
}

footer.footer2 .widget.twit--widget .user {
	margin-top: 14px
}

footer.footer2 .widget.twit--widget .user .name {
	color: #fff
}

footer.footer2 .widget.twit--widget .user .name+span:before {
	content: "-";
	margin: 0 3px
}

footer.footer2 .widget.twit--widget a {
	display: inline-block
}

footer.footer2 .widget.twit--widget span.fab {
	margin-right: 12px;
	font-size: 18px
}

footer.footer2 .widget.twit--widget .twit_wrapper>span {
	position: relative;
	top: .46667rem
}

footer.footer2 .footer__small p {
	color: rgba(255, 255, 255, .7)
}

footer.footer2 .footer__small p a:hover {
	color: #fff
}

footer.footer3 .footer__small {
	background: #e4e8ed
}

footer.footer3 .footer__small p {
	color: #5a6671
}

footer.footer4 .footer__big {
	padding: 7.33333rem 0
}

footer.footer4 .footer_menu_items ul li {
	padding: .94rem
}

footer.footer4 .footer_menu_items ul li a {
	line-height: 2.14rem;
	color: rgba(255, 255, 255, .5)
}

footer.footer4 .footer_menu_items ul li a:hover {
	color: #fff
}

footer.footer4 .footer__small .info_links li+li {
	margin-left: 17px
}

footer.footer4 .footer__small .info_links:before {
	content: '|';
	margin: 0 30px;
	color: rgba(255, 255, 255, .2)
}

footer.footer4 .footer_menu_items {
	background: rgba(255, 255, 255, .1)
}

footer.footer4 .footer__small {
	padding: 1.66667rem 0;
	border-top: 1px solid rgba(255, 255, 255, .1)
}

footer.footer4 .footer__small p,
footer.footer4 .footer__small ul {
	padding: 0;
	margin: 0
}

footer.footer4 .social.square ul li a {
	border: 1px solid rgba(255, 255, 255, .2)
}

footer.footer4 .social.square ul li a:hover {
	border-color: transparent
}

footer.footer4.footer--light .footer4_text {
	color: #5a6671
}

footer.footer4.footer--light .footer_menu_items {
	background: #fff
}

footer.footer4.footer--light .footer__small {
	background: #fff
}

footer.footer4.footer--light .footer__small p {
	color: #5a6671
}

footer.footer4.footer--light .footer__small .info_links li a {
	color: #5a6671
}

footer.footer4.footer--light .footer__small .social.square li a {
	color: #9192a3;
	border-color: #e4e8ed
}

footer.footer4.footer--light .footer__small .social.square li a:hover {
	color: #fff;
	border-color: transparent
}

footer.footer4 .footer4_text {
	margin: 3.33rem 0 4.66rem;
	line-height: 2rem
}

footer.footer5.footer--bw .footer__big {
	background: #111115
}

footer.footer5.footer--bw .footer__big .text_widget a {
	color: #fff
}

footer.footer5.footer--bw .footer__big .text_widget a:hover {
	color: #413aa4
}

footer.footer5.footer--bw .footer__big .widget ul.links a:hover {
	color: #fff
}

footer.footer5.footer--bw .footer__big .widget .widget__title {
	color: #fff
}

footer.footer5.footer--bw .footer_small {
	background: #000
}

footer.footer--light-gradient {
	background: linear-gradient(to bottom, #fbfbfd, #f2f1fa)
}

footer.footer6 {
	position: relative;
	overflow: hidden;
	padding-top: 4.33333rem
}

footer.footer6:before {
	position: absolute;
	content: "";
	width: 180%;
	height: 150%;
	background: #fff;
	left: -40%;
	top: -137%;
	border-radius: 50%
}

footer.footer6.footer--dark .widget .widget__title2 {
	color: #fff
}

footer.footer6.footer--dark .footer__bottom .footer__bottom-content {
	border-color: rgba(255, 255, 255, .1)
}

footer.footer7 {
	position: relative;
	overflow: hidden;
	background: url(https://snmtechnologies.in/startup/img/shape-wave3.png) center/100% 100% no-repeat;
	padding-top: 4.66667rem
}

footer.footer7.footer--dark .widget .widget__title2 {
	color: #fff
}

footer.footer7.footer--dark .footer__bottom .footer__bottom-content {
	border-color: rgba(255, 255, 255, .1)
}

.nav-tabs {
	justify-content: center;
	border: 0 none
}

.nav-tabs .nav-item .nav-link {
	background: #413aa4;
	transition: all .3s ease;
	color: #fff;
	font-size: 1.06667rem;
	font-weight: 500;
	line-height: 3.2rem;
	padding: 0 1.86667rem
}

.nav-tabs .nav-item .nav-link.active {
	background: #fff
}

.nav-tabs .nav-item {
	position: relative;
	top: 1px;
	z-index: 1;
	margin: 0
}

.nav-tabs .nav-item:first-child .nav-link {
	border-radius: 4px 0 0 0
}

.nav-tabs .nav-item:last-child .nav-link {
	border-radius: 0 4px 0 0
}

.nav-pills .nav-item {
	margin-right: 10px
}

.nav-pills .nav-item:last-child {
	margin-right: 0
}

.nav-pills .nav-item .nav-link {
	background: rgba(65, 58, 164, .1);
	font-weight: 400;
	font-size: .93333rem;
	line-height: 3.06667rem;
	padding: 0 30px
}

.nav-pills .nav-item .nav-link:hover {
	color: #fff
}

.tab.tab--1 .tab_nav {
	padding: 1.66rem 2.66rem;
	border-radius: .26667rem
}

.tab.tab--1 .tab_nav .nav ul {
	margin-bottom: 0
}

.tab.tab--1 .tab_nav .nav ul li {
	line-height: 2rem
}

.tab.tab--1 .tab_nav .nav .nav-link {
	font-weight: 500;
	text-transform: capitalize;
	padding: 15px 0;
	border-bottom: 1px solid #e4e8ed
}

.tab.tab--1 .tab_nav .nav .nav-link:last-child {
	border-bottom: 0
}

.tab.tab--1 .tab_nav .nav .nav-link.active {
	background: 0 0
}

.tab.tab--1 .tab-content {
	padding-left: 30px
}

.tab.tab--1 .tab-content .tab-pane {
	background: #fff;
	border-radius: .26667rem;
	overflow: hidden;
	box-shadow: 0 5px 20px rgba(105, 106, 119, .05)
}

.tab.tab--1 .tab-content .tab-pane figure {
	margin: 0
}

.tab.tab--1 .tab-content .tab-pane figure figcaption {
	padding: 2.13333rem 2.33333rem 2.33333rem
}

.tab.tab--1 .tab-content .tab-pane figure figcaption h5 {
	line-height: 30px;
	font-weight: 600;
	margin-bottom: 1rem
}

.tab.tab--1 .tab-content .tab-pane figure figcaption a.btn {
	margin-top: 8px
}

.tab.tab--2 .tab_nav2 .nav,
.tab.tab--6 .tab_nav2 .nav {
	border-bottom: 1px solid #e4e8ed
}

.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link,
.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link {
	font-size: 1.2rem;
	font-weight: 500;
	line-height: 4rem;
	position: relative;
	color: rgba(32, 36, 40, .5);
	padding-left: 2rem;
	padding-right: 2rem
}

.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link:before,
.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link:before {
	content: "";
	position: absolute;
	height: 8px;
	width: 8px;
	background: #9d9ebc;
	border-radius: 200px;
	bottom: 0;
	left: 50%;
	transform: translate(-50%, 50%)
}

.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link.active:after,
.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link.active:after {
	position: absolute;
	content: '';
	width: 1.33333rem;
	height: 1.33333rem;
	background: rgba(6, 181, 144, .1);
	border-radius: 200px;
	bottom: 0;
	left: 50%;
	transform: translate(-50%, 50%)
}

.tab.tab--3 .tab_nav3 {
	border-bottom: 1px solid #e4e8ed
}

.tab.tab--3 .tab_nav3 .nav li {
	flex-basis: 0;
	flex-grow: 1;
	text-align: center
}

.tab.tab--3 .tab_nav3 .nav li a {
	font-size: 1.06667rem;
	color: #5a6671;
	font-weight: 500;
	transition: .3s;
	padding: 1.4rem 0
}

.tab.tab--4 .tab--content4 {
	padding: 50px 50px 50px 0;
	border: 1px solid #e4e8ed;
	border-radius: 4px;
	overflow: hidden
}

.tab.tab--4 .tab--content9 {
	padding: 2.66667rem
}

.tab.tab--4 .tab-content .tab-pane .graph_area {
	margin-right: 35px
}

.tab.tab--4 .tab-content .tab-pane .text_content p {
	margin-bottom: 0
}

.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link {
	font-size: 1.2rem
}

.tab.tab--7 .tab_nav7,
.tab.tab--8 .tab_nav7 {
	border-bottom: 1px solid #e4e8ed
}

.tab.tab--7 .tab_nav7 .nav .nav-item .nav-link,
.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link {
	font-size: 1rem;
	line-height: 3.33333rem;
	padding: 0rem 2rem;
	position: relative;
	color: #9192a3
}

.tab.tab--7 .tab_nav7 .nav .nav-item .nav-link span,
.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link span {
	margin-right: 10px;
	font-size: 1.2rem
}

.tab.tab--7 .tab_nav7 .nav .nav-item .nav-link.active:before,
.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link.active:before {
	content: "";
	width: 100%;
	height: 2px;
	position: absolute;
	bottom: -1px;
	left: 0
}

.tab.tab--7 .tab--content7,
.tab.tab--8 .tab--content7 {
	margin-top: 35px
}

.tab.tab--7 .tab--content7 h5,
.tab.tab--8 .tab--content7 h5 {
	margin-bottom: 20px
}

.tab.tab--8 .tab_nav7 {
	border-bottom: 0;
	border-left: 1px solid #e4e8ed
}

.tab.tab--8 .tab_nav7 .nav {
	flex-direction: column
}

.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link {
	padding: 0rem 1.66667rem
}

.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link.active:before {
	height: 100%;
	width: 1px;
	left: -1px
}

.tab.tab--8 .tab-content h5 {
	margin-bottom: 1.33333rem
}

.tab-content.tab--content2 {
	margin-top: 3.33333rem
}

.tab-content.tab--content2 .tab-pane .tab_text_module .tab_text_module__subtitle {
	font-size: 1.06667rem;
	font-weight: 400;
	margin-bottom: 5px;
	color: #06b590
}

.tab-content.tab--content2 .tab-pane .tab_text_module h2 {
	font-weight: 600;
	font-size: 2.4rem;
	line-height: 2.8rem;
	margin-bottom: 2rem
}

.tab-content.tab--content2 .tab-pane .tab_text_module .btn {
	margin-top: 1.26667rem
}

.tab-content.tab--content2 .tab-pane .tab_text_module ul li {
	color: #202428;
	font-weight: 500;
	line-height: 2.13333rem;
	margin: 0
}

.tab-content.tab--content2 .tab-pane .tab_image_module--left,
.tab-content.tab--content2 .tab-pane .tab_image_module--right {
	margin-bottom: 0
}

.tab-content.tab--content2 .tab-pane .tab_image_module--left img,
.tab-content.tab--content2 .tab-pane .tab_image_module--right img {
	border-radius: 4px
}

.tab_nav4 .nav-tabs li a {
	background: #00008b
}

.tab_nav5 {
	margin-bottom: 2rem
}

.tab_event>p {
	color: #413aa4;
	font-weight: 500;
	line-height: 2.53333rem;
	margin-top: 16px;
	margin-bottom: 15px
}

.tab_event .tab_event__module {
	padding: 32px 40px 2.46667rem;
	border-radius: .266rem
}

.tab_event .tab_event__module .event_meta {
	margin-bottom: 10px;
	display: flex;
	flex-wrap: wrap
}

.tab_event .tab_event__module .event_meta p {
	margin-right: 1.46667rem;
	font-size: 1rem;
	display: flex;
	align-items: center;
	margin-bottom: 0
}

.tab_event .tab_event__module .event_meta p span.la {
	font-size: 1.2rem;
	vertical-align: middle;
	margin-right: 8px
}

.tab_event .tab_event__module h5 {
	color: #202428;
	line-height: 2.53333rem;
	margin-bottom: .66667rem
}

.tab_event .tab_event__module .speakers {
	display: flex;
	margin-bottom: 0;
	padding-top: 11px
}

.tab_event .tab_event__module .speakers li {
	display: flex;
	align-items: center
}

.tab_event .tab_event__module .speakers li>div {
	margin-left: 20px
}

.tab_event .tab_event__module .speakers li+li {
	margin-left: 30px
}

.tab_event .tab_event__module .speakers li img {
	border-radius: 200px;
	height: 50px;
	width: 50px
}

.tab_event .tab_event__module .speakers li h6,
.tab_event .tab_event__module .speakers li p {
	margin: 0;
	line-height: 1.86667rem
}

.tab_event .tab_event__module .speakers li p {
	font-size: 14px
}

.tab_event .tab_event__module .speakers li h5 {
	font-size: 1.2rem
}

.service--tabs .tab_nav2 .nav {
	padding: 0
}

.service--tabs .tab_nav2 .nav .nav-link {
	padding: .86667rem 1.33333rem;
	color: #202428;
	background: rgba(65, 58, 164, .05);
	margin-bottom: 5px;
	transition: all .3s ease;
	font-size: 1.06667rem;
	font-weight: 500
}

.service--tabs .tab_nav2 .nav .nav-link:last-child {
	margin-bottom: 0
}

.service--tabs .tab_nav2 .nav .nav-link.active {
	background: #06b590;
	color: #fff
}

.testimonial2 .carousel-single .author-spec .author-desc h5 {
	color: #202428
}

.testimonial6 {
	padding: 5.33333rem 0
}

.single_testimonial .big--quote {
	font-size: 7.33333rem;
	color: rgba(255, 255, 255, .1);
	position: relative;
	left: -13px
}

.single_testimonial p {
	color: rgba(255, 255, 255, .7);
	font-size: 1.33333rem;
	line-height: 2.4rem;
	margin: 0
}

.single_testimonial .single_testimonial_meta {
	padding-top: 35px;
	color: #fff;
	font-weight: 500;
	margin-bottom: 0
}

.single_testimonial .single_testimonial_meta span {
	font-size: 1.2rem;
	font-weight: 400;
	color: rgba(255, 255, 255, .5);
	margin-left: .66667rem
}

.intro-area-11 {
	background-image: url(https://snmtechnologies.in/startup/img/intro-bg.png);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	padding-bottom: 3.33333rem;
	position: relative
}

.intro-area-11:before {
	position: absolute;
	content: '';
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background: #fff;
	background: linear-gradient(to right, #fff, #f3f2fa);
	filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0, startColorstr=#ffffff, endColorstr=#f3f2fa);
	z-index: -1
}

.intro-area-11 .menu_area.menu8 {
	box-shadow: none;
	background: 0 0
}

.intro-area-two {
	background-image: linear-gradient(to right, #413aa4, #06b590);
	position: relative;
	padding-bottom: 4rem
}

.intro-area-two:before {
	position: absolute;
	content: '';
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background-image: url(https://snmtechnologies.in/startup/img/svg/shape2.svg), linear-gradient(to right, #413aa4, #06b590);
	background-repeat: no-repeat;
	background-position: right;
	opacity: .15
}

.intro-area-two .menu_area.menu8 {
	box-shadow: none;
	background: 0 0
}

.intro-one {
	position: relative;
	min-height: 47.46667rem
}

.intro-one .intro-one--contents {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	display: flex;
	align-items: center
}

.intro-one h1 {
	color: #202428;
	font-weight: 600
}

.intro-one p {
	font-size: 17px;
	margin: 0;
	line-height: 2.13333rem
}

.intro-one .btn {
	margin-top: 2.66667rem
}

.intro-one .intro-one--img {
	position: absolute;
	width: 50%;
	height: 100%;
	right: 0;
	top: 0;
	background: linear-gradient(-45deg, #06b590, #413aa4);
	display: flex;
	align-items: center;
	justify-content: center
}

.intro-two {
	min-height: 53.33333rem;
	display: flex;
	align-items: center;
	position: relative;
	overflow: hidden
}

@media all and (-ms-high-contrast:none),
(-ms-high-contrast:active) {
	.intro-two {
		height: 53.33333rem
	}
}

.intro-two:before {
	position: absolute;
	content: '';
	width: 89%;
	height: 100%;
	border-top: 800px solid #06b590;
	border-right: 836px solid transparent;
	border-left: 0 solid transparent;
	left: 0;
	top: 0
}

.intro-two h1 {
	line-height: 4rem;
	color: #fff;
	font-weight: 600;
	margin-bottom: 1.66667rem
}

.intro-two p {
	color: #fff;
	margin: 0;
	font-size: 1.13333rem;
	line-height: 2.13333rem
}

.intro-two ul {
	margin: 2.66667rem 0 0 0;
	display: flex;
	flex-wrap: wrap
}

.intro-two ul li {
	margin-right: 2rem
}

.intro-two ul li:last-child {
	margin-right: 0
}

.intro-three {
	min-height: 53.33333rem;
	position: relative;
	background: linear-gradient(-45deg, #f7f6fc, #fff);
	overflow: hidden
}

.intro-three:before {
	position: absolute;
	content: '';
	width: 80rem;
	height: 93.33333rem;
	border-radius: 50%;
	left: -520px;
	bottom: -900px
}

.intro-three:after {
	position: absolute;
	content: '';
	width: 100%;
	height: 100%;
	background: url(https://snmtechnologies.in/startup/img/shape2.png) top right/auto no-repeat
}

.intro-three .intro-three--img {
	position: absolute;
	width: 50%;
	height: 100%;
	left: 0;
	top: 0;
	display: flex;
	align-items: center;
	padding-left: 16.66667rem
}

.intro-three .intro-three--contents {
	position: absolute;
	width: 100%;
	left: 0;
	height: 100%;
	top: 0;
	display: flex;
	align-items: center;
	z-index: 1
}

.intro-three .intro-three--contents h1 {
	font-weight: 600
}

.intro-three .intro-three--contents p {
	font-size: 1.13333rem;
	margin: 0;
	line-height: 2.13333rem
}

.intro-three .intro-three--contents .btn {
	margin-top: 2.33333rem
}

.intro-four {
	position: relative;
	min-height: 53.33333rem
}

.intro-four:before {
	position: absolute;
	content: "";
	width: 80%;
	height: 100%;
	left: 0;
	top: 0;
	background: linear-gradient(to right, #f1f2f7 50%, rgba(241, 242, 247, 0));
	z-index: 1
}

.intro-four .intro-four--contents {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	display: flex;
	align-items: center
}

.intro-four .intro-four--contents h1 {
	font-weight: 600;
	margin-bottom: 1.66667rem
}

.intro-four .intro-four--contents p {
	margin: 0;
	font-size: 1.13333rem;
	color: #202428;
	line-height: 2.13333rem
}

.intro-four .intro-four--contents ul {
	display: flex;
	margin-top: 2.66667rem
}

.intro-four .intro-four--contents ul li {
	margin-right: 2rem
}

.intro-four .intro-four--contents ul li:last-child {
	margin-right: 0
}

.intro-five h1 {
	font-weight: 600
}

.intro-five p {
	font-size: 1.13333rem;
	margin: 0;
	line-height: 2.13333rem
}

.intro-five .btn {
	margin-top: 2.33333rem
}

.shape-wrapper {
	position: relative
}

.shape-wrapper:before {
	position: absolute;
	content: '';
	width: 100%;
	height: 100%;
	left: 0;
	top: 0
}

.shape-wrapper img {
	width: 100%
}

.shape-wrapper.img-shape-one:before {
	background: url(https://snmtechnologies.in/startup/img/img_shape1.png);
	background-size: 100% 100%;
	background-repeat: no-repeat
}

.shape-wrapper.img-shape-two:before {
	background: url(https://snmtechnologies.in/startup/img/img_shape2.png);
	background-size: 100% 101%;
	background-repeat: no-repeat
}

.shape-wrapper.img-shape-three:before {
	background: url(https://snmtechnologies.in/startup/img/img_shape3.png);
	background-size: 100% 101%;
	background-repeat: no-repeat;
	background-position: center
}

.intro_area9 {
	min-height: 56.66667rem;
	position: relative
}

.intro_area9 .intro_area9--contents {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	display: flex;
	align-items: center
}

.intro_area9 .intro_area9--contents:before {
	position: absolute;
	width: 50%;
	height: 100%;
	left: 0;
	top: 0;
	content: '';
	background: linear-gradient(140deg, #413aa4 0, #413aa4 25%, #06b590 100%)
}

.intro_area9 .intro_area9--contents h1 {
	font-size: 3.6rem;
	line-height: 4rem;
	color: #fff;
	font-weight: 600;
	margin: 0 0 2.66667rem
}

.intro_area9 .intro_area9--contents p {
	font-size: 1.13333rem;
	line-height: 2.13333rem;
	color: rgba(255, 255, 255, .8);
	margin: 0 0 2.66667rem
}

.intro_area9 .intro_area9--contents .btn {
	text-transform: uppercase
}

.intro_area9 .intro_area9--slides {
	position: absolute;
	width: 50%;
	right: 0;
	top: 0;
	height: 100%;
	display: flex;
	align-items: center
}

.intro_area9 .intro_area9--slides .intro_area9-carousel {
	text-align: center
}

.intro_area9 .intro_area9--slides .intro_area9-carousel img {
	display: inline-block;
	width: auto
}

.intro_area9 .intro_area9--slides .intro_area9-carousel .dot-light,
.intro_area9 .intro_area9--slides .intro_area9-carousel .owl-dots {
	height: 2.13333rem;
	background: rgba(6, 181, 144, .1);
	border-radius: 20rem;
	padding: 0 1.33333rem;
	display: inline-flex
}

.intro_area9 .intro_area9--slides .intro_area9-carousel .dot-light .owl-dot span,
.intro_area9 .intro_area9--slides .intro_area9-carousel .owl-dots .owl-dot span {
	border: 0 none;
	background: #fff
}

.intro_area9 .intro_area9--slides .intro_area9-carousel .dot-light .owl-dot.active span,
.intro_area9 .intro_area9--slides .intro_area9-carousel .owl-dots .owl-dot.active span {
	background: #06b590
}

.intro-area-four {
	display: flex;
	align-items: flex-end;
	border-bottom: 1px solid #e4e8ed;
	min-height: 56.66667rem;
	position: relative
}

.intro-area-four .img-left,
.intro-area-four .img-right {
	position: absolute;
	top: 50%;
	transform: translateY(-50%)
}

.intro-area-four .img-left {
	left: 0
}

.intro-area-four .img-right {
	right: 0
}

.intro-area-four .intro-area-four--contents {
	text-align: center
}

.intro-area-four .intro-area-four--contents h1 {
	font-weight: 300;
	font-size: 3.6rem;
	line-height: 4.13333rem;
	margin-bottom: 1.33333rem
}

.intro-area-four .intro-area-four--contents h1 span {
	color: #06b590;
	font-weight: 600
}

.intro-area-four .intro-area-four--contents p {
	font-size: 1.13333rem;
	line-height: 2.13333rem;
	margin: 0
}

.intro-form {
	margin: 2.53333rem 0 3.33333rem 0;
	display: flex;
	flex-wrap: wrap
}

.intro-form .input-group {
	width: auto;
	flex: 1 1
}

.intro-form .input-group span.icon-left {
	left: 1.33333rem
}

.intro-form .input-group input {
	border-radius: 3px 0 0 3px !important;
	box-shadow: 0 .33333rem .66667rem rgba(145, 142, 187, .1);
	padding-left: 3.33333rem
}

.intro-form button {
	flex: auto;
	border-radius: 0 3px 3px 0;
	box-shadow: 0 .33333rem .66667rem rgba(145, 142, 187, .1)
}

.rev_slider {
	direction: lTr
}

.rev_slider .slotholder:before {
	position: absolute;
	content: "";
	height: 100%;
	width: 100%;
	background: rgba(65, 58, 164, .7);
	z-index: 99
}

#rev_slider_15_1_wrapper .slotholder:before,
#rev_slider_15_2_wrapper .slotholder:before,
#rev_slider_17_1_wrapper .slotholder:before {
	position: absolute;
	content: "";
	height: 100%;
	width: 100%;
	background: rgba(32, 36, 40, .6);
	z-index: 99;
	left: 0;
	top: 0
}

.overlay_blue.rev_slider .slotholder:before {
	background: rgba(59, 62, 121, .7)
}

.rev_slider_17_1_wrapper .form-wrapper .btn {
	text-align: center
}

.rev_slider.without_overlay .slotholder:before {
	display: none
}

#rev_slider_7_1_wrapper .slotholder:before,
#rev_slider_9_1_wrapper .slotholder:before {
	content: none
}

.custom.tparrows:before,
.hephaistos.tparrows:before,
.hesperiden.tparrows:before,
.tparrows:before {
	font-family: LineAwesome, sans-serif;
	font-size: 20px
}

.custom.tparrows.tp-leftarrow:before {
	content: "\\f120"
}

.custom.tparrows.tp-rightarrow:before {
	content: "\\f121"
}

.hephaistos.tparrows.tp-leftarrow:before,
.hesperiden.tparrows.tp-leftarrow:before {
	content: "\\f111"
}

.hephaistos.tparrows.tp-rightarrow:before,
.hesperiden.tparrows.tp-rightarrow:before {
	content: "\\f112"
}

#rev_slider_27_1_wrapper .hero_btn {
	border-color: #fff;
	color: #fff
}

#rev_slider_27_1_wrapper .hero_btn:hover {
	border-color: #413aa4
}

.rev_slider .btn-icon i,
.rev_slider .btn-icon span {
	font-size: 20px
}

.tp-caption .form-wrapper {
	min-width: 21.33333rem
}

.erinyen .tp-bullet {
	background: #fff;
	border: 0 none;
	transition: all .3s ease;
	width: 12px;
	height: 12px
}

.erinyen .tp-bullet.selected,
.erinyen .tp-bullet:hover {
	background: rgba(255, 255, 255, .4);
	border: 0 none
}

.erinyen.tp-bullets:before {
	content: "";
	background: rgba(255, 255, 255, .15);
	border-radius: 300px;
	box-shadow: none;
	left: 0
}

.zeus.tparrows:before {
	font-family: LineAwesome
}

.zeus.tparrows.tp-rightarrow:before {
	content: '\\f112'
}

.zeus.tparrows.tp-leftarrow:before {
	content: '\\f111'
}

.hades .tp-thumb-img-wrap {
	background: rgba(255, 255, 255, .2);
	box-shadow: none
}

.hades .tp-thumb-image {
	box-shadow: none
}

.hades .tp-thumb.selected .tp-thumb-img-wrap,
.hades .tp-thumb:hover .tp-thumb-img-wrap {
	background: #06b590
}

.trumbowyg-box .trumbowyg-editor {
	min-height: 13.33333rem
}

.separator {
	margin-top: 5.33333rem;
	height: 1px;
	background: #e4e8ed;
	margin-bottom: 5.33333rem
}

.case_studies {
	position: relative
}

.bt1 {
	border-top: 1px solid #e4e8ed
}

.services_area .section_title {
	margin-bottom: 0
}

.services_area .section_title h1 {
	margin-bottom: 10px
}

.features-area .section-title {
	text-align: center;
	margin-bottom: 2.66667rem
}

.features-area .section-title h3 {
	color: #202428;
	margin-bottom: 1.66667rem
}

.features-area .section-title p {
	color: #202428;
	margin: 0
}

.service-two {
	padding: 7.33333rem 0 5.33333rem;
	background: url(https://snmtechnologies.in/startup/img/shape-wave2.png) center/100% 100% no-repeat
}

.p-box {
	padding: 2rem 2.66667rem 2.33333rem;
	background: #377dff;
	border-radius: .4rem
}

.p-box p {
	margin: 0;
	font-size: 1.13333rem;
	line-height: 2.26667rem
}

.p-box h4 {
	font-weight: 500;
	line-height: 2.66667rem;
	margin: 0;
	color: #fff
}

.about-links,
.event-types {
	box-shadow: 0 5px 30px rgba(105, 106, 119, .1);
	position: relative;
	z-index: 1
}

.about-links ul li,
.event-types ul li {
	margin: 0 15px
}

.about-links ul li a,
.event-types ul li a {
	font-size: 1.06667rem;
	color: #5a6671;
	padding: 2rem 0;
	display: block;
	font-weight: 500;
	transition: all .3s ease
}

.about-links ul li a.active,
.event-types ul li a.active {
	color: #413aa4;
	border-bottom: 2px solid #413aa4
}

.about-links ul li a:hover,
.event-types ul li a:hover {
	color: #413aa4
}

.event-types {
	background: #fff
}

.event-types ul li a {
	padding-left: 50px;
	padding-right: 50px
}

.search-wrapper form {
	padding: 2.66667rem;
	box-shadow: 0 5px 30px rgba(105, 106, 119, .1);
	background: #fff;
	border-radius: .4rem
}

.search-wrapper form h4 {
	font-weight: 600;
	color: #413aa4;
	margin-bottom: 1rem
}

.search-wrapper .form-group .form-control {
	width: auto;
	border: 1px solid #ecf1f7 !important;
	height: 3.66667rem;
	background: #fff;
	margin-right: -1px
}

.search-wrapper .form-group .form-control:first-child {
	flex: 3 1
}

.search-wrapper .form-group .form-control:nth-child(2) {
	flex: 1 1
}

.search-wrapper .form-group .select-basic {
	flex: 2 1
}

.search-wrapper .form-group .select-basic .form-control {
	width: 100%;
	height: 3.66667rem
}

.career-search {
	position: relative
}

.career-search .search-wrapper {
	position: absolute;
	width: 100%;
	left: 0;
	top: 0;
	transform: translateY(-50%);
	z-index: 1
}

.job-categories .card {
	margin-bottom: 2rem
}

.information-box {
	position: relative
}

.information-wrapper {
	position: absolute;
	width: 100%;
	left: 0;
	top: -80px;
	z-index: 1
}

.information-wrapper .card-header {
	padding: 1.8rem 2.13333rem 1.66667rem
}

.information-wrapper ul li {
	margin-bottom: 2rem
}

.information-wrapper ul li:last-child {
	margin-bottom: 0
}

.information-wrapper ul li span {
	flex: 1 1
}

.information-wrapper ul li span i {
	color: #413aa4;
	padding-right: .53333rem;
	font-size: 1.06667rem
}

.information-wrapper ul li span:first-child {
	color: #202428;
	font-weight: 500
}

.apply-form .apply-form--header {
	margin-bottom: 3.33333rem;
	text-align: center
}

.apply-form .apply-form--header h3 {
	margin-bottom: 1rem
}

.apply-form .apply-form--header p {
	font-size: 1.2rem
}

.apply-form .form-group {
	display: flex;
	align-items: center;
	margin-bottom: 1.33333rem
}

.apply-form .form-group label {
	min-width: 13.33333rem;
	color: #202428
}

.apply-form .form-group label .sup {
	color: #413aa4
}

.apply-form .form-group label .optional {
	color: #8c96a0
}

.apply-form .form-group .select-basic {
	width: 100%
}

.apply-form form h4 .optional {
	color: #9192a3;
	font-weight: 400
}

.team-profile .team-details h4 {
	margin-bottom: .66667rem
}

.team-profile .team-details span {
	display: block;
	line-height: 1.7
}

.team-profile .team-details span strong {
	font-weight: 500
}

.service-tab-wrapper .download-widget {
	overflow: hidden
}

.service-tab-wrapper .download-widget .header {
	padding: 1rem;
	text-align: center;
	border-width: 1px 1px 0 1px;
	border-color: #e4e8ed;
	border-style: solid
}

.service-tab-wrapper .download-widget .header h6 {
	font-weight: 500;
	margin: 0
}

.service-tab-wrapper .download-widget .content {
	padding: 2rem 2rem 1.13333rem;
	border: 1px solid #e4e8ed;
	border-radius: 0 0 .4rem .4rem
}

.service-tab-wrapper .download-widget .content p {
	margin: 1.66667rem 0 0 0;
	text-align: center
}

.service-tab-wrapper .download-widget .content p span {
	display: block;
	margin-top: 5px;
	font-size: 13px;
	color: #9192a3
}

.service-tab-wrapper .cta-widget {
	border: 1px solid #e4e8ed
}

.service-tab-wrapper .cta-widget h6 {
	padding: 1rem;
	font-weight: 500;
	text-align: center;
	border-bottom: 1px solid #e4e8ed;
	margin: 0
}

.service-tab-wrapper .cta-widget .content {
	text-align: center;
	padding: 1.33333rem 2rem 2rem
}

.service-tab-wrapper .cta-widget .content p {
	margin: 0
}

.service-tab-wrapper .cta-widget .content p>span {
	display: block
}

.service-tab-wrapper .cta-widget .content p.call-us span:last-child {
	font-weight: 500;
	color: #202428
}

.service-tab-wrapper .cta-widget .content p.call-us span:last-child i {
	color: #413aa4
}

.event-details-intro .subtext {
	margin-bottom: 1rem
}

.event-details-intro h1 {
	line-height: 4rem
}

.event-details-intro .countdown {
	margin-top: 3.33333rem
}

.event-overview h4 {
	margin-bottom: 13px
}

.countdown {
	display: flex;
	justify-content: center;
	flex-wrap: wrap
}

.countdown li {
	width: 8rem;
	height: 8rem;
	background: rgba(255, 255, 255, .1);
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 1.33333rem;
	flex-direction: column
}

.countdown li:last-child {
	margin-right: 0
}

.countdown li span:first-child {
	font-size: 2.66667rem;
	font-weight: 600;
	color: #fff;
	line-height: 3.33333rem
}

.countdown li span:last-child {
	color: rgba(255, 255, 255, .5)
}

.error-wrapper {
	padding: 7.33333rem 0
}

.error-wrapper .error-contents figure {
	margin-bottom: 2.26667rem
}

.error-wrapper .error-contents figure img {
	width: 26.66667rem
}

.error-wrapper .error-contents h3 {
	color: #202428
}

.error-wrapper .error-contents p {
	margin: 0 auto;
	width: 33.33333rem
}

.login-register {
	height: 100%;
	position: relative
}

.login-register .login-form .form-wrapper,
.login-register .signup-form .form-wrapper {
	padding: 0 2rem
}

.login-register .login-form .form-wrapper .card .card-header h4,
.login-register .signup-form .form-wrapper .card .card-header h4 {
	margin: 1.33333rem 0
}

.login-register .login-form .form-wrapper .card .card-body,
.login-register .signup-form .form-wrapper .card .card-body {
	padding-bottom: 4rem
}

.login-register .login-form .form-wrapper .card .card-body .form-group,
.login-register .signup-form .form-wrapper .card .card-body .form-group {
	margin-bottom: 1.66667rem
}

.login-register .login-form .form-wrapper .card .card-body .custom-control,
.login-register .signup-form .form-wrapper .card .card-body .custom-control {
	padding-left: 0
}

.login-register .login-form .form-wrapper .other-logins a,
.login-register .signup-form .form-wrapper .other-logins a {
	line-height: 2.66667rem;
	padding: 0 1.33333rem;
	font-size: .93333rem;
	margin-right: 1.33333rem;
	border-radius: .2rem
}

.login-register .login-form .form-wrapper .other-logins a:first-child,
.login-register .signup-form .form-wrapper .other-logins a:first-child {
	color: #06b590;
	border: 1px solid #06b590
}

.login-register .login-form .form-wrapper .other-logins a:last-child,
.login-register .signup-form .form-wrapper .other-logins a:last-child {
	margin-right: 0;
	color: #413aa4;
	border: 1px solid #413aa4
}

.login-register .login-form {
	padding-top: 11.66667rem;
	padding-bottom: 11.66667rem
}

.login-register .signup-form {
	padding-top: 5.66667rem;
	padding-bottom: 7.33333rem
}

.coming-soon {
	min-height: 65.33333rem
}

.coming-soon .cs-contents {
	padding: 10rem 0
}

.coming-soon .cs-contents .cs-text {
	display: block;
	font-size: 3.33333rem;
	font-weight: 600;
	color: #fff;
	margin: 3.33333rem 0 2.26667rem
}

.coming-soon .cs-contents p {
	width: 33.33333rem;
	margin: 0 auto 3rem auto;
	color: rgba(255, 255, 255, .8);
	font-size: 1.2rem
}

.project-list {
	margin-bottom: 2rem
}

.project-list .card {
	flex-direction: row
}

.project-list .card figure {
	flex: 2 1
}

.project-list .card .card-body {
	flex: 2 1;
	padding: 2.93333rem 3.33333rem
}

.project-list .card .card-body h5 {
	margin-bottom: 1.66667rem
}

.project-list .card .card-body h5 a {
	transition: all .3s ease
}

.project-list .card .card-body h5 a:hover {
	color: #413aa4
}

.project-masonry .filtr-container-masonry .filtr-item {
	margin-bottom: 2rem
}

.project-single .project-info .info-box {
	padding: 2.33333rem;
	border: 1px solid #e4e8ed;
	box-shadow: 0 5px 30px rgba(105, 106, 119, .05)
}

.project-single .project-info .info-box h6 {
	margin-bottom: 25px
}

.project-single .project-info .info-box ul li {
	margin-bottom: 1rem;
	display: flex
}

.project-single .project-info .info-box ul li:last-child {
	margin-bottom: 0
}

.project-single .project-info .info-box ul li span {
	flex: 1 1
}

.project-single .project-info .info-box ul li span:last-child {
	font-weight: 500;
	color: #202428
}

.project-desc h4 {
	margin-bottom: 20px
}

.project-gallery figure {
	margin-bottom: 2rem
}

.project-gallery figure img {
	width: 100%
}

.products-wrapper .product-sort {
	margin-bottom: 2.33333rem
}

.products-wrapper .product-sort .sort,
.products-wrapper .product-sort .total-pages {
	flex-basis: 0;
	flex-grow: 1
}

.products-wrapper .product-sort .sort span {
	flex: 1 1
}

.products-wrapper .product-sort .sort .form-group {
	flex: 4 1
}

.products-wrapper .product-sort .total-pages p {
	margin-bottom: 0
}

.product-details .product-info h4 {
	margin-bottom: 1rem
}

.product-details .product-info .product-price {
	font-size: 1.6rem;
	font-weight: 600;
	color: #413aa4;
	display: block;
	margin-bottom: .33333rem
}

.product-details .product-info .product-ratings {
	align-items: center;
	margin-bottom: 1rem
}

.product-details .product-info .product-ratings p {
	margin: 0
}

.product-details .product-info .product-ratings p span {
	color: #ffaf00
}

.product-details .product-info .product-ratings .total-reviews {
	margin-left: 1rem
}

.product-details .product-info .product-actions {
	margin: 1.33333rem 0;
	padding: 2rem 0;
	border-top: 1px solid #e4e8ed;
	border-bottom: 1px solid #e4e8ed
}

.product-details .product-info .product-actions form {
	display: flex;
	align-items: center
}

.product-details .product-info .product-actions form .total-item {
	margin-right: 2rem
}

.product-details .product-info .product-actions form .total-item .pcount {
	font-size: 16px;
	cursor: pointer
}

.product-details .product-info .product-actions form .total-item input {
	width: 3rem;
	height: 3rem;
	text-align: center;
	border: 1px solid #9192a3
}

.product-details .product-info .product-actions form ul li {
	margin-right: 1.33333rem
}

.product-details .product-info .product-actions form ul li:last-child {
	margin-right: 0
}

.product-details .product-info .product-category {
	align-items: center
}

.product-details .product-info .product-category span {
	margin-right: 1.33333rem
}

.product-details .product-info .product-category p {
	margin: 0
}

.product-info-tab .review-wrapper .reviews {
	margin-bottom: 1.66667rem;
	margin-top: 3.33333rem;
	padding: 0 2.66667rem
}

.product-info-tab .review-wrapper .reviews .review-single {
	display: flex;
	padding-bottom: 2.33333rem;
	margin-bottom: 2.33333rem;
	border-bottom: 1px solid #e4e8ed
}

.product-info-tab .review-wrapper .reviews .review-single .review-details {
	flex: 1 1
}

.product-info-tab .review-wrapper .reviews .review-single .review-details ul li {
	display: flex;
	margin-bottom: .86667rem
}

.product-info-tab .review-wrapper .reviews .review-single .review-details ul li:last-child {
	margin-bottom: 0
}

.product-info-tab .review-wrapper .reviews .review-single .review-details ul li span {
	flex: 1 1
}

.product-info-tab .review-wrapper .reviews .review-single .review-details ul li .strong {
	flex: 3 1;
	color: #202428;
	font-weight: 500
}

.product-info-tab .review-wrapper .reviews .review-single .review-details ul li .strong span {
	color: #ffaf00;
	font-size: 12px
}

.product-info-tab .review-wrapper .reviews .review-single .review-text {
	flex: 1 1
}

.product-info-tab .review-wrapper .review-form {
	padding: 4rem
}

.product-info-tab .review-wrapper .review-form h4 {
	color: #202428;
	margin-bottom: .66667rem
}

.product-info-tab .review-wrapper .review-form p {
	margin: 0
}

.product-info-tab .review-wrapper .review-form p a {
	color: #5a6671;
	font-size: 1.2rem
}

.product-info-tab .review-wrapper .review-form form {
	margin-top: 3rem
}

.product-info-tab .review-wrapper .review-form form input,
.product-info-tab .review-wrapper .review-form form textarea {
	margin-bottom: 2rem
}

.product-info-tab .review-wrapper .review-form form .rating span {
	padding-bottom: .6rem;
	margin-right: 1rem;
	color: #202428;
	font-weight: 500
}

.br-theme-fontawesome-stars .br-widget {
	height: 28px;
	white-space: nowrap
}

.br-theme-fontawesome-stars .br-widget a {
	font-family: LineAwesome, sans-serif;
	text-rendering: auto;
	-webkit-font-smoothing: antialiased;
	text-decoration: none;
	margin-right: 2px
}

.br-theme-fontawesome-stars .br-widget a:after {
	content: "\\f318";
	color: #d2d2d2
}

.br-theme-fontawesome-stars .br-widget a.br-active:after {
	color: #f2b01e
}

.br-theme-fontawesome-stars .br-widget a.br-selected:after {
	color: #f2b01e
}

.br-theme-fontawesome-stars .br-widget .br-current-rating {
	display: none
}

.br-theme-fontawesome-stars .br-readonly a {
	cursor: default
}

@media print {
	.br-theme-fontawesome-stars .br-widget a:after {
		content: '\\f318';
		color: #000
	}

	.br-theme-fontawesome-stars .br-widget a.br-active:after,
	.br-theme-fontawesome-stars .br-widget a.br-selected:after {
		content: '\\f318';
		color: #000
	}
}

.cart-table thead th {
	border-top: 1px solid #e4e8ed;
	vertical-align: middle;
	padding: 1rem 0
}

.cart-table thead th+th {
	padding-left: 4.66667rem
}

.cart-table thead th span {
	font-size: 1.06667rem;
	font-weight: 500;
	color: #202428
}

.cart-table thead th span:last-child {
	text-align: right
}

.cart-table .cart-single td,
.cart-table .cart-single th {
	vertical-align: middle;
	padding: 1.33333rem 0
}

.cart-table .cart-single td+td {
	padding-left: 4.66667rem
}

.cart-table .cart-single .name {
	display: flex;
	align-items: center;
	flex-wrap: wrap
}

.cart-table .cart-single .name a {
	font-size: 1.2rem;
	font-weight: 500;
	line-height: 1.73333rem;
	color: #202428;
	margin-left: 2rem;
	flex: 2 1
}

.cart-table .cart-single .total-item input {
	width: 3rem;
	height: 3rem;
	border: 1px solid #9192a3;
	text-align: center
}

.cart-table .cart-single .total-item input[type=number]::-webkit-inner-spin-button,
.cart-table .cart-single .total-item input[type=number]::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0
}

.cart-table .cart-single .remove a {
	font-size: 1.33333rem
}

.cart-table .cart-bottom {
	padding-bottom: 2rem
}

.cart-table .cart-bottom td {
	padding: 2rem 0;
	border-bottom: 1px solid #e4e8ed;
	vertical-align: middle
}

.cart-table .cart-bottom form {
	display: flex;
	max-width: 24.66667rem
}

.cart-table .cart-bottom form button {
	margin-left: 2rem
}

.cart-table .cart-bottom .total-amount span {
	color: #202428;
	font-weight: 500
}

.cart-table .cart-actions {
	display: flex;
	align-items: center;
	flex-wrap: wrap
}

.cart-table .cart-actions .ml-auto a:last-child {
	margin-left: .46667rem
}

.cart-table.cart-table--2 thead th {
	padding: 1.66667rem 0
}

.cart-table.cart-table--2 thead th:last-child {
	padding-left: 4rem
}

.cart-table.cart-table--2 .cart-bottom td {
	border-bottom: 0
}

.ukm .filter-item {
	padding-bottom: 30px
}

.checkout-wrapper .nav-item {
	position: relative
}

.checkout-wrapper .nav-item:before {
	position: absolute;
	content: "\\f186";
	font-family: LineAwesome, sans-serif;
	font-size: 20px;
	right: -75px;
	top: 50%;
	transform: translateY(-50%);
	color: rgba(59, 62, 121, .5)
}

.checkout-wrapper .nav-item:last-child {
	margin-right: 0
}

.checkout-wrapper .nav-item:last-child:before {
	content: none
}

.checkout-wrapper .nav-item .nav-link {
	padding: 0
}

.checkout-wrapper .tab-content h4 {
	padding-bottom: 1.53333rem;
	margin-bottom: 3.33333rem;
	border-bottom: 1px solid #e4e8ed
}

.checkout-wrapper .tab-content form .form-group {
	margin-bottom: 1.66667rem
}

.checkout-wrapper .tab-content form .shipping-method .custom-control {
	padding-left: 0
}

.checkout-wrapper .tab-content .method-1 {
	border: 1px solid #e4e8ed;
	margin-bottom: 2rem
}

.checkout-wrapper .tab-content .method-1 .header {
	background: #f5f5f7;
	padding: 1.66667rem 2rem
}

.checkout-wrapper .tab-content .method-1 .body {
	padding: 2.66667rem
}

.checkout-wrapper .tab-content .method-1 .body p {
	margin-bottom: 3.33333rem
}

.checkout-wrapper .tab-content .method-1 .body p img {
	margin-left: 1.33333rem
}

.checkout-wrapper .tab-content .method-1 .body input {
	margin-bottom: 2rem
}

.checkout-wrapper .tab-content .method-2 {
	margin-bottom: 2rem
}

.checkout-wrapper .tab-content .method-2 .header {
	background: #f5f5f7;
	padding: 1.66667rem 2rem
}

.checkout-wrapper .tab-content .order-info {
	border: 1px solid #e4e8ed
}

.checkout-wrapper .tab-content .order-info h6 {
	margin: 0 0 2rem 0;
	padding-bottom: 1.33333rem;
	border-bottom: 1px solid #e4e8ed
}

.checkout-wrapper .tab-content .order-info ul li {
	display: flex;
	margin-bottom: 1rem
}

.checkout-wrapper .tab-content .order-info ul li:last-child {
	margin-bottom: 0
}

.checkout-wrapper .tab-content .order-info ul li span {
	flex: 1 1
}

.checkout-wrapper .tab-content .order-info ul li span:last-child {
	color: #202428
}

.checkout-confirm h2 {
	margin-bottom: 1.66667rem
}

.checkout-confirm p {
	margin-bottom: 2.66667rem
}

.checkout-confirm form {
	margin-bottom: 3.33333rem
}

.blog-grid-wrapper .post--card {
	margin-bottom: 2rem
}

.blog-wrapper .blog-single {
	margin-bottom: 3.33333rem
}

.blog-grid-masonry .filtr-item {
	margin-bottom: 2rem
}

.blog-single-wrapper .post-gallery {
	margin-bottom: -2rem
}

.blog-single-wrapper .post-gallery figure {
	margin-bottom: 2rem
}

.blog-single-wrapper .post-details img {
	width: 100%
}

.blog-single-wrapper .post-details .post-head {
	margin-bottom: 2.46667rem
}

.blog-single-wrapper .post-details .post-content .post-header {
	margin-bottom: 2rem
}

.blog-single-wrapper .post-details .post-content .post-header h3 {
	color: #202428;
	margin-bottom: 1.33333rem
}

.blog-single-wrapper .post-details .post-content .post-header ul {
	display: flex;
	padding-bottom: 2rem;
	border-bottom: 1px solid #e4e8ed
}

.blog-single-wrapper .post-details .post-content .post-header ul li {
	margin-right: 1.33333rem
}

.blog-single-wrapper .post-details .post-content .post-header ul li:last-child {
	margin-right: 0
}

.blog-single-wrapper .post-details .post-content .post-header ul li a {
	color: #202428
}

.blog-single-wrapper .post-bottom {
	align-items: center;
	padding: 2rem 0;
	border-top: 1px solid #e4e8ed;
	border-bottom: 1px solid #e4e8ed;
	margin: 3rem 0 4.66667rem 0
}

.blog-single-wrapper .post-bottom .tags {
	flex: 1 1
}

.blog-single-wrapper .post-bottom .tags ul li {
	margin-right: .66667rem
}

.blog-single-wrapper .post-bottom .tags ul li:last-child {
	margin-right: 0
}

.blog-single-wrapper .post-bottom .tags ul li a {
	line-height: 1.86667rem;
	display: block;
	border: 1px solid #e4e8ed;
	border-radius: .2rem;
	padding: 0 .8rem;
	transition: all .3s ease;
	color: #5a6671;
	font-size: .93333rem
}

.blog-single-wrapper .post-bottom .tags ul li a:hover {
	color: #fff;
	background: #413aa4;
	border-color: #413aa4
}

.blog-single-wrapper .post-bottom .social-share {
	flex: 1 1;
	justify-content: flex-end
}

.blog-single-wrapper .post-author {
	padding: 2.66667rem;
	display: flex;
	margin-bottom: 4rem
}

.blog-single-wrapper .post-author .author-thumb {
	flex: 1 1
}

.blog-single-wrapper .post-author .author-info {
	flex: 4 1
}

.blog-single-wrapper .post-author .author-info h5 {
	color: #202428;
	margin-bottom: 1rem
}

.blog-single-wrapper .post-author .author-info h5 span {
	color: #413aa4
}

.blog-single-wrapper .post-pagination {
	display: flex;
	justify-content: space-between;
	border-bottom: 1px solid #e4e8ed;
	padding-bottom: 4rem
}

.blog-single-wrapper .post-pagination .next-post,
.blog-single-wrapper .post-pagination .prev-post {
	flex: 1 1
}

.blog-single-wrapper .post-pagination .next-post>span,
.blog-single-wrapper .post-pagination .prev-post>span {
	display: block
}

.blog-single-wrapper .post-pagination .next-post .title,
.blog-single-wrapper .post-pagination .prev-post .title {
	font-size: 16px;
	color: #202428;
	font-weight: 500;
	margin: .66667rem 0;
	display: block;
	transition: all .3s ease
}

.blog-single-wrapper .post-pagination .next-post .title:hover,
.blog-single-wrapper .post-pagination .prev-post .title:hover {
	color: #413aa4
}

.blog-single-wrapper .post-pagination .next-post p,
.blog-single-wrapper .post-pagination .prev-post p {
	margin: 0
}

.blog-single-wrapper .post-pagination .next-post {
	text-align: right
}

.blog-single-wrapper .related-post {
	border-bottom: 1px solid #e4e8ed
}

.blog-single-wrapper .related-post .related-post--title {
	margin-bottom: 1.8rem;
	text-align: center
}

.blog-single-wrapper .related-post .related-post--title h4 {
	margin: 0
}

.blog-single-wrapper .related-post .single-post {
	margin-bottom: 3.33333rem
}

.blog-single-wrapper .related-post .single-post h6 {
	margin: 1.2rem 0 .33333rem;
	font-size: 1rem
}

.blog-single-wrapper .related-post .single-post h6 a {
	color: #202428
}

.blog-single-wrapper .related-post .single-post p {
	font-size: .93333rem
}

.comments-area .comment-title {
	margin-bottom: 1.66667rem;
	text-align: center
}

.comments-area .comment-title h3 {
	position: relative;
	margin-bottom: 0
}

.comments-area .comment-lists ul .depth-1 {
	padding: 2rem 2rem 1.6rem;
	border: 1px solid #e4e8ed;
	border-radius: .26667rem;
	margin-bottom: 2rem
}

.comments-area .comment-lists ul .depth-1:last-child {
	margin-bottom: 0
}

.comments-area .comment-lists ul .depth-1 .media {
	display: flex
}

.comments-area .comment-lists ul .depth-1 .media .media-body {
	margin-left: 1.66667rem
}

.comments-area .comment-lists ul .depth-1 .media .media-body .media_top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1rem
}

.comments-area .comment-lists ul .depth-1 .media .media-body .media_top h6 {
	margin-bottom: .46667rem
}

.comments-area .comment-lists ul .depth-1 .media .media-body .media_top .reply {
	border: 1px solid #e4e8ed;
	color: #5a6671;
	line-height: 2.26667rem;
	border-radius: 1.66667rem;
	display: inline-block;
	font-weight: 500;
	font-size: .86667rem;
	padding: 0 1rem;
	transition: all .3s ease
}

.comments-area .comment-lists ul .depth-1 .media .media-body .media_top .reply:hover {
	color: #fff;
	background: #413aa4;
	border-color: #413aa4
}

.comments-area .comment-lists ul .depth-1 .media p {
	margin: 0
}

.comments-area .comment-lists ul .depth-1 .depth-2 {
	padding-left: 2.66667rem;
	margin-top: 2rem;
	padding-top: 2rem;
	border-top: 1px solid #e4e8ed
}

.comment-form {
	padding: 3rem 2.66667rem
}

.comment-form .comment-title h5 {
	color: #202428;
	margin-bottom: .66667rem
}

.comment-form form textarea {
	height: 8.33333rem
}

.video-background {
	height: 500px !important;
	padding-bottom: 0 !important
}

.video-background .video-content {
	position: absolute;
	width: 100%;
	left: 0;
	top: 50%;
	transform: translateY(-50%)
}

.video-background .video-content h2 {
	color: #fff;
	margin-bottom: 0
}

.news-area .section-title {
	text-align: center;
	margin-bottom: 2.06667rem
}

.news-area .section-title h2 {
	color: #202428;
	margin-bottom: 1.06667rem
}

.news-area .section-title p {
	color: #202428
}

.about-wrapper .about-contents h3 {
	color: #202428;
	line-height: 2.8rem;
	margin-bottom: 1rem
}

.about-wrapper .about-contents p {
	margin: 1.33333rem 0 0 0
}

.about-wrapper .about-contents .sub-title {
	font-size: 1.33333rem;
	font-weight: 500
}

.team-wrapper {
	background: url(https://snmtechnologies.in/startup/img/shape1.png) center/100% 100% no-repeat;
	padding: 7.33333rem 0;
	position: relative
}

.team-wrapper:before {
	content: '';
	position: absolute;
	width: 30%;
	height: 100%;
	left: 0;
	top: 0;
	background: #f7f6fc;
	z-index: -1
}

.team-wrapper:after {
	content: '';
	position: absolute;
	width: 70%;
	height: 100%;
	right: 0;
	top: 0;
	background: linear-gradient(-45deg, #06b590, #413aa4);
	z-index: -1
}

.team-wrapper .title-box {
	background: #fff;
	padding: 4rem;
	height: 100%;
	display: flex;
	align-items: center;
	border-radius: .26667rem;
	box-shadow: 0 5px 30px rgba(41, 41, 59, .1)
}

.team-wrapper .title-box h2 {
	color: #202428;
	line-height: 3.2rem;
	margin: 0
}

.testimonials .owl-carousel {
	margin-top: -1rem
}

@media (min-width:992px) and (max-width:1199px) {
	.menu_area.menu1 .nav_right_content .search_module {
		display: none
	}

	.top_bar .infos .infos--single {
		flex-basis: 0;
		flex-grow: 1
	}

	.top_bar .infos .infos--single+.infos--single {
		margin-left: 25px
	}

	.footer__small .content-left,
	.footer__small .content-right {
		flex: 1 1
	}

	.footer__small .content-right {
		justify-content: flex-end;
		display: flex
	}

	footer.footer4 .footer__small .info_links:before {
		content: none
	}

	.process-one .process-single:nth-child(2n+1) .icon:before {
		content: url(https://snmtechnologies.in/startup/img/arrow-up-sm.png)
	}

	.process-one .process-single .icon:before {
		content: url(https://snmtechnologies.in/startup/img/arrow-down-sm.png)
	}

	.process-one .process-single .icon:before {
		right: -58%
	}

	.pricing.pricing--2 {
		display: block !important
	}

	.event-single {
		height: auto
	}

	.event-single .event-info .view-btn {
		margin-left: 0;
		margin-top: 1.33333rem
	}

	.testimonial-carousel-three .card--testimonial2 {
		margin-bottom: 0
	}

	.testimonials {
		padding-bottom: 3rem
	}

	.search-wrapper form .form-group button {
		margin: 1rem 0 0 0
	}

	.service-tab-wrapper .cta-widget {
		padding: 2rem 1rem
	}

	.other-logins {
		justify-content: center
	}

	.project-list .card figure {
		align-self: center
	}

	.cart-table .cart-single .name a {
		margin-left: 1.33333rem
	}

	.card-body {
		padding: 2.3rem
	}

	.card--testimonial {
		padding: 2.33333rem
	}

	.card .card-footer {
		padding: 2rem
	}

	.address-blocks .adress {
		padding: 0
	}

	.team-wrapper .title-box {
		padding: 2rem
	}

	.service-tab-wrapper .cta-widget .content {
		padding: 0
	}

	.pricing.pricing--2 .pricing__features_list {
		padding: 30px
	}

	.pricing.pricing--2 .pricing__features_list ul.list {
		margin-top: 30px
	}

	section.intro-area {
		overflow-x: hidden
	}
}

@media (max-width:991px) {
	.margin-md-60 {
		margin-bottom: 4rem
	}

	.margin-md-60 p {
		margin-bottom: 0
	}

	.menu_area .navbar .navbar-nav .nav-item.dropdown .nav-link:before {
		right: 20px;
		font-size: 13px
	}

	.menu_area .navbar .navbar-nav .nav-item .nav-link {
		padding: 10px 20px;
		color: #202428
	}

	.menu_area .navbar.navbar-bg .navbar-nav .nav-item.dropdown .nav-link:before {
		color: inherit
	}

	.menu_area .navbar-nav .nav-item>.nav-link {
		color: #202428
	}

	.menu_area .navbar-nav .nav-item>.nav-link.active {
		color: #413aa4
	}

	.menu_area .dropdown-menu a.dropdown-item {
		padding: 4px 15px
	}

	.menu_area .dropdown-menu,
	.menu_area .mega-menu {
		width: 100%;
		box-shadow: 0 0 0;
		background: #f9f9f9;
		left: auto;
		position: initial;
		padding: 10px 20px
	}

	.menu_area .dropdown-menu ul,
	.menu_area .mega-menu ul {
		flex: initial;
		padding: 0 15px
	}

	.menu_area .dropdown-menu ul+ul,
	.menu_area .mega-menu ul+ul {
		margin-top: 7px
	}

	.menu_area .dropdown-menu ul+ul>li>h6,
	.menu_area .mega-menu ul+ul>li>h6 {
		margin-top: 24px
	}

	.menu_area .dropdown-menu ul li,
	.menu_area .mega-menu ul li {
		margin-bottom: 8px
	}

	.top_bar .infos {
		display: none !important
	}

	.top_bar .infos .infos--single span {
		display: none
	}

	.carousel-four .owl-item img,
	.team-carousel-two .owl-item img {
		width: 100%
	}

	.testimonial-carousel-four .carousel-single .author-text {
		width: 100%
	}

	.logo-grid-one li,
	.logo-grid-three li {
		width: 33.33%
	}

	.dropdowns-wrapper .dropdown {
		margin-bottom: 2rem
	}

	.tab-content.tab--content2 .tab-pane .tab_image_module--left {
		margin: 0 0 2rem 0
	}

	.tab-content.tab--content2 .tab-pane .tab_image_module--right {
		margin: 2rem 0 0 0
	}

	.video-single figure img {
		width: 100%
	}

	.video-wrapper.video--three .video-banner figure figcaption {
		padding: 2rem
	}

	.accordion-styles.accordion--two .form-box {
		margin-top: 3.33333rem
	}

	.card--team1 figure img,
	.card--team2 figure img {
		width: 100%
	}

	.divider.text-center p {
		width: 100%
	}

	.splitted-banner:after {
		position: absolute;
		content: '';
		width: 50%;
		right: 0;
		top: 0;
		height: 100%;
		background: rgba(0, 0, 0, .3)
	}

	.subscribe-four form,
	.subscribe-six form,
	.subscribe-three form {
		margin-top: 2rem
	}

	.twitter-feeds .feed-single .feed-content {
		width: 100%
	}

	.quotes-with-image {
		padding-top: 5.33333rem
	}

	.blockquote5 .author-sign {
		margin-bottom: 1rem
	}

	.cta--eight p,
	.cta--five p,
	.cta--four p,
	.cta--seven p,
	.cta--six p,
	.cta--two p {
		text-align: center
	}

	.cta--eight .action-btn,
	.cta--five .action-btn,
	.cta--four .action-btn,
	.cta--seven .action-btn,
	.cta--six .action-btn,
	.cta--two .action-btn {
		text-align: center;
		margin-top: 2rem
	}

	.cta--five p,
	.cta--seven p,
	.cta--six p {
		line-height: 3rem
	}

	.cta--seven p {
		line-height: 3.66667rem
	}

	.contact-split {
		display: block !important;
		height: auto
	}

	.contact-split .g-maps {
		position: relative;
		width: 100%
	}

	.contact-split .g-maps #map2 {
		height: 33.33333rem
	}

	.contact-split .form-wrapper {
		margin-top: 4rem;
		margin-bottom: 4rem
	}

	.contact--four .form-wrapper {
		margin-bottom: 4rem
	}

	.block-full-width2:before,
	.block-full-width:before {
		position: absolute;
		content: '';
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		background: rgba(255, 255, 255, .9);
		z-index: 1
	}

	.block-full-width .img,
	.block-full-width2 .img {
		width: 100%
	}

	.content-block--12 .highlighted-text .content {
		padding: 0 3rem
	}

	.section-split:before {
		width: 100%
	}

	.section-split .skills {
		margin-top: 4rem
	}

	.contact--from8 .form-wrapper .select-basic,
	.contact--from8 .form-wrapper input {
		box-shadow: 0 5px 30px rgba(105, 106, 119, .05)
	}

	.footer__small .content-left,
	.footer__small .content-right {
		display: flex;
		justify-content: center;
		width: 100%
	}

	.footer__small .content-left {
		flex-wrap: wrap;
		text-align: center
	}

	.footer__small .content-left p,
	.footer__small .content-left ul {
		width: 100%
	}

	.footer__small .content-left ul {
		justify-content: center
	}

	.footer__small .content-right {
		margin-top: 1rem
	}

	footer.footer4 .footer__small .info_links:before {
		content: none
	}

	.process-one .process-single {
		width: 50%
	}

	.process-one .process-single .icon:before,
	.process-one .process-single:nth-child(2n+1) .icon:before {
		content: none
	}

	.process-three {
		margin-bottom: 2rem
	}

	.team-single.team-five,
	.team-single.team-four {
		margin-bottom: 2rem
	}

	.team-single.team-five img,
	.team-single.team-four img {
		width: 100%
	}

	.pricing.pricing--2 {
		display: block !important
	}

	.event-single {
		height: auto
	}

	.event-single .event-info .view-btn {
		margin-left: 0;
		margin-top: 1.33333rem
	}

	#accordion_one,
	#accordion_two {
		padding: 2rem 2.66667rem
	}

	.section-news {
		padding-bottom: 6rem
	}

	.services {
		padding-bottom: 4rem
	}

	.testimonials {
		padding-bottom: 5rem
	}

	.section-split2:before {
		content: none
	}

	.about-links ul,
	.event-types ul {
		flex-wrap: wrap;
		justify-content: center !important;
		padding: 1rem 0
	}

	.about-links ul li,
	.event-types ul li {
		margin: 0 2rem
	}

	.about-links ul li a,
	.event-types ul li a {
		padding: 1rem 0
	}

	.timeline1 .happening .happening__period:before {
		right: -20px
	}

	.timeline1 .happening .happening__period .wrapper:before {
		right: -39px
	}

	.values-info .value-desc p {
		padding-left: 0;
		margin-bottom: 0
	}

	.search-wrapper form .form-group button {
		margin: 1rem 0 0 0
	}

	.search-wrapper .form-group .form-control:first-child {
		flex: 1 1;
		border-right: 1px solid #e4e8ed !important
	}

	.search-wrapper .form-group .select-basic {
		min-width: 100%;
		flex: 1 1;
		margin-top: 1rem
	}

	.search-wrapper .form-group .form-control,
	.search-wrapper .form-group .select-basic .form-control {
		border-right: 0 !important
	}

	.career-search .search-wrapper {
		position: relative;
		transform: none
	}

	.information-box {
		padding: 8rem 0 4rem !important
	}

	.information-wrapper {
		position: relative;
		transform: none;
		top: 0
	}

	.information-wrapper ul {
		margin-bottom: 1rem
	}

	.information-wrapper ul li {
		margin-bottom: 1rem
	}

	.information-wrapper .card {
		border: 1px solid #e4e8ed !important
	}

	.information-wrapper .card .card-body {
		padding-bottom: 1.66667rem
	}

	.action-btns ul {
		flex-wrap: wrap
	}

	.card.card--team4 {
		flex-wrap: wrap
	}

	.card.card--team4 .team-info {
		flex-wrap: wrap
	}

	.card.card--team4 .team-info .m-bottom-25 {
		margin-bottom: 15px
	}

	.card.card--team4 .team-info .social-basic {
		margin-bottom: 25px
	}

	.card.card--team4 .team-image {
		align-self: center;
		flex: 1 0 100%
	}

	.card.card--team4 .team-image img {
		width: 100%
	}

	.team-profile .team-details {
		margin-left: 0
	}

	.service-tab-wrapper .service--tabs .sidebar {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start
	}

	.service-tab-wrapper .service--tabs .sidebar .tab_nav2 {
		width: 100%;
		order: 2
	}

	.service-tab-wrapper .service--tabs .sidebar .cta-widget,
	.service-tab-wrapper .service--tabs .sidebar .download-widget {
		width: 45%;
		margin-right: 20px
	}

	.event-share {
		margin-bottom: 2rem
	}

	.other-logins {
		justify-content: center
	}

	.project-list .card {
		flex-direction: column
	}

	.project-list .card figure img {
		width: 100%
	}

	.filter-wrapper .filter-sort2 ul li {
		margin-bottom: 1rem
	}

	.checkout-wrapper .nav-item {
		margin: 0 3.33333rem !important
	}

	.checkout-wrapper .nav-item:before {
		content: none
	}

	.widget-wrapper:last-child .widget-default {
		margin-bottom: 0
	}

	.cart-table .cart-single .name a {
		margin-left: 0;
		margin-top: .66667rem
	}

	.cart-table--2 .cart-single .name a {
		margin-left: 1.33333rem
	}

	.hr-divider-gray {
		margin-top: 3.66667rem
	}

	.products-wrapper .product-sort .sort .form-group {
		flex: 1 1
	}

	.total-pages {
		display: none
	}

	.products-wrapper .product-grid {
		margin-bottom: 50px
	}

	.content_block3_wrapper {
		align-items: center
	}

	.team-wrapper .title-box {
		padding: 2rem
	}

	.team-carousel-three {
		margin-top: 2rem
	}

	.intro-one .intro-one--contents {
		margin-bottom: 3.33333rem
	}

	.intro-one .intro-one--contents,
	.intro-one .intro-one--img,
	.intro-three .intro-three--contents,
	.intro-three .intro-three--img {
		position: static;
		width: 100%
	}

	.intro-three .intro-three--img {
		z-index: 1;
		position: relative;
		margin-top: 3.33333rem
	}

	.intro_area9 .intro_area9--contents,
	.intro_area9 .intro_area9--slides {
		width: 100%;
		position: relative;
		right: auto;
		top: auto;
		padding: 6.66667rem 0
	}

	.intro_area9 .intro_area9--contents:before {
		width: 100%
	}

	.shape-wrapper.img-shape-one:before {
		background-size: 100% 100.2%
	}

	.intro-area-four {
		min-height: 46.66667rem
	}

	.intro_area9 .intro_area9--contents h1 br {
		display: none
	}

	.tp-caption .form-wrapper {
		display: none
	}

	.intro-four {
		min-height: 33.33333rem
	}

	.intro-area-four .img-left,
	.intro-area-four .img-right {
		max-width: 10rem
	}

	.intro-two {
		min-height: 550px
	}

	.navbar.navbar-bg .navbar-toggler {
		color: #fff
	}

	.breadcrumb3 {
		padding: 80px 0
	}

	.search-wrapper form {
		border: 1px solid #e4e8ed
	}

	.search-wrapper .form-group .form-control,
	.search-wrapper .form-group .select-basic .form-control {
		border: 1px solid #e4e8ed !important
	}

	.subscribe--five h2 {
		margin-top: 2rem
	}

	.pricing.pricing--2 .pricing__features_list {
		padding: 30px
	}

	.pricing.pricing--2 .pricing__features_list ul.list {
		margin-top: 30px
	}

	.subscribe-six h4,
	.subscribe-three h4 {
		margin-bottom: 30px
	}

	.subscribe-six h4 {
		margin-bottom: 0
	}

	.tab.tab--1 .tab_nav {
		padding: 10px 20px
	}

	.menu6 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before,
	.menu7 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before,
	.menu8 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link,
	.menu8 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before {
		color: #202428
	}
}

@media (min-width:768px) and (max-width:991px) {
	html {
		font-size: 14.5px
	}

	.gallery-fullwidth .portfolio-carousel-single {
		width: 33.33%
	}

	.content-block .content-list--one,
	.content-block .content-list--two {
		display: flex
	}

	.content-block .content-list--one .content-list,
	.content-block .content-list--two .content-list {
		width: 50%
	}

	.content-block .content-list--one .content-list:nth-child(2n+2),
	.content-block .content-list--two .content-list:nth-child(2n+2) {
		padding-left: 15px
	}

	.content-block .content-list--one .content-list:nth-child(2n+1),
	.content-block .content-list--two .content-list:nth-child(2n+1) {
		padding-right: 15px
	}

	.content-block--12 .highlighted-text .content {
		min-height: 20rem
	}

	.content-block--12 .highlighted-text .content p {
		font-size: 1.66667rem;
		line-height: 2.66667rem
	}
}

@media screen and (max-width:767px) {
	.margin-sm-60 {
		margin-bottom: 4rem
	}

	.margin-sm-60 p {
		margin-bottom: 0
	}

	.card-body {
		padding: 2rem
	}

	.blog-carousel-two .owl-item img,
	.carousel-one .owl-item img,
	.carousel-two .owl-item img {
		width: 100%
	}

	.carousel-three .nav-circle .owl-prev {
		margin-left: 0
	}

	.carousel-three .nav-circle .owl-next {
		margin-right: 0
	}

	.logo-carousel-three .nav-square-dark .owl-prev {
		margin-left: 0
	}

	.logo-carousel-three .nav-square-dark .owl-next {
		margin-right: 0
	}

	.logo-grid-one li,
	.logo-grid-three li {
		width: 50%
	}

	.gallery-fullwidth .portfolio-carousel-single {
		width: 50%
	}

	.gallery-grid figure img {
		width: 100%
	}

	.tab.tab--1 .tab-content {
		padding-left: 0;
		margin-top: 2rem
	}

	.tab-content.tab--content2 .tab-pane .tab_image_module {
		margin-top: 2rem
	}

	.tab.tab--4 .tab--content4 {
		padding: 2.66667rem
	}

	.tab.tab--4 .tab--content4 .text_content {
		margin-top: 2rem;
		padding-left: 0
	}

	.tab.tab--4 .nav-tabs li {
		width: 100%;
		margin-bottom: 1px
	}

	.tab.tab--8 .tab_nav7 {
		margin-bottom: 2rem
	}

	.card figure img,
	.card--ten figure img {
		width: 100%
	}

	.section-title-simple {
		width: 100%
	}

	.social-btns li {
		margin-bottom: 1.33333rem
	}

	.counter--1,
	.counter--2,
	.counter--3,
	.counter--4,
	.counter--6 {
		padding-bottom: 4.66667rem !important
	}

	.counter--1 .counter_single,
	.counter--2 .counter_single,
	.counter--3 .counter_single,
	.counter--4 .counter_single,
	.counter--6 .counter_single {
		width: 50%;
		margin-bottom: 3.33333rem
	}

	.breadcrumb_area.breadcrumb1 .page_title {
		line-height: 3rem;
		margin-bottom: 1rem
	}

	.breadcrumb3 .breadcrumb_wrapper .page_title,
	.breadcrumb_area.breadcrumb2 .page_title {
		width: 100%
	}

	.breadcrumb_area.breadcrumb1 .breadcrumb_wrapper {
		flex-direction: column
	}

	.content-block--12 .highlighted-text {
		position: relative;
		top: 0;
		transform: none;
		padding: 5.33333rem 0
	}

	.content-block--12 .clients-logo {
		padding-top: 0
	}

	.event-single {
		flex-direction: column
	}

	.event-single .event-date {
		padding: 2rem 0
	}

	.event-single .event-date,
	.event-single .event-info {
		width: 100%;
		flex: 1 1
	}

	.header--6 .nav_right_content .cart_module,
	.header--6 .nav_right_content .search_module {
		order: 1
	}

	.header--6 .nav_right_content .ctabtn {
		order: 0;
		padding-left: 0 !important;
		padding-right: 20px !important
	}

	.nav_right_content .cart_module .cart__items {
		width: 250px;
		min-width: auto;
		right: 0
	}

	.nav_right_content .cart_module .cart__items .cart_info a+a {
		margin-left: 0;
		margin-top: 10px
	}

	.error-wrapper .error-contents p {
		width: 100%
	}

	.home8-counter {
		padding-bottom: 0
	}

	.timeline1 .happening .happening__period:before {
		content: none
	}

	.timeline1 .happening .happening__period .wrapper:before {
		content: none
	}

	.timeline1 .happening .happening__desc {
		margin-top: 2rem;
		padding-left: 1rem;
		padding-right: 1rem
	}

	.timeline1 .happening:last-child .happening__desc {
		padding-bottom: 0
	}

	.search-wrapper .form-group .form-control:first-child {
		border-right: 0 !important;
		margin-bottom: 1rem
	}

	.action-btns ul li {
		margin-bottom: .66667rem
	}

	.career-search .search-wrapper .form-group .form-control:first-child {
		border-right: 1px solid #e4e8ed !important
	}

	.career-search .search-wrapper form {
		padding: 30px
	}

	.service-tab-wrapper .service--tabs .sidebar .cta-widget,
	.service-tab-wrapper .service--tabs .sidebar .download-widget {
		width: 100%
	}

	.service-tab-wrapper .service--tabs .sidebar .download-widget {
		text-align: center
	}

	.service-tab-wrapper .service--tabs .sidebar .download-widget .content p {
		justify-content: center
	}

	.login-register .login-form .form-wrapper .other-logins,
	.login-register .signup-form .form-wrapper .other-logins {
		flex-direction: column;
		align-items: center
	}

	.login-register .login-form .form-wrapper .other-logins a,
	.login-register .signup-form .form-wrapper .other-logins a {
		margin: 10px 0
	}

	.project-single .project-info .info-box {
		margin-top: 3rem
	}

	.blog-single-wrapper .post-bottom {
		flex-direction: column;
		justify-content: flex-start !important;
		align-items: start
	}

	.blog-single-wrapper .post-bottom .social-share {
		margin-top: 1.33333rem
	}

	.cart-table .cart-actions .ml-auto {
		margin-left: 0 !important;
		margin-top: 1rem
	}

	.checkout-wrapper .nav-item {
		width: 100%;
		margin: 0 !important
	}

	.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link:before {
		bottom: auto;
		top: 50%;
		transform: translate(0, -50%);
		left: auto;
		right: 0
	}

	.gallery-image-view .portfolio-carousel-single img {
		width: 100%
	}

	.product-info-tab .review-wrapper .reviews {
		padding: 0
	}

	.nav-circle button {
		width: 3rem;
		height: 3rem
	}

	textarea.form-control {
		height: 200px
	}

	html {
		font-size: 14px
	}

	.mb-sm-50 {
		margin-bottom: 50px
	}

	.services_area .icon-box-five {
		padding: 0;
		box-shadow: 0 0 0
	}

	.event-single .event-info {
		padding: 2rem 2.33333rem
	}

	.nav_right_content .search_module {
		position: initial
	}

	.nav_right_content .search_module .search_area {
		width: 100%;
		right: 0
	}

	.nav_right_content .search_module .search_area.active {
		top: 100%
	}

	.cta--nine .cta--none-contents {
		text-align: center
	}

	.cta--nine .cta--none-contents h3 {
		margin-top: 2rem
	}

	.about-wrapper img {
		margin-bottom: 2rem
	}

	.about-wrapper .line-chart_wrap {
		margin-top: 2rem
	}

	.team-carousel-three .carousel-single .team-desc {
		padding: 2rem
	}

	.team-carousel-three .carousel-single .team-img {
		display: flex;
		align-items: center
	}

	.intro-three,
	.intro-two {
		padding: 5.33333rem 0
	}

	.intro-two .form-wrapper {
		margin-top: 3.33333rem
	}

	.image-carousel-one .nav-circle button {
		width: 2.33333rem;
		height: 2.33333rem;
		font-size: .86667rem
	}

	.text-box {
		margin-top: 0
	}

	.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link,
	.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link {
		line-height: 2rem
	}

	.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link.active:after,
	.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link.active:after {
		content: none
	}

	.checkout-wrapper .tab-content .method-1 .body p img {
		margin-left: 0;
		margin-top: 10px
	}

	.quotes-with-image .blockquote5 {
		margin-top: 80px
	}

	.quotes-with-image .blockquote5 .author-sign {
		margin-bottom: 0
	}

	.nav-circle .owl-next,
	.nav-circle .owl-prev {
		margin: 0
	}

	.timeline1 .happening .happening__period .wrapper:after {
		content: none
	}
}

@media (min-width:320px) and (max-width:575.98px) {

	.logo-grid-one li,
	.logo-grid-three li {
		width: 100%
	}

	.gallery-fullwidth .portfolio-carousel-single {
		width: 100%
	}

	.tab.tab--4 .nav-tabs li {
		width: 100%
	}

	.tab.tab--4 .nav-pills li {
		margin-top: 1rem
	}

	.tab.tab--7 .tab_nav7 .nav .nav-item,
	.tab.tab--8 .tab_nav7 .nav .nav-item {
		width: 100%
	}

	.tab.tab--3 ul.nav {
		flex-direction: column
	}

	.tab.tab--3 .tab_nav3 {
		padding-bottom: 1rem
	}

	.tab.tab--3 .tab_nav3 .nav li a {
		padding: 0 0 1rem 0
	}

	.breadcrumb {
		flex-direction: column;
		align-items: center
	}

	.breadcrumb li {
		margin-bottom: .66667rem
	}

	.breadcrumb li:last-child {
		margin-bottom: 0
	}

	.counter--1 .counter_single,
	.counter--2 .counter_single,
	.counter--3 .counter_single,
	.counter--4 .counter_single,
	.counter--6 .counter_single {
		width: 100%
	}

	.subscribe--two .subscribe-form,
	.subscribe-six .subscribe-form,
	.subscribe-three .subscribe-form {
		display: block !important
	}

	.subscribe--two .subscribe-form button,
	.subscribe-six .subscribe-form button,
	.subscribe-three .subscribe-form button {
		margin: 1.33333rem 0 0 0
	}

	.process-one .process-single {
		width: 100%
	}

	.portfolio-carousel .owl-item img {
		width: 100%
	}

	.pagination-area .pagination {
		flex-wrap: wrap
	}

	.filter-wrapper .filter-sort ul {
		flex-direction: column
	}

	.error-wrapper {
		padding: 8rem 0
	}

	.error-wrapper .error-contents .error-404 {
		font-size: 8rem
	}

	.error-wrapper .error-contents h2 {
		font-size: 1.66667rem;
		line-height: 2.33333rem
	}

	.apply-form form .form-group {
		display: flex;
		flex-direction: column
	}

	.apply-form form .form-group label {
		min-width: 100%
	}

	.countdown {
		flex-wrap: wrap;
		justify-content: center
	}

	.countdown li {
		margin: 0 .66667rem 1.33333rem !important
	}

	.tab_event .tab_event__module .speakers {
		flex-direction: column
	}

	.tab_event .tab_event__module .speakers li {
		margin-bottom: 1.33333rem
	}

	.tab_event .tab_event__module .speakers li:last-child {
		margin-bottom: 0
	}

	.tab_event .tab_event__module .speakers li+li {
		margin-left: 0
	}

	.login-register .login-form .form-wrapper .form-action {
		flex-direction: column;
		align-items: center;
		margin-bottom: 20px
	}

	.login-register .login-form .form-wrapper .form-action .custom-control {
		padding-left: 0;
		margin-bottom: 1rem
	}

	.coming-soon .cs-contents p {
		width: 100%
	}

	.coming-soon .cs-contents form .subscribe-form {
		flex-direction: column;
		flex-wrap: wrap
	}

	.coming-soon .cs-contents form .subscribe-form button {
		margin-left: 0;
		margin-top: 1rem
	}

	.related-post .single-post img {
		width: 100%
	}

	.blog-single-wrapper .post-pagination {
		flex-direction: column
	}

	.blog-single-wrapper .post-pagination .next-post {
		margin-top: 1rem
	}

	.product-info-tab .review-wrapper .reviews .review-single {
		flex-direction: column
	}

	.product-info-tab .review-wrapper .reviews .review-single .review-text {
		margin-top: 2rem
	}

	.product-details .product-info .product-share {
		flex-direction: column;
		align-items: start !important
	}

	.product-details .product-info .product-share>span {
		margin-bottom: 1rem
	}

	.rev_column {
		padding: 0 15px !important
	}

	.go_top {
		line-height: 30px;
		width: 30px;
		font-size: 13px
	}

	.services_area .icon-box-five {
		text-align: center;
		margin-bottom: 50px
	}

	.intro-one .intro-one--contents {
		padding-top: 40px
	}

	.display-3 {
		font-size: 2.5rem
	}

	.login-register .login-form .form-wrapper .other-logins a,
	.login-register .signup-form .form-wrapper .other-logins a {
		width: 100%;
		text-align: center
	}

	.list-inline-wrapper .list--inline {
		flex-direction: column
	}

	.p-top-70 {
		padding-top: 50px
	}

	.p-bottom-70 {
		padding-bottom: 50px
	}

	.p-top-105 {
		padding-top: 75px
	}

	.p-bottom-75 {
		padding-bottom: 50px
	}

	.content-block--15 {
		padding: 73px 0 62px
	}

	.testimonial-carousel-six-wrapper {
		padding: 6.06667rem 0 5.86667rem 0
	}

	.p-top-100 {
		padding-top: 70px
	}

	.subscribe-seven {
		padding: 50px 0
	}

	footer .footer__big {
		padding: 75px 0 20px
	}

	.service-two {
		padding: 80px 0 50px
	}

	.p-top-110,
	.p-top-115,
	.p-top-120 {
		padding-top: 80px
	}

	.p-bottom-100,
	.p-bottom-105,
	.p-bottom-110,
	.p-bottom-120,
	.p-bottom-95 {
		padding-bottom: 80px
	}

	.team-wrapper+.p-top-50 {
		padding-top: 0
	}

	.subscribe-eight {
		padding: 80px 0 0
	}

	.services_area.p-bottom-70 {
		padding-bottom: 30px
	}

	.section-padding {
		padding: 80px 0
	}

	.testimonials {
		padding-bottom: 40px
	}

	.p-bottom-90 {
		padding-bottom: 70px
	}

	.p-bottom-80 {
		padding-bottom: 50px
	}

	.block-full-width,
	.block-full-width2 {
		min-height: auto;
		padding-bottom: 50px
	}

	.block-full-width2 {
		padding-top: 50px
	}

	.counter.counter--3 {
		padding: 80px 0 30px !important
	}

	.testimonial-carousel-four {
		padding: 80px 0 70px
	}

	.counter--1,
	.counter--2,
	.counter--3,
	.counter--4,
	.counter--6 {
		padding-bottom: 28px !important
	}

	.subscribe-four {
		padding: 80px 0
	}

	.testimonial6 .single_testimonial.p-bottom-50 {
		padding-bottom: 0
	}

	.accordion-styles .accordion_four {
		margin-top: 50px
	}

	.counter.counter--5 {
		padding: 80px 0 55px
	}

	.splitted-banner {
		padding: 80px 0
	}

	.p-bottom-55 {
		padding-bottom: 25px
	}

	.logo-carousel {
		padding: 80px 0
	}

	.m-top-110 {
		margin-top: 80px
	}

	.section-padding2 {
		padding: 80px 0 50px
	}

	.project-grid-3.section-padding2 {
		padding-bottom: 50px
	}

	.m-bottom-120 {
		margin-bottom: 80px
	}

	.information-box {
		padding: 80px 0 60px !important
	}

	.action-btns ul li {
		margin-bottom: 0
	}

	.action-btns ul li.share-btn {
		padding-bottom: 0
	}

	.checkout-confirm {
		padding: 72px 0 80px
	}
}

@media screen and (max-width:479px) {
	html {
		font-size: 13px
	}

	body {
		font-size: 14px
	}

	.top_bar .top_bar--lang {
		display: none
	}

	.top_bar .topbar_content {
		justify-content: center !important
	}

	.menu6 .ctabtn,
	.menu6 .search_module {
		display: none
	}

	.menu1 .navbar-brand {
		order: 0 !important
	}

	.menu1 .nav_right_content {
		display: none !important
	}

	.menu5 {
		padding: 12px 0
	}

	.menu5 .navbar-brand {
		order: 0 !important;
		width: 50%
	}

	.menu5 .nav_right_content {
		display: none !important
	}

	.navbar .navbar-brand {
		width: 40%
	}

	.breadcrumb_area.breadcrumb2 {
		padding-top: 4rem
	}

	.breadcrumb_area.breadcrumb2 .page_title {
		margin-bottom: 3rem
	}

	.showcase-box .showcase-body,
	.showcase-box .showcase-header {
		padding: 2rem
	}

	.cta-wrapper {
		padding: 6rem 0
	}

	.card .card-body {
		padding: 2rem
	}

	.card .card-footer {
		padding: 1.66rem
	}

	.cta--nine:before,
	footer.footer6:before {
		content: none
	}

	footer.footer6 {
		padding-top: 0
	}

	footer .footer__bottom .footer__bottom-content {
		flex-direction: column;
		align-items: center;
		justify-content: center
	}

	footer .footer__bottom .footer__bottom-content p {
		text-align: center;
		margin-bottom: 1rem
	}

	.play-btn.play-btn--lg {
		width: 3.33333rem;
		height: 3.33333rem
	}

	.play-btn.play-btn--lg .svg {
		width: 15px
	}

	.nav-pills .nav-item {
		margin-bottom: 10px
	}

	.coming-soon .cs-contents .cs-text {
		font-size: 2.33333rem
	}

	.content-block--12 .highlighted-text .content {
		padding: 15px 20px
	}

	.subscribe-form-two {
		padding: 0
	}

	.subscribe-form-two .btn {
		position: static;
		top: 0;
		transform: none;
		margin-top: 15px
	}

	.subscribe-form-two .form-control {
		padding: 0 15px
	}
}

@media (min-width:480px) and (max-width:575px) {
	html {
		font-size: 14px
	}
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style1.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;;;;;;;;;;;;;;;CAiBC;AACD;;AAEA;;;;;;;;;;;;;;;;;;;;;CAqBC;AACD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAyCC;AACD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;;;CAKC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;;;CAKC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;;;;;CAQC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;;;;;;CASC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,uCAAuC;CACvC,eAAe;CACf;AACD;;AAEA;CACC,uCAAuC;CACvC,eAAe;CACf;AACD;;AAEA;CACC,uCAAuC;CACvC,eAAe;CACf;AACD;;AAEA;CACC,wCAAwC;CACxC,eAAe;CACf;AACD;;AAEA;CACC,uCAAuC;CACvC,eAAe;CACf;AACD;;AAEA;CACC,uCAAuC;CACvC,eAAe;CACf;AACD;;AAEA;CACC,yCAAyC;CACzC,eAAe;CACf;AACD;;AAEA;CACC,sCAAsC;CACtC,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ;AACD;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,MAAM;CACN,OAAO;CACP,WAAW;CACX,WAAW;CACX,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,OAAO;CACP,MAAM;CAGN,mHAAmH;CACnH;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,2BAA2B;CAC3B,gCAAgC;CAChC,iBAAiB;CACjB,iBAAiB;CACjB,eAAe;CAEf;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,SAAS;CACT,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,MAAM;CACN,OAAO;CAEP,iCAAiC;CACjC,uCAAuC;CACvC,uCAAuC;CACvC,UAAU;CAEV,8BAA8B;CAC9B,sCAAsC;CACtC,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CAIC;AACD;;AAEA;CACC,gBAAgB;CAEhB,+CAA+C;CAC/C;AACD;;AAEA;CACC;AACD;;AAEA;CACC,SAAS;CACT,mBAAmB;CACnB,qBAAqB;CACrB,gBAAgB;CAChB;AACD;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB;AACD;;AAEA;CACC,oBAAoB;CACpB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC,kBAAkB;CAIlB,aAAa;CAKb,sBAAsB;CACtB,YAAY;CACZ,qBAAqB;CACrB,sBAAsB;CAEtB,2BAA2B;CAC3B,yBAAyB;CAEzB,qBAAqB;CACrB;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,sBAAsB;CACtB;AACD;;AAEA;;CAEC,SAAS;CACT,qBAAqB;CACrB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,aAAa;CAIb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,gBAAgB;CAIhB;AACD;;AAEA;CAIC;AACD;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,WAAW;CAEX,kBAAkB;CAClB;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC;AACD;;AAEA;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,YAAY;CACZ,OAAO;CACP,MAAM;CACN;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,YAAY;CACZ,SAAS;CACT,MAAM;CAGN,2BAA2B;CAC3B;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,WAAW;CACX,OAAO;CACP;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,SAAS;CACT,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;CA0BC;AACD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAoDC;AACD;;AAEA;CACC,0FAA0F;CAC1F;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC;AACD;;AAEA;CACC,6BAA6B;CAC7B,WAAW;CACX;AACD;;AAEA;CACC,6BAA6B;CAC7B,WAAW;CACX;AACD;;AAEA;CACC,6BAA6B;CAC7B,WAAW;CACX;AACD;;AAEA;CACC,mCAAmC;CACnC,WAAW;CACX,WAAW;CACX;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CAGd,wBAAwB;CACxB;AACD;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX;AACD;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB;AACD;;AAEA;CACC,cAAc;CACd,SAAS;CACT;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,uBAAuB;CACvB,eAAe;CACf,iBAAiB;CACjB,WAAW;CAGX,wBAAwB;CACxB,eAAe;CAEf,uCAAuC;CAEvC,wCAAwC;CACxC,QAAQ;CACR,YAAY;CACZ,YAAY;CACZ;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,uCAAuC;CACvC,eAAe;CACf;AACD;;AAEA;CACC,uCAAuC;CACvC,eAAe;CACf;AACD;;AAEA;CACC,uCAAuC;CACvC,eAAe;CACf;AACD;;AAEA;CACC,wCAAwC;CACxC,eAAe;CACf;AACD;;AAEA;CACC,uCAAuC;CACvC,eAAe;CACf;AACD;;AAEA;CACC,uCAAuC;CACvC,eAAe;CACf;AACD;;AAEA;CACC,yCAAyC;CACzC,eAAe;CACf;AACD;;AAEA;CACC,sCAAsC;CACtC,eAAe;CACf;AACD;;AAEA;CACC,0BAA0B;CAC1B,oBAAoB;CACpB;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CAIC,oBAAoB;CAIpB,mBAAmB;CAInB;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,oBAAoB;CAIpB,mBAAmB;CAInB,uBAAuB;CAGvB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,iBAAiB;CACjB,cAAc;CACd,yCAAyC;CAEzC,kBAAkB;CAClB,UAAU;CAIV,aAAa;CAIb,mBAAmB;CAInB,uBAAuB;CACvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,eAAe;CACf,eAAe;CACf,qBAAqB;CACrB,gBAAgB;CAChB,0BAA0B;CAE1B;AACD;;AAEA;CACC,UAAU;CAEV;AACD;;AAEA;CAIC,uDAAuD;CACvD,WAAW;CACX,YAAY;CAEZ;AACD;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB;AACD;;AAEA;CAIC,aAAa;CAIb,mBAAmB;CACnB,cAAc;CACd,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,aAAa;CAIb,uBAAuB;CAIvB,mBAAmB;CAEnB,kBAAkB;CAClB,WAAW;CACX,eAAe;CAGf,wBAAwB;CACxB;AACD;;AAEA;CACC,aAAa;CACb,UAAU;CAGV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,UAAU;CACV,SAAS;CACT,kCAAkC;CAElC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,UAAU;CACV,SAAS;CACT,kCAAkC;CAElC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CAIT,aAAa;CAIb,uBAAuB;CACvB,kBAAkB;CAClB,gBAAgB;CAEhB,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;CAGV,wBAAwB;CAExB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,mCAAmC;CACnC,yCAAyC;CACzC,wCAAwC;CACxC,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,cAAc;CAGd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,cAAc;CACd,QAAQ;CAGR;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;CACC,aAAa;CACb,cAAc;CACd,sBAAsB;CAEtB,gBAAgB;CAChB,+BAA+B;CAC/B,QAAQ;CACR;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;AACA,EAAE,yBAAyB,CAAC;AAC5B;CACC,eAAe;CACf,qBAAqB;CACrB,WAAW;CACX,wBAAwB;CACxB,WAAW;CACX,kBAAkB;CAIlB,aAAa;CAIb,uBAAuB;CAIvB,mBAAmB;CACnB;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,2BAA2B;CAC3B,aAAa;CACb;AACD;;AAEA;CACC,YAAY;CACZ,aAAa;CAEb,oBAAoB;CACpB,WAAW;CACX;AACD;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb;AACD;;AAEA;CACC,YAAY;CACZ,aAAa;CAEb,kBAAkB;CAClB,WAAW;CACX;AACD;;AAEA;CAEC,gBAAgB;CAChB,YAAY;CAGZ;AACD;;AAEA;;CAEC;EACC;CACD;AACD;;AAEA;CACC,UAAU;CAEV;AACD;;AAUA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,gCAAgC;CAEhC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,cAAc;CACd;AACD;;AAEA;CAGC,gBAAgB;CAChB;AACD;;AAEA;CACC,wBAAwB;CACxB,aAAa;CACb,cAAc;CAEd,kBAAkB;CAClB,+BAA+B;CAC/B,mBAAmB;CACnB;AACD;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,WAAW;CACX;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CAGR,2BAA2B;CAC3B,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAIlB,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,wBAAwB;CACxB;AACD;;AAEA;CAEC,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAElB,kBAAkB;CAClB,MAAM;CACN;AACD;;AAEA;CACC,aAAa;CACb,cAAc;CACd;AACD;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,wBAAwB;CACxB,OAAO;CACP,oBAAoB;CACpB,kBAAkB;CAClB,QAAQ;CACR;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,wBAAwB;CACxB,OAAO;CACP,oBAAoB;CACpB,kBAAkB;CAClB,QAAQ;CACR;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;CACP,yBAAyB;CAGzB,wBAAwB;CACxB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,cAAc;CACd,aAAa;CACb,WAAW;CACX,aAAa;CACb,sBAAsB;CAGtB;AACD;;AAEA;CAGC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CAGC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CAGV;AACD;;AAEA;;CAEC,mBAAmB;CACnB,iBAAiB;CACjB,oBAAoB;CACpB,yBAAyB;CACzB;AACD;;AAEA;CACC,uBAAuB;CACvB;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CAGC,2BAA2B;CAC3B;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CAGC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;CAChB,QAAQ;CAGR,2BAA2B;CAC3B;AACD;;AAEA;CAEC,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd,kBAAkB;CAElB,kBAAkB;CAClB;AACD;;AAEA;CACC,WAAW;CACX,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,YAAY;CACZ,cAAc;CACd,qBAAqB;CACrB,mBAAmB;CACnB,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,wBAAwB;CACxB,gBAAgB;CAChB,QAAQ;CAGR,2BAA2B;CAC3B;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,yBAAyB;CAEzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;CAChB,QAAQ;CAGR,2BAA2B;CAC3B;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,SAAS;CACT,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,yBAAyB;CAEzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,qBAAqB;CACrB,sBAAsB;CACtB,oBAAoB;CACpB,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,UAAU;CACV,SAAS;CACT;AACD;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CAEzB,kBAAkB;CAIlB,aAAa;CAIb,mBAAmB;CAInB,uBAAuB;CAKvB;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,aAAa;CAIb,uBAAuB;CAKvB,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,UAAU;CACV,SAAS;CACT;AACD;;AAEA;CAIC,aAAa;CAIb,uBAAuB;CAKvB,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;;;;CAMC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;;;;CAMC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;;;;;;CAMC;AACD;;AAEA;CACC,yBAAyB;CACzB,0BAA0B;CAE1B,oBAAoB;CACpB;AACD;;AAEA;CACC,SAAS;CACT,kBAAkB;CAClB,cAAc;CACd,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAClB,qBAAqB;CACrB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CACjB,WAAW;CACX,mBAAmB;CACnB,OAAO;CACP,QAAQ;CAGR;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,cAAc;CAEd,gBAAgB;CAIhB;AACD;;AAEA;;CAEC,gBAAgB;CAChB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,kBAAkB;CAClB,gBAAgB;CAChB,wBAAwB;CACxB,8BAA8B;CAC9B,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,wBAAwB;CACxB,gBAAgB;CAChB,8BAA8B;CAC9B,OAAO;CACP;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,4BAA4B;CAC5B,WAAW;CACX,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;;CAGC,+CAA+C;CAC/C,gBAAgB;CAChB,mBAAmB;CACnB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,QAAQ;CAGR;AACD;;AAEA;;CAEC,QAAQ;CAGR;AACD;;AAEA;;CAEC,cAAc;CACd,cAAc;CACd,kBAAkB;CAClB,4BAA4B;CAC5B,qBAAqB;CACrB,gBAAgB;CAChB;AACD;;AAEA;;CAEC,kBAAkB;CAClB,gBAAgB;CAChB,wBAAwB;CACxB,QAAQ;CACR,QAAQ;CAGR,2BAA2B;CAC3B,cAAc;CACd;AACD;;AAEA;;CAEC,kBAAkB;CAClB,gBAAgB;CAChB,oCAAoC;CACpC,QAAQ;CACR,QAAQ;CAGR,2BAA2B;CAC3B,oBAAoB;CACpB;AACD;;AAEA;CAEC,+CAA+C;CAC/C,aAAa;CAEb;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,kCAAkC;CAClC,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAGlB,wBAAwB;CACxB,uBAAuB;CACvB,eAAe;CACf;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,wBAAwB;CACxB,WAAW;CACX,QAAQ;CAGR,2BAA2B;CAC3B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,aAAa;CAIb,mBAAmB;CACnB,kCAAkC;CAClC,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAGlB,wBAAwB;CACxB,uBAAuB;CACvB,eAAe;CACf;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,wBAAwB;CACxB,WAAW;CACX,QAAQ;CAGR,2BAA2B;CAC3B;AACD;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAGlB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;CACjB,kBAAkB;CAClB;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,QAAQ;CAGR,2BAA2B;CAC3B,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,OAAO;CACP,MAAM;CACN,iCAAiC;CAGjC,wBAAwB;CAIxB,aAAa;CAIb,uBAAuB;CAIvB,mBAAmB;CACnB,UAAU;CACV;AACD;;AAEA;CAIC,oBAAoB;CAIpB,mBAAmB;CAInB,uBAAuB;CACvB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAEhB,kBAAkB;CAClB,iBAAiB;CAGjB,wBAAwB;CAGxB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,uBAAuB;CACvB;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CAGC;AACD;;AAEA;CAIC,aAAa;CAGb;AACD;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,MAAM;CACN;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;CAGC;AACD;;AAEA;;;CAGC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,OAAO;CACP,MAAM;CACN,gCAAgC;CAIhC,aAAa;CAIb,uBAAuB;CAIvB;AACD;;AAEA;CAIC,oBAAoB;CACpB,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,cAAc;CAEd,kBAAkB;CAClB,6BAA6B;CAI7B,uBAAuB;CAIvB;AACD;;AAEA;CACC,gBAAgB;CAChB,aAAa;CAGb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,OAAO;CACP,aAAa;CACb,mBAAmB;CAGnB,wBAAwB;CACxB;AACD;;AAEA;CACC,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qCAAqC;CACrC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CAGd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB;AACD;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;CACrB,iBAAiB;CACjB,cAAc;CACd;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CAGd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,WAAW;CACX,iBAAiB;CACjB,iCAAiC;CACjC,mBAAmB;CACnB,UAAU;CAGV,wBAAwB;CACxB,wBAAwB;CACxB;AACD;;AAEA;CAIC,aAAa;CACb,gBAAgB;CAIhB;AACD;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,aAAa;CAGb,oBAAoB;CACpB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,8BAA8B;CAC9B;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,OAAO;CACP,QAAQ;CAGR,2BAA2B;CAC3B;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CAEd,kBAAkB;CAElB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,mBAAmB;CACnB,UAAU;CACV;AACD;;AAEA;CACC,kBAAkB;CAElB,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,OAAO;CACP,WAAW;CACX,kCAAkC;CAClC,kBAAkB;CAClB,UAAU;CAGV,wBAAwB;CACxB,kBAAkB;CAClB,wBAAwB;CAExB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,8BAA8B;CAC9B,wBAAwB;CACxB;AACD;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,SAAS;CACT,4BAA4B;CAC5B,qBAAqB;CACrB,wBAAwB;CACxB,cAAc;CACd;AACD;;AAEA;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,0BAA0B;CAI1B,aAAa;CAIb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CAGV;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,qBAAqB;CACrB,iCAAiC;CAEjC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,8BAA8B;CAC9B,oBAAoB;CACpB,iBAAiB;CACjB,kBAAkB;CAElB,oBAAoB;CACpB,mCAAmC;CAInC,aAAa;CAIb,mBAAmB;CAInB;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,OAAO;CACP,MAAM;CACN,mBAAmB;CAInB,aAAa;CAIb,uBAAuB;CAIvB,mBAAmB;CAKnB,sBAAsB;CACtB,UAAU;CACV,kBAAkB;CAGlB,oBAAoB;CAGpB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,mBAAmB;CAGnB;AACD;;AAEA;CACC,cAAc;CAEd,+CAA+C;CAE/C,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,wBAAwB;CACxB;AACD;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB,oBAAoB;CACpB;AACD;;AAEA;CACC,mBAAmB;CAKnB,mBAAmB;CAInB;AACD;;AAEA;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAGC,wBAAwB;CAExB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CAGd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gCAAgC;CAChC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAElB,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;CAIX,aAAa;CAIb,uBAAuB;CAIvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,0BAA0B;CAC1B,yBAAyB;CACzB,gCAAgC;CAGhC;AACD;;AAEA;CACC,cAAc;CAGd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,wBAAwB;CACxB;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CAEC;AACD;;AAEA;;;;;;;;;;CAUC;AACD;;AAEA;CAEC,8CAA8C;CAC9C,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,iBAAiB;CACjB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,OAAO;CACP,MAAM;CACN,mBAAmB;CAEnB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,QAAQ;CACR,MAAM;CACN,mBAAmB;CAEnB;AACD;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,iBAAiB;CACjB,mBAAmB;CAEnB;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,mBAAmB;CAEnB,8BAA8B;CAE9B,4BAA4B;CAC5B,kBAAkB;CAClB,WAAW;CACX;AACD;;AAEA;;CAEC,WAAW;CACX,YAAY;CAEZ,wBAAwB;CAExB;AACD;;AAEA;CAIC,qDAAqD;CAErD,gBAAgB;CAChB,kBAAkB;CAClB,MAAM;CAEN,2BAA2B;CAC3B,uBAAuB;CAEvB,qBAAqB;CAErB,4BAA4B;CAC5B;AACD;;AAEA;CAIC,qDAAqD;CAErD,gBAAgB;CAChB,kBAAkB;CAClB,MAAM;CAEN,2BAA2B;CAC3B,uBAAuB;CAEvB,0BAA0B;CAE1B,4BAA4B;CAC5B;AACD;;AAEA;CAEC,2BAA2B;CAE3B;AACD;;AAEA;CAEC,qBAAqB;CAErB;AACD;;AAEA;CAGC,uDAAuD;CAEvD;AACD;;AAEA;CAEC,gEAAgE;CAEhE;AACD;;AAEA;;CAEC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,QAAQ;CAIR,qDAAqD;CAGrD,4BAA4B;CAC5B;AACD;;AAEA;;CAEC,iBAAiB;CACjB;AACD;;AAEA;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAEhB,oBAAoB;CAEpB,+CAA+C;CAC/C,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,WAAW;CACX,mBAAmB;CACnB,OAAO;CACP,SAAS;CACT,SAAS;CACT,kBAAkB;CAGlB,oBAAoB;CAEpB,0BAA0B;CAG1B;AACD;;AAEA;CAGC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,oBAAoB;CACpB,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CAIjB,uBAAuB;CAIvB,mBAAmB;CACnB,WAAW;CAEX,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAKC,oBAAoB;CACpB,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,eAAe;CAIf,uBAAuB;CAIvB,mBAAmB;CACnB,WAAW;CAGX;AACD;;AAEA;CAEC,kBAAkB;CAClB;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,gBAAgB;CAGhB;AACD;;AAEA;CACC;AACD;;AAEA;CAGC,wBAAwB;CACxB,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAEhB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,wBAAwB;CACxB;AACD;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB;AACD;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAEhB,oBAAoB;CAEpB,+CAA+C;CAC/C;AACD;;AAEA;CACC,eAAe;CACf,uCAAuC;CACvC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB;AACD;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAGlB,wBAAwB;CACxB;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAIC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAElB,qBAAqB;CACrB,WAAW;CAIX,oBAAoB;CAIpB,mBAAmB;CAInB,uBAAuB;CACvB,mBAAmB;CAGnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB,8BAA8B;CAC9B,gBAAgB;CAGhB,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,yBAAyB;CAEzB,gDAAgD;CAChD,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,aAAa;CAIb;AACD;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,oCAAoC;CACpC;AACD;;AAEA;;;CAGC;AACD;;AAEA;;;CAGC;AACD;;AAEA;;;CAGC,aAAa;CACb,cAAc;CAEd,kBAAkB;CAIlB,oBAAoB;CAIpB,mBAAmB;CAInB,uBAAuB;CACvB,oBAAoB;CACpB,oBAAoB;CACpB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,wBAAwB;CACxB,OAAO;CACP,QAAQ;CACR;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CAEZ,kBAAkB;CAIlB,aAAa;CAIb,uBAAuB;CAIvB,mBAAmB;CACnB,mBAAmB;CACnB,kBAAkB;CAGlB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,WAAW;CAEX,kBAAkB;CAClB,OAAO;CACP;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,wBAAwB;CAIxB,aAAa;CAIb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,WAAW;CAIX,aAAa;CAIb;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;;;;;;;;CAQC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;;CAEC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,aAAa;CAIb,mBAAmB;CACnB,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB;AACD;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd;AACD;;AAEA;CACC,oBAAoB;CACpB,cAAc;CACd,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC;AACD;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB;AACD;;AAEA;CACC,qBAAqB;CACrB,qBAAqB;CACrB,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oBAAoB;CACpB,qBAAqB;CACrB,UAAU;CACV,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN;AACD;;AAEA;CACC,0CAA0C;CAC1C;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAEhB,kBAAkB;CAIlB,aAAa;CAIb,mBAAmB;CAInB,uBAAuB;CACvB,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAGlB;AACD;;AAEA;CACC,wBAAwB;CACxB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,SAAS;CAIT,8BAA8B;CAG9B;AACD;;AAEA;CACC,mBAAmB;CAInB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd;AACD;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CAGd;AACD;;AAEA;CACC,eAAe;CACf,kBAAkB;CAElB,yBAAyB;CACzB,mBAAmB;CAInB,aAAa;CAIb,mBAAmB;CAInB,uBAAuB;CAGvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CAEC,6BAA6B;CAE7B;AACD;;AAEA;CAEC,8BAA8B;CAE9B;AACD;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,6BAA6B;CAC7B,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;CAIV,aAAa;CAIb,uBAAuB;CAIvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,qBAAqB;CAErB,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,QAAQ;CAGR;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,uBAAuB;CACvB,kBAAkB;CAIlB,aAAa;CAIb,mBAAmB;CACnB;AACD;;AAEA;;;CAGC;;EAEC;CACD;AACD;;AAEA;;CAEC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,MAAM;CACN,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CAGR;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAKC;AACD;;AAEA;CACC;EACC,cAAc;EACd;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,OAAO;CACP,SAAS;CAGT,0BAA0B;CAC1B;AACD;;AAEA;CACC,gBAAgB;CAEhB,8CAA8C;CAC9C,uBAAuB;CACvB;AACD;;AAEA;;CAEC;EACC;CACD;AACD;;AAEA;CACC,iBAAiB;CACjB,uBAAuB;CACvB,cAAc;CACd,gBAAgB;CAChB;AACD;;AAEA;CACC,4BAA4B;CAI5B;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;CAEX;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,OAAO;CACP,MAAM;CACN;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,QAAQ;CAGR,2BAA2B;CAC3B,gBAAgB;CAChB,kBAAkB;CAElB,0BAA0B;CAE1B;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CAInB,aAAa;CAIb;AACD;;AAEA;CACC,qBAAqB;CAIrB,uBAAuB;CACvB,gBAAgB;CAEhB,8CAA8C;CAE9C,yBAAyB;CACzB;AACD;;AAEA;CACC,WAAW;CACX,cAAc;CACd,gBAAgB;CAChB,uBAAuB;CACvB,qBAAqB;CACrB,eAAe;CAGf,wBAAwB;CAExB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,0BAA0B;CAC1B,yBAAyB;CACzB,gCAAgC;CAIhC,aAAa;CAGb,eAAe;CAIf;AACD;;AAEA;CACC,wBAAwB;CACxB,cAAc;CACd,gBAAgB;CAChB,eAAe;CAGf;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CAInB,mBAAmB;CAEnB;AACD;;AAEA;CACC,kBAAkB;CAGlB,mBAAmB;CAInB,aAAa;CAKb,sBAAsB;CAItB,uBAAuB;CAIvB,mBAAmB;CAInB;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,8BAA8B;CAI9B,aAAa;CACb,sBAAsB;CAItB,mBAAmB;CAInB,SAAO;CAGP;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CAGd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,uBAAuB;CACvB,iBAAiB;CACjB,qBAAqB;CACrB,kBAAkB;CAElB,0BAA0B;CAC1B,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC,uBAAuB;CACvB,iBAAiB;CAGjB;AACD;;AAEA;CACC,WAAW;CAGX;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,gBAAgB;CAChB,eAAe;CACf;AACD;;AAEA;CACC,8BAA8B;CAC9B;AACD;;AAEA;CAGC,wBAAwB;CACxB;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,2BAA2B;CAG3B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAElB,kBAAkB;CAClB,gBAAgB;CAIhB,aAAa;CAIb,mBAAmB;CAInB,uBAAuB;CACvB,gBAAgB;CAChB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,SAAS;CACT,iBAAiB;CACjB,gBAAgB;CAChB;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,8BAA8B;CAC9B;AACD;;AAEA;CACC,8BAA8B;CAC9B;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,qBAAqB;CACrB,sBAAsB;CACtB;AACD;;AAEA;CACC,qBAAqB;CACrB,SAAS;CACT,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,8BAA8B;CAC9B,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,uDAAuD;CACvD;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB;AACD;;AAEA;CACC;EACC,cAAc;EACd,0BAA0B;EAE1B,gBAAgB;EAGhB,wBAAwB;EAExB,yCAAyC;EACzC,UAAU;EACV,kBAAkB;EAClB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,0BAA0B;EAC1B,UAAU;EACV;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,oBAAoB;CACpB,wBAAwB;CACxB,wBAAwB;CACxB,QAAQ;CACR,QAAQ;CAGR;AACD;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CAEnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,0BAA0B;CAC1B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,SAAS;CAGT;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CAEC,uDAAuD;CACvD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,8BAA8B;CAC9B;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC,kBAAkB;EAElB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EAGX,wBAAwB;EACxB,UAAU;EACV;CACD;AACD;;AAEA;CACC,mBAAmB;CAInB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC,WAAW;EACX;CACD;AACD;;AAEA;;;CAGC;AACD;;AAEA;;;CAGC;AACD;;AAEA;;;;;;;;;CASC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;EAEd,qCAAqC;EACrC;CACD;;CAEA;EACC,UAAU;EACV;CACD;;CAEA;EACC;CACD;;CAEA;EACC,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAEhB;CACD;AACD;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;CAIV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,mBAAmB;CACnB;AACD;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAGhB,wBAAwB;CACxB,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;CACV;AACD;;AAEA;CAIC,aAAa;CAIb,mBAAmB;CACnB,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,uBAAuB;CACvB,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CAGrB;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,mBAAmB;CACnB,kBAAkB;CAElB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,SAAS;CACT,qBAAqB;CACrB,uBAAuB;CACvB,aAAa;CACb,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CAEX;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,aAAa;CAGb,wBAAwB;CACxB,sBAAsB;CACtB,gBAAgB;CAEhB,kBAAkB;CAElB;AACD;;AAEA;CAGC,oBAAoB;CACpB;AACD;;AAEA;CACC,sBAAsB;CACtB,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,0CAA0C;CAC1C,WAAW;CACX;AACD;;AAUA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,+BAA+B;CAC/B,eAAe;CAGf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CAEnB,iDAAiD;CACjD;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,SAAS;CACT,0BAA0B;CAC1B;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;;;CAGC,cAAc;CACd;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,mBAAmB;CACnB,gBAAgB;CAChB;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,WAAW;CACX,eAAe;CACf,cAAc;CACd,UAAU;CACV,oBAAoB;CACpB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,aAAa;CACb;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,SAAS;CACT,WAAW;CACX,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,8BAA8B;CAC9B,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAI7B,aAAa;CAIb,mBAAmB;CAInB,8BAA8B;CAC9B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oBAAoB;CACpB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;;CAEC,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,UAAU;CACV,UAAU;CAEV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,kGAAkG;CAClG;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb;AACD;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB;AACD;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;CAChB,uBAAuB;CAIvB,aAAa;CAIb,mBAAmB;CAInB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB;AACD;;AAEA;CAEC,kBAAkB;CAClB,uBAAuB;CACvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,SAAO;CAGP;AACD;;AAEA;CACC,4BAA4B;CAG5B,aAAa;CAIb,YAAY;CAGZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,mBAAmB;CACnB,YAAY;CACZ;AACD;;AAEA;CACC,gBAAgB;CAChB,UAAU;CACV,aAAa;CACb,kBAAkB;CAClB,sBAAsB;CAItB,aAAa;CAKb,sBAAsB;CAItB;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAGlB,eAAe;CACf,YAAY;CACZ,WAAW;CACX,gBAAgB;CAEhB,oBAAoB;CACpB,cAAc;CACd,UAAU;CACV,yBAAyB;CACzB,QAAQ;CAGR;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CAEZ,oBAAoB;CACpB,cAAc;CACd,UAAU;CACV,QAAQ;CAGR,2BAA2B;CAG3B;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB;AACD;;AAEA;CACC,uBAAuB;CACvB;AACD;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,UAAU;CACV,mBAAmB;CACnB,kBAAkB;CAClB;AACD;;AAEA;CACC,0BAA0B;CAC1B,oBAAoB;CACpB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,YAAY;CAEZ,oBAAoB;CACpB,yBAAyB;CACzB,gBAAgB;CAChB,OAAO;CAGP;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,SAAS;CACT,gBAAgB;CAChB;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CAEf,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;CACrB,mBAAmB;CAEnB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,gBAAgB;CAChB,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;;CAEC,kBAAkB;CAClB;AACD;;AAEA;;CAEC,qBAAqB;CACrB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,YAAY;CACZ,aAAa;CAEb,oBAAoB;CACpB,iCAAiC;CACjC;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAElB,kBAAkB;CAClB,iBAAiB;CACjB,WAAW;CACX,cAAc;CACd,eAAe;CAGf;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,OAAO;CACP,QAAQ;CAGR;AACD;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,QAAQ;CACR,QAAQ;CAGR;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CAEd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,mCAAmC;CACnC,WAAW;CAEX,2CAA2C;CAC3C;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;CACX,qBAAqB;CACrB,mCAAmC;CACnC,cAAc;CAGd,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CAGR;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,QAAQ;CAGR;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,OAAO;CACP,MAAM;CACN,iCAAiC;CAIjC,aAAa;CAIb,uBAAuB;CAIvB,mBAAmB;CAKnB,sBAAsB;CACtB,kBAAkB;CAClB,UAAU;CAGV;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;;CAIC,qBAAqB;CAGrB;AACD;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CAIjB,aAAa;CAIb,uBAAuB;CAIvB,mBAAmB;CAEnB,wBAAwB;CAGxB;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;;CAIC;AACD;;AAEA;CACC,MAAM;CACN;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,gCAAgC;CAChC;AACD;;AAEA;CACC,cAAc;CACd,cAAc;CACd;AACD;;AAEA;CACC,iBAAiB;CACjB,uBAAuB;CACvB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,gCAAgC;CAChC,WAAW;CACX,YAAY;CACZ,OAAO;CACP;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CAGV;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,uBAAuB;CACvB;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,wBAAwB;CACxB,gBAAgB;CAChB,+BAA+B;CAC/B,SAAS;CACT,MAAM;CACN,eAAe;CAGf,2BAA2B;CAC3B;AACD;;AAEA;CACC,iBAAiB;CACjB,8BAA8B;CAC9B,uBAAuB;CACvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,oCAAoC;CACpC,oBAAoB;CACpB;AACD;;AAEA;;CAEC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,8CAA8C;CAC9C,8BAA8B;CAC9B;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,0CAA0C;CAC1C,yCAAyC;CACzC,iCAAiC;CACjC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CAIvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sEAAsE;CAEtE,sBAAsB;CACtB,4BAA4B;CAC5B;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,wBAAwB;CACxB,sBAAsB;CACtB,4BAA4B;CAC5B,WAAW;CACX,QAAQ;CAGR;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,gBAAgB;CAEhB;AACD;;AAEA;CAIC,aAAa;CAGb;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,UAAU;CAIV,aAAa;CAIb,uBAAuB;CAKvB,sBAAsB;CACtB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;CAClB,UAAU;CAGV;AACD;;AAEA,4BAA4B;AAC5B;EACE,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA,gEAAgE;AAChE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA,SAAS,WAAW,CAAC,WAAW,CAAC;AACjC;CACC,yBAAyB;CACzB,kBAAkB;CAClB,UAAU;CAGV;AACD;;AAEA;;CAEC,mBAAmB;CACnB,UAAU;CAGV;AACD;;AAEA;;CAEC,WAAW;CACX;AACD;;AAEA;;CAKC,aAAa;CAIb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;CAIhB,aAAa;CAIb,mBAAmB;CAEnB;AACD;;AAEA;;CAEC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB,YAAY;CAIZ,aAAa;CAIb,uBAAuB;CAIvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CAGV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CAIC,aAAa;CAIb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,qBAAqB;CACrB,WAAW;CAEX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,wBAAwB;CACxB,iBAAiB;CACjB,6BAA6B;CAI7B,aAAa;CAIb;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CAEC,2CAA2C;CAC3C;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,UAAU;CACV,+BAA+B;CAC/B,gCAAgC;CAChC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB;AACD;;AAEA;;CAEC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,yBAAyB;CACzB,gBAAgB;CAChB,uBAAuB;CACvB,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,+CAA+C;CAC/C,gBAAgB;CAChB,uBAAuB;CACvB,yBAAyB;CACzB,qBAAqB;CACrB,kBAAkB;CAElB;AACD;;AAEA;CAEC,8CAA8C;CAC9C,mBAAmB;CACnB,kBAAkB;CAIlB,aAAa;CAIb,uBAAuB;CAIvB,mBAAmB;CACnB,kBAAkB;CAClB,SAAS;CACT,MAAM;CAGN,gCAAgC;CAChC,gBAAgB;CAEhB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,aAAa;CAIb,mBAAmB;CAInB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,SAAS;CACT,UAAU;CAEV,2CAA2C;CAC3C;AACD;;AAEA;CACC,eAAe;CACf,cAAc;CAEd;AACD;;AAEA;CACC,mBAAmB;CACnB,WAAW;CAEX;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CAEnB,yBAAyB;CACzB,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,aAAa;CACb,cAAc;CACd,+BAA+B;CAC/B,gBAAgB;CAEhB,kBAAkB;CAClB,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,uBAAuB;CACvB,cAAc;CACd,qBAAqB;CACrB,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,OAAO;CACP,MAAM;CACN;AACD;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,qBAAqB;CAIrB,aAAa;CAIb,uBAAuB;CAIvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CAIjB,aAAa;CAIb,uBAAuB;CAIvB;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,WAAW;CACX,+BAA+B;CAC/B,mBAAmB;CACnB;AACD;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,mBAAmB;CACnB,OAAO;CACP,QAAQ;CAGR,2BAA2B;CAC3B,mBAAmB;CACnB,UAAU;CACV;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,QAAQ;CAGR,2BAA2B;CAE3B,mCAAmC;CAEnC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,qBAAqB;CACrB,8BAA8B;CAC9B;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAGlB,yEAAyE;CACzE,qBAAqB;CACrB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,gEAAgE;CAChE,4BAA4B;CAE5B,sBAAsB;CACtB;AACD;;AAEA;;CAGC,+CAA+C;CAC/C,eAAe;CACf,kBAAkB;CAClB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,uBAAuB;CACvB;AACD;;AAEA;CACC,SAAS;CACT,8BAA8B;CAC9B;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB;AACD;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB;AACD;;AAEA;CACC,uBAAuB;CACvB;AACD;;AAEA;CACC,qBAAqB;CACrB,kEAAkE;CAClE,4BAA4B;CAC5B;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAElB,gDAAgD;CAChD,cAAc;CAEd,oBAAoB;CACpB,0BAA0B;CAC1B;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CAGR,2BAA2B;CAE3B;AACD;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,iBAAiB;CACjB,uBAAuB;CACvB,8BAA8B;CAC9B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,0BAA0B;CAI1B,oBAAoB;CAIpB;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,gEAAgE;CAChE,4BAA4B;CAE5B,sBAAsB;CACtB,2BAA2B;CAE3B,2CAA2C;CAC3C;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;;;;;CAKC;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,uBAAuB;CACvB,gBAAgB;CAChB;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,8BAA8B;CAC9B,iBAAiB;CACjB;AACD;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,WAAW;CACX,mBAAmB;CACnB;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,eAAe;CACf,cAAc;CACd;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,QAAQ;CACR,MAAM;CACN,oCAAoC;CAEpC,yBAAyB;CAGzB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,QAAQ;CACR,MAAM;CACN,oCAAoC;CAEpC,yBAAyB;CAGzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,uBAAuB;CACvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,UAAU;CACV,QAAQ;CAER;AACD;;AAEA;CAIC,aAAa;CAGb,eAAe;CACf,kBAAkB;CAClB;AACD;;AAEA;CACC,UAAU;CACV,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAElB,kBAAkB;CAClB,kBAAkB;CAIlB,aAAa;CAIb,uBAAuB;CAIvB,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAElB,kBAAkB;CAClB,gBAAgB;CAIhB,aAAa;CAIb,uBAAuB;CAIvB,mBAAmB;CACnB,cAAc;CACd,gBAAgB;CAChB,OAAO;CACP,MAAM;CAEN;AACD;;AAEA;CACC,kBAAkB;CAClB,mEAAmE;CACnE,WAAW;CACX,QAAQ;CAGR;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,gBAAgB;CAEhB,8CAA8C;CAC9C;AACD;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,gBAAgB;CAChB,cAAc;CACd,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAGC,wBAAwB;CAExB;AACD;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB;AACD;;AAEA;CAEC,sCAAsC;CAGtC;AACD;;AAEA;CACC,yBAAyB;CAEzB,sCAAsC;CAGtC,wBAAwB;CACxB;AACD;;AAEA;CACC,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;;;;;;;;;;;CAaC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,wBAAwB;CACxB,yBAAyB;CACzB;AACD;;AAEA;CACC,SAAS;CACT,gCAAgC;CAChC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAEhB,+CAA+C;CAE/C;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CAEX,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;CACd,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CAErB,yBAAyB;CACzB,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,kBAAkB;CAClB,eAAe;CACf,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CAGd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,gBAAgB;CAChB;AACD;;AAEA;CAIC,aAAa;CAGb,eAAe;CACf;AACD;;AAEA;CACC,uBAAuB;CACvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,uBAAuB;CACvB,cAAc;CACd,yBAAyB;CAEzB,kBAAkB;CAClB,sBAAsB;CAGtB,wBAAwB;CACxB,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB;AACD;;AAEA;CACC,eAAe;CACf,WAAW;CACX;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,sBAAsB;CACtB,iBAAiB;CACjB,cAAc;CACd,wBAAwB;CACxB;AACD;;AAEA;CACC,eAAe;CACf,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;;;CAGC,cAAc;CACd;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,mBAAmB;CACnB,gBAAgB;CAChB;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,WAAW;CACX,eAAe;CACf,cAAc;CACd,UAAU;CACV,oBAAoB;CACpB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,aAAa;CACb;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,SAAS;CACT,WAAW;CACX,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,8BAA8B;CAC9B,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAI7B,aAAa;CAIb,mBAAmB;CAInB,8BAA8B;CAC9B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oBAAoB;CACpB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;;CAEC,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,UAAU;CACV,UAAU;CAEV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,kGAAkG;CAClG;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,uBAAuB;CACvB;AACD;;AAEA;CACC,mBAAmB;CAGnB,wBAAwB;CACxB,WAAW;CACX,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iCAAiC;CACjC,gBAAgB;CAChB,oBAAoB;CACpB,uBAAuB;CACvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,wBAAwB;CAExB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,0BAA0B;CAC1B,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAEhB,wBAAwB;CACxB,gBAAgB;CAEhB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,2BAA2B;CAC3B,kBAAkB;CAClB;AACD;;AAEA;;CAEC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,mBAAmB;CAEnB,oBAAoB;CACpB,SAAS;CACT,SAAS;CAGT;AACD;;AAEA;;CAEC,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,iCAAiC;CAEjC,oBAAoB;CACpB,SAAS;CACT,SAAS;CAGT;AACD;;AAEA;CACC;AACD;;AAEA;CAGC,aAAa;CAIb,YAAY;CACZ;AACD;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,gBAAgB;CAGhB,eAAe;CACf;AACD;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CAEzB,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,eAAe;CACf,uBAAuB;CACvB,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;;CAEC,kBAAkB;CAClB;AACD;;AAEA;;CAEC,WAAW;CACX,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CAKC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;CAClB;AACD;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,uBAAuB;CACvB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,uBAAuB;CACvB,gBAAgB;CAChB;AACD;;AAEA;CACC,6BAA6B;CAE7B;AACD;;AAEA;CACC,mBAAmB;CAInB,aAAa;CAGb;AACD;;AAEA;CACC,wBAAwB;CACxB,eAAe;CAIf,aAAa;CAIb,mBAAmB;CACnB;AACD;;AAEA;CACC,iBAAiB;CACjB,sBAAsB;CACtB;AACD;;AAEA;CACC,cAAc;CACd,uBAAuB;CACvB;AACD;;AAEA;CAIC,aAAa;CACb,gBAAgB;CAChB;AACD;;AAEA;CAIC,aAAa;CAIb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,oBAAoB;CACpB,YAAY;CACZ;AACD;;AAEA;;CAEC,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd,kCAAkC;CAClC,kBAAkB;CAGlB,wBAAwB;CACxB,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,8BAA8B;CAC9B,kBAAkB;CAClB;AACD;;AAEA;CACC,8BAA8B;CAC9B,qBAAqB;CACrB,mBAAmB;CACnB;AACD;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,gBAAgB;CAChB;AACD;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,8BAA8B;CAC9B;AACD;;AAEA;CACC,0EAA0E;CAE1E,0BAA0B;CAC1B,4BAA4B;CAC5B,0BAA0B;CAC1B;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,OAAO;CACP,MAAM;CACN,gBAAgB;CAMhB,oDAAoD;CACpD,8GAA8G;CAC9G;AACD;;AAEA;CAEC,gBAAgB;CAChB;AACD;;AAEA;CAIC,6DAA6D;CAC7D,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,OAAO;CACP,MAAM;CAIN,yHAAyH;CACzH,4BAA4B;CAC5B,0BAA0B;CAC1B;AACD;;AAEA;CAEC,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,OAAO;CACP,MAAM;CAIN,aAAa;CAIb;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,eAAe;CACf,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,QAAQ;CACR,MAAM;CAGN,qDAAqD;CAIrD,aAAa;CAIb,mBAAmB;CAInB;AACD;;AAEA;CACC,uBAAuB;CAIvB,aAAa;CAIb,mBAAmB;CACnB,kBAAkB;CAClB;AACD;;AAEA;;CAEC;EACC;CACD;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,YAAY;CACZ,+BAA+B;CAC/B,qCAAqC;CACrC,gCAAgC;CAChC,OAAO;CACP;AACD;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,gBAAgB;CAChB;AACD;;AAEA;CACC,WAAW;CACX,SAAS;CACT,qBAAqB;CACrB;AACD;;AAEA;CACC,wBAAwB;CAIxB,aAAa;CAGb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,uBAAuB;CACvB,kBAAkB;CAGlB,kDAAkD;CAClD;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,mBAAmB;CAEnB,kBAAkB;CAClB,YAAY;CACZ;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,OAAO;CACP,MAAM;CAIN,aAAa;CAIb,mBAAmB;CACnB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,OAAO;CACP,YAAY;CACZ,MAAM;CAIN,aAAa;CAIb,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,YAAY;CACZ,OAAO;CACP,MAAM;CAIN,0EAA0E;CAC1E;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,OAAO;CACP,MAAM;CAIN,aAAa;CAIb;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,SAAS;CACT,qBAAqB;CACrB,cAAc;CACd;AACD;;AAEA;CAIC,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,OAAO;CACP;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sEAAsE;CAEtE,0BAA0B;CAC1B;AACD;;AAEA;CACC,sEAAsE;CAEtE,0BAA0B;CAC1B;AACD;;AAEA;CACC,sEAAsE;CAEtE,0BAA0B;CAC1B,4BAA4B;CAC5B;AACD;;AAEA;CACC,uBAAuB;CACvB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,OAAO;CACP,MAAM;CAIN,aAAa;CAIb;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,OAAO;CACP,MAAM;CACN,WAAW;CAGX;AACD;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,WAAW;CACX,gBAAgB;CAChB;AACD;;AAEA;CACC,qBAAqB;CACrB,uBAAuB;CACvB,8BAA8B;CAC9B;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,MAAM;CACN,YAAY;CAIZ,aAAa;CAIb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;;CAEC,kBAAkB;CAClB,iCAAiC;CAEjC,oBAAoB;CACpB,qBAAqB;CAIrB;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;CAEC;AACD;;AAEA;CAIC,aAAa;CAIb,qBAAqB;CACrB,gCAAgC;CAChC,uBAAuB;CACvB;AACD;;AAEA;;CAEC,kBAAkB;CAClB,QAAQ;CAGR;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,uBAAuB;CACvB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,qBAAqB;CACrB,uBAAuB;CACvB;AACD;;AAEA;CACC,iCAAiC;CAIjC,aAAa;CAGb;AACD;;AAEA;CACC,WAAW;CAIX;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,qCAAqC;CAErC,yDAAyD;CACzD;AACD;;AAEA;CAIC,UAAU;CAEV,0BAA0B;CAE1B;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,WAAW;CACX,iCAAiC;CACjC;AACD;;AAEA;;;CAGC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,WAAW;CACX,gCAAgC;CAChC,WAAW;CACX,OAAO;CACP;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC,oCAAoC;CACpC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,cAAc;CAGd,wBAAwB;CACxB,WAAW;CACX;AACD;;AAEA;;CAEC,mCAAmC;CACnC;AACD;;AAEA;CACC,WAAW;CACX,oCAAoC;CAEpC,oBAAoB;CAEpB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mCAAmC;CAEnC;AACD;;AAEA;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB,WAAW;CACX,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,gCAAgC;CAChC;AACD;;AAEA;CACC,mCAAmC;CACnC,mBAAmB;CAEnB;AACD;;AAEA;CACC,SAAS;CACT,qBAAqB;CACrB;AACD;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,SAAS;CACT;AACD;;AAEA;;CAGC,8CAA8C;CAC9C,kBAAkB;CAClB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,qBAAqB;CACrB,cAAc;CACd,eAAe;CACf,cAAc;CACd,gBAAgB;CAGhB;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,mBAAmB;CAEnB,8CAA8C;CAC9C,gBAAgB;CAEhB;AACD;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,oCAAoC;CACpC,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CAIC;AACD;;AAEA;CAIC;AACD;;AAEA;CAIC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,OAAO;CACP,MAAM;CAGN,2BAA2B;CAC3B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,OAAO;CACP,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC;AACD;;AAEA;CACC,cAAc;CACd,wBAAwB;CACxB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,aAAa;CAIb,mBAAmB;CACnB;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,2BAA2B;CAC3B,qBAAqB;CACrB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,6BAA6B;CAC7B,yBAAyB;CAEzB;AACD;;AAEA;CACC,wBAAwB;CACxB;AACD;;AAEA;CACC,cAAc;CACd,eAAe;CACf,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,gCAAgC;CAChC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,aAAa;CAIb,uBAAuB;CAGvB;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mCAAmC;CAEnC,kBAAkB;CAIlB,aAAa;CAIb,mBAAmB;CAInB,uBAAuB;CACvB,wBAAwB;CAKxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,uBAAuB;CACvB,qBAAqB;CACrB,oBAAoB;CACpB,wBAAwB;CAExB;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;CAEC,eAAe;CACf,cAAc;CACd;AACD;;AAEA;CACC,wBAAwB;CACxB;AACD;;AAEA;CACC,uBAAuB;CACvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,gBAAgB;CAChB,WAAW;CACX;AACD;;AAEA;CACC,kBAAkB;CAClB,wBAAwB;CACxB,8BAA8B;CAC9B;AACD;;AAEA;CACC;AACD;;AAEA;CAKC;AACD;;AAEA;CAIC;AACD;;AAEA;CAIC,SAAO;CACP;AACD;;AAEA;CACC;AACD;;AAEA;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CAEzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CAInB;AACD;;AAEA;CACC;AACD;;AAEA;CAIC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAIC,aAAa;CAIb;AACD;;AAEA;CAIC;AACD;;AAEA;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd,cAAc;CACd;AACD;;AAEA;CAIC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oBAAoB;CACpB,eAAe;CACf,6BAA6B;CAC7B;AACD;;AAEA;CAIC,aAAa;CAIb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB;AACD;;AAEA;CAIC,aAAa;CACb,0BAA0B;CAC1B,yBAAyB;CACzB;AACD;;AAEA;CAIC;AACD;;AAEA;CAIC,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CAIC;AACD;;AAEA;CAIC,SAAO;CACP,cAAc;CACd;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,cAAc;CACd;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,oCAAoC;CACpC,oBAAoB;CACpB,mCAAmC;CACnC,qBAAqB;CACrB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC,gBAAgB;EAChB;CACD;;CAEA;;EAEC,gBAAgB;EAChB;CACD;AACD;;AAEA;CACC,6BAA6B;CAC7B,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,aAAa;CAIb,mBAAmB;CAGnB;AACD;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,uBAAuB;CACvB,cAAc;CACd,iBAAiB;CAIjB;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB;AACD;;AAEA;;CAEC,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,gCAAgC;CAChC;AACD;;AAEA;CAIC,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CAIC,aAAa;CAIb,mBAAmB;CAGnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,oCAAoC;CACpC,eAAe;CACf,YAAY;CACZ,QAAQ;CAGR,2BAA2B;CAC3B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,0BAA0B;CAC1B,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;CAC1B;AACD;;AAEA;CAIC,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CAIC,aAAa;CACb,oBAAoB;CACpB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,mBAAmB;CACnB,eAAe;CACf,6BAA6B;CAC7B,gCAAgC;CAChC;AACD;;AAEA;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,uBAAuB;CACvB,cAAc;CACd,yBAAyB;CAEzB,oBAAoB;CACpB,gBAAgB;CAGhB,wBAAwB;CACxB,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB;AACD;;AAEA;CAIC,SAAO;CAIP;AACD;;AAEA;CACC,mBAAmB;CAInB,aAAa;CACb;AACD;;AAEA;CAIC;AACD;;AAEA;CAIC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,aAAa;CAIb,8BAA8B;CAC9B,gCAAgC;CAChC;AACD;;AAEA;;CAKC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;CAGd;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,0BAA0B;CAC1B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CAEzB,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CAIC,aAAa;CAIb,8BAA8B;CAI9B,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,uBAAuB;CAEvB,yBAAyB;CACzB,qBAAqB;CACrB,gBAAgB;CAChB,oBAAoB;CACpB,eAAe;CAGf;AACD;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,wBAAwB;CACxB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,OAAO;CACP,QAAQ;CAGR;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,6FAA6F;CAC7F,qBAAqB;CACrB;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,OAAO;CACP,MAAM;CACN,mBAAmB;CACnB;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,QAAQ;CACR,MAAM;CAGN,qDAAqD;CACrD;AACD;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,YAAY;CAIZ,aAAa;CAIb,mBAAmB;CAEnB,wBAAwB;CAExB;AACD;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EAGC,aAAa;EAIb;CACD;;CAEA;EACC;CACD;;CAEA;;EAKC;CACD;;CAEA;EAIC,yBAAyB;EAIzB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,cAAc;EACd;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAIC;CACD;;CAEA;EAGC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,WAAW;EACX;CACD;;CAEA;EACC,kBAAkB;EAClB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC,WAAW;EAEX,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB;CACD;;CAEA;;EAKC,aAAa;EACb;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,MAAM;EACN,YAAY;EACZ;CACD;;CAEA;;;EAGC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;;;;;EAMC;CACD;;CAEA;;;;;;EAMC,kBAAkB;EAClB;CACD;;CAEA;;;EAGC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,yBAAyB;EACzB;CACD;;CAEA;EACC,kBAAkB;EAClB;CACD;;CAEA;EACC;CACD;;CAEA;EACC,gBAAgB;EAChB;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,mCAAmC;EACnC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAGC;CACD;;CAEA;;EAKC,aAAa;EAIb,uBAAuB;EACvB;CACD;;CAEA;EAGC,eAAe;EACf;CACD;;CAEA;;EAEC;CACD;;CAEA;EAIC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,cAAc;EACd;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAIC,eAAe;EAIf,kCAAkC;EAClC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,eAAe;EACf;CACD;;CAEA;EACC;CACD;;CAEA;EAIC,SAAO;EACP;CACD;;CAEA;EACC,eAAe;EAIf,SAAO;EACP;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC,kBAAkB;EAGlB;CACD;;CAEA;EACC;CACD;;CAEA;EACC,kBAAkB;EAGlB,eAAe;EACf;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAGC;CACD;;CAEA;EAGC;CACD;;CAEA;EAGC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAGC,kBAAkB;EAIlB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAIC,aAAa;EAGb,eAAe;EAIf;CACD;;CAEA;EACC,WAAW;EAIX;CACD;;CAEA;;EAEC,UAAU;EACV;CACD;;CAEA;EACC;CACD;;CAEA;EAIC;CACD;;CAEA;EAKC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,cAAc;EACd;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAIC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAIC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;;;EAIC,gBAAgB;EAChB;CACD;;CAEA;EACC,UAAU;EACV,kBAAkB;EAClB;CACD;;CAEA;;EAEC,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT;CACD;;CAEA;EACC;CACD;;CAEA;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;;;EAIC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAKC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,qBAAqB;EACrB;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;;EAGC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,eAAe;EACf;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,gBAAgB;EAChB;CACD;;CAEA;EACC,WAAW;EACX;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;;;;EAKC;CACD;;CAEA;;;;;EAKC,UAAU;EACV;CACD;;CAEA;EACC,iBAAiB;EACjB;CACD;;CAEA;;EAEC;CACD;;CAEA;EAKC;CACD;;CAEA;EACC,kBAAkB;EAClB,MAAM;EAGN,eAAe;EACf;CACD;;CAEA;EACC;CACD;;CAEA;EAKC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC,WAAW;EAIX;CACD;;CAEA;;EAKC;CACD;;CAEA;EAIC,QAAQ;EACR,0BAA0B;EAC1B;CACD;;CAEA;EACC,YAAY;EACZ,eAAe;EACf;CACD;;CAEA;EACC,cAAc;EACd;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,gBAAgB;EAChB,kBAAkB;EAClB;CACD;;CAEA;EACC;CACD;;CAEA;EACC,0BAA0B;EAC1B;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EAIC;CACD;;CAEA;;EAMC,sBAAsB;EAItB;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EAKC,sBAAsB;EAItB,sCAAsC;EAItC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,yBAAyB;EACzB;CACD;;CAEA;EACC,WAAW;EACX;CACD;;CAEA;EACC,YAAY;EACZ,QAAQ;EAGR,6BAA6B;EAC7B,UAAU;EACV;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,WAAW;EACX;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,UAAU;EAEV;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,WAAW;EACX;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAIC,aAAa;EAIb;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,iBAAiB;EACjB,kBAAkB;EAClB;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC,cAAc;EACd;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;;CAEC;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EAKC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAKC,sBAAsB;EAItB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;;;;EAKC;CACD;;CAEA;;;EAGC;CACD;;CAEA;;;EAGC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAGC;CACD;;CAEA;EAKC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,qBAAqB;EACrB;CACD;;CAEA;EAIC,aAAa;EAKb;CACD;;CAEA;EACC;CACD;;CAEA;EAGC,eAAe;EAIf;CACD;;CAEA;EACC;CACD;;CAEA;EAKC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAKC,sBAAsB;EAItB,mBAAmB;EACnB;CACD;;CAEA;EACC,eAAe;EACf;CACD;;CAEA;EACC;CACD;;CAEA;EAKC,sBAAsB;EAGtB;CACD;;CAEA;EACC,cAAc;EACd;CACD;;CAEA;EACC;CACD;;CAEA;EAKC;CACD;;CAEA;EACC;CACD;;CAEA;EAKC;CACD;;CAEA;EACC;CACD;;CAEA;EAKC,sBAAsB;EAItB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,iBAAiB;EACjB,WAAW;EACX;CACD;;CAEA;EACC,kBAAkB;EAClB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC,WAAW;EACX;CACD;;CAEA;EAKC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;;EAGC;CACD;;CAEA;;;;;EAKC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC,gBAAgB;EAChB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;;;;EAKC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAIC;CACD;;CAEA;;EAEC;CACD;;CAEA;EAIC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAIC,mBAAmB;EACnB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EAKC,sBAAsB;EAItB,mBAAmB;EAInB;CACD;;CAEA;EACC,kBAAkB;EAClB;CACD;;CAEA;EACC,iBAAiB;EACjB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,gBAAgB;EAChB,MAAM;EAGN,eAAe;EACf;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD","sourcesContent":[".dropdown-menu.show {\n  display: block !important;\n}\n\n.m-top-0 {\n\tmargin-top: 0\n}\n\n.m-top-5 {\n\tmargin-top: 5px\n}\n\n.m-top-10 {\n\tmargin-top: 10px\n}\n\n.m-top-15 {\n\tmargin-top: 15px\n}\n\n.m-top-20 {\n\tmargin-top: 20px\n}\n\n.m-top-25 {\n\tmargin-top: 25px\n}\n\n.m-top-30 {\n\tmargin-top: 30px\n}\n\n.m-top-35 {\n\tmargin-top: 35px\n}\n\n.m-top-40 {\n\tmargin-top: 40px\n}\n\n.m-top-45 {\n\tmargin-top: 45px\n}\n\n.m-top-50 {\n\tmargin-top: 50px\n}\n\n.m-top-55 {\n\tmargin-top: 55px\n}\n\n.m-top-60 {\n\tmargin-top: 60px\n}\n\n.m-top-65 {\n\tmargin-top: 65px\n}\n\n.m-top-70 {\n\tmargin-top: 70px\n}\n\n.m-top-75 {\n\tmargin-top: 75px\n}\n\n.m-top-80 {\n\tmargin-top: 80px\n}\n\n.m-top-85 {\n\tmargin-top: 85px\n}\n\n.m-top-90 {\n\tmargin-top: 90px\n}\n\n.m-top-95 {\n\tmargin-top: 95px\n}\n\n.m-top-100 {\n\tmargin-top: 100px\n}\n\n.m-top-105 {\n\tmargin-top: 105px\n}\n\n.m-top-110 {\n\tmargin-top: 110px\n}\n\n.m-top-115 {\n\tmargin-top: 115px\n}\n\n.m-top-120 {\n\tmargin-top: 120px\n}\n\n.m-top-125 {\n\tmargin-top: 125px\n}\n\n.m-top-130 {\n\tmargin-top: 130px\n}\n\n.m-top-135 {\n\tmargin-top: 135px\n}\n\n.m-top-140 {\n\tmargin-top: 140px\n}\n\n.m-top-145 {\n\tmargin-top: 145px\n}\n\n.m-top-150 {\n\tmargin-top: 150px\n}\n\n.m-right-0 {\n\tmargin-right: 0\n}\n\n.m-right-5 {\n\tmargin-right: 5px\n}\n\n.m-right-10 {\n\tmargin-right: 10px\n}\n\n.m-right-15 {\n\tmargin-right: 15px\n}\n\n.m-right-20 {\n\tmargin-right: 20px\n}\n\n.m-right-25 {\n\tmargin-right: 25px\n}\n\n.m-right-30 {\n\tmargin-right: 30px\n}\n\n.m-right-35 {\n\tmargin-right: 35px\n}\n\n.m-right-40 {\n\tmargin-right: 40px\n}\n\n.m-right-45 {\n\tmargin-right: 45px\n}\n\n.m-right-50 {\n\tmargin-right: 50px\n}\n\n.m-right-55 {\n\tmargin-right: 55px\n}\n\n.m-right-60 {\n\tmargin-right: 60px\n}\n\n.m-right-65 {\n\tmargin-right: 65px\n}\n\n.m-right-70 {\n\tmargin-right: 70px\n}\n\n.m-right-75 {\n\tmargin-right: 75px\n}\n\n.m-right-80 {\n\tmargin-right: 80px\n}\n\n.m-right-85 {\n\tmargin-right: 85px\n}\n\n.m-right-90 {\n\tmargin-right: 90px\n}\n\n.m-right-95 {\n\tmargin-right: 95px\n}\n\n.m-right-100 {\n\tmargin-right: 100px\n}\n\n.m-right-105 {\n\tmargin-right: 105px\n}\n\n.m-right-110 {\n\tmargin-right: 110px\n}\n\n.m-right-115 {\n\tmargin-right: 115px\n}\n\n.m-right-120 {\n\tmargin-right: 120px\n}\n\n.m-right-125 {\n\tmargin-right: 125px\n}\n\n.m-right-130 {\n\tmargin-right: 130px\n}\n\n.m-right-135 {\n\tmargin-right: 135px\n}\n\n.m-right-140 {\n\tmargin-right: 140px\n}\n\n.m-right-145 {\n\tmargin-right: 145px\n}\n\n.m-right-150 {\n\tmargin-right: 150px\n}\n\n.m-bottom-0 {\n\tmargin-bottom: 0\n}\n\n.m-bottom-5 {\n\tmargin-bottom: 5px\n}\n\n.m-bottom-10 {\n\tmargin-bottom: 10px\n}\n\n.m-bottom-15 {\n\tmargin-bottom: 15px\n}\n\n.m-bottom-20 {\n\tmargin-bottom: 20px\n}\n\n.m-bottom-25 {\n\tmargin-bottom: 25px\n}\n\n.m-bottom-30 {\n\tmargin-bottom: 30px\n}\n\n.m-bottom-35 {\n\tmargin-bottom: 35px\n}\n\n.m-bottom-40 {\n\tmargin-bottom: 40px\n}\n\n.m-bottom-45 {\n\tmargin-bottom: 45px\n}\n\n.m-bottom-50 {\n\tmargin-bottom: 50px\n}\n\n.m-bottom-55 {\n\tmargin-bottom: 55px\n}\n\n.m-bottom-60 {\n\tmargin-bottom: 60px\n}\n\n.m-bottom-65 {\n\tmargin-bottom: 65px\n}\n\n.m-bottom-70 {\n\tmargin-bottom: 70px\n}\n\n.m-bottom-75 {\n\tmargin-bottom: 75px\n}\n\n.m-bottom-80 {\n\tmargin-bottom: 80px\n}\n\n.m-bottom-85 {\n\tmargin-bottom: 85px\n}\n\n.m-bottom-90 {\n\tmargin-bottom: 90px\n}\n\n.m-bottom-95 {\n\tmargin-bottom: 95px\n}\n\n.m-bottom-100 {\n\tmargin-bottom: 100px\n}\n\n.m-bottom-105 {\n\tmargin-bottom: 105px\n}\n\n.m-bottom-110 {\n\tmargin-bottom: 110px\n}\n\n.m-bottom-115 {\n\tmargin-bottom: 115px\n}\n\n.m-bottom-120 {\n\tmargin-bottom: 120px\n}\n\n.m-bottom-125 {\n\tmargin-bottom: 125px\n}\n\n.m-bottom-130 {\n\tmargin-bottom: 130px\n}\n\n.m-bottom-135 {\n\tmargin-bottom: 135px\n}\n\n.m-bottom-140 {\n\tmargin-bottom: 140px\n}\n\n.m-bottom-145 {\n\tmargin-bottom: 145px\n}\n\n.m-bottom-150 {\n\tmargin-bottom: 150px\n}\n\n.m-left-0 {\n\tmargin-left: 0\n}\n\n.m-left-5 {\n\tmargin-left: 5px\n}\n\n.m-left-10 {\n\tmargin-left: 10px\n}\n\n.m-left-15 {\n\tmargin-left: 15px\n}\n\n.m-left-20 {\n\tmargin-left: 20px\n}\n\n.m-left-25 {\n\tmargin-left: 25px\n}\n\n.m-left-30 {\n\tmargin-left: 30px\n}\n\n.m-left-35 {\n\tmargin-left: 35px\n}\n\n.m-left-40 {\n\tmargin-left: 40px\n}\n\n.m-left-45 {\n\tmargin-left: 45px\n}\n\n.m-left-50 {\n\tmargin-left: 50px\n}\n\n.m-left-55 {\n\tmargin-left: 55px\n}\n\n.m-left-60 {\n\tmargin-left: 60px\n}\n\n.m-left-65 {\n\tmargin-left: 65px\n}\n\n.m-left-70 {\n\tmargin-left: 70px\n}\n\n.m-left-75 {\n\tmargin-left: 75px\n}\n\n.m-left-80 {\n\tmargin-left: 80px\n}\n\n.m-left-85 {\n\tmargin-left: 85px\n}\n\n.m-left-90 {\n\tmargin-left: 90px\n}\n\n.m-left-95 {\n\tmargin-left: 95px\n}\n\n.m-left-100 {\n\tmargin-left: 100px\n}\n\n.m-left-105 {\n\tmargin-left: 105px\n}\n\n.m-left-110 {\n\tmargin-left: 110px\n}\n\n.m-left-115 {\n\tmargin-left: 115px\n}\n\n.m-left-120 {\n\tmargin-left: 120px\n}\n\n.m-left-125 {\n\tmargin-left: 125px\n}\n\n.m-left-130 {\n\tmargin-left: 130px\n}\n\n.m-left-135 {\n\tmargin-left: 135px\n}\n\n.m-left-140 {\n\tmargin-left: 140px\n}\n\n.m-left-145 {\n\tmargin-left: 145px\n}\n\n.m-left-150 {\n\tmargin-left: 150px\n}\n\n.p-left-0 {\n\tpadding-left: 0\n}\n\n.p-left-5 {\n\tpadding-left: 5px\n}\n\n.p-left-10 {\n\tpadding-left: 10px\n}\n\n.p-left-15 {\n\tpadding-left: 15px\n}\n\n.p-left-20 {\n\tpadding-left: 20px\n}\n\n.p-left-25 {\n\tpadding-left: 25px\n}\n\n.p-left-30 {\n\tpadding-left: 30px\n}\n\n.p-left-35 {\n\tpadding-left: 35px\n}\n\n.p-left-40 {\n\tpadding-left: 40px\n}\n\n.p-left-45 {\n\tpadding-left: 45px\n}\n\n.p-left-50 {\n\tpadding-left: 50px\n}\n\n.p-left-55 {\n\tpadding-left: 55px\n}\n\n.p-left-60 {\n\tpadding-left: 60px\n}\n\n.p-left-65 {\n\tpadding-left: 65px\n}\n\n.p-left-70 {\n\tpadding-left: 70px\n}\n\n.p-left-75 {\n\tpadding-left: 75px\n}\n\n.p-left-80 {\n\tpadding-left: 80px\n}\n\n.p-left-85 {\n\tpadding-left: 85px\n}\n\n.p-left-90 {\n\tpadding-left: 90px\n}\n\n.p-left-95 {\n\tpadding-left: 95px\n}\n\n.p-left-100 {\n\tpadding-left: 100px\n}\n\n.p-left-105 {\n\tpadding-left: 105px\n}\n\n.p-left-110 {\n\tpadding-left: 110px\n}\n\n.p-left-115 {\n\tpadding-left: 115px\n}\n\n.p-left-120 {\n\tpadding-left: 120px\n}\n\n.p-left-125 {\n\tpadding-left: 125px\n}\n\n.p-left-130 {\n\tpadding-left: 130px\n}\n\n.p-left-135 {\n\tpadding-left: 135px\n}\n\n.p-left-140 {\n\tpadding-left: 140px\n}\n\n.p-left-145 {\n\tpadding-left: 145px\n}\n\n.p-left-150 {\n\tpadding-left: 150px\n}\n\n.p-right-0 {\n\tpadding-right: 0\n}\n\n.p-right-5 {\n\tpadding-right: 5px\n}\n\n.p-right-10 {\n\tpadding-right: 10px\n}\n\n.p-right-15 {\n\tpadding-right: 15px\n}\n\n.p-right-20 {\n\tpadding-right: 20px\n}\n\n.p-right-25 {\n\tpadding-right: 25px\n}\n\n.p-right-30 {\n\tpadding-right: 30px\n}\n\n.p-right-35 {\n\tpadding-right: 35px\n}\n\n.p-right-40 {\n\tpadding-right: 40px\n}\n\n.p-right-45 {\n\tpadding-right: 45px\n}\n\n.p-right-50 {\n\tpadding-right: 50px\n}\n\n.p-right-55 {\n\tpadding-right: 55px\n}\n\n.p-right-60 {\n\tpadding-right: 60px\n}\n\n.p-right-65 {\n\tpadding-right: 65px\n}\n\n.p-right-70 {\n\tpadding-right: 70px\n}\n\n.p-right-75 {\n\tpadding-right: 75px\n}\n\n.p-right-80 {\n\tpadding-right: 80px\n}\n\n.p-right-85 {\n\tpadding-right: 85px\n}\n\n.p-right-90 {\n\tpadding-right: 90px\n}\n\n.p-right-95 {\n\tpadding-right: 95px\n}\n\n.p-right-100 {\n\tpadding-right: 100px\n}\n\n.p-right-105 {\n\tpadding-right: 105px\n}\n\n.p-right-110 {\n\tpadding-right: 110px\n}\n\n.p-right-115 {\n\tpadding-right: 115px\n}\n\n.p-right-120 {\n\tpadding-right: 120px\n}\n\n.p-right-125 {\n\tpadding-right: 125px\n}\n\n.p-right-130 {\n\tpadding-right: 130px\n}\n\n.p-right-135 {\n\tpadding-right: 135px\n}\n\n.p-right-140 {\n\tpadding-right: 140px\n}\n\n.p-right-145 {\n\tpadding-right: 145px\n}\n\n.p-right-150 {\n\tpadding-right: 150px\n}\n\n.p-top-0 {\n\tpadding-top: 0\n}\n\n.p-top-5 {\n\tpadding-top: 5px\n}\n\n.p-top-10 {\n\tpadding-top: 10px\n}\n\n.p-top-15 {\n\tpadding-top: 15px\n}\n\n.p-top-20 {\n\tpadding-top: 20px\n}\n\n.p-top-25 {\n\tpadding-top: 25px\n}\n\n.p-top-30 {\n\tpadding-top: 30px\n}\n\n.p-top-35 {\n\tpadding-top: 35px\n}\n\n.p-top-40 {\n\tpadding-top: 40px\n}\n\n.p-top-45 {\n\tpadding-top: 45px\n}\n\n.p-top-50 {\n\tpadding-top: 50px\n}\n\n.p-top-55 {\n\tpadding-top: 55px\n}\n\n.p-top-60 {\n\tpadding-top: 60px\n}\n\n.p-top-65 {\n\tpadding-top: 65px\n}\n\n.p-top-70 {\n\tpadding-top: 70px\n}\n\n.p-top-75 {\n\tpadding-top: 75px\n}\n\n.p-top-80 {\n\tpadding-top: 80px\n}\n\n.p-top-85 {\n\tpadding-top: 85px\n}\n\n.p-top-90 {\n\tpadding-top: 90px\n}\n\n.p-top-95 {\n\tpadding-top: 95px\n}\n\n.p-top-100 {\n\tpadding-top: 100px\n}\n\n.p-top-105 {\n\tpadding-top: 105px\n}\n\n.p-top-110 {\n\tpadding-top: 110px\n}\n\n.p-top-115 {\n\tpadding-top: 115px\n}\n\n.p-top-120 {\n\tpadding-top: 120px\n}\n\n.p-top-125 {\n\tpadding-top: 125px\n}\n\n.p-top-130 {\n\tpadding-top: 130px\n}\n\n.p-top-135 {\n\tpadding-top: 135px\n}\n\n.p-top-140 {\n\tpadding-top: 140px\n}\n\n.p-top-145 {\n\tpadding-top: 145px\n}\n\n.p-top-150 {\n\tpadding-top: 150px\n}\n\n.p-bottom-0 {\n\tpadding-bottom: 0\n}\n\n.p-bottom-5 {\n\tpadding-bottom: 5px\n}\n\n.p-bottom-10 {\n\tpadding-bottom: 10px\n}\n\n.p-bottom-15 {\n\tpadding-bottom: 15px\n}\n\n.p-bottom-20 {\n\tpadding-bottom: 20px\n}\n\n.p-bottom-25 {\n\tpadding-bottom: 25px\n}\n\n.p-bottom-30 {\n\tpadding-bottom: 30px\n}\n\n.p-bottom-35 {\n\tpadding-bottom: 35px\n}\n\n.p-bottom-40 {\n\tpadding-bottom: 40px\n}\n\n.p-bottom-45 {\n\tpadding-bottom: 45px\n}\n\n.p-bottom-50 {\n\tpadding-bottom: 50px\n}\n\n.p-bottom-55 {\n\tpadding-bottom: 55px\n}\n\n.p-bottom-60 {\n\tpadding-bottom: 60px\n}\n\n.p-bottom-65 {\n\tpadding-bottom: 65px\n}\n\n.p-bottom-70 {\n\tpadding-bottom: 70px\n}\n\n.p-bottom-75 {\n\tpadding-bottom: 75px\n}\n\n.p-bottom-80 {\n\tpadding-bottom: 80px\n}\n\n.p-bottom-85 {\n\tpadding-bottom: 85px\n}\n\n.p-bottom-90 {\n\tpadding-bottom: 90px\n}\n\n.p-bottom-95 {\n\tpadding-bottom: 95px\n}\n\n.p-bottom-100 {\n\tpadding-bottom: 100px\n}\n\n.p-bottom-105 {\n\tpadding-bottom: 105px\n}\n\n.p-bottom-110 {\n\tpadding-bottom: 110px\n}\n\n.p-bottom-115 {\n\tpadding-bottom: 115px\n}\n\n.p-bottom-120 {\n\tpadding-bottom: 120px\n}\n\n.p-bottom-125 {\n\tpadding-bottom: 125px\n}\n\n.p-bottom-130 {\n\tpadding-bottom: 130px\n}\n\n.p-bottom-135 {\n\tpadding-bottom: 135px\n}\n\n.p-bottom-140 {\n\tpadding-bottom: 140px\n}\n\n.p-bottom-145 {\n\tpadding-bottom: 145px\n}\n\n.p-bottom-150 {\n\tpadding-bottom: 150px\n}\n\n.h-5 {\n\theight: 5px\n}\n\n.h-10 {\n\theight: 10px\n}\n\n.h-15 {\n\theight: 15px\n}\n\n.h-20 {\n\theight: 20px\n}\n\n.h-25 {\n\theight: 25px\n}\n\n.h-30 {\n\theight: 30px\n}\n\n.h-35 {\n\theight: 35px\n}\n\n.h-40 {\n\theight: 40px\n}\n\n.h-45 {\n\theight: 45px\n}\n\n.h-50 {\n\theight: 50px\n}\n\n.h-55 {\n\theight: 55px\n}\n\n.h-60 {\n\theight: 60px\n}\n\n.h-65 {\n\theight: 65px\n}\n\n.h-70 {\n\theight: 70px\n}\n\n.h-75 {\n\theight: 75px\n}\n\n.h-80 {\n\theight: 80px\n}\n\n.h-85 {\n\theight: 85px\n}\n\n.h-90 {\n\theight: 90px\n}\n\n.h-95 {\n\theight: 95px\n}\n\n.h-100 {\n\theight: 100px\n}\n\n.h-105 {\n\theight: 105px\n}\n\n.h-110 {\n\theight: 110px\n}\n\n.h-115 {\n\theight: 115px\n}\n\n.h-120 {\n\theight: 120px\n}\n\n.h-125 {\n\theight: 125px\n}\n\n.h-130 {\n\theight: 130px\n}\n\n.h-135 {\n\theight: 135px\n}\n\n.h-140 {\n\theight: 140px\n}\n\n.h-145 {\n\theight: 145px\n}\n\n.h-150 {\n\theight: 150px\n}\n\n.cart-table .cart-single .remove a,\n.color-primary,\n.counter.counter--4 .counter_single .value,\n.error-wrapper .error-contents p a:hover,\n.nav_right_content .cart_module .cart__items .cart_info p span,\n.nav_right_content .cart_module .cart__items .items .item_info>a:hover,\n.nav_right_content .cart_module .cart__items .items .item_remove span,\n.post--card .card-body .post-meta li a:hover,\n.pricing .pricing__title h4,\n.tab-content.tab--content2 .tab-pane .tab_text_module .tab_text_module__subtitle,\n.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link.active,\n.team-five .content h6 a:hover,\n.timeline1 .happening .happening__period .wrapper .year,\nfooter.footer--light .widget ul.links li a:hover,\nfooter.footer4 .footer__small .info_links li a:hover,\nfooter.footer4.footer--light .footer__small .info_links li a:hover,\nfooter.footer4.footer--light .footer_menu_items ul li a:hover {\n\tcolor: #413aa4\n}\n\n.bg-primary,\n.dot-light .owl-dot.active span,\n.filter-wrapper .filter-sort ul li.active,\n.filter-wrapper .filter-sort ul li:hover,\n.flip-card .flip-overlay2,\n.go_top,\n.intro-three:before,\n.intro-two,\n.nav-circle button:hover,\n.nav-circle.nav-circle--light button:hover,\n.nav-circle.nav-circle--lighten button:hover,\n.nav-pills .nav-item .nav-link.active,\n.nav-pills .nav-item .nav-link:hover,\n.nav-square button:hover,\n.nav-square.nav-square-dark button:hover,\n.nav_right_content .cart_module .cart__items .items .item_remove:hover span,\n.owl-dots .owl-dot.active span,\n.play-btn:hover,\n.portfolio-carousel-single figure figcaption .link:hover,\nfooter.footer4 .social.square ul li a:hover,\nfooter.footer4.footer--colored {\n\tbackground: #413aa4\n}\n\n.blog-carousel-one .post-single .post-bottom a:hover,\n.card .card-body h6 a:hover,\n.card-four .card-body h5:hover a,\n.card-product .card-body h6 a:hover,\n.color-secondary,\n.content--block4 h3 span,\n.content-block--12 .highlighted-text .content p span,\n.counter.counter--5 .counter_single .value,\n.counter.counter--7 .counter_single .value,\n.cta--five p span,\n.error-wrapper .error-contents p a,\n.icon-list2 .icon,\n.intro-five h1 span,\n.intro-four .intro-four--contents h1 span,\n.intro-one h1 span,\n.intro-three .intro-three--contents h1 span,\n.list-inline-wrapper .list--inline li .icon span,\n.nav-tabs .nav-item .nav-link.active,\n.number-list li.numbers-roman:before,\n.number-list li:before,\n.post--card .card-body .post-meta li a,\n.project-single .project-info .info-box h6,\n.subtext,\n.tab.tab--1 .tab_nav .nav .nav-link.active,\n.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link.active,\n.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link:hover,\n.tab.tab--3 .tab_nav3 .nav li a.active,\n.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link.active,\n.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link:hover,\n.tab.tab--7 .tab_nav7 .nav .nav-item .nav-link.active,\n.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link.active,\n.tab_event .tab_event__module .event_meta p span.la,\n.team-five .content h6 a,\n.timeline1 .happening .happening__period .wrapper .date,\n.timeline2 .happening2 .happening2__period,\n.video--one h3 span,\nfooter .footer__big .widget--latest-news ul li a:hover,\nfooter.footer--dark .footer__big .text_widget a,\nfooter.footer2 .widget.twit--widget a,\nfooter.footer2 .widget.twit--widget span.fab,\nfooter.footer4.footer--light .footer_menu_items ul li a {\n\tcolor: #06b590\n}\n\n.bg-secondary,\n.bullet_list:before,\n.card--team1 .card-body .team-social li a:hover,\n.custom-radio-three .custom-control-input:checked~.custom-control-label::after,\n.custom-radio-two .custom-control-input:checked~.custom-control-label::after,\n.dot-secondary.dot-light .owl-dot.active span,\n.event-single .event-date,\n.go_top:hover,\n.icon-light .content-list .icon-circle span,\n.nav-circle button,\n.nav-square.nav-square-dark button,\n.nav_right_content .cart_module .cart_count,\n.owl-dots.dot-secondary .owl-dot.active span,\n.portfolio-carousel-single figure figcaption .link,\n.pricing .pricing__price,\n.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link.active:before,\n.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link:hover:before,\n.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link.active:before,\n.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link:hover:before,\n.tab.tab--7 .tab_nav7 .nav .nav-item .nav-link.active:before,\n.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link.active:before,\n.toggle-switch input:checked+.slider,\nfooter.footer4.footer--colored .footer--small,\nfooter.footer4.footer--light .footer__small .social.square li a:hover {\n\tbackground: #06b590\n}\n\n.color-success {\n\tcolor: #35b53e\n}\n\n.bg-success {\n\tbackground: #35b53e\n}\n\n.apply-form .apply-form--header p span,\n.blog-single-wrapper .post-pagination .next-post p a,\n.blog-single-wrapper .post-pagination .prev-post p a,\n.color-info,\n.sidebar-post .post-single P span a {\n\tcolor: #377dff\n}\n\n.bg-info {\n\tbackground: #377dff\n}\n\n.color-warning,\n.twitter-feeds .feed-single .feed-content .tags {\n\tcolor: #ffaf00\n}\n\n.bg-warning {\n\tbackground: #ffaf00\n}\n\n.color-danger {\n\tcolor: #e23636\n}\n\n.bg-danger {\n\tbackground: #e23636\n}\n\n.color-light,\n.nav_right_content .cart_module .cart__items .items .item_remove:hover span,\nfooter .footer__big .widget--contact_info ul li span.la,\nfooter.footer--dark .footer__big .text_widget a:hover,\nfooter.footer2.footer--dark .widget.twit--widget a:hover {\n\tcolor: #fff\n}\n\n.bg-light,\n.event-single {\n\tbackground: #fff\n}\n\n.blog-carousel-one .post-single .post-bottom a,\n.card .card-body h6 a,\n.card--eight .card-body h5 a,\n.card--ten .card-body h6 a,\n.color-dark,\n.counter.counter--5 .counter_single .title,\n.tab.tab--1 .tab_nav .nav .nav-link,\nfooter.footer2 .widget.twit--widget a:hover {\n\tcolor: #202428\n}\n\n.bg-dark,\nfooter.footer2 .footer__small {\n\tbackground: #202428\n}\n\n.color-footer-dark-text,\nfooter.footer--dark,\nfooter.footer--dark .footer__big .text_widget p,\nfooter.footer--dark .footer__big .widget ul.links li a,\nfooter.footer4 .footer4_text,\nfooter.footer4 .footer__small .info_links li a,\nfooter.footer4.footer--colored,\nfooter.footer5.footer--bw,\nfooter.footer5.footer--bw .footer__big .widget ul.links a {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\n.bg-footer-dark-text,\nfooter.footer5.footer--bw .footer__big .widget .widget__title:before {\n\tbackground: rgba(255, 255, 255, .5)\n}\n\n.color-footer-dark {\n\tcolor: #111014\n}\n\n.bg-footer-dark,\nfooter.footer--dark {\n\tbackground: #111014\n}\n\n.btn-primary {\n\t-webkit-box-shadow: 0 10px 20px rgba(65, 58, 164, .2);\n\tbox-shadow: 0 10px 20px rgba(65, 58, 164, .2)\n}\n\n.btn-secondary {\n\t-webkit-box-shadow: 0 10px 20px rgba(6, 181, 144, .2);\n\tbox-shadow: 0 10px 20px rgba(6, 181, 144, .2)\n}\n\n.btn-success {\n\t-webkit-box-shadow: 0 10px 20px rgba(53, 181, 62, .2);\n\tbox-shadow: 0 10px 20px rgba(53, 181, 62, .2)\n}\n\n.btn-info {\n\t-webkit-box-shadow: 0 10px 20px rgba(55, 125, 255, .2);\n\tbox-shadow: 0 10px 20px rgba(55, 125, 255, .2)\n}\n\n.btn-warning {\n\t-webkit-box-shadow: 0 10px 20px rgba(255, 175, 0, .2);\n\tbox-shadow: 0 10px 20px rgba(255, 175, 0, .2)\n}\n\n.btn-danger {\n\t-webkit-box-shadow: 0 10px 20px rgba(226, 54, 54, .2);\n\tbox-shadow: 0 10px 20px rgba(226, 54, 54, .2)\n}\n\n.btn-light {\n\t-webkit-box-shadow: 0 10px 20px rgba(255, 255, 255, .2);\n\tbox-shadow: 0 10px 20px rgba(255, 255, 255, .2)\n}\n\n.btn-dark {\n\t-webkit-box-shadow: 0 10px 20px rgba(32, 36, 40, .2);\n\tbox-shadow: 0 10px 20px rgba(32, 36, 40, .2)\n}\n\n.outline-thick-primary {\n\tborder: 2px solid rgba(65, 58, 164, .2);\n\tbackground: 0 0;\n\tcolor: #413aa4\n}\n\n.outline-thick-secondary {\n\tborder: 2px solid rgba(6, 181, 144, .2);\n\tbackground: 0 0;\n\tcolor: #06b590\n}\n\n.outline-thick-success {\n\tborder: 2px solid rgba(53, 181, 62, .2);\n\tbackground: 0 0;\n\tcolor: #35b53e\n}\n\n.outline-thick-info {\n\tborder: 2px solid rgba(55, 125, 255, .2);\n\tbackground: 0 0;\n\tcolor: #377dff\n}\n\n.outline-thick-warning {\n\tborder: 2px solid rgba(255, 175, 0, .2);\n\tbackground: 0 0;\n\tcolor: #ffaf00\n}\n\n.outline-thick-danger {\n\tborder: 2px solid rgba(226, 54, 54, .2);\n\tbackground: 0 0;\n\tcolor: #e23636\n}\n\n.outline-thick-light {\n\tborder: 2px solid rgba(255, 255, 255, .2);\n\tbackground: 0 0;\n\tcolor: #fff\n}\n\n.outline-thick-dark {\n\tborder: 2px solid rgba(32, 36, 40, .2);\n\tbackground: 0 0;\n\tcolor: #202428\n}\n\n.checkbox-primary .custom-control-label::before {\n\tbackground: #413aa4\n}\n\n.checkbox-primary .custom-control-input:checked~.custom-control-label::before {\n\tbackground: #413aa4;\n\tborder: 1px solid #413aa4\n}\n\n.checkbox-primary .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #fff\n}\n\n.checkbox-secondary .custom-control-label::before {\n\tbackground: #06b590\n}\n\n.checkbox-secondary .custom-control-input:checked~.custom-control-label::before {\n\tbackground: #06b590;\n\tborder: 1px solid #06b590\n}\n\n.checkbox-secondary .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #fff\n}\n\n.checkbox-success .custom-control-label::before {\n\tbackground: #35b53e\n}\n\n.checkbox-success .custom-control-input:checked~.custom-control-label::before {\n\tbackground: #35b53e;\n\tborder: 1px solid #35b53e\n}\n\n.checkbox-success .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #fff\n}\n\n.checkbox-info .custom-control-label::before {\n\tbackground: #377dff\n}\n\n.checkbox-info .custom-control-input:checked~.custom-control-label::before {\n\tbackground: #377dff;\n\tborder: 1px solid #377dff\n}\n\n.checkbox-info .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #fff\n}\n\n.checkbox-warning .custom-control-label::before {\n\tbackground: #ffaf00\n}\n\n.checkbox-warning .custom-control-input:checked~.custom-control-label::before {\n\tbackground: #ffaf00;\n\tborder: 1px solid #ffaf00\n}\n\n.checkbox-warning .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #fff\n}\n\n.checkbox-danger .custom-control-label::before {\n\tbackground: #e23636\n}\n\n.checkbox-danger .custom-control-input:checked~.custom-control-label::before {\n\tbackground: #e23636;\n\tborder: 1px solid #e23636\n}\n\n.checkbox-danger .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #fff\n}\n\n.checkbox-light .custom-control-label::before {\n\tbackground: #fff\n}\n\n.checkbox-light .custom-control-input:checked~.custom-control-label::before {\n\tbackground: #fff;\n\tborder: 1px solid #fff\n}\n\n.checkbox-light .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #fff\n}\n\n.checkbox-dark .custom-control-label::before {\n\tbackground: #202428\n}\n\n.checkbox-dark .custom-control-input:checked~.custom-control-label::before {\n\tbackground: #202428;\n\tborder: 1px solid #202428\n}\n\n.checkbox-dark .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #fff\n}\n\n.checkbox-outline-primary .custom-control-label:before {\n\tborder: 1px solid #413aa4\n}\n\n.checkbox-outline-primary .custom-control-input:checked~.custom-control-label::before {\n\tborder: 1px solid #413aa4\n}\n\n.checkbox-outline-primary .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #413aa4\n}\n\n.checkbox-outline-secondary .custom-control-label:before {\n\tborder: 1px solid #06b590\n}\n\n.checkbox-outline-secondary .custom-control-input:checked~.custom-control-label::before {\n\tborder: 1px solid #06b590\n}\n\n.checkbox-outline-secondary .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #06b590\n}\n\n.checkbox-outline-success .custom-control-label:before {\n\tborder: 1px solid #35b53e\n}\n\n.checkbox-outline-success .custom-control-input:checked~.custom-control-label::before {\n\tborder: 1px solid #35b53e\n}\n\n.checkbox-outline-success .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #35b53e\n}\n\n.checkbox-outline-info .custom-control-label:before {\n\tborder: 1px solid #377dff\n}\n\n.checkbox-outline-info .custom-control-input:checked~.custom-control-label::before {\n\tborder: 1px solid #377dff\n}\n\n.checkbox-outline-info .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #377dff\n}\n\n.checkbox-outline-warning .custom-control-label:before {\n\tborder: 1px solid #ffaf00\n}\n\n.checkbox-outline-warning .custom-control-input:checked~.custom-control-label::before {\n\tborder: 1px solid #ffaf00\n}\n\n.checkbox-outline-warning .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #ffaf00\n}\n\n.checkbox-outline-danger .custom-control-label:before {\n\tborder: 1px solid #e23636\n}\n\n.checkbox-outline-danger .custom-control-input:checked~.custom-control-label::before {\n\tborder: 1px solid #e23636\n}\n\n.checkbox-outline-danger .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #e23636\n}\n\n.checkbox-outline-light .custom-control-label:before {\n\tborder: 1px solid #fff\n}\n\n.checkbox-outline-light .custom-control-input:checked~.custom-control-label::before {\n\tborder: 1px solid #fff\n}\n\n.checkbox-outline-light .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #fff\n}\n\n.checkbox-outline-dark .custom-control-label:before {\n\tborder: 1px solid #202428\n}\n\n.checkbox-outline-dark .custom-control-input:checked~.custom-control-label::before {\n\tborder: 1px solid #202428\n}\n\n.checkbox-outline-dark .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #202428\n}\n\n.biz_overlay {\n\tposition: relative;\n\theight: 100%;\n\twidth: 100%\n}\n\n.biz_overlay:before {\n\tposition: absolute;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\tcontent: '';\n\tz-index: 1;\n\tbackground: rgba(0, 0, 0, .3)\n}\n\n.biz_overlay.overlay--primary:before {\n\tbackground-color: rgba(65, 58, 164, .85)\n}\n\n.biz_overlay.overlay--secondary:before {\n\tbackground-color: rgba(6, 181, 144, .8)\n}\n\n.biz_overlay.overlay--secondary2:before {\n\tbackground: rgba(27, 28, 57, .8)\n}\n\n.biz_overlay.overlay--dark:before {\n\tbackground-color: rgba(32, 36, 40, .6)\n}\n\n.biz_overlay.overlay--dark2:before {\n\tbackground: rgba(29, 30, 51, .7)\n}\n\n.gradient-overlay {\n\tposition: relative\n}\n\n.gradient-overlay:before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tbackground: -webkit-linear-gradient(310deg, rgba(65, 58, 164, .9) 0, rgba(65, 58, 164, .9) 25%, rgba(6, 181, 144, .9) 100%);\n\tbackground: -o-linear-gradient(310deg, rgba(65, 58, 164, .9) 0, rgba(65, 58, 164, .9) 25%, rgba(6, 181, 144, .9) 100%);\n\tbackground: linear-gradient(140deg, rgba(65, 58, 164, .9) 0, rgba(65, 58, 164, .9) 25%, rgba(6, 181, 144, .9) 100%);\n\tz-index: 1\n}\n\nhtml {\n\tfont-size: 15px\n}\n\nbody {\n\tdirection: ltr;\n\ttext-align: left\n}\n\n.la.la-search {\n\t-webkit-transform: rotateY(-180deg);\n\t-ms-transform: rotateY(-180deg);\n\ttransform: rotateY(-180deg)\n}\n\nimg {\n\tmax-width: 100%\n}\n\na {\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\na:hover {\n\tcolor: #06b590\n}\n\nsup {\n\ttop: -.66667rem\n}\n\n.showcase {\n\tmargin: 4.66667rem 0 4rem 0;\n\tborder-bottom: 1px solid #e4e8ed;\n\tfont-size: 1.6rem;\n\tline-height: 48px;\n\tpadding: 2rem 0;\n\t-webkit-border-radius: 0;\n\tborder-radius: 0\n}\n\n.showcase h3 {\n\tcolor: #202428;\n\tfont-weight: 400;\n\tmargin: 0;\n\tfont-size: 1.46667rem;\n\ttext-align: center\n}\n\n.showcase.showcase--title2 {\n\tbackground: #fff\n}\n\np {\n\tline-height: 2rem\n}\n\n.sectionbg {\n\tbackground: #f5f7fc\n}\n\n.bgimage {\n\tposition: relative\n}\n\n.bg_image_holder {\n\tposition: absolute;\n\theight: 100%;\n\twidth: 100%;\n\ttop: 0;\n\tleft: 0;\n\t-webkit-background-size: cover !important;\n\tbackground-size: cover !important;\n\tbackground-position: 50% 50% !important;\n\tbackground-repeat: no-repeat !important;\n\tz-index: 0;\n\t-o-transition: opacity .3s linear;\n\ttransition: opacity .3s linear;\n\t-webkit-transition: opacity .3s linear;\n\topacity: 0;\n\toverflow: hidden\n}\n\n.bg_image_holder img {\n\tdisplay: none\n}\n\n.content_above {\n\tz-index: 2;\n\tposition: relative\n}\n\nul {\n\tlist-style: none;\n\tpadding: 0\n}\n\n.flex-1 {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.cardify {\n\tbackground: #fff;\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .05);\n\tpadding: 2rem\n}\n\n.text-box {\n\tpadding: 3rem 3.33333rem\n}\n\n.text-box p {\n\tmargin: 0;\n\tline-height: 2.4rem;\n\tfont-size: 1.46667rem;\n\tfont-weight: 500;\n\tcolor: #fff\n}\n\n.accordion-styles2 {\n\tbackground: #f4f4f4;\n\tpadding: 0 0 5.33333rem 0;\n\tmargin-top: 5.33333rem\n}\n\n.alert-types {\n\tmargin: 6.66667rem 0 3.33333rem 0\n}\n\n.shadow-types {\n\tpadding: 4.66667rem 0 1.33333rem\n}\n\n.shadow-types .showcase-box {\n\tbackground: 0 0\n}\n\n.shadow-types .showcase-box .showcase-header {\n\tbackground: 0 0\n}\n\n.shadow-types .showcase-box .showcase-body ul {\n\tpadding: 2.33333rem 2rem;\n\tbackground: #fff;\n\tmargin: 0\n}\n\n.shadow-types .showcase-box .showcase-body ul li {\n\tmargin-bottom: .8rem;\n\tvisibility: hidden\n}\n\n.shadow-types .showcase-box .showcase-body ul li:last-child {\n\tmargin-bottom: 0\n}\n\n.shadow-types .showcase-box .showcase-body ul li span {\n\tmin-width: 10rem;\n\tdisplay: inline-block\n}\n\n.shadow-types.shadow-types2 {\n\tmargin-top: 3.33333rem;\n\tbackground: #f4f4f4\n}\n\n.showcase-box {\n\tposition: relative;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tmin-width: 0;\n\tword-wrap: break-word;\n\tbackground-color: #fff;\n\t-webkit-background-clip: border-box;\n\tbackground-clip: border-box;\n\tborder: 1px solid #e4e8ed;\n\t-webkit-border-radius: .25rem;\n\tborder-radius: .25rem;\n\tmargin-bottom: 50px\n}\n\n.showcase-box .showcase-header {\n\tpadding: 2rem 3rem;\n\tmargin-bottom: 0;\n\tbackground-color: #fff;\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.showcase-box .showcase-header h4,\n.showcase-box .showcase-header h5 {\n\tmargin: 0;\n\tfont-size: 1.33333rem;\n\tfont-weight: 400;\n\tcolor: #202428\n}\n\n.showcase-box .showcase-header p {\n\tmargin: 10px 0 0 0\n}\n\n.showcase-box .showcase-body {\n\tpadding: 3rem;\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1 1 auto;\n\t-ms-flex: 1 1 auto;\n\tflex: 1 1 auto\n}\n\n.showcase-box:last-child .button-group {\n\tmargin-bottom: 0\n}\n\n.buttons-wrapper {\n\tpadding: 70px 0 20px\n}\n\n.buttons-wrapper .button-group {\n\tmargin-bottom: -21px\n}\n\n.buttons-wrapper .button-group button {\n\tmargin: 0 17px 21px 0\n}\n\n.shadow-default {\n\t-webkit-box-shadow: 0 5px 15px rgba(32, 36, 40, .1) !important;\n\tbox-shadow: 0 5px 15px rgba(32, 36, 40, .1) !important\n}\n\n.btn-shadow {\n\t-webkit-box-shadow: 0 10px 20px rgba(41, 41, 59, .15) !important;\n\tbox-shadow: 0 10px 20px rgba(41, 41, 59, .15) !important\n}\n\n.color-group {\n\tmargin: 0 0 40px;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex\n}\n\n.color-group li {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.color-group li:first-child span {\n\tdisplay: block;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tcolor: #fff;\n\t-webkit-border-radius: 3px;\n\tborder-radius: 3px;\n\tpadding: 25px 30px\n}\n\n.color-group li:last-child {\n\twidth: 80px;\n\tmargin-left: 55px\n}\n\n.color-group li:last-child span {\n\tdisplay: block;\n\tmargin: 10px 0\n}\n\n.color-group.other-colors li:first-child span {\n\tcolor: #202428\n}\n\n.color-group .bg-light-gray {\n\tbackground: #9192a3\n}\n\n.color-group .bg-light-default {\n\tbackground: #5a6671\n}\n\n.color-group .bg-line {\n\tbackground: #e4e8ed\n}\n\n.color-group .bg-default {\n\tbackground: #f5f7fc\n}\n\n.color-group .color-default {\n\tcolor: #5a6671\n}\n\n.color-group .color-light-gray {\n\tcolor: #9192a3\n}\n\n.bg-gradient {\n\tbackground: -webkit-gradient(linear, left top, right top, from(#413aa4), to(#06b590)) !important;\n\tbackground: -webkit-linear-gradient(left, #413aa4, #06b590) !important;\n\tbackground: -o-linear-gradient(left, #413aa4, #06b590) !important;\n\tbackground: linear-gradient(to right, #413aa4, #06b590) !important\n}\n\n.bg-gradient-corner {\n\tbackground: -webkit-linear-gradient(45deg, #413aa4, #06b590);\n\tbackground: -o-linear-gradient(45deg, #413aa4, #06b590);\n\tbackground: linear-gradient(45deg, #413aa4, #06b590)\n}\n\n.color-light-gray {\n\tcolor: #9192a3\n}\n\n.flip-boxes {\n\tbackground: #f5f4f7\n}\n\n.section-bg {\n\tbackground: #f5f7fc\n}\n\niframe {\n\twidth: 100%\n}\n\n.section-padding {\n\tpadding: 7.33333rem 0\n}\n\n.section-padding2 {\n\tpadding: 7.33333rem 0 5.33333rem\n}\n\n.section-padding3 {\n\tpadding: 6.66667rem 0 1.33333rem 0\n}\n\n.section-padding4 {\n\tpadding: 7.33333rem 0 6.33333rem 0\n}\n\n.section-padding5 {\n\tpadding: 7.33333rem 0 3.33333rem 0\n}\n\n.section-padding-top {\n\tpadding: 7.33333rem 0 0 0\n}\n\n.section-padding-sm {\n\tpadding: 6rem 0\n}\n\n.section-split {\n\tposition: relative\n}\n\n.section-split:before {\n\tposition: absolute;\n\tcontent: \"\";\n\twidth: 50%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tbackground: #f5f7fc\n}\n\n.section-split2 {\n\tposition: relative\n}\n\n.section-split2:before {\n\tposition: absolute;\n\tcontent: \"\";\n\twidth: 1px;\n\theight: 100%;\n\tleft: 50%;\n\ttop: 0;\n\t-webkit-transform: translateX(-50%);\n\t-ms-transform: translateX(-50%);\n\ttransform: translateX(-50%);\n\tbackground: #e2e1ea\n}\n\n.bg-half-gray,\n.bg-half-secondary {\n\tposition: relative\n}\n\n.bg-half-gray:before,\n.bg-half-secondary:before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 100%;\n\theight: 50%;\n\tleft: 0;\n\ttop: 0\n}\n\n.bg-half-secondary:before {\n\tbackground: #413aa4\n}\n\n.bg-half-gray:before {\n\tbackground: #f5f7fc;\n\ttop: auto;\n\tbottom: 0;\n\theight: 48%\n}\n\n.list-types ul {\n\tmargin-bottom: 2rem\n}\n\n.card--team1 .card-body .team-social li a.list-types:hover,\n.custom-radio-three .custom-control-input:checked~.list-types.custom-control-label::after,\n.custom-radio-two .custom-control-input:checked~.list-types.custom-control-label::after,\n.dot-secondary.dot-light .owl-dot.active span.list-types,\n.event-single .list-types.event-date,\n.icon-light .content-list .icon-circle span.list-types,\n.list-types.bg-dark,\n.list-types.bg-secondary,\n.list-types.bullet_list:before,\n.list-types.go_top:hover,\n.nav-circle button.list-types,\n.nav-square.nav-square-dark button.list-types,\n.nav_right_content .cart_module .list-types.cart_count,\n.owl-dots.dot-secondary .owl-dot.active span.list-types,\n.portfolio-carousel-single figure figcaption .list-types.link,\n.pricing .list-types.pricing__price,\n.tab.tab--2 .tab_nav2 .nav .nav-item .list-types.nav-link.active:before,\n.tab.tab--2 .tab_nav2 .nav .nav-item .list-types.nav-link:hover:before,\n.tab.tab--6 .tab_nav2 .nav .nav-item .list-types.nav-link.active:before,\n.tab.tab--6 .tab_nav2 .nav .nav-item .list-types.nav-link:hover:before,\n.tab.tab--7 .tab_nav7 .nav .nav-item .list-types.nav-link.active:before,\n.tab.tab--8 .tab_nav7 .nav .nav-item .list-types.nav-link.active:before,\n.toggle-switch input:checked+.list-types.slider,\nfooter.footer2 .list-types.footer__small,\nfooter.footer4.footer--colored .list-types.footer--small,\nfooter.footer4.footer--light .footer__small .social.square li a.list-types:hover {\n\tpadding: 4.66667rem 0 2.33333rem\n}\n\n.card--team1 .card-body .team-social li a.list-types:hover ol,\n.card--team1 .card-body .team-social li a.list-types:hover ul,\n.custom-radio-three .custom-control-input:checked~.list-types.custom-control-label::after ol,\n.custom-radio-three .custom-control-input:checked~.list-types.custom-control-label::after ul,\n.custom-radio-two .custom-control-input:checked~.list-types.custom-control-label::after ol,\n.custom-radio-two .custom-control-input:checked~.list-types.custom-control-label::after ul,\n.dot-secondary.dot-light .owl-dot.active span.list-types ol,\n.dot-secondary.dot-light .owl-dot.active span.list-types ul,\n.event-single .list-types.event-date ol,\n.event-single .list-types.event-date ul,\n.icon-light .content-list .icon-circle span.list-types ol,\n.icon-light .content-list .icon-circle span.list-types ul,\n.list-types.bg-dark ol,\n.list-types.bg-dark ul,\n.list-types.bg-secondary ol,\n.list-types.bg-secondary ul,\n.list-types.bullet_list:before ol,\n.list-types.bullet_list:before ul,\n.list-types.go_top:hover ol,\n.list-types.go_top:hover ul,\n.nav-circle button.list-types ol,\n.nav-circle button.list-types ul,\n.nav-square.nav-square-dark button.list-types ol,\n.nav-square.nav-square-dark button.list-types ul,\n.nav_right_content .cart_module .list-types.cart_count ol,\n.nav_right_content .cart_module .list-types.cart_count ul,\n.owl-dots.dot-secondary .owl-dot.active span.list-types ol,\n.owl-dots.dot-secondary .owl-dot.active span.list-types ul,\n.portfolio-carousel-single figure figcaption .list-types.link ol,\n.portfolio-carousel-single figure figcaption .list-types.link ul,\n.pricing .list-types.pricing__price ol,\n.pricing .list-types.pricing__price ul,\n.tab.tab--2 .tab_nav2 .nav .nav-item .list-types.nav-link.active:before ol,\n.tab.tab--2 .tab_nav2 .nav .nav-item .list-types.nav-link.active:before ul,\n.tab.tab--2 .tab_nav2 .nav .nav-item .list-types.nav-link:hover:before ol,\n.tab.tab--2 .tab_nav2 .nav .nav-item .list-types.nav-link:hover:before ul,\n.tab.tab--6 .tab_nav2 .nav .nav-item .list-types.nav-link.active:before ol,\n.tab.tab--6 .tab_nav2 .nav .nav-item .list-types.nav-link.active:before ul,\n.tab.tab--6 .tab_nav2 .nav .nav-item .list-types.nav-link:hover:before ol,\n.tab.tab--6 .tab_nav2 .nav .nav-item .list-types.nav-link:hover:before ul,\n.tab.tab--7 .tab_nav7 .nav .nav-item .list-types.nav-link.active:before ol,\n.tab.tab--7 .tab_nav7 .nav .nav-item .list-types.nav-link.active:before ul,\n.tab.tab--8 .tab_nav7 .nav .nav-item .list-types.nav-link.active:before ol,\n.tab.tab--8 .tab_nav7 .nav .nav-item .list-types.nav-link.active:before ul,\n.toggle-switch input:checked+.list-types.slider ol,\n.toggle-switch input:checked+.list-types.slider ul,\nfooter.footer2 .list-types.footer__small ol,\nfooter.footer2 .list-types.footer__small ul,\nfooter.footer4.footer--colored .list-types.footer--small ol,\nfooter.footer4.footer--colored .list-types.footer--small ul,\nfooter.footer4.footer--light .footer__small .social.square li a.list-types:hover ol,\nfooter.footer4.footer--light .footer__small .social.square li a.list-types:hover ul {\n\tmargin: 0\n}\n\n.bg-image {\n\tbackground: url(https://snmtechnologies.in/startup/img/list-bg.jpg) center/cover no-repeat;\n\tpadding: 6rem\n}\n\n.bg-image ol,\n.bg-image ul {\n\tmargin: 0\n}\n\n.bg-image.list-types {\n\tpadding: 6rem 0 4rem\n}\n\n.bg-gray-light {\n\tbackground: #f5f7fc\n}\n\n.bg-gradient--light {\n\tbackground: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#fbfaff));\n\tbackground: -webkit-linear-gradient(top, #fff, #fbfaff);\n\tbackground: -o-linear-gradient(top, #fff, #fbfaff);\n\tbackground: linear-gradient(to bottom, #fff, #fbfaff)\n}\n\n.hr-divider {\n\tborder-top: 1px solid #e4e8ed;\n\theight: 1px;\n\tmargin-top: 4rem\n}\n\n.hr-divider2 {\n\tborder-top: 1px solid #e4e8ed;\n\theight: 1px;\n\tmargin: 3.6rem 0 3.53333rem 0\n}\n\n.hr-divider3 {\n\tborder-top: 1px solid #d8d9e4;\n\theight: 1px;\n\tmargin: 2.66667rem 0 5.33333rem 0\n}\n\n.hr-divider-gray {\n\tbackground: rgba(100, 103, 145, .5);\n\twidth: 100%;\n\theight: 1px;\n\tmargin: 5.33333rem 0 4.33333rem\n}\n\n.hr-line {\n\tbackground: #e4e8ed;\n\theight: 1px\n}\n\n.form-elements .form-tabs li {\n\tmargin-left: -1px\n}\n\n.form-elements .form-tabs li:first-child a {\n\t-webkit-border-radius: 3px 0 0 3px;\n\tborder-radius: 3px 0 0 3px\n}\n\n.form-elements .form-tabs li:last-child a {\n\t-webkit-border-radius: 0 3px 3px 0;\n\tborder-radius: 0 3px 3px 0\n}\n\n.form-elements .form-tabs li a {\n\tborder: 1px solid #e4e8ed;\n\tpadding: 13px 15px;\n\tcolor: #5a6671;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tdisplay: block\n}\n\n.form-elements .form-tabs li a.active {\n\tbackground: #413aa4;\n\tcolor: #fff;\n\tborder-color: #413aa4\n}\n\n.form-elements .form-tabs li a:hover {\n\tcolor: #fff;\n\tbackground: #413aa4;\n\tborder-color: #413aa4\n}\n\n.tab--3 .tab-content>.tab-pane {\n\tdisplay: block;\n\theight: 0;\n\tvisibility: hidden\n}\n\n.tab--3 .tab-content>.active {\n\theight: auto;\n\tvisibility: visible\n}\n\n.go_top {\n\tline-height: 2.66667rem;\n\tcursor: pointer;\n\twidth: 2.66667rem;\n\tcolor: #fff;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tposition: fixed;\n\t-webkit-box-shadow: 0 4px 4px rgba(0, 0, 0, .1);\n\tbox-shadow: 0 4px 4px rgba(0, 0, 0, .1);\n\t-webkit-border-radius: 1.66667rem 0 0 1.66667rem;\n\tborder-radius: 1.66667rem 0 0 1.66667rem;\n\tright: 0;\n\tz-index: 111;\n\tbottom: 30px;\n\ttext-align: center\n}\n\n.btn-primary {\n\t-webkit-box-shadow: 0 10px 20px rgba(65, 58, 164, .2);\n\tbox-shadow: 0 10px 20px rgba(65, 58, 164, .2)\n}\n\n.btn-secondary {\n\t-webkit-box-shadow: 0 10px 20px rgba(6, 181, 144, .2);\n\tbox-shadow: 0 10px 20px rgba(6, 181, 144, .2)\n}\n\n.btn-success {\n\t-webkit-box-shadow: 0 10px 20px rgba(53, 181, 62, .2);\n\tbox-shadow: 0 10px 20px rgba(53, 181, 62, .2)\n}\n\n.btn-info {\n\t-webkit-box-shadow: 0 10px 20px rgba(55, 125, 255, .2);\n\tbox-shadow: 0 10px 20px rgba(55, 125, 255, .2)\n}\n\n.btn-warning {\n\t-webkit-box-shadow: 0 10px 20px rgba(255, 175, 0, .2);\n\tbox-shadow: 0 10px 20px rgba(255, 175, 0, .2)\n}\n\n.btn-danger {\n\t-webkit-box-shadow: 0 10px 20px rgba(226, 54, 54, .2);\n\tbox-shadow: 0 10px 20px rgba(226, 54, 54, .2)\n}\n\n.btn-light {\n\t-webkit-box-shadow: 0 10px 20px rgba(255, 255, 255, .2);\n\tbox-shadow: 0 10px 20px rgba(255, 255, 255, .2)\n}\n\n.btn-dark {\n\t-webkit-box-shadow: 0 10px 20px rgba(32, 36, 40, .2);\n\tbox-shadow: 0 10px 20px rgba(32, 36, 40, .2)\n}\n\n.outline-thick-primary {\n\tborder: 2px solid rgba(65, 58, 164, .2);\n\tbackground: 0 0;\n\tcolor: #413aa4\n}\n\n.outline-thick-secondary {\n\tborder: 2px solid rgba(6, 181, 144, .2);\n\tbackground: 0 0;\n\tcolor: #06b590\n}\n\n.outline-thick-success {\n\tborder: 2px solid rgba(53, 181, 62, .2);\n\tbackground: 0 0;\n\tcolor: #35b53e\n}\n\n.outline-thick-info {\n\tborder: 2px solid rgba(55, 125, 255, .2);\n\tbackground: 0 0;\n\tcolor: #377dff\n}\n\n.outline-thick-warning {\n\tborder: 2px solid rgba(255, 175, 0, .2);\n\tbackground: 0 0;\n\tcolor: #ffaf00\n}\n\n.outline-thick-danger {\n\tborder: 2px solid rgba(226, 54, 54, .2);\n\tbackground: 0 0;\n\tcolor: #e23636\n}\n\n.outline-thick-light {\n\tborder: 2px solid rgba(255, 255, 255, .2);\n\tbackground: 0 0;\n\tcolor: #fff\n}\n\n.outline-thick-dark {\n\tborder: 2px solid rgba(32, 36, 40, .2);\n\tbackground: 0 0;\n\tcolor: #202428\n}\n\n.btn {\n\ttext-transform: capitalize;\n\tfont-size: .93333rem;\n\tfont-weight: 500\n}\n\n.btn.btn--rounded {\n\t-webkit-border-radius: 200px;\n\tborder-radius: 200px\n}\n\n.btn.btn-sm {\n\tfont-size: .86rem\n}\n\n.btn.btn-lg {\n\tfont-size: 1rem;\n\twhite-space: normal\n}\n\n.btna {\n\tcolor: #fff\n}\n\n.btn.btn-light {\n\t-webkit-box-shadow: 0 10px 20px rgba(41, 41, 59, .15);\n\tbox-shadow: 0 10px 20px rgba(41, 41, 59, .15)\n}\n\n.btn.btn-outline-light {\n\tborder: 1px solid #e4e8ed;\n\tcolor: #e4e8ed\n}\n\n.btn.btn-outline-light:hover {\n\tcolor: #212529;\n\tbackground: #e4e8ed\n}\n\n.btn.btn-arrow {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -webkit-inline-flex;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center\n}\n\n.btn.btn-arrow i {\n\tmargin-left: .66rem\n}\n\n.btn.btn-icon {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -webkit-inline-flex;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.btn.btn-icon.icon-left i,\n.btn.btn-icon.icon-left span {\n\tmargin-right: 6px\n}\n\n.btn.btn-icon.icon-right i,\n.btn.btn-icon.icon-right span {\n\tmargin-left: 6px\n}\n\n.btn.like-btn {\n\twidth: 2.73333rem;\n\theight: 2.73333rem;\n\tfont-size: 1.2rem;\n\tcolor: #06b590;\n\tborder: 1px solid rgba(255, 255, 255, .3);\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tpadding: 0;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\tbackground: rgba(6, 181, 144, .1)\n}\n\n.btn.like-btn:focus {\n\toutline: 0\n}\n\n.btn.like-btn:hover {\n\tcolor: #fff;\n\tbackground: #06b590\n}\n\n.btn.filter-btn {\n\tfont-size: 1rem;\n\tmin-width: auto;\n\tpadding: 0 1.33333rem;\n\tfont-weight: 400;\n\ttext-transform: capitalize;\n\t-webkit-box-shadow: none;\n\tbox-shadow: none\n}\n\n.btn.filter-btn:focus {\n\toutline: 0;\n\t-webkit-box-shadow: none;\n\tbox-shadow: none\n}\n\n.btn.btn-gradient {\n\tbackground: -webkit-gradient(linear, left top, right top, from(#413aa4), to(#06b590));\n\tbackground: -webkit-linear-gradient(left, #413aa4, #06b590);\n\tbackground: -o-linear-gradient(left, #413aa4, #06b590);\n\tbackground: linear-gradient(to right, #413aa4, #06b590);\n\tcolor: #fff;\n\tborder: none;\n\t-webkit-box-shadow: 0 10px 15px rgba(6, 181, 144, .2);\n\tbox-shadow: 0 10px 15px rgba(6, 181, 144, .2)\n}\n\n.btn.btn-icon-only {\n\tpadding-left: 1rem;\n\tpadding-right: 1rem;\n\tfont-size: 1.2rem\n}\n\n.play-btn-wrapper {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tcolor: #06b590;\n\tfont-weight: 500;\n\tmargin-left: 1rem\n}\n\n.play-btn-wrapper .play-btn {\n\tmargin-right: 1.33333rem\n}\n\n.play-btn {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tcolor: #fff;\n\tfont-size: 2rem;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tposition: relative\n}\n\n.play-btn .svg {\n\twidth: 1.2rem;\n\tfill: #fff;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.play-btn:hover {\n\tcolor: #fff\n}\n\n.play-btn.play-btn--lg {\n\twidth: 4.66667rem;\n\theight: 4.66667rem\n}\n\n.play-btn.play-btn--sm {\n\twidth: 3.33333rem;\n\theight: 3.33333rem;\n\tfont-size: 1.53333rem\n}\n\n.play-btn.play-btn--sm .svg {\n\twidth: 1rem\n}\n\n.play-btn.play-btn-light {\n\tbackground: #fff;\n\tcolor: #202428\n}\n\n.play-btn.play-btn-light:hover {\n\tbackground: #06b590;\n\tcolor: #fff\n}\n\n.play-btn.play-btn-light:hover .svg {\n\tfill: #fff\n}\n\n.play-btn.play-btn-light .svg {\n\tfill: #06b590\n}\n\n.play-btn.play-btn--gesture {\n\tcolor: #06b590;\n\tfont-size: 1.86667rem\n}\n\n.play-btn.play-btn--gesture:before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 130%;\n\theight: 130%;\n\tleft: -15%;\n\ttop: -15%;\n\tbackground: rgba(6, 181, 144, .15);\n\t-webkit-border-radius: 20rem;\n\tborder-radius: 20rem\n}\n\n.play-btn.play-btn--gesture:after {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 160%;\n\theight: 160%;\n\tleft: -30%;\n\ttop: -30%;\n\tbackground: rgba(6, 181, 144, .05);\n\t-webkit-border-radius: 20rem;\n\tborder-radius: 20rem\n}\n\n.play-btn.play-btn--gesture:hover {\n\tbackground: inherit\n}\n\n.play-btn.play-btn--primary {\n\tbackground: #413aa4\n}\n\n.play-btn.play-btn--secondary {\n\tbackground: #06b590\n}\n\n.action-btns ul li {\n\tmargin-right: 5px\n}\n\n.action-btns ul li:last-child {\n\tmargin-right: 0\n}\n\n.action-btns ul li.share-btn {\n\tposition: relative;\n\tpadding-bottom: 1rem\n}\n\n.action-btns ul li.share-btn ul {\n\tposition: absolute;\n\tright: 0;\n\ttop: 4rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\tpadding: 1rem 2rem;\n\tbackground: #fff;\n\t-webkit-border-radius: 3px;\n\tborder-radius: 3px;\n\tvisibility: hidden;\n\topacity: 0;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\t-webkit-box-shadow: 0 0 15px rgba(0, 0, 0, .15);\n\tbox-shadow: 0 0 15px rgba(0, 0, 0, .15)\n}\n\n.action-btns ul li.share-btn ul:before {\n\tposition: absolute;\n\tcontent: '';\n\tborder-bottom: .66667rem solid #fff;\n\tborder-right: .53333rem solid transparent;\n\tborder-left: .53333rem solid transparent;\n\tright: 1.13333rem;\n\tbottom: 100%\n}\n\n.action-btns ul li.share-btn ul li {\n\tmargin-right: 1rem\n}\n\n.action-btns ul li.share-btn ul li:last-child {\n\tmargin-right: 0\n}\n\n.action-btns ul li.share-btn ul li a {\n\tfont-size: 1rem;\n\tcolor: #06b590;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.action-btns ul li.share-btn ul li a:hover {\n\tcolor: #413aa4\n}\n\n.action-btns ul li.share-btn:hover ul {\n\topacity: 1;\n\tvisibility: visible\n}\n\n.input_with_embed {\n\tposition: relative\n}\n\n.input_with_embed .embed_button,\n.input_with_embed .embed_icon {\n\tposition: absolute\n}\n\n.input_with_embed .embed_icon {\n\tright: 1.33rem;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.input_with_embed .embed_icon button {\n\tbackground: 0 0;\n\tborder: 0\n}\n\ninput.input--rounded {\n\t-webkit-border-radius: 13.33333rem;\n\tborder-radius: 13.33333rem\n}\n\n.custom-radio {\n\tmargin-bottom: 1rem;\n\tpadding-left: 10px\n}\n\n.custom-radio:last-child {\n\tmargin-bottom: 0\n}\n\n.custom-radio input:active {\n\tbackground: 0 0\n}\n\n.custom-radio .custom-control-label {\n\tpadding-left: 2rem;\n\tposition: relative;\n\tmin-width: 100px\n}\n\n.custom-radio .custom-control-label:before {\n\twidth: 1.2rem;\n\theight: 1.2rem;\n\tbackground-color: #fff;\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\tborder: .33333rem solid #cbd0e3;\n\ttop: 1px;\n\tleft: 0\n}\n\n.custom-radio .custom-control-label:after {\n\twidth: auto;\n\theight: auto;\n\tbackground-image: none\n}\n\n.custom-radio .custom-control-label span {\n\tposition: relative;\n\ttop: 0rem\n}\np{font-size: 18px!important;}\n.custom-radio .custom-control-input:checked~.custom-control-label::before {\n\tbackground: 0 0;\n\tborder-color: #06b590;\n\tcontent: \"\";\n\tfont-family: LineAwesome;\n\tcolor: #fff;\n\ttext-align: center;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tfont-size: .8rem\n}\n\n.custom-control-input:focus~.custom-control-label::before {\n\t-webkit-box-shadow: none;\n\tbox-shadow: none\n}\n\n.custom-radio-two .custom-control-label:before {\n\tborder: .2rem solid #cbd0e3;\n\twidth: 1.2rem;\n\theight: 1.2rem\n}\n\n.custom-radio-two .custom-control-input:checked~.custom-control-label::after {\n\twidth: .4rem;\n\theight: .4rem;\n\t-webkit-border-radius: 20rem;\n\tborder-radius: 20rem;\n\tleft: .4rem;\n\ttop: .46667rem\n}\n\n.custom-radio-three .custom-control-label:before {\n\tborder: 1px solid #cbd0e3;\n\twidth: 1.2rem;\n\theight: 1.2rem\n}\n\n.custom-radio-three .custom-control-input:checked~.custom-control-label::after {\n\twidth: .4rem;\n\theight: .4rem;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tleft: .4rem;\n\ttop: .46667rem\n}\n\n.form-control {\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\tresize: none;\n\t-webkit-appearance: none;\n\t-moz-appearance: none;\n\tappearance: none\n}\n\n@media all and (-ms-high-contrast:none),\n(-ms-high-contrast:active) {\n\t.form-control {\n\t\tpadding: .5rem 1.2rem 1rem\n\t}\n}\n\n.form-control:focus {\n\toutline: 0;\n\t-webkit-box-shadow: none;\n\tbox-shadow: none\n}\n\n.form-control::-webkit-input-placeholder {\n\tcolor: #9192a3\n}\n\n.form-control::-ms-input-placeholder {\n\tcolor: #9192a3\n}\n\n.form-control::placeholder {\n\tcolor: #9192a3\n}\n\n.form-control.fc--squared {\n\t-webkit-border-radius: 0;\n\tborder-radius: 0\n}\n\n.form-control.fc--rounded {\n\t-webkit-border-radius: 1.66667rem;\n\tborder-radius: 1.66667rem;\n\tpadding-left: 1.66667rem\n}\n\n.form-control.fc--solid-bg {\n\tbackground: #f5f4f7\n}\n\n.form-control.form-outline {\n\tborder: 0 none;\n\tborder-bottom: 1px solid #e4e8ed;\n\t-webkit-border-radius: 0;\n\tborder-radius: 0;\n\tpadding-left: 0\n}\n\n.form-control.form-outline:focus {\n\tborder-bottom-color: #06b590\n}\n\n.form-control--color {\n\tmin-height: 3rem;\n\tpadding: .66667rem;\n\tbackground: 0 0\n}\n\n.form-group {\n\tmargin-bottom: 2rem\n}\n\n.form-group:last-child {\n\tmargin-bottom: 0\n}\n\n.form-group label {\n\tcolor: #202428\n}\n\n.range-input:after {\n\tcontent: '';\n\tdisplay: block;\n\tclear: both\n}\n\n.range-input .custom-range {\n\t-webkit-appearance: none;\n\t-moz-appearance: none;\n\tappearance: none;\n\tbackground: 0 0\n}\n\n.range-input .custom-range::-webkit-slider-thumb {\n\t-webkit-appearance: none;\n\twidth: 1.2rem;\n\theight: 1.2rem;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tborder: .33333rem solid #413aa4;\n\tbackground: #e3e6ef;\n\tmargin-top: -6px\n}\n\n.range-input .custom-range::-webkit-slider-runnable-track {\n\tbackground: #e3e6ef;\n\theight: .4rem;\n\twidth: 100%;\n\tcursor: pointer\n}\n\n.input-group-light .form-control {\n\t-webkit-border-radius: 3px !important;\n\tborder-radius: 3px !important\n}\n\n.input-group-light span {\n\tposition: absolute;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tz-index: 10;\n\tfont-size: 1.2rem\n}\n\n.input-group-light span.icon-left {\n\tleft: 1.33333rem\n}\n\n.input-group-light span.icon-left+.form-control {\n\tpadding-left: 3rem\n}\n\n.input-group-light span.icon-right {\n\tright: 1rem\n}\n\n.input-group-light span.icon-right+.form-control {\n\tpadding-right: 2.66667rem\n}\n\n.checkbox-group .input-group-text {\n\tline-height: normal;\n\tpadding: 0 .8rem\n}\n\n.checkbox-group .input-group-text .custom-control {\n\tpadding-left: 1rem\n}\n\n.checkbox-group .custom-checkbox .custom-control-input:checked~.custom-control-label::after {\n\tpadding-left: 1px;\n\tpadding-top: 2px\n}\n\n.radio-group .input-group-text {\n\tline-height: normal;\n\tpadding: 0 .8rem\n}\n\n.radio-group .input-group-text .custom-control {\n\tpadding-left: .53333rem\n}\n\n.radio-group .custom-control-label {\n\tpadding-left: 0;\n\twidth: 1.46667rem;\n\theight: 1.53333rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-left: -.46667rem\n}\n\n.custom-checkbox {\n\tmargin-bottom: 2.33333rem\n}\n\n.custom-checkbox:last-child {\n\tmargin-bottom: 0\n}\n\n.custom-checkbox .custom-control-label {\n\tmin-width: 6.66667rem;\n\tpadding-left: 2.33333rem;\n\tposition: relative\n}\n\n.custom-checkbox .custom-control-label::before {\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\twidth: 1.46667rem;\n\theight: 1.46667rem;\n\t-webkit-border-radius: 2px;\n\tborder-radius: 2px;\n\ttop: 0;\n\tleft: 0\n}\n\n.custom-checkbox .custom-control-label::after {\n\twidth: 1.4rem;\n\theight: 1.4rem;\n\ttop: 0\n}\n\n.custom-checkbox .custom-control-input:checked~.custom-control-label::after {\n\tbackground-image: none;\n\tcontent: \"\\f17b\";\n\tfont-family: LineAwesome;\n\tleft: 0;\n\tfont-size: .86667rem;\n\ttext-align: center;\n\ttop: 2px;\n\tfont-weight: 600\n}\n\n.checkbox-outline .custom-control-label:before {\n\tbackground: 0 0\n}\n\n.checkbox-outline .custom-control-input:checked~.custom-control-label::before {\n\tbackground: 0 0\n}\n\n.checkbox-outline .custom-control-input:checked~.custom-control-label::after {\n\tbackground-image: none;\n\tcontent: \"\\f17b\";\n\tfont-family: LineAwesome;\n\tleft: 0;\n\tfont-size: .86667rem;\n\ttext-align: center;\n\ttop: 2px;\n\tfont-weight: 600\n}\n\n.checkbox-outline-gray .custom-control-label:before {\n\tborder: 1px solid #e4e8ed\n}\n\n.checkbox-outline-gray .custom-control-input:checked~.custom-control-label::before {\n\tborder: 1px solid #e4e8ed\n}\n\n.checkbox-outline-gray .custom-control-input:checked~.custom-control-label::after {\n\tcolor: #5a6671\n}\n\n.checkbox-rounded .custom-control-label:before {\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%\n}\n\n.toggle-switch {\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: 4rem;\n\theight: 2rem\n}\n\n.toggle-switch input {\n\tdisplay: none\n}\n\n.toggle-switch .slider {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tbackground-color: #cbd0e3;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tcursor: pointer\n}\n\n.toggle-switch .slider:before {\n\tposition: absolute;\n\tcontent: \"\";\n\theight: 1.6rem;\n\twidth: 1.6rem;\n\tleft: .2rem;\n\tbottom: .2rem;\n\tbackground-color: #fff;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.toggle-switch input:checked+.slider:before {\n\t-webkit-transform: translateX(30px);\n\t-ms-transform: translateX(30px);\n\ttransform: translateX(30px)\n}\n\n.toggle-switch input:focus+.slider {\n\t-webkit-box-shadow: 0 0 1px #2196f3;\n\tbox-shadow: 0 0 1px #2196f3\n}\n\n.toggle-switch .slider.round {\n\t-webkit-border-radius: 1.66667rem;\n\tborder-radius: 1.66667rem\n}\n\n.toggle-switch .slider.round:before {\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%\n}\n\n.toggle-switch-text {\n\twidth: 4.66667rem\n}\n\n.toggle-switch-text input:checked+.slider:before {\n\t-webkit-transform: translateX(2.66667rem);\n\t-ms-transform: translateX(2.66667rem);\n\ttransform: translateX(2.66667rem)\n}\n\n.toggle-switch-text input:checked+.slider .on {\n\tvisibility: visible;\n\topacity: 1\n}\n\n.toggle-switch-text input:checked+.slider .off {\n\tvisibility: hidden\n}\n\n.toggle-switch-text .slider.round .on {\n\tvisibility: hidden;\n\topacity: 0;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.toggle-switch-text .slider.round .off,\n.toggle-switch-text .slider.round .on {\n\tpadding-left: .2rem;\n\tmargin-top: .4rem;\n\tfont-size: .86667rem;\n\ttext-transform: uppercase;\n\tdisplay: inline-block\n}\n\n.toggle-switch-text .slider.round .on {\n\tpadding-left: .66667rem;\n\tcolor: #fff\n}\n\n.toggle-switch-bordered .slider {\n\tbackground: 0 0;\n\tborder: 1px solid #cbd0e3\n}\n\n.toggle-switch-bordered .slider:before {\n\theight: 2rem;\n\twidth: 2rem;\n\tleft: -.06667rem;\n\tbottom: -.06667rem;\n\tborder: 1px solid #cbd0e3\n}\n\n.toggle-switch-bordered input:checked+.slider {\n\tborder-color: #06b590;\n\tbackground: 0 0\n}\n\n.toggle-switch-bordered input:checked+.slider:before {\n\t-webkit-transform: translateX(30px);\n\t-ms-transform: translateX(30px);\n\ttransform: translateX(30px);\n\tborder-color: #06b590\n}\n\nselect.form-control {\n\tmin-height: 3rem;\n\tcolor: #9192a3\n}\n\n.select-basic {\n\tposition: relative\n}\n\n.select-basic select {\n\t-webkit-appearance: none;\n\t-moz-appearance: none;\n\tappearance: none\n}\n\n.select-basic:before {\n\tposition: absolute;\n\tcontent: \"\\f110\";\n\tright: 1rem;\n\tfont-size: .8rem;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tfont-family: LineAwesome\n}\n\n.form--rounded {\n\t-webkit-border-radius: 1.66667rem;\n\tborder-radius: 1.66667rem;\n\tborder: 0 none\n}\n\n.input-group-subscribe {\n\tdisplay: block;\n\tposition: relative;\n\t-webkit-border-radius: 3px;\n\tborder-radius: 3px;\n\toverflow: hidden\n}\n\n.input-group-subscribe input {\n\twidth: 100%;\n\tborder: 0 none;\n\tpadding-left: 4rem;\n\tpadding-right: 7.66667rem;\n\theight: 4rem\n}\n\n.input-group-subscribe button {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\theight: 100%;\n\tborder: 0 none;\n\tpadding: 0 1.66667rem;\n\tbackground: #06b590;\n\tcolor: #fff;\n\tcursor: pointer\n}\n\n.input-group-subscribe .text-field {\n\tposition: relative\n}\n\n.input-group-subscribe .text-field:before {\n\tposition: absolute;\n\tcontent: '\\f1c6';\n\tfont-family: LineAwesome;\n\tleft: 1.66667rem;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tfont-size: 1.46667rem\n}\n\n.input-group-subscribe.subscribe--rounded input {\n\t-webkit-border-radius: 2rem;\n\tborder-radius: 2rem\n}\n\n.input-group-subscribe.subscribe--rounded button {\n\t-webkit-border-radius: 0 2rem 2rem 0;\n\tborder-radius: 0 2rem 2rem 0\n}\n\nselect[multiple]::-webkit-scrollbar-track {\n\tbackground-color: rgba(32, 36, 40, .05)\n}\n\nselect[multiple]::-webkit-scrollbar {\n\twidth: 6px;\n\tbackground-color: transparent\n}\n\nselect[multiple]::-webkit-scrollbar-thumb {\n\tbackground-color: #e4e8ed;\n\t-webkit-border-radius: 5px;\n\tborder-radius: 5px\n}\n\n.form-wrapper .cardify h5 {\n\tfont-weight: 600\n}\n\n.select2-container {\n\twidth: 100% !important\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow b:before {\n\tposition: absolute;\n\tcontent: \"\\f110\";\n\tright: 1rem;\n\tfont-weight: 400;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tfont-family: LineAwesome\n}\n\n.select2-container .select2-selection--multiple .select2-selection__rendered {\n\tdisplay: block;\n\twidth: 100% !important\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\n\tmargin: 5px;\n\tbackground: #f1f3f8;\n\tborder: 0;\n\tcolor: #9192a3;\n\tpadding: 0 10px\n}\n\n.select2-results__options::-webkit-scrollbar-track {\n\tbackground-color: rgba(32, 36, 40, .05)\n}\n\n.select2-results__options::-webkit-scrollbar {\n\twidth: 6px;\n\tbackground-color: transparent\n}\n\n.select2-results__options::-webkit-scrollbar-thumb {\n\tbackground-color: #e4e8ed;\n\t-webkit-border-radius: 5px;\n\tborder-radius: 5px\n}\n\n.custom_select_with_icon .select2-results .select2-results__options .select2-results__option.select2-results__option--highlighted span span.la {\n\tcolor: #06b590\n}\n\n.custom_select_with_icon .select2-results .select2-results__options .select2-results__option span span.la {\n\tfont-size: 18px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tline-height: inherit;\n\tmargin-right: 4px;\n\tcolor: #9192a3\n}\n\n.custom-photo-upload {\n\tposition: relative\n}\n\n.custom-photo-upload input {\n\twidth: 13.33333rem;\n\theight: 13.33333rem;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\topacity: 0;\n\tmargin: 0;\n\tcursor: pointer\n}\n\n.custom-photo-upload .custom-upload-box .image-box {\n\twidth: 13.33333rem;\n\theight: 13.33333rem;\n\tborder: 1px solid #e4e8ed;\n\t-webkit-border-radius: 3px;\n\tborder-radius: 3px;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column\n}\n\n.custom-photo-upload .custom-upload-box .image-box .icon {\n\tfont-size: 6.66667rem;\n\tcolor: #e4e8ed\n}\n\n.custom-photo-upload .custom-upload-box .image-box span {\n\tcolor: #9192a3\n}\n\n.custom-photo-upload .custom-upload-box .image-box span.file-name {\n\ttext-align: center\n}\n\n.custom-photo-upload .custom-upload-box .image-info {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tmargin-left: 2rem\n}\n\n.custom-photo-upload .custom-upload-box .image-info span {\n\tcolor: #9192a3\n}\n\n.custom-upload {\n\tposition: relative\n}\n\n.custom-upload input {\n\twidth: 13.33333rem;\n\theight: 3.33333rem;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\topacity: 0;\n\tmargin: 0;\n\tcursor: pointer\n}\n\n.custom-upload .custom-upload-box .upload-info {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tmargin-left: 2rem\n}\n\n.custom-upload .custom-upload-box .upload-info span {\n\tcolor: #9192a3\n}\n\ntextarea.form-control {\n\tpadding-top: 1rem\n}\n\n.form-control-lg {\n\tfont-size: 1rem\n}\n\n.heading-styles .card-body {\n\tpadding: 3rem 3rem 1.8rem\n}\n\n.heading-styles .card-body h1,\n.heading-styles .card-body h2,\n.heading-styles .card-body h3,\n.heading-styles .card-body h4,\n.heading-styles .card-body h5,\n.heading-styles .card-body h6 {\n\tcolor: #202428\n}\n\n.sub_heading-group {\n\tmargin-bottom: 2.66rem\n}\n\n.sub_heading-group:last-child {\n\tmargin-bottom: 0\n}\n\n.sub_heading-group h1,\n.sub_heading-group h2,\n.sub_heading-group h3,\n.sub_heading-group h4,\n.sub_heading-group h5,\n.sub_heading-group h6 {\n\tmargin-bottom: 1.5rem\n}\n\n.sub_heading-group .subHeading-top {\n\tfont-size: 1.33rem;\n\tfont-weight: 500;\n\tmargin-bottom: .4rem\n}\n\n.sub_heading-group .subHeading-bottom {\n\tfont-size: 1.2rem;\n\tmargin-bottom: 0\n}\n\n.lead {\n\tline-height: 2.4rem\n}\n\n.lead--medium {\n\tfont-size: 1.6rem;\n\tfont-weight: 500;\n\tline-height: 2.93rem\n}\n\np {\n\tline-height: 2rem\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\tfont-weight: 600\n}\n\n.blockquote {\n\tborder: 1px solid #e4e8ed;\n\tpadding: 2.5rem 3.33333rem;\n\t-webkit-border-radius: .3rem;\n\tborder-radius: .3rem;\n\tmargin: 0\n}\n\n.blockquote p {\n\tmargin: 0;\n\tfont-size: 1.33rem;\n\tcolor: #202428;\n\tline-height: 2.4rem;\n\tfont-weight: 500\n}\n\n.blockquote .quote-author {\n\tmargin-top: 1.66rem\n}\n\n.blockquote .quote-author p {\n\tfont-size: 1rem;\n\tfont-weight: 400;\n\tline-height: 2rem;\n\tcolor: #9192a3;\n\tposition: relative;\n\tdisplay: inline-block;\n\tpadding-left: 3.66667rem\n}\n\n.blockquote .quote-author p:before {\n\tposition: absolute;\n\tcontent: \"\";\n\twidth: 2.66667rem;\n\theight: 2px;\n\tbackground: #06b590;\n\tleft: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.blockquote .quote-author p span {\n\tfont-weight: 500;\n\tcolor: #202428\n}\n\n.blockquote.blockquote1 .quote-author {\n\ttext-align: left\n}\n\n.blockquote.blockquote-sm p {\n\tfont-size: 1.06667rem;\n\tline-height: 1.86667rem\n}\n\n.blockquote.blockquote-sm .quote-author p {\n\tpadding: 0\n}\n\n.blockquote.blockquote-sm .quote-author p:before {\n\tcontent: none\n}\n\n.blockquote.blockquote-sm .quote-author p span {\n\tfont-size: 1rem\n}\n\n.blockquote.blockquote3,\n.blockquote.blockquote4 {\n\tborder: 0 none;\n\t-webkit-border-radius: 0;\n\tborder-radius: 0;\n\tbackground: -webkit-gradient(linear, left top, right top, from(#413aa4), to(#06b590));\n\tbackground: -webkit-linear-gradient(left, #413aa4, #06b590);\n\tbackground: -o-linear-gradient(left, #413aa4, #06b590);\n\tbackground: linear-gradient(to right, #413aa4, #06b590)\n}\n\n.blockquote.blockquote3 p,\n.blockquote.blockquote4 p {\n\tfont-weight: 400;\n\tcolor: #fff\n}\n\n.blockquote.blockquote3 .quote-author p,\n.blockquote.blockquote4 .quote-author p {\n\tcolor: rgba(255, 255, 255, .7)\n}\n\n.blockquote.blockquote3 .quote-author span,\n.blockquote.blockquote4 .quote-author span {\n\tcolor: #fff\n}\n\n.blockquote.blockquote3 .quote-author {\n\ttext-align: left\n}\n\n.blockquote.blockquote1,\n.blockquote.blockquote3 {\n\tposition: relative\n}\n\n.blockquote.blockquote1:before,\n.blockquote.blockquote3:before {\n\tposition: absolute;\n\tcontent: \"\\f2ce\";\n\tfont-family: LineAwesome;\n\tcolor: rgba(255, 255, 255, .1);\n\tfont-size: 8rem;\n\tleft: 2.33333rem;\n\tbottom: .66667rem\n}\n\n.quotes-with-image {\n\tbackground: -webkit-gradient(linear, left top, right top, from(#413aa4), to(#06b590));\n\tbackground: -webkit-linear-gradient(left, #413aa4, #06b590);\n\tbackground: -o-linear-gradient(left, #413aa4, #06b590);\n\tbackground: linear-gradient(to right, #413aa4, #06b590)\n}\n\n.blockquote5 {\n\tmargin-bottom: 0\n}\n\n.blockquote5 .strong {\n\tfont-size: 1.46667rem;\n\tfont-weight: 500;\n\tcolor: #fff;\n\tmargin-bottom: 2.33333rem;\n\tline-height: 2.4rem;\n\tposition: relative;\n\tmargin-top: 2.66667rem\n}\n\n.blockquote5 .strong:before {\n\tposition: absolute;\n\tcontent: \"\\f2cd\";\n\tfont-family: LineAwesome;\n\tfont-size: 10rem;\n\tcolor: rgba(255, 255, 255, .1);\n\tleft: 0;\n\ttop: -1rem\n}\n\n.blockquote5 p {\n\tcolor: rgba(255, 255, 255, .8)\n}\n\n.blockquote5 .author-sign {\n\tfont-size: 2.33333rem;\n\tfont-family: Allura, cursive;\n\tcolor: #fff;\n\tdisplay: block;\n\tmargin-top: 2rem\n}\n\n.hr {\n\tmargin: 5.33333rem 0\n}\n\n.accordion_one,\n.accordion_two {\n\t-webkit-box-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\tbackground: #fff;\n\tpadding: 2.66667rem;\n\tborder: 1px solid #e4e8ed\n}\n\n.accordion_one .accordion-single,\n.accordion_two .accordion-single {\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.accordion_one .accordion-single:first-child,\n.accordion_two .accordion-single:first-child {\n\tpadding-top: 0\n}\n\n.accordion_one .accordion-single:first-child h6 a,\n.accordion_two .accordion-single:first-child h6 a {\n\tpadding-top: 0\n}\n\n.accordion_one .accordion-single:first-child h6 a[aria-expanded=true]:before,\n.accordion_two .accordion-single:first-child h6 a[aria-expanded=true]:before {\n\ttop: 10%;\n\t-webkit-transform: translateY(-10%);\n\t-ms-transform: translateY(-10%);\n\ttransform: translateY(-10%)\n}\n\n.accordion_one .accordion-single:first-child h6 a[aria-expanded=false]:before,\n.accordion_two .accordion-single:first-child h6 a[aria-expanded=false]:before {\n\ttop: 10%;\n\t-webkit-transform: translateY(-10%);\n\t-ms-transform: translateY(-10%);\n\ttransform: translateY(-10%)\n}\n\n.accordion_one .accordion-single h6 a,\n.accordion_two .accordion-single h6 a {\n\tcolor: #202428;\n\tdisplay: block;\n\tposition: relative;\n\tpadding: 1.33rem 2rem 1rem 0;\n\tfont-size: 1.06667rem;\n\tfont-weight: 500;\n\tcursor: pointer\n}\n\n.accordion_one .accordion-single h6 a[aria-expanded=true]:before,\n.accordion_two .accordion-single h6 a[aria-expanded=true]:before {\n\tposition: absolute;\n\tcontent: '\\f110';\n\tfont-family: LineAwesome;\n\tright: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tcolor: #9192a3;\n\tfont-size: .93333rem\n}\n\n.accordion_one .accordion-single h6 a[aria-expanded=false]:before,\n.accordion_two .accordion-single h6 a[aria-expanded=false]:before {\n\tposition: absolute;\n\tcontent: '\\f113';\n\tfont-family: LineAwesome, sans-serif;\n\tright: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tfont-size: .93333rem;\n\tcolor: #9192a3\n}\n\n.accordion_two {\n\t-webkit-box-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\tpadding: 3rem;\n\t-webkit-border-radius: .3rem;\n\tborder-radius: .3rem\n}\n\n.accordion_two .accordion-single h6 a[aria-expanded=true]:before {\n\tcontent: '\\f28e';\n\tcolor: #9192a3\n}\n\n.accordion_two .accordion-single h6 a[aria-expanded=false]:before {\n\tcontent: '\\f2c2'\n}\n\n.accordion_three .accordion-single {\n\tmargin-bottom: 5px\n}\n\n.accordion_three .accordion-heading h6 a {\n\tdisplay: block;\n\tpadding: 1rem 2.66667rem 1rem 2rem;\n\tbackground: #fff;\n\tcolor: #202428;\n\tposition: relative;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tline-height: 1.46667rem;\n\tfont-size: 1rem;\n\tfont-weight: 500\n}\n\n.accordion_three .accordion-heading h6 a[aria-expanded=true] {\n\tbackground: #06b590;\n\tcolor: #fff\n}\n\n.accordion_three .accordion-heading h6 a[aria-expanded=true]:before {\n\tcontent: '\\f28e';\n\tcolor: #fff\n}\n\n.accordion_three .accordion-heading h6 a:before {\n\tposition: absolute;\n\tcontent: '\\f2c2';\n\tfont-family: LineAwesome;\n\tright: 2rem;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tcolor: #9192a3\n}\n\n.accordion_three .accordion-contents {\n\tpadding: 1.33rem 2rem .66rem\n}\n\n.accordion_three .collapsed.bg-gray-light {\n\tbackground: #f5f4f7\n}\n\n.accordion_four .accordion-single {\n\tmargin-bottom: 5px\n}\n\n.accordion_four .accordion-heading h6 a {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tpadding: 1rem 2.66667rem 1rem 2rem;\n\tbackground: #fff;\n\tcolor: #202428;\n\tposition: relative;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tline-height: 1.46667rem;\n\tfont-size: 1rem;\n\tfont-weight: 500\n}\n\n.accordion_four .accordion-heading h6 a[aria-expanded=true] {\n\tbackground: #06b590;\n\tcolor: #fff\n}\n\n.accordion_four .accordion-heading h6 a[aria-expanded=true]:before {\n\tcontent: '\\f28e';\n\tcolor: #fff\n}\n\n.accordion_four .accordion-heading h6 a[aria-expanded=true] i {\n\tcolor: #fff\n}\n\n.accordion_four .accordion-heading h6 a:before {\n\tposition: absolute;\n\tcontent: '\\f2c2';\n\tfont-family: LineAwesome;\n\tright: 2rem;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tcolor: #9192a3\n}\n\n.accordion_four .accordion-heading h6 a i {\n\tfont-size: 1.4rem;\n\tcolor: #06b590;\n\tmargin-right: 1rem;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.accordion_four .accordion-contents {\n\tpadding: 1.33rem 2rem .66rem\n}\n\n.accordion_four .collapsed.bg-gray-light {\n\tbackground: #f5f4f7\n}\n\n.alert-group .alert:last-child {\n\tmargin-bottom: 0\n}\n\n.alert {\n\tborder: 0 none\n}\n\n.alert strong {\n\tfont-weight: 500;\n\tfont-size: 1.06rem\n}\n\n.alert a {\n\tcolor: inherit;\n\tfont-weight: 500;\n\tfont-size: 1.06rem\n}\n\n.alert p {\n\tmargin: 0\n}\n\n.alert i.la {\n\tpadding-right: .66rem;\n\tfont-size: 1.2rem;\n\tposition: relative;\n\ttop: 2px\n}\n\n.alert.alert-outline {\n\tbackground: 0 0;\n\tborder: 1px solid\n}\n\n.alert.alert-dismissible .close {\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tright: 2rem;\n\tpadding: 0\n}\n\n.alert.alert-dismissible .close:focus {\n\toutline: 0\n}\n\n.card {\n\t-webkit-border-radius: .26667rem;\n\tborder-radius: .26667rem;\n\toverflow: hidden\n}\n\n.card figure {\n\tmargin: 0\n}\n\n.card .card-body .card-title {\n\tmargin-bottom: 25px\n}\n\n.card .card-body h6 {\n\tmargin-bottom: 0;\n\tline-height: 1.86667rem\n}\n\n.card .card-body h4 a:hover {\n\tcolor: #413aa4\n}\n\n.card .card-footer {\n\tpadding: 1.66667rem 2rem\n}\n\n.card .card-footer ul {\n\tmargin: 0\n}\n\n.card.card-shadow {\n\t-webkit-box-shadow: 0 5px 20px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 20px rgba(105, 106, 119, .05)\n}\n\n.card.card--dark {\n\tbackground: #fff\n}\n\n.card.card--dark .card-header {\n\tbackground: inherit;\n\tpadding: 1.53333rem 2rem 2rem\n}\n\n.card.card--dark .card-header h5 {\n\tmargin: 0\n}\n\n.card.card--sidebar .card-header {\n\tpadding: 2rem\n}\n\n.card.card--sidebar .card-header h4 {\n\tmargin: 0\n}\n\n.card.card--sidebar .card-body {\n\tpadding: 2rem 2rem 3.33333rem\n}\n\n.card-one {\n\tmargin-bottom: 2rem\n}\n\n.card-one figure {\n\tposition: relative\n}\n\n.card-one figure figcaption {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tbackground: rgba(6, 181, 144, .8);\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\topacity: 0;\n\tvisibility: hidden\n}\n\n.card-one figure figcaption a {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -webkit-inline-flex;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\twidth: 3.33333rem;\n\theight: 3.33333rem;\n\tbackground: #fff;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tfont-size: 1.2rem;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\t-webkit-transform: scale(1.5);\n\t-ms-transform: scale(1.5);\n\ttransform: scale(1.5)\n}\n\n.card-one figure figcaption a:hover {\n\tbackground: #413aa4;\n\tcolor: #fff\n}\n\n.card-one .card-subtitle {\n\tmargin: 0 0 .66667rem 0;\n\tline-height: 1\n}\n\n.card-one:hover figure figcaption {\n\topacity: 1;\n\tvisibility: visible\n}\n\n.card-one:hover figure figcaption a {\n\t-webkit-transform: scale(1);\n\t-ms-transform: scale(1);\n\ttransform: scale(1)\n}\n\n.card-two .card-footer ul {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.card-two .card-footer ul li {\n\tcolor: #9192a3;\n\tpadding-right: 1rem;\n\tmargin-right: 1rem;\n\tposition: relative\n}\n\n.card-two .card-footer ul li:before {\n\tposition: absolute;\n\tcontent: '|';\n\tright: 0;\n\ttop: 0;\n\tcolor: #e4e8ed\n}\n\n.card-two .card-footer ul li:last-child {\n\tmargin-right: 0\n}\n\n.card-two .card-footer ul li:last-child:before {\n\tcontent: none\n}\n\n.card-two .card-footer ul li a {\n\tcolor: #9192a3\n}\n\n.card-text,\n.card-three,\n.card-video {\n\tmargin-bottom: 2rem !important\n}\n\n.card-text .card-subtitle,\n.card-three .card-subtitle,\n.card-video .card-subtitle {\n\tmargin: 0 0 .66667rem 0\n}\n\n.card-text .card-text,\n.card-three .card-text,\n.card-video .card-text {\n\tmargin-top: 1rem\n}\n\n.card-video figure {\n\tposition: relative\n}\n\n.card-video figure figcaption {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tbackground: rgba(32, 36, 40, .2);\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.card-video figure figcaption a {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -webkit-inline-flex;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\twidth: 3rem;\n\theight: 3rem;\n\tbackground: #fff;\n\tcolor: #06b590;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tborder: 2px solid transparent;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.card-video figure figcaption a .svg {\n\twidth: .86667rem;\n\tfill: #06b590;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.card-video figure figcaption a:hover {\n\tbackground: #06b590\n}\n\n.card-video figure figcaption a:hover .svg {\n\tfill: #fff\n}\n\n.card-text .card-body h5 {\n\tmargin: 0 0 2rem 0\n}\n\n.card-text:last-child {\n\tmargin-bottom: 0 !important\n}\n\n.card-four {\n\tmargin-bottom: 2rem\n}\n\n.card-four .card-body .card-subtitle {\n\tmargin-bottom: 4px\n}\n\n.card-four .card-body h5 {\n\tmargin-bottom: 1.33rem\n}\n\n.card-four .card-body h5 a {\n\tcolor: #202428\n}\n\n.card-four .card-body .card-text {\n\tmargin-bottom: 1.6rem\n}\n\n.card-product {\n\tmargin-bottom: 2rem;\n\tposition: relative\n}\n\n.card-product figure {\n\tposition: relative;\n\toverflow: hidden\n}\n\n.card-product figure figcaption {\n\tposition: absolute;\n\twidth: 100%;\n\tleft: 0;\n\tbottom: -76px;\n\tbackground: #413aa4;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\topacity: 0\n}\n\n.card-product figure figcaption ul {\n\tmargin: 0;\n\tpadding: .8rem 0\n}\n\n.card-product figure figcaption ul li:last-child {\n\tmargin-left: .66rem\n}\n\n.card-product figure figcaption ul a.btn--rounded {\n\tborder-color: rgba(255, 255, 255, .3);\n\tcolor: #fff\n}\n\n.card-product figure figcaption ul .like-btn {\n\tposition: relative\n}\n\n.card-product figure figcaption ul .like-btn i {\n\tz-index: 2\n}\n\n.card-product figure figcaption ul .like-btn:hover {\n\tcolor: #413aa4;\n\tbackground: #fff\n}\n\n.card-product .card-body {\n\ttext-align: center;\n\tpadding: 1.66667rem 2rem\n}\n\n.card-product .card-body h6 {\n\tmargin-bottom: 5px\n}\n\n.card-product .card-body h6 a {\n\tcolor: #202428;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.card-product .card-body .prices {\n\tmargin-top: .66667rem\n}\n\n.card-product .card-body .prices .product-price {\n\tfont-size: 1.33rem;\n\tfont-weight: 600;\n\tline-height: 1.2rem;\n\tdisplay: inline-block\n}\n\n.card-product .card-body .prices .old-price {\n\tfont-weight: 500;\n\tdisplay: inline-block;\n\tmargin-right: 7px;\n\tcolor: #9192a3;\n\ttext-decoration: line-through\n}\n\n.card-product:hover figure figcaption {\n\topacity: 1;\n\tbottom: 0\n}\n\n.card-product .badge {\n\tposition: absolute;\n\tleft: .66rem;\n\ttop: .66rem;\n\tpadding: 6px 10px;\n\tfont-size: .8rem;\n\tfont-weight: 500\n}\n\n.card-six .card-body h5 {\n\tmargin-bottom: 1.33333rem\n}\n\n.card-six .card-body h5 a {\n\tcolor: #202428;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.card-six .card-body h5 a:hover {\n\tcolor: #06b590\n}\n\n.card--seven .card-body {\n\tpadding-bottom: 2rem\n}\n\n.card--seven .card-body h6 {\n\tmargin-bottom: 1rem\n}\n\n.card--seven .card-body h6 a {\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.card--seven .card-body p {\n\tmargin-bottom: 0\n}\n\n.card--seven .card-body .btn {\n\tmargin-top: 1.66667rem\n}\n\n.card--seven:hover .card-body h5 a {\n\tcolor: #06b590\n}\n\n.card--eight .card-body {\n\tpadding-bottom: 2rem\n}\n\n.card--eight .card-body h5 {\n\tmargin-bottom: 1rem\n}\n\n.card--eight .card-body h5 a {\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.card--eight .card-body h5 a:hover {\n\tcolor: #06b590\n}\n\n.card--eight .card-body p {\n\tmargin-bottom: 0\n}\n\n.card--eight .card-body .btn {\n\tmargin-top: 1.66667rem\n}\n\n.card--ten {\n\tmargin-bottom: 4.66667rem\n}\n\n.card--ten figure {\n\tmargin-bottom: 0\n}\n\n.card--eleven {\n\tposition: relative;\n\tborder: 0 none;\n\toverflow: hidden\n}\n\n.card--eleven figure img {\n\t-webkit-border-radius: .33333rem;\n\tborder-radius: .33333rem\n}\n\n.card--eleven .card-body {\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\twidth: 100%;\n\tmin-height: 100px;\n\tbackground: rgba(65, 58, 164, .7);\n\tvisibility: visible;\n\topacity: 1;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tpadding: 1.33333rem 2rem;\n\ttransition: all .3s ease\n}\n\n.card--eleven .card-body .card-contents .content-top {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\ttext-align: left;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.card--eleven .card-body .card-contents .content-top span {\n\tfont-size: 2.4rem;\n\tcolor: #fff;\n\tmargin-right: 1rem\n}\n\n.card--eleven .card-body .card-contents .content-top h6 {\n\tmargin-bottom: 0\n}\n\n.card--eleven .card-body .card-contents .content-bottom {\n\tmax-height: 0;\n\t-webkit-transition: .5s ease;\n\t-o-transition: .5s ease;\n\ttransition: .5s ease;\n\toverflow: hidden\n}\n\n.card--eleven .card-body .card-contents .content-bottom p {\n\tmargin-top: 1rem\n}\n\n.card--eleven .card-body h6 {\n\tcolor: #fff;\n\tmargin-bottom: 0\n}\n\n.card--eleven .card-body p {\n\tcolor: rgba(255, 255, 255, .9);\n\tmargin-bottom: 2rem\n}\n\n.card--eleven:hover .card-body {\n\tmin-height: 100%\n}\n\n.card--eleven:hover .card-body .card-contents {\n\tposition: absolute;\n\twidth: 100%;\n\tleft: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tpadding: 0 2.66667rem\n}\n\n.card--eleven:hover .card-body .card-contents .content-top {\n\tdisplay: block;\n\ttext-align: center\n}\n\n.card--eleven:hover .card-body .card-contents .content-top span {\n\tdisplay: none\n}\n\n.card--eleven:hover .card-body .card-contents .content-top h5 {\n\tmargin-bottom: 2rem\n}\n\n.card--eleven:hover .card-body .card-contents .content-bottom {\n\tmax-height: 300px\n}\n\n.card-twelve {\n\tborder: 0 none;\n\t-webkit-border-radius: 3px;\n\tborder-radius: 3px;\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .1)\n}\n\n.card-twelve .card-body {\n\tpadding-bottom: 2rem\n}\n\n.card-twelve .card-body .step {\n\tdisplay: block;\n\tfont-size: 2.4rem;\n\tfont-weight: 500;\n\tcolor: #06b590;\n\tline-height: 1\n}\n\n.card-twelve .card-body h6 {\n\tmargin: 1rem 0;\n\tcolor: #202428\n}\n\n.card-twelve .card-body p {\n\tmargin-bottom: 1.6rem\n}\n\n.card--fourteen {\n\tposition: relative;\n\tborder: 0 none\n}\n\n.card--fourteen:hover .card-body {\n\tvisibility: visible;\n\topacity: 1;\n\tbottom: 0\n}\n\n.card--fourteen figure {\n\tposition: relative;\n\t-webkit-border-radius: 4px;\n\tborder-radius: 4px;\n\toverflow: hidden\n}\n\n.card--fourteen .card-body {\n\tposition: absolute;\n\tbottom: -50px;\n\tleft: 0;\n\twidth: 100%;\n\tbackground: rgba(55, 125, 255, .9);\n\tvisibility: hidden;\n\topacity: 0;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tpadding: 1rem 2rem;\n\ttransition: all .3s ease;\n\t-webkit-border-radius: 0 0 4px 4px;\n\tborder-radius: 0 0 4px 4px\n}\n\n.card--fourteen .card-body .card-contents .content-top h6 {\n\tmargin-bottom: 0\n}\n\n.card--fourteen .card-body .card-contents .content-top h6 a {\n\tcolor: #fff\n}\n\n.card--fourteen .card-body .card-contents .content-top span {\n\tcolor: rgba(255, 255, 255, .8);\n\tmargin-bottom: .33333rem;\n\tdisplay: block\n}\n\n.card--testimonial {\n\tpadding: 2rem;\n\tposition: relative;\n\tz-index: 1\n}\n\n.card--testimonial:before {\n\tposition: absolute;\n\tcontent: \"\\f2ce\";\n\tright: 2rem;\n\ttop: 2rem;\n\tcolor: rgba(65, 58, 164, .1);\n\tfont-size: 5.33333rem;\n\tfont-family: LineAwesome;\n\tline-height: 1;\n\tz-index: -1\n}\n\n.card--testimonial .author {\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.card--testimonial .author .author-spec {\n\tmargin-left: 1rem\n}\n\n.card--testimonial .author .author-spec h6 {\n\tmargin-bottom: .53333rem\n}\n\n.card--testimonial .content {\n\tmargin-top: 1.33333rem\n}\n\n.card--testimonial .content p {\n\tmargin: 0\n}\n\n.card--testimonial2 {\n\tmargin-bottom: 2rem;\n\tborder: 1px solid #f3f3f3 !important\n}\n\n.card--testimonial2 .card-body h6 {\n\tpadding-top: 18px;\n\tcolor: #202428\n}\n\n.card--testimonial2 .ratings {\n\tmargin: .33333rem 0 1rem 0;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center\n}\n\n.card--testimonial2 .ratings span {\n\tmargin: 0 1px 0 0\n}\n\n.card--testimonial2 .ratings span:last-child {\n\tmargin--right: 0\n}\n\n.card--testimonial2 .author-spec {\n\tmargin-top: 1.33333rem;\n\tmargin-bottom: 0\n}\n\n.card--testimonial2 .author-spec strong {\n\tfont-weight: 500;\n\tcolor: #202428\n}\n\n.team-carousel-one .nav-square {\n\tvisibility: hidden;\n\topacity: 0;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.team-carousel-one:hover .nav-square {\n\tvisibility: visible;\n\topacity: 1\n}\n\n.card--team1 {\n\tborder: 1px solid #f3f3f3 !important\n}\n\n.card--team1 .card-body {\n\tpadding: 2rem\n}\n\n.card--team1 .card-body h6 {\n\tmargin: 1.33333rem 0 .66667rem 0\n}\n\n.card--team1 .card-body .team-designation {\n\tpadding: 0 1rem;\n\tline-height: 2rem;\n\tdisplay: inline-block;\n\tbackground: rgba(6, 181, 144, .1);\n\t-webkit-border-radius: 3px;\n\tborder-radius: 3px;\n\tcolor: #06b590\n}\n\n.card--team1 .card-body .team-social {\n\tmargin: 1.66667rem 0 0 0\n}\n\n.card--team1 .card-body .team-social li {\n\tmargin-right: .66667rem\n}\n\n.card--team1 .card-body .team-social li:last-child {\n\tmargin-right: 0\n}\n\n.card--team1 .card-body .team-social li a {\n\tcolor: rgba(145, 146, 163, .7);\n\tfont-size: .93333rem;\n\twidth: 2.26667rem;\n\theight: 2.26667rem;\n\t-webkit-border-radius: 20rem;\n\tborder-radius: 20rem;\n\tbackground: rgba(245, 247, 252, .5);\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center\n}\n\n.card--team1 .card-body .team-social li a:hover {\n\tcolor: #fff\n}\n\n.card--team2 {\n\t-webkit-border-radius: 0;\n\tborder-radius: 0;\n\tborder: 0 none\n}\n\n.card--team2 figure {\n\tposition: relative;\n\toverflow: hidden;\n\tmargin-bottom: .66667rem\n}\n\n.card--team2 figure figcaption {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tbackground: #413aa4;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\topacity: 0;\n\tvisibility: hidden;\n\t-webkit-transform: scale(.9);\n\t-ms-transform: scale(.9);\n\ttransform: scale(.9);\n\t-webkit-transition: .4s ease;\n\t-o-transition: .4s ease;\n\ttransition: .4s ease\n}\n\n.card--team2 figure figcaption .team-social {\n\tmargin: 0 0 2.66667rem 0\n}\n\n.card--team2 figure figcaption .team-social li {\n\tmargin-right: 1.33333rem\n}\n\n.card--team2 figure figcaption .team-social li:last-child {\n\tmargin-right: 0\n}\n\n.card--team2 figure figcaption .team-social li a {\n\tcolor: #fff;\n\tfont-size: 1.06667rem\n}\n\n.card--team2 figure figcaption .btn-outline-light {\n\tcolor: #fff\n}\n\n.card--team2 .card-body {\n\tpadding: 1rem;\n\ttext-align: center\n}\n\n.card--team2 .card-body h6 {\n\tcolor: #fff;\n\tmargin-bottom: .33333rem\n}\n\n.card--team2 .card-body span {\n\tcolor: rgba(255, 255, 255, .7)\n}\n\n.card--team2:hover figure figcaption {\n\topacity: 1;\n\tvisibility: visible;\n\t-webkit-transform: scale(1);\n\t-ms-transform: scale(1);\n\ttransform: scale(1)\n}\n\n.card--team3 {\n\tborder: 0 none;\n\t-webkit-box-shadow: 0 5px 20px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 20px rgba(105, 106, 119, .05);\n\t-webkit-border-radius: 4px;\n\tborder-radius: 4px;\n\toverflow: hidden;\n\tmargin-bottom: 2rem\n}\n\n.card--team3 .card__thumbnail img {\n\twidth: 100%\n}\n\n.card--team3 .card-body {\n\tpadding: 1.6rem 2rem\n}\n\n.card--team3 .card-body>p {\n\tmargin-bottom: 25px\n}\n\n.card--team3 .card-body h6 {\n\tmargin-bottom: .33333rem;\n\tcolor: #202428\n}\n\n.card--team3 .card-body .subtitle {\n\tdisplay: block;\n\tmargin-bottom: 1rem;\n\tfont-size: .93333rem;\n\tcolor: #9192a3\n}\n\n.card.card--team4 {\n\tmargin-bottom: 2rem;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t-webkit-flex-direction: row;\n\t-ms-flex-direction: row;\n\tflex-direction: row;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.card.card--team4 .team-image {\n\t-webkit-box-flex: 0;\n\t-webkit-flex: none;\n\t-ms-flex: none;\n\tflex: none\n}\n\n.card.card--team4 .team-info h6 {\n\tmargin-bottom: 5px\n}\n\n.card.card--team4 .team-info h6 a {\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.card.card--team4 p {\n\tmargin: 0\n}\n\n.card.card--team4:hover .team-info h5 a {\n\tcolor: #413aa4\n}\n\n.post--card {\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\t-webkit-box-shadow: 0 5px 20px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 20px rgba(105, 106, 119, .05)\n}\n\n.post--card .card-body h6 {\n\tmargin: 0 0 .66667rem 0\n}\n\n.post--card .card-body h6 a {\n\tcolor: #202428;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.post--card .card-body h6 a:hover {\n\tcolor: #413aa4\n}\n\n.post--card .card-body .post-meta {\n\tmargin-bottom: 1rem\n}\n\n.post--card .card-body .post-meta li {\n\tcolor: #9192a3;\n\tmargin-right: 1rem\n}\n\n.post--card .card-body .post-meta li:last-child {\n\tmargin-right: 0\n}\n\n.post--card .card-body p {\n\tmargin-bottom: 0\n}\n\n.post--card2 figure {\n\tpadding: 1.33333rem 1.33333rem 0;\n\tposition: relative\n}\n\n.post--card2 figure figcaption {\n\tposition: absolute;\n\tleft: 2.66667rem;\n\tbottom: 1.33333rem\n}\n\n.post--card2 figure figcaption a {\n\twidth: 2.66667rem;\n\theight: 2.66667rem;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tbackground: #e23636;\n\tcolor: #fff;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.post--card2 .card-body h5 {\n\tmargin-bottom: .66667rem\n}\n\n.post--card2 .card-body .post-meta {\n\tpadding-bottom: 1.33333rem;\n\tmargin-bottom: 1.33333rem;\n\tborder-bottom: 1px solid #e4e8ed;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.post--card2 .card-body .post-meta li a {\n\tcolor: #202428;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.post--card2 .card-body .post-meta li a:hover {\n\tcolor: #413aa4\n}\n\n.post--card2.post--card3 figure {\n\tpadding: 0\n}\n\n.post--card2.post--card3 figure figcaption {\n\tleft: 1.33333rem\n}\n\n.post--card2.post--card3 .card-body h6 {\n\tmargin-bottom: .66667rem;\n\tline-height: 1.86667rem\n}\n\n.post--card2.post--card3 .card-body .post-meta {\n\tpadding-bottom: 1.2rem;\n\tmargin-bottom: .8rem\n}\n\n.card--rounded {\n\t-webkit-border-radius: .53333rem;\n\tborder-radius: .53333rem\n}\n\n.card--team1,\n.card--team2,\n.card-style-eight .card--eight,\n.card-style-eleven .card--eleven,\n.card-style-fourteen .card--fourteen,\n.card-style-nine .card--nine,\n.card-style-seven .card--seven,\n.card-style-twelve .card-twelve,\n.card-style-two .card-two,\n.post--card1 .post--card {\n\tmargin-bottom: 2rem\n}\n\n.post--card4 {\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tborder: 0 none;\n\tmargin-bottom: 2rem\n}\n\n.post--card4:hover {\n\tborder: 0 none\n}\n\n.post--card4 .card-body .post-meta {\n\tmargin-bottom: 0\n}\n\n.divider h1,\n.divider h2 {\n\tmargin-bottom: .33333rem\n}\n\n.divider .divider-split {\n\tdisplay: inline-block;\n\twidth: 5.66rem;\n\theight: .33333rem;\n\tposition: relative\n}\n\n.divider .divider-split:before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 4rem;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tbackground: #413aa4;\n\t-webkit-border-radius: 3.33333rem;\n\tborder-radius: 3.33333rem\n}\n\n.divider .divider-split:after {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 1rem;\n\theight: 100%;\n\tright: 0;\n\ttop: 0;\n\tbackground: #413aa4;\n\t-webkit-border-radius: 3.33333rem;\n\tborder-radius: 3.33333rem\n}\n\n.divider .divider-straight {\n\tdisplay: inline-block;\n\twidth: 4.66rem;\n\theight: .33333rem;\n\tbackground: #413aa4;\n\t-webkit-border-radius: 50px;\n\tborder-radius: 50px\n}\n\n.divider .divider-line {\n\tdisplay: block;\n\theight: 1px;\n\tbackground: #e4e8ed\n}\n\n.divider p {\n\tmargin: 1rem 0 0 0;\n\tfont-size: 18px\n}\n\n.divider.text-center p {\n\tmax-width: 40rem\n}\n\n.divider.divider-light {\n\tmargin-bottom: 3.13333rem\n}\n\n.divider.divider-light .divider-split:before {\n\tbackground: #fff\n}\n\n.divider.divider-light .divider-split:after {\n\tbackground: #fff\n}\n\n.divider.divider-simple h3 {\n\tmargin-bottom: 1rem\n}\n\n.divider.divider-simple h2 {\n\tmargin-bottom: 1.33333rem\n}\n\n.section-title-simple {\n\twidth: 40rem;\n\tmargin: 0 auto;\n\ttext-align: center\n}\n\n.section-title-simple h1 {\n\tmargin-bottom: 20px\n}\n\n.subtext {\n\tfont-size: 1.33333rem;\n\tfont-weight: 600;\n\tdisplay: block;\n\tmargin-bottom: .33333rem\n}\n\n.section-title-primary {\n\ttext-align: center;\n\tmargin-bottom: 3rem\n}\n\n.section-title-primary h3 {\n\tcolor: #202428;\n\tmargin: 0 0 1rem;\n\tline-height: 2.93333rem\n}\n\n.section-title-primary p {\n\tcolor: #202428;\n\tmargin: 0\n}\n\n.flip-card {\n\tmargin-bottom: 2rem\n}\n\n.flip-card .flip-wrapper {\n\t-webkit-perspective: 1000px;\n\tperspective: 1000px;\n\t-webkit-transform: perspective(1000px);\n\ttransform: perspective(1000px);\n\t-webkit-transform-style: preserve-3d;\n\ttransform-style: preserve-3d;\n\tposition: relative;\n\twidth: 100%;\n\tmin-height: 22rem\n}\n\n.flip-card .flip-back,\n.flip-card .flip-front {\n\twidth: 100%;\n\theight: 100%;\n\t-webkit-border-radius: .33333rem;\n\tborder-radius: .33333rem;\n\t-webkit-box-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 10px rgba(105, 106, 119, .05)\n}\n\n.flip-card .flip-front {\n\t-webkit-transition: -webkit-transform .6s cubic-bezier(.5, .3, .3, 1);\n\ttransition: -webkit-transform .6s cubic-bezier(.5, .3, .3, 1);\n\t-o-transition: transform .6s cubic-bezier(.5, .3, .3, 1);\n\ttransition: transform .6s cubic-bezier(.5, .3, .3, 1);\n\ttransition: transform .6s cubic-bezier(.5, .3, .3, 1), -webkit-transform .6s cubic-bezier(.5, .3, .3, 1);\n\toverflow: hidden;\n\tposition: absolute;\n\ttop: 0;\n\t-webkit-backface-visibility: hidden;\n\tbackface-visibility: hidden;\n\t-webkit-filter: blur(0);\n\t-webkit-transform: rotateY(0);\n\ttransform: rotateY(0);\n\t-webkit-transform-style: preserve-3d;\n\ttransform-style: preserve-3d;\n\tz-index: 1\n}\n\n.flip-card .flip-back {\n\t-webkit-transition: -webkit-transform .6s cubic-bezier(.5, .3, .3, 1);\n\ttransition: -webkit-transform .6s cubic-bezier(.5, .3, .3, 1);\n\t-o-transition: transform .6s cubic-bezier(.5, .3, .3, 1);\n\ttransition: transform .6s cubic-bezier(.5, .3, .3, 1);\n\ttransition: transform .6s cubic-bezier(.5, .3, .3, 1), -webkit-transform .6s cubic-bezier(.5, .3, .3, 1);\n\toverflow: hidden;\n\tposition: absolute;\n\ttop: 0;\n\t-webkit-backface-visibility: hidden;\n\tbackface-visibility: hidden;\n\t-webkit-filter: blur(0);\n\t-webkit-transform: rotateY(180deg);\n\ttransform: rotateY(180deg);\n\t-webkit-transform-style: preserve-3d;\n\ttransform-style: preserve-3d;\n\tz-index: 1\n}\n\n.flip-card .flip-wrapper:hover .flip-front {\n\t-webkit-transform: rotateY(-180deg);\n\ttransform: rotateY(-180deg);\n\t-webkit-transform-style: preserve-3d;\n\ttransform-style: preserve-3d\n}\n\n.flip-card .flip-wrapper:hover .flip-back {\n\t-webkit-transform: rotateY(0);\n\ttransform: rotateY(0);\n\t-webkit-transform-style: preserve-3d;\n\ttransform-style: preserve-3d\n}\n\n.flip-card .flip-wrapper:hover .front-contents {\n\t-webkit-transform: translateY(-50%) translateX(-650px) scale(1);\n\t-ms-transform: translateY(-50%) translateX(-650px) scale(1);\n\ttransform: translateY(-50%) translateX(-650px) scale(1);\n\t-webkit-transform-style: preserve-3d;\n\ttransform-style: preserve-3d\n}\n\n.flip-card .flip-wrapper:hover .back-contents {\n\t-webkit-transform: translateY(-50%) translateX(0) translateZ(0) scale(1);\n\ttransform: translateY(-50%) translateX(0) translateZ(0) scale(1);\n\t-webkit-transform-style: preserve-3d;\n\ttransform-style: preserve-3d\n}\n\n.flip-card .back-contents,\n.flip-card .front-contents {\n\ttext-align: center;\n\tpadding: 0 3rem;\n\tposition: relative;\n\ttop: 50%;\n\t-webkit-transition: -webkit-transform .6s cubic-bezier(.5, .3, .3, 1);\n\ttransition: -webkit-transform .6s cubic-bezier(.5, .3, .3, 1);\n\t-o-transition: transform .6s cubic-bezier(.5, .3, .3, 1);\n\ttransition: transform .6s cubic-bezier(.5, .3, .3, 1);\n\ttransition: transform .6s cubic-bezier(.5, .3, .3, 1), -webkit-transform .6s cubic-bezier(.5, .3, .3, 1);\n\t-webkit-transform-style: preserve-3d;\n\ttransform-style: preserve-3d;\n\tz-index: 2\n}\n\n.flip-card .back-contents h6,\n.flip-card .front-contents h6 {\n\tline-height: 2rem;\n\tmargin-bottom: 1rem\n}\n\n.flip-card .front-contents {\n\t-webkit-transform: translateY(-50%) translateX(0) scale(1);\n\t-ms-transform: translateY(-50%) translateX(0) scale(1);\n\ttransform: translateY(-50%) translateX(0) scale(1)\n}\n\n.flip-card .front-contents span {\n\tfont-size: 4rem\n}\n\n.flip-card .back-contents {\n\t-webkit-transform: translateY(-50%) translateX(650px) translateZ(60px) scale(.88);\n\ttransform: translateY(-50%) translateX(650px) translateZ(60px) scale(.88)\n}\n\n.flip-card .back-contents p {\n\tcolor: rgba(255, 255, 255, .6)\n}\n\n.flip-card .back-contents .btn {\n\tmargin-top: 1.66rem\n}\n\n.flip-card .flip-overlay,\n.flip-card .flip-overlay2 {\n\tdisplay: block;\n\twidth: 100%;\n\theight: 100%;\n\tposition: absolute;\n\ttop: 0\n}\n\n.flip-card .flip-overlay {\n\tbackground: #fff\n}\n\n.icon-box span {\n\tfont-size: 2.66667rem;\n\tmargin-bottom: 1.33333rem;\n\tdisplay: inline-block;\n\tline-height: 1\n}\n\n.icon-box h6 {\n\tmargin-bottom: 1.13333rem\n}\n\n.icon-box p {\n\tmargin: 0\n}\n\n.icon-box-one,\n.icon-box-two {\n\tmargin-bottom: 3.33333rem\n}\n\n.icon-box-two h5 {\n\tfont-weight: 500\n}\n\n.icon-box-three {\n\tmargin-bottom: 2rem;\n\tbackground: #fff;\n\t-webkit-border-radius: .3rem;\n\tborder-radius: .3rem;\n\t-webkit-box-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\tpadding: 3rem 2rem;\n\tposition: relative\n}\n\n.icon-box-three:before {\n\tposition: absolute;\n\tcontent: \"\";\n\twidth: 100%;\n\theight: 3px;\n\tbackground: #413aa4;\n\tleft: 0;\n\tbottom: 0;\n\tmargin: 0;\n\tvisibility: hidden;\n\t-webkit-transition: .5s ease;\n\t-o-transition: .5s ease;\n\ttransition: .5s ease;\n\t-webkit-border-radius: 0 0 6px 6px;\n\tborder-radius: 0 0 6px 6px;\n\t-webkit-transform: scale(0);\n\t-ms-transform: scale(0);\n\ttransform: scale(0)\n}\n\n.icon-box-three:hover:before {\n\t-webkit-transform: scale(1);\n\t-ms-transform: scale(1);\n\ttransform: scale(1);\n\tvisibility: visible\n}\n\n.icon-box-three h6 {\n\tmargin-bottom: 1.13333rem\n}\n\n.icon-box-three p {\n\tmargin-bottom: 0\n}\n\n.icon-rounded-lg {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -webkit-inline-flex;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\twidth: 5.33333rem;\n\theight: 5.33333rem;\n\tbackground: #413aa4;\n\tfont-size: 2.4rem;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tcolor: #fff;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tmargin-bottom: 2rem\n}\n\n.icon-box-four {\n\tmargin-bottom: 3.33333rem\n}\n\n.icon-box-four .box-icon {\n\tmargin-right: 2rem\n}\n\n.icon-box-four .box-content h6 {\n\tmargin: 0 0 1.13333rem 0;\n\tcolor: #202428\n}\n\n.icon-box-four .box-content p {\n\tmargin: 0\n}\n\n.icon-box-four:hover .icon-rounded-sm {\n\tbackground: #06b590\n}\n\n.icon-rounded-sm,\n.icon-square-sm {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -webkit-inline-flex;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\twidth: 4rem;\n\theight: 4rem;\n\tbackground: #413aa4;\n\tfont-size: 2rem;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tcolor: #fff;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.icon-rounded-sm {\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tmargin-bottom: 1.33333rem\n}\n\n.icon-square-sm {\n\t-webkit-border-radius: 4px;\n\tborder-radius: 4px\n}\n\n.icon-box-five {\n\tpadding: 2.66rem;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.icon-box-five .icon-rounded-sm {\n\tbackground: #06b590\n}\n\n.icon-box-five h6 {\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tmargin-bottom: 1.13333rem;\n\tcolor: #202428\n}\n\n.icon-box-five p {\n\tmargin-bottom: 2.33rem\n}\n\n.icon-box-five:hover {\n\tbackground: #fff;\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .1)\n}\n\n.icon-box-five:hover .icon-rounded-sm {\n\tbackground: #413aa4\n}\n\n.icon-box-five:hover h5 {\n\tcolor: #413aa4\n}\n\n.icon-box-five:hover .btn:hover {\n\tbackground: #413aa4;\n\tborder-color: #413aa4\n}\n\n.icon-box-four h6 {\n\tcolor: #202428\n}\n\n.icon-box-four .icon-square-sm {\n\tmargin-bottom: 2.33rem\n}\n\n.icon-box-four:hover .icon-square-sm {\n\tbackground: #06b590\n}\n\n.icon-box-eight {\n\tmargin-bottom: 3.33333rem\n}\n\n.icon-box-eight h6 {\n\tmargin: 0 0 1.13333rem 0;\n\tcolor: #202428\n}\n\n.icon-box-eight .icon-square-sm {\n\tbackground: 0 0;\n\tborder: 1px solid #06b590;\n\tcolor: #06b590;\n\tmargin-bottom: 2.33rem\n}\n\n.icon-box-eight p {\n\tmargin-bottom: 0\n}\n\n.icon-box-eight:hover .icon-square-sm {\n\tbackground: #06b590;\n\tborder-color: #06b590;\n\tcolor: #fff\n}\n\n.icon-box-nine {\n\tmargin-bottom: 2rem;\n\tbackground: #fff;\n\t-webkit-border-radius: .3rem;\n\tborder-radius: .3rem;\n\t-webkit-box-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\tpadding: 2rem 1.5rem\n}\n\n.icon-box-nine .icon-rounded-sm {\n\tbackground: 0 0;\n\tborder: 1px solid rgba(6, 181, 144, .2);\n\tcolor: #06b590\n}\n\n.icon-box-nine h6 {\n\tmargin: 0\n}\n\n.icon-box-nine p {\n\tmargin: 1rem 0 0 0\n}\n\n.icon-box-nine:hover .icon-rounded-sm {\n\tbackground: #06b590;\n\tborder-color: #06b590;\n\tcolor: #fff\n}\n\n.icon-box-img {\n\tborder: 1px solid #e4e8ed;\n\tpadding: 3rem 2rem;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tmargin-bottom: 2rem\n}\n\n.icon-box-img .svg {\n\twidth: 5.33333rem;\n\tmargin-bottom: 1.33rem\n}\n\n.icon-box-img h6 {\n\tmargin-bottom: 1.13333rem\n}\n\n.icon-box-img p {\n\tmargin-bottom: 0\n}\n\n.icon-box-img h6,\n.icon-box-img p {\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.icon-box-img:hover {\n\t-webkit-box-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 10px rgba(105, 106, 119, .05)\n}\n\n.icon-box-img2 {\n\tmargin-bottom: 5.33rem\n}\n\n.icon-box-img2 .box-icon {\n\tmargin-right: 2rem\n}\n\n.icon-box-img2 .box-icon .svg {\n\twidth: 4.66667rem\n}\n\n.icon-box-img2 .box-content h6 {\n\tmargin: 0 0 1.13333rem 0\n}\n\n.icon-box-img2 .box-content p {\n\tmargin: 0\n}\n\n.icon-box-rtl {\n\tmargin-bottom: 4rem\n}\n\n.icon-box-rtl .box-icon {\n\tmargin-left: 2rem\n}\n\n.icon-box-rtl h5 {\n\tmargin-bottom: 1.13333rem\n}\n\n.icon-box-rtl:hover .icon-square-sm {\n\tbackground: #06b590\n}\n\n.icon-box-13 {\n\tmargin-bottom: 2rem;\n\tpadding: 3.33333rem;\n\tborder: 1px solid #e4e8ed\n}\n\n.icon-box-13>span {\n\tfont-size: 3.2rem\n}\n\n.icon-box-fourteen {\n\tmargin-bottom: 2rem\n}\n\n.icon-box-fourteen .icon-rounded {\n\tfont-size: 2.4rem;\n\twidth: 4.66667rem;\n\theight: 4.66667rem;\n\t-webkit-border-radius: 1.6rem;\n\tborder-radius: 1.6rem;\n\tcolor: #fff;\n\tdisplay: -webkit-inline-box;\n\tdisplay: -webkit-inline-flex;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\tmargin-bottom: 2rem;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.icon-box-fourteen:hover .icon-rounded {\n\tbackground: #413aa4 !important\n}\n\n.icon-box-15 {\n\tborder: 1px solid #e4e8ed;\n\tpadding: 3.33333rem 1.86667rem;\n\tbackground: #fff;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tmargin-bottom: 2rem\n}\n\n.icon-box-15 img {\n\tmargin-bottom: 2.66667rem\n}\n\n.icon-box-15 h6 {\n\tcolor: #202428;\n\tmargin-bottom: 1.33333rem\n}\n\n.icon-box-15:hover {\n\tborder-color: transparent;\n\t-webkit-box-shadow: 0 10px 30px rgba(105, 106, 119, .15);\n\tbox-shadow: 0 10px 30px rgba(105, 106, 119, .15);\n\tmargin-top: -5px;\n\tmargin-bottom: 5px\n}\n\nul {\n\tmargin: 0\n}\n\n.list-item {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: start;\n\t-webkit-align-items: flex-start;\n\t-ms-flex-align: start;\n\talign-items: flex-start\n}\n\n.arrow-list1 {\n\tfont-weight: 500;\n\tmargin-bottom: .45rem;\n\tvertical-align: middle\n}\n\n.arrow-list1:last-child {\n\tmargin-bottom: 0\n}\n\n.arrow-list1:before {\n\tcontent: \"\\f121\";\n\tfont-family: Lineawesome, sans-serif;\n\tmargin-right: 10px\n}\n\n.arrow-list2,\n.arrow-list3,\n.arrow-list5 {\n\tmargin-bottom: .8rem\n}\n\n.arrow-list2:last-child,\n.arrow-list3:last-child,\n.arrow-list5:last-child {\n\tmargin-bottom: 0\n}\n\n.arrow-list2 span,\n.arrow-list3 span,\n.arrow-list5 span {\n\twidth: 1.4rem;\n\theight: 1.4rem;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tdisplay: -webkit-inline-box;\n\tdisplay: -webkit-inline-flex;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\tfont-size: .66667rem;\n\tmargin-right: .86rem;\n\tcolor: #413aa4\n}\n\n.arrow-list2 span,\n.arrow-list5 span {\n\tbackground: rgba(65, 58, 164, .1)\n}\n\n.arrow-list3 span {\n\tbackground: #413aa4;\n\tcolor: #fff\n}\n\n.arrow-list4 {\n\tmargin-bottom: .66rem;\n\tposition: relative;\n\tpadding-left: 18px\n}\n\n.arrow-list4:before {\n\tposition: absolute;\n\tcontent: '\\f186';\n\tfont-family: LineAwesome;\n\tleft: 0;\n\ttop: 2px;\n\tfont-size: .8rem\n}\n\n.arrow-list4:last-child {\n\tmargin-bottom: 0\n}\n\n.arrow-list4 span {\n\tcolor: #9192a3;\n\tpadding-right: .33333rem\n}\n\n.arrow-list5 {\n\tfont-weight: 500\n}\n\n.content-list {\n\tmargin-bottom: 2.66667rem\n}\n\n.content-list:last-child {\n\tmargin-bottom: 0\n}\n\n.content-list .icon {\n\tmargin-right: 1rem;\n\tfont-size: 2rem;\n\tline-height: 1\n}\n\n.content-list h6 {\n\tmargin-bottom: .46667rem\n}\n\n.content-list p {\n\tmargin-bottom: 0\n}\n\n.content-list .icon-circle {\n\tmargin-right: 2rem\n}\n\n.content-list .icon-circle span {\n\twidth: 4rem;\n\theight: 4rem;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tbackground: #f5f4f7;\n\tfont-size: 1.73rem;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.content-list:hover .icon-circle span {\n\tbackground: #06b590;\n\tcolor: #fff\n}\n\n.icon-light {\n\tmargin-bottom: 0\n}\n\n.icon-light .content-list .icon-circle span {\n\tcolor: #fff\n}\n\n.icon-light .content-list:hover .icon-circle span {\n\tbackground: #06b590;\n\tcolor: #fff\n}\n\n.text-list {\n\tmargin-bottom: 2rem\n}\n\n.text-list:last-child {\n\tmargin-bottom: 0\n}\n\n.text-list h5,\n.text-list h6 {\n\tcolor: #202428;\n\tmargin-bottom: 1.2rem\n}\n\n.text-list p {\n\tmargin-bottom: 0\n}\n\n.text-list .sub-text {\n\tfont-size: 1.2rem;\n\tfont-weight: 400;\n\tdisplay: block;\n\tmargin-bottom: .66rem\n}\n\n.image-list {\n\tmargin-bottom: 2.33333rem\n}\n\n.image-list:last-child {\n\tmargin-bottom: 0\n}\n\n.image-list .img {\n\tmargin-right: 1.66rem\n}\n\n.image-list .img img {\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%\n}\n\n.image-list h6 {\n\tmargin-bottom: .66rem;\n\tcolor: #202428\n}\n\n.image-list .sub-text {\n\tmargin-bottom: 1rem;\n\tdisplay: block;\n\tcolor: #9192a3\n}\n\n.image-list p {\n\tmargin: 0\n}\n\n.bullet_list {\n\tposition: relative;\n\tpadding-left: 1.66rem;\n\tmargin-bottom: .66rem\n}\n\n.bullet_list:last-child {\n\tmargin-bottom: 0\n}\n\n.bullet_list:before {\n\tposition: absolute;\n\tcontent: \"\";\n\twidth: 7px;\n\theight: 7px;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tleft: 0;\n\ttop: 6px\n}\n\n.bullet_list strong {\n\tfont-weight: 500\n}\n\n.bullet_list p {\n\tmargin: 0\n}\n\n.bullet_list.bullet_list--three {\n\tmargin-bottom: 1.66667rem\n}\n\n.bullet_list.bullet_list--three:last-child {\n\tmargin-bottom: 0\n}\n\n.checklist {\n\tmargin-bottom: .66667rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.checklist:last-child {\n\tmargin-bottom: 0\n}\n\n.checklist span {\n\tfont-size: 1rem;\n\tfont-weight: 700;\n\tmargin-right: .93rem\n}\n\n.checklist.checklist-light {\n\tcolor: #fff;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.checklist.checklist-light .svg {\n\twidth: 1.2rem;\n\tfill: #fff\n}\n\n.checklist.checklist-light span {\n\tfont-weight: 400;\n\tmargin-left: .8rem\n}\n\n.blog-carousel-one .post-single .post-bottom a.checklist.checklist-light .svg,\n.card .card-body h6 a.checklist.checklist-light .svg,\n.card--eight .card-body h5 a.checklist.checklist-light .svg,\n.card--ten .card-body h6 a.checklist.checklist-light .svg,\n.checklist.checklist-light.color-dark .svg,\n.counter.counter--5 .counter_single .checklist.checklist-light.title .svg,\n.tab.tab--1 .tab_nav .nav .checklist.checklist-light.nav-link .svg,\nfooter.footer2 .widget.twit--widget a.checklist.checklist-light:hover .svg {\n\tfill: #202428\n}\n\n.checklist .svg {\n\tmargin-right: 8px;\n\twidth: .8rem\n}\n\n@media all and (-ms-high-contrast:none),\n(-ms-high-contrast:active) {\n\t.checklist .svg {\n\t\theight: 12px\n\t}\n}\n\n.checklist.icon-primary .svg .st0 {\n\tfill: #413aa4\n}\n\n.checklist.icon-secondary .svg .st0 {\n\tfill: #06b590\n}\n\n.checklist.icon-light .svg .st0 {\n\tfill: #fff\n}\n\n.checklist.icon-dark .svg .st0 {\n\tfill: #202428\n}\n\n.checklist-three {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin-bottom: .66667rem;\n\tfont-weight: 500\n}\n\n.checklist-three:last-child {\n\tmargin-bottom: 0\n}\n\n.checklist-three .svg {\n\twidth: .8rem\n}\n\n@media all and (-ms-high-contrast:none),\n(-ms-high-contrast:active) {\n\t.checklist-three .svg {\n\t\theight: 12px\n\t}\n}\n\n.checklist-three .svg .st0 {\n\tfill: #06b590\n}\n\n.checklist-three span {\n\tmargin-left: .66667rem\n}\n\n.checklist-three.checklist-light span {\n\tcolor: #fff;\n\tfont-weight: 400\n}\n\n.checklist-three.checklist-light .svg .st0 {\n\tfill: #fff\n}\n\n.icon-list {\n\tmargin-bottom: 1rem\n}\n\n.icon-list:last-child {\n\tmargin-bottom: 0\n}\n\n.icon-list span {\n\tfont-size: 1.33rem;\n\tpadding-right: .66rem;\n\tline-height: 0\n}\n\n.icon-list strong {\n\tfont-weight: 500;\n\tcolor: #202428;\n\tmargin-right: 1rem\n}\n\n.icon-list.list-light {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\n.icon-list.list-light strong {\n\tcolor: #fff\n}\n\n.icon-list2 {\n\tmargin-bottom: 2rem\n}\n\n.icon-list2:last-child {\n\tmargin-bottom: 0\n}\n\n.icon-list2 .icon {\n\tfont-size: 1.8rem;\n\tline-height: 1;\n\tmargin-right: 1rem\n}\n\n.icon-list2 h6 {\n\tmargin-bottom: .6rem;\n\tcolor: #202428;\n\tfont-weight: 500;\n\tfont-size: 1.13333rem\n}\n\n.icon-list2 .sub-text {\n\tcolor: #9192a3\n}\n\n.icon-list2.list-light h6 {\n\tcolor: #fff\n}\n\n.icon-list--two .icon-list {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex\n}\n\n.number-list {\n\tlist-style: none;\n\tcounter-reset: li;\n\tpadding: 0\n}\n\n.number-list li {\n\tcounter-increment: li;\n\tmargin-bottom: .66rem;\n\tposition: relative;\n\tpadding-left: 2rem\n}\n\n.number-list li:last-child {\n\tmargin-bottom: 0\n}\n\n.number-list li:before {\n\tcontent: counter(li);\n\tdisplay: inline-block;\n\twidth: 1em;\n\ttext-align: right;\n\tdirection: rtl;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tfont-weight: 500\n}\n\n.number-list li.numbers-decimal-zero:before {\n\tcontent: counter(li, decimal-leading-zero);\n\tcolor: #202428\n}\n\n.number-list li.numbers-decimal-zero.list-light:before {\n\tcolor: #fff\n}\n\n.number-list li.numbers-roman:before {\n\tcontent: counter(li, lower-roman)\n}\n\n.number-list li.list-light {\n\tcolor: rgba(255, 255, 255, .7)\n}\n\n.process-list {\n\tmargin: 0\n}\n\n.process-list li {\n\tmargin-bottom: 2rem\n}\n\n.process-list li:last-child {\n\tmargin-bottom: 0\n}\n\n.process-list li:last-child .number span:before {\n\tcontent: none\n}\n\n.process-list li:hover .number span {\n\tbackground: #06b590;\n\tcolor: #fff\n}\n\n.process-list .number {\n\tmargin-right: 2rem\n}\n\n.process-list .number.gray-bg span {\n\tbackground: rgba(6, 181, 144, .1)\n}\n\n.process-list .number span {\n\twidth: 4.53333rem;\n\theight: 4.53333rem;\n\tbackground: #fff;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\tfont-size: 1.6rem;\n\tfont-weight: 600;\n\tcolor: #06b590;\n\tposition: relative;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.process-list .content h6 {\n\tmargin-bottom: .66667rem;\n\tcolor: #202428;\n\tfont-weight: 600\n}\n\n.process-list .content p {\n\tmargin: 0\n}\n\n.list-inline-wrapper {\n\t-webkit-box-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\tbox-shadow: 0 5px 30px rgba(41, 41, 59, .1)\n}\n\n.list-inline-wrapper .list--inline {\n\tmargin: 0;\n\t-webkit-box-pack: justify;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: justify;\n\tjustify-content: space-between;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.list-inline-wrapper .list--inline li {\n\tmargin-bottom: 2rem;\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.list-inline-wrapper .list--inline li .icon {\n\tmargin-right: 1rem\n}\n\n.list-inline-wrapper .list--inline li .icon span {\n\tfont-size: 3.33333rem;\n\tdisplay: block;\n\tline-height: 2rem\n}\n\n.list-inline-wrapper .list--inline li .contents h6 {\n\tfont-weight: 600;\n\tcolor: #202428;\n\tmargin: 0 0 5px\n}\n\n.list-count {\n\tmargin-bottom: 1rem\n}\n\n.list-count:last-child {\n\tmargin-bottom: 0\n}\n\n.list-count span {\n\tcolor: #202428;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.list-count .count {\n\tmin-width: 3rem;\n\theight: 1.66667rem;\n\t-webkit-border-radius: 1.66667rem;\n\tborder-radius: 1.66667rem;\n\tbackground: #f5f7fc;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.list-count a:hover span {\n\tcolor: #413aa4\n}\n\n.list-count a:hover .count {\n\tcolor: #fff;\n\tbackground: #413aa4\n}\n\n.progress-wrapper {\n\tmargin-bottom: 2rem\n}\n\n.progress-wrapper:last-child {\n\tmargin-bottom: 0\n}\n\n.progress-wrapper .labels {\n\tmargin-bottom: .66rem\n}\n\n.progress-wrapper .labels span {\n\tcolor: #202428\n}\n\n.progress-wrapper .labels span:last-child {\n\tfont-weight: 600\n}\n\n.progress-wrapper .progress {\n\t-webkit-box-shadow: none;\n\tbox-shadow: none\n}\n\n.progress-wrapper .progress .progress-bar {\n\t-webkit-border-radius: .25rem;\n\tborder-radius: .25rem\n}\n\n.progress-dark {\n\tpadding: 2.33rem 2.66rem;\n\tbackground: #202428\n}\n\n.progress-dark .labels span {\n\tcolor: #fff\n}\n\n.progress-dark .progress {\n\tbackground: #414144\n}\n\n.pagination-area .pagination .page-item:first-child .page-link,\n.pagination-area .pagination .page-item:last-child .page-link {\n\tcolor: #5a6671\n}\n\n.pagination-area .pagination .page-item:first-child .page-link {\n\t-webkit-border-top-left-radius: .2rem;\n\tborder-top-left-radius: .2rem;\n\t-webkit-border-bottom-left-radius: .2rem;\n\tborder-bottom-left-radius: .2rem\n}\n\n.pagination-area .pagination .page-item:last-child .page-link {\n\t-webkit-border-top-right-radius: .2rem;\n\tborder-top-right-radius: .2rem;\n\t-webkit-border-bottom-right-radius: .2rem;\n\tborder-bottom-right-radius: .2rem\n}\n\n.pagination-area .pagination .page-item.active .page-link {\n\tcolor: #fff;\n\tbackground: #413aa4;\n\tborder-color: #413aa4\n}\n\n.pagination-area .pagination .page-item.active .page-link:hover {\n\tbackground: #413aa4\n}\n\n.pagination-area .pagination .page-link {\n\tcolor: #202428\n}\n\n.pagination-area .pagination .page-link:hover {\n\tbackground: #fff;\n\tborder-color: #413aa4\n}\n\n.pagination-area .pagination .page-link:focus {\n\t-webkit-box-shadow: none;\n\tbox-shadow: none\n}\n\n.pagination-area .pagination.pagination-rounded .page-item {\n\tmargin-right: .66rem\n}\n\n.pagination-area .pagination.pagination-rounded .page-item:last-child {\n\tmargin-right: 0\n}\n\n.pagination-area .pagination.pagination-rounded .page-link {\n\t-webkit-border-radius: 50% !important;\n\tborder-radius: 50% !important;\n\twidth: 2.66667rem;\n\theight: 2.66667rem;\n\tpadding: 0;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.table-styles {\n\tbackground: #f4f4f4\n}\n\n.table-secondary--darken {\n\tbackground: #06b590\n}\n\n.table-secondary--darken th,\n.table-secondary--darken tr {\n\tcolor: #fff\n}\n\n.table {\n\tmargin-bottom: 0\n}\n\n.table td,\n.table th {\n\tpadding: 1.33333rem 2rem;\n\tvertical-align: middle\n}\n\n.table th {\n\tfont-weight: 500\n}\n\n.table thead th {\n\tborder: 0 none\n}\n\n.table tbody {\n\tbackground: #fff\n}\n\n.table tbody th {\n\tcolor: #202428\n}\n\n.table.table-one {\n\tborder: 1px solid #e4e8ed\n}\n\n.table.table-two thead th {\n\tfont-size: 1.2rem;\n\tcolor: #202428\n}\n\n.table.table-two tbody tr:first-child td,\n.table.table-two tbody tr:first-child th {\n\tborder-top: 0 none\n}\n\n.table.table-two tbody tr:last-child td,\n.table.table-two tbody tr:last-child th {\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.table.table-two tbody th {\n\tpadding: 1.66rem 1.66rem 1.66rem 0\n}\n\n.table .table-gray {\n\tbackground: #f5f5f7\n}\n\n.line-chart_wrap h6 {\n\tfont-weight: 600;\n\tcolor: #202428;\n\tmargin-bottom: 2.66667rem\n}\n\n.legend ul {\n\tmargin-top: 1.33333rem;\n\tmargin-bottom: 0\n}\n\n.legend ul li {\n\tdisplay: inline-block;\n\tmargin-right: 1.33333rem\n}\n\n.legend ul li:last-child {\n\tmargin-right: 0\n}\n\n.legend ul li span {\n\twidth: .8rem;\n\theight: .8rem;\n\tdisplay: inline-block;\n\t-webkit-border-radius: 2px;\n\tborder-radius: 2px;\n\tmargin-right: .46667rem\n}\n\n.legend.legend-list {\n\tposition: absolute;\n\tright: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.legend.legend-list ul li {\n\tdisplay: block\n}\n\n.pie-chart {\n\tposition: relative\n}\n\n.block-full-width,\n.block-full-width2 {\n\tmin-height: 37.66667rem;\n\tposition: relative;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tbackground: #f2f2f2\n}\n\n@media all and (-ms-high-contrast:none),\n(-ms-high-contrast:active) {\n\n\t.block-full-width,\n\t.block-full-width2 {\n\t\tpadding-top: 30px\n\t}\n}\n\n.block-full-width .img,\n.block-full-width2 .img {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 50%;\n\theight: 100%\n}\n\n.block-full-width2 {\n\tbackground: 0 0\n}\n\n.block-full-width2 .img {\n\tposition: absolute;\n\tright: 0;\n\tleft: auto;\n\ttop: 0;\n\twidth: 50%;\n\theight: 100%\n}\n\n.feature-boxes .icon-box-nine {\n\tmargin-bottom: 2rem\n}\n\n.section-feature-boxes {\n\toverflow: hidden\n}\n\n.section-feature-boxes .container {\n\tposition: relative\n}\n\n.section-feature-boxes .section-img {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.section-feature-boxes .feature-boxes {\n\tmargin-bottom: -30px\n}\n\n.content--block3 .content_block3_wrapper {\n\tpadding-bottom: 4.66667rem\n}\n\n.content--block3 .content_block3_wrapper:last-child {\n\tpadding-bottom: 0\n}\n\n.content--block3 .content_block3_wrapper+.content_block3_wrapper {\n\tpadding-top: 4.66667rem\n}\n\n.content--block3 .content_block3_wrapper:nth-child(2n+2) {\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: reverse;\n\t-webkit-flex-direction: row-reverse;\n\t-ms-flex-direction: row-reverse;\n\tflex-direction: row-reverse\n}\n\n@media (min-width:992px) {\n\t.content--block3 .content_block3_wrapper:nth-child(2n+2) .offset-lg-1 {\n\t\tmargin-left: 0;\n\t\tmargin-right: 8.33333%\n\t}\n}\n\n.content--block3 .content_block3_wrapper+.content_block3_wrapper {\n\tborder-top: 1px solid #e4e8ed\n}\n\n.content--block3 h4 {\n\tcolor: #202428\n}\n\n.content-block--12 {\n\tposition: relative\n}\n\n.content-block--12 .counter-wrapper {\n\tposition: relative\n}\n\n.content-block--12 .counter-wrapper .counter--alt {\n\tpadding: 6.06667rem 0 11.33333rem\n}\n\n.content-block--12 .clients-logo {\n\tpadding: 13.33333rem 0 6.66667rem\n}\n\n.content-block--12 .highlighted-text {\n\tposition: absolute;\n\twidth: 100%;\n\tleft: 0;\n\tbottom: 0;\n\t-webkit-transform: translateY(50%);\n\t-ms-transform: translateY(50%);\n\ttransform: translateY(50%);\n\tz-index: 1\n}\n\n.content-block--12 .highlighted-text .content {\n\tbackground: #fff;\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tmin-height: 14.66667rem;\n\tpadding: 0 6.66667rem\n}\n\n@media all and (-ms-high-contrast:none),\n(-ms-high-contrast:active) {\n\t.content-block--12 .highlighted-text .content {\n\t\theight: 220px\n\t}\n}\n\n.content-block--12 .highlighted-text .content p {\n\tfont-size: 1.6rem;\n\tline-height: 2.93333rem;\n\tcolor: #202428;\n\tfont-weight: 600;\n\tmargin-bottom: 0\n}\n\n.content-block--15 {\n\tpadding: 6.8rem 0 7.33333rem;\n\tbackground: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f8f7fd));\n\tbackground: -webkit-linear-gradient(top, #fff, #f8f7fd);\n\tbackground: -o-linear-gradient(top, #fff, #f8f7fd);\n\tbackground: linear-gradient(to bottom, #fff, #f8f7fd)\n}\n\n.content-block--15 .section-title {\n\ttext-align: center;\n\tmargin-bottom: 2.33333rem\n}\n\n.content-block--15 .section-title h2 {\n\tcolor: #202428\n}\n\n.content-block--15 .section-title p {\n\tcolor: #202428\n}\n\n.content-block--15 .content-desc h4 {\n\tcolor: #202428\n}\n\n.content-block--6 {\n\tbackground: #fff\n}\n\n.content--block8 h4 {\n\tmargin-bottom: 20px\n}\n\n.section_title h1 {\n\tfont-weight: 600;\n\tmargin-bottom: 3.46667rem\n}\n\n.section_title .section_title_underline {\n\twidth: 70px;\n\tbackground: #413aa4;\n\tdisplay: inline-block;\n\theight: 5px;\n\t-webkit-border-radius: 10px;\n\tborder-radius: 10px\n}\n\n.contact-split {\n\tposition: relative;\n\theight: 720px\n}\n\n.contact-split .g-maps {\n\tposition: absolute;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\twidth: 50%\n}\n\n.contact-split .g-maps #map2 {\n\theight: 100%\n}\n\n.contact-split .g-maps .map-top {\n\tposition: absolute;\n\tright: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tbackground: #fff;\n\tpadding: 55px 40px;\n\t-webkit-border-radius: 8px 0 0 8px;\n\tborder-radius: 8px 0 0 8px;\n\t-webkit-box-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\tbox-shadow: 0 5px 30px rgba(41, 41, 59, .1)\n}\n\n.contact-split .g-maps .map-top ul {\n\tmargin: 0\n}\n\n.filter-wrapper .filter-sort {\n\tmargin-bottom: 50px;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center\n}\n\n.filter-wrapper .filter-sort ul {\n\tdisplay: inline-block;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\tbackground: #fff;\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\t-webkit-border-radius: 1.66667rem;\n\tborder-radius: 1.66667rem;\n\tmargin: 0\n}\n\n.filter-wrapper .filter-sort ul li {\n\tfloat: left;\n\tcolor: #202428;\n\tfont-weight: 400;\n\tline-height: 3.33333rem;\n\tpadding: 0 1.66667rem;\n\tcursor: pointer;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\t-webkit-border-radius: 1.66667rem;\n\tborder-radius: 1.66667rem\n}\n\n.filter-wrapper .filter-sort ul li.active,\n.filter-wrapper .filter-sort ul li:hover {\n\tcolor: #fff\n}\n\n.filter-wrapper .filter-sort2 ul {\n\tpadding-bottom: 1.33333rem;\n\tmargin-bottom: 3.33333rem;\n\tborder-bottom: 1px solid #e4e8ed;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center\n}\n\n.filter-wrapper .filter-sort2 ul li {\n\tmargin-right: 2.33333rem;\n\tcolor: #202428;\n\tfont-weight: 500;\n\tcursor: pointer;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.filter-wrapper .filter-sort2 ul li.active,\n.filter-wrapper .filter-sort2 ul li:hover {\n\tcolor: #06b590\n}\n\n.filter-wrapper .filter-sort2 ul li:last-child {\n\tmargin-right: 0\n}\n\n.event-single {\n\tmargin-bottom: 130px;\n\theight: 13.33333rem;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .05)\n}\n\n.event-single .event-date {\n\twidth: 15.33333rem;\n\t-webkit-align-self: stretch;\n\t-ms-flex-item-align: stretch;\n\talign-self: stretch;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.event-single .event-date h1 {\n\tcolor: #fff;\n\tmargin-bottom: 0\n}\n\n.event-single .event-date .month {\n\tfont-size: 1.2rem;\n\tcolor: #fff\n}\n\n.event-single .event-date .year {\n\tdisplay: block;\n\tfont-size: 2rem;\n\tfont-weight: 600;\n\tcolor: #fff\n}\n\n.event-single .event-info {\n\tpadding: 2.33333rem 2.66667rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tbackground-color: #fff;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-flex: 3;\n\t-webkit-flex: 3;\n\t-ms-flex: 3;\n\tflex: 3;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.event-single .event-info h5 {\n\tmargin-bottom: 1rem\n}\n\n.event-single .event-info h5 a {\n\tcolor: #202428;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.event-single .event-info h5 a:hover {\n\tcolor: #413aa4\n}\n\n.event-single .event-info .view-btn {\n\tmargin-left: auto\n}\n\n.social ul li {\n\tmargin-right: .66667rem\n}\n\n.social ul li:last-child {\n\tmargin-right: 0\n}\n\n.social ul li a {\n\tline-height: 2.53333rem;\n\twidth: 2.53333rem;\n\tdisplay: inline-block;\n\ttext-align: center;\n\t-webkit-border-radius: 33.33333rem;\n\tborder-radius: 33.33333rem;\n\tbackground: #29292d;\n\tcolor: #fff\n}\n\n.social ul li a span {\n\tfont-size: .86667rem\n}\n\n.social ul li a:hover {\n\tbackground-color: #413aa4;\n\tcolor: #fff\n}\n\n.social.social--small ul li a {\n\tline-height: 2.53333rem;\n\twidth: 2.53333rem;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.social.social--small ul li a span {\n\tcolor: #fff;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.social.social--small ul li a:hover span {\n\tcolor: #fff\n}\n\n.social.square ul li a {\n\t-webkit-border-radius: 0;\n\tborder-radius: 0;\n\tbackground: 0 0;\n\tborder: 1px solid #e4e8ed\n}\n\n.social.social--gray ul li a {\n\tbackground: #f5f4f7 !important;\n\tcolor: #5a6671\n}\n\n.social.social--gray ul li a span {\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tcolor: #9192a3\n}\n\n.social.social--gray ul li a:hover {\n\tcolor: #fff;\n\tbackground: #413aa4\n}\n\n.social.social--gray ul li a:hover span {\n\tcolor: #fff\n}\n\n.social.social--colored ul li a.facebook {\n\tbackground: #3b5998\n}\n\n.social.social--colored ul li a.twitter {\n\tbackground: #47adfa\n}\n\n.social.social--colored ul li a.linkedin {\n\tbackground: #0677b4\n}\n\n.social.social--colored ul li a.gplus {\n\tbackground: #dd4b39\n}\n\n.social.social--colored ul li a.pinterest {\n\tbackground: #bc091b\n}\n\n.social-basic ul li {\n\tmargin-right: 1.66667rem\n}\n\n.social-basic ul li:last-child {\n\tmargin-right: 0\n}\n\n.social-basic ul li a {\n\tcolor: rgba(32, 36, 40, .5);\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.social-basic ul li a:hover {\n\tcolor: #06b590\n}\n\n.social-basic .rounded-circle li {\n\tmargin-right: .66667rem\n}\n\n.social-basic .rounded-circle li a {\n\twidth: 2.13333rem;\n\theight: 2.13333rem;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tbackground: #fff;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\tfont-size: .8rem;\n\tcolor: rgba(90, 102, 113, .6)\n}\n\n.social-basic.icon-light li a {\n\tbackground: #fff;\n\tcolor: rgba(90, 102, 113, .6)\n}\n\n.social-basic.icon-light li a:hover {\n\tbackground: #413aa4;\n\tcolor: #fff\n}\n\n.social-basic.icon-grey li a {\n\tbackground: rgba(65, 58, 164, .06)\n}\n\n.social-basic.icon-grey li a:hover {\n\tbackground: #413aa4;\n\tcolor: #fff\n}\n\n.social-btns {\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.social-btns li {\n\tmargin-right: 1.33333rem\n}\n\n.social-btns li:last-child {\n\tmargin-right: 0\n}\n\n.social-btns .btn {\n\tcolor: #fff\n}\n\n.social-btns .btn span {\n\tpadding-right: .53333rem\n}\n\n.social-btns .btn-facebook {\n\tbackground: #3b5998\n}\n\n.social-btns .btn-twitter {\n\tbackground: #47adfa\n}\n\n.social-btns .btn-linkedin {\n\tbackground: #0677b4\n}\n\n.social-btns .btn-gplus {\n\tbackground: #dd4b39\n}\n\n.shadow-lg-2 {\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .1) !important;\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .1) !important\n}\n\n.shadow_lg--bgwhite {\n\t-webkit-box-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\tbox-shadow: 0 5px 30px rgba(41, 41, 59, .1)\n}\n\n.shadow_lg2--bgwhite {\n\t-webkit-box-shadow: 0 10px 30px rgba(41, 41, 59, .1);\n\tbox-shadow: 0 10px 30px rgba(41, 41, 59, .1)\n}\n\n.top_bar {\n\tmin-height: 3.33333rem\n}\n\n.top_bar .infos .infos--single+.infos--single {\n\tmargin-left: 2rem\n}\n\n.top_bar .infos .infos--single span {\n\tcolor: #413aa4;\n\tfont-size: 1.8rem;\n\tmargin-right: 11px;\n\tmargin-top: 3px\n}\n\n.top_bar .infos .infos--single .info {\n\tline-height: 1.7rem\n}\n\n.top_bar .infos .infos--single .info p {\n\tmargin: 0;\n\tfont-size: 1.1rem;\n\tfont-weight: 500;\n\tcolor: #202428\n}\n\n.top_bar .infos .infos--single .info small {\n\tfont-size: 15px;\n\tcolor: #9192a3\n}\n\n.top_bar ul {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0\n}\n\n.top_bar .top_bar--lang {\n\tcursor: pointer\n}\n\n.top_bar .top_bar--lang .dropdown .dropdown-menu {\n\tmin-width: 150px\n}\n\n.top_bar .top_bar--lang .dropdown .lang_flag {\n\tmargin: 0 10px\n}\n\n.top_bar .top_bar--lang .dropdown .dropdown-item img {\n\tmargin-right: 12px\n}\n\n.top_bar .top_bar--lang .dropdown .lang {\n\tcolor: rgba(255, 255, 255, .6);\n\ttext-transform: uppercase\n}\n\n.top_bar .top_bar--lang .dropdown span.la {\n\tcolor: rgba(255, 255, 255, .6);\n\tfont-size: .86667rem\n}\n\n.top_bar .top_bar--info li {\n\tdisplay: inline-block;\n\tcolor: rgba(255, 255, 255, .8)\n}\n\n.top_bar .top_bar--info li span {\n\tmargin-right: 8px;\n\tfont-size: 20px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tcolor: rgba(255, 255, 255, .6)\n}\n\n.top_bar .top_bar--info li p {\n\tdisplay: inline-block;\n\tmargin: 0;\n\tvertical-align: middle;\n\tcolor: rgba(255, 255, 255, .6)\n}\n\n.top_bar .top_bar--info li+li {\n\tmargin-left: 2rem\n}\n\n.top_bar .top_bar--social ul li {\n\tdisplay: inline-block;\n\tline-height: 3.6rem;\n\tborder-left: 1px solid rgba(255, 255, 255, .1)\n}\n\n.top_bar .top_bar--social ul li:last-child {\n\tborder-right: 1px solid rgba(255, 255, 255, .1)\n}\n\n.top_bar .top_bar--social ul li a {\n\tcolor: rgba(255, 255, 255, .6);\n\tfont-size: 15px;\n\tpadding: 0 20px\n}\n\n.top_bar .top_bar--social ul li a:hover {\n\tcolor: #fff\n}\n\n.top_bar.top--bar2 .top_bar--info li {\n\tcolor: rgba(255, 255, 255, .3)\n}\n\n.top_bar.top--bar2 .top_bar--social ul li {\n\tborder: 0\n}\n\n.top_bar.top--bar2 .top_bar--social ul li a {\n\tpadding: 0 11px;\n\tcolor: rgba(255, 255, 255, .6)\n}\n\n.top_bar.top--bar2 .top_bar--social ul li a:hover {\n\tcolor: #fff\n}\n\n.top_bar.top--bar3,\n.top_bar.top--bar4 {\n\tpadding: 1.33333rem 0\n}\n\n.top_bar.top--bar4 .infos .infos--single p {\n\tcolor: #202428\n}\n\n.menu_area {\n\t-webkit-box-shadow: .33333rem 0 1.33333rem rgba(87, 87, 87, .1);\n\tbox-shadow: .33333rem 0 1.33333rem rgba(87, 87, 87, .1);\n\tposition: relative\n}\n\n.menu_area.bgimage:before {\n\tcontent: '';\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\tz-index: 1;\n\tbackground: rgba(12, 13, 32, .8)\n}\n\n.menu_area .nav_right_content .nav_right_module+.nav_right_module {\n\tpadding-left: 1.6rem\n}\n\n.menu_area .nav_right_content .nav_right_module:last-child {\n\tpadding-right: 0\n}\n\n.menu_area .navbar {\n\tpadding: 1rem\n}\n\n.menu_area .navbar.navbar-primary .navbar-toggler {\n\tcolor: #fff\n}\n\n.menu_area .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before {\n\tcolor: #928d8d\n}\n\n.menu_area .navbar.navbar-bg .navbar-nav .nav-item.dropdown .nav-link:before {\n\tcolor: #ededed\n}\n\n.menu_area .navbar .navbar-nav .nav-item {\n\tposition: relative\n}\n\n.menu_area .navbar .navbar-nav .nav-item .dropdown-menu .dropdown-item {\n\tfont-size: 15px\n}\n\n.menu_area .navbar .navbar-nav .nav-item.has_mega-lg {\n\tposition: static\n}\n\n.menu_area .navbar .navbar-nav .nav-item:hover .mega-menu {\n\tvisibility: visible;\n\topacity: 1;\n\ttop: 4.53333rem\n}\n\n.menu_area .navbar .navbar-nav .nav-item:hover .mega-menu-lg {\n\ttop: 5.6rem\n}\n\n.menu_area .navbar .navbar-nav .nav-item .nav-link:after {\n\tposition: absolute;\n\twidth: 100%;\n\tcontent: '';\n\theight: 1rem;\n\tbottom: -1.06667rem;\n\tleft: 0\n}\n\n@media (min-width:992px) {\n\t.menu_area .navbar .navbar-nav .nav-item.dropdown .dropdown-menu {\n\t\tdisplay: block;\n\t\ttop: 6.66667rem !important;\n\t\t-webkit-border-radius: 0;\n\t\tborder-radius: 0;\n\t\t-webkit-transition: all .3s ease;\n\t\t-o-transition: all .3s ease;\n\t\ttransition: all .3s ease;\n\t\t-webkit-box-shadow: 0 0 30px rgba(41, 41, 59, .1);\n\t\tbox-shadow: 0 0 30px rgba(41, 41, 59, .1);\n\t\topacity: 0;\n\t\tvisibility: hidden;\n\t\tpadding: 2rem\n\t}\n\n\t.menu_area .navbar .navbar-nav .nav-item.dropdown .dropdown-menu .dropdown-item {\n\t\tpadding: 0 0 1rem\n\t}\n\n\t.menu_area .navbar .navbar-nav .nav-item.dropdown .dropdown-menu .dropdown-item:last-child {\n\t\tpadding: 0\n\t}\n\n\t.menu_area .navbar .navbar-nav .nav-item.dropdown:hover .dropdown-menu {\n\t\ttop: 4.66667rem !important;\n\t\topacity: 1;\n\t\tvisibility: visible\n\t}\n}\n\n.menu_area .navbar .navbar-nav .nav-item.dropdown .nav-link {\n\tposition: relative\n}\n\n.menu_area .navbar .navbar-nav .nav-item.dropdown .nav-link:before {\n\tposition: absolute;\n\tcontent: '\\f110';\n\tfont-size: .66667rem;\n\tfont-family: LineAwesome;\n\tcolor: rgba(0, 0, 0, .5);\n\tright: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.menu_area .navbar.navbar-primary {\n\tpadding: .66667rem 1.8rem;\n\tbackground: #413aa4;\n\t-webkit-border-radius: 4px;\n\tborder-radius: 4px\n}\n\n.menu_area .navbar.navbar-primary .navbar-nav .nav-link {\n\tcolor: #fff\n}\n\n.menu_area .navbar.navbar-primary .nav_right_content .nav_right_module>span.la {\n\tcolor: #fff\n}\n\n.menu_area .navbar.navbar-primary .nav_right_content .social_module ul li a {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\n.menu_area .navbar.navbar-primary .nav_right_content .social_module ul li a:hover {\n\tcolor: #fff\n}\n\n.menu_area .navbar-nav .nav-link {\n\tfont-weight: 500;\n\ttext-transform: capitalize;\n\tpadding: 1.2rem 1rem\n}\n\n.menu_area.menu1 {\n\tbackground: #fff\n}\n\n.menu_area.menu3 {\n\tbackground: #202428\n}\n\n.menu_area.menu3 .nav_right_content .cart_module {\n\tborder-right: 1px solid rgba(255, 255, 255, .3)\n}\n\n.menu_area.menu3 .nav_right_content .cart_module .cart_count {\n\tleft: 50%;\n\t-webkit-transform: translate(-50%);\n\t-ms-transform: translate(-50%);\n\ttransform: translate(-50%)\n}\n\n.menu_area.menu3 .nav_right_content .nav_right_module {\n\tpadding: 0 1.6rem\n}\n\n.menu_area.menu3 .nav_right_content .nav_right_module:last-child {\n\tpadding-right: 0\n}\n\n.menu_area.menu3 .nav_right_content .nav_right_module .cart__icon span.la,\n.menu_area.menu3 .nav_right_content .nav_right_module .la.search_trigger {\n\tcolor: rgba(255, 255, 255, .7)\n}\n\n.menu_area.menu4 {\n\t-webkit-box-shadow: 0 .33333rem 1.33333rem rgba(87, 87, 87, .1);\n\tbox-shadow: 0 .33333rem 1.33333rem rgba(87, 87, 87, .1);\n\tborder-top: 1px solid #e4e8ed\n}\n\n.menu_area.menu4 .nav_right_content .nav_right_module {\n\tpadding: 0 1.6rem\n}\n\n.menu_area.menu4 .nav_right_content .nav_right_module+.nav_right_module {\n\tborder-left: 1px solid #e4e8ed\n}\n\n.menu_area.menu4 .nav_right_content .nav_right_module:last-child {\n\tpadding-right: 0\n}\n\n.menu_area.menu5 {\n\tborder-bottom: 1px solid rgba(255, 255, 255, .12)\n}\n\n.menu_area.menu5 .navbar {\n\tpadding: 0\n}\n\n.menu_area.menu5 .nav_right_content .search_module {\n\tline-height: 6rem;\n\tpadding: 0 .66667rem;\n\tcolor: #fff;\n\tfont-size: 1.66667rem\n}\n\n.menu_area.menu5 .nav_right_content .search_module span {\n\tfont-size: 1.46667rem\n}\n\n.menu_area.menu5 .nav_right_content .language_module {\n\tpadding: 0 1.33333rem;\n\tcursor: pointer\n}\n\n.menu_area.menu5 .nav_right_content .language_module .dropdown .lang {\n\ttext-transform: uppercase;\n\tcolor: rgba(255, 255, 255, .5)\n}\n\n.menu_area.menu5 .nav_right_content .language_module .dropdown .lang_flag {\n\tpadding: 0 .66667rem\n}\n\n.menu_area.menu5 .nav_right_content .language_module .dropdown span.la {\n\tcolor: rgba(255, 255, 255, .5);\n\tfont-size: .86667rem\n}\n\n.menu_area.menu5 .nav_right_content .language_module .dropdown .dropdown-menu .dropdown-item img {\n\tmargin-right: .66667rem\n}\n\n.menu_area.menu7 {\n\t-webkit-box-shadow: 0 0 0;\n\tbox-shadow: 0 0 0\n}\n\n.menu_area.menu7 .navbar .navbar-nav .nav-item.dropdown .nav-link:before {\n\tcolor: #fff\n}\n\n@media (min-width:992px) {\n\t.menu_area .mega-menu {\n\t\tposition: absolute;\n\t\t-webkit-box-shadow: 0 0 30px rgba(41, 41, 59, .1);\n\t\tbox-shadow: 0 0 30px rgba(41, 41, 59, .1);\n\t\tbackground: #fff;\n\t\twidth: 46.66667rem;\n\t\tleft: -2.66667rem;\n\t\ttop: 6.66667rem;\n\t\tz-index: 10;\n\t\t-webkit-transition: all .3s ease;\n\t\t-o-transition: all .3s ease;\n\t\ttransition: all .3s ease;\n\t\topacity: 0;\n\t\tvisibility: hidden\n\t}\n}\n\n.menu_area .mega-menu ul {\n\tpadding: 2.66667rem;\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.menu_area .mega-menu ul li {\n\tmargin-bottom: 1rem\n}\n\n.menu_area .mega-menu ul li:last-child {\n\tmargin-bottom: 0\n}\n\n.menu_area .mega-menu ul li h6 {\n\tcolor: #202428;\n\tfont-weight: 500;\n\tmargin-bottom: 1.33333rem\n}\n\n.menu_area .mega-menu ul li a {\n\tcolor: inherit;\n\tfont-size: 15px\n}\n\n.menu_area .mega-menu ul li a:hover {\n\tcolor: #413aa4\n}\n\n.menu_area .mega-menu ul li+li h6 {\n\tmargin-top: 2rem\n}\n\n@media (min-width:992px) {\n\t.menu_area .mega-menu.mega-menu-lg {\n\t\twidth: 100%;\n\t\tleft: 0\n\t}\n}\n\n.menu6 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link,\n.menu7 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link,\n.menu8 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link {\n\tcolor: #fff\n}\n\n.menu6 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before,\n.menu7 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before,\n.menu8 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\n.menu6 .navbar-dark .nav_right_content .cart_module .cart__icon span.la,\n.menu6 .navbar-dark .nav_right_content .search_module>span,\n.menu6 .navbar-dark .navbar-toggler,\n.menu7 .navbar-dark .nav_right_content .cart_module .cart__icon span.la,\n.menu7 .navbar-dark .nav_right_content .search_module>span,\n.menu7 .navbar-dark .navbar-toggler,\n.menu8 .navbar-dark .nav_right_content .cart_module .cart__icon span.la,\n.menu8 .navbar-dark .nav_right_content .search_module>span,\n.menu8 .navbar-dark .navbar-toggler {\n\tcolor: #fff\n}\n\n.navbar-bg .navbar-nav .nav-link {\n\tcolor: rgba(255, 255, 255, .7)\n}\n\n.navbar-bg .navbar-nav .nav-link:hover {\n\tcolor: #fff\n}\n\n.navbar-bg .nav_right_content .nav_right_module .input-group-light span.icon-left .la {\n\tcolor: #5a6671\n}\n\n.navbar-bg .nav_right_content .nav_right_module .search_trigger,\n.navbar-bg .nav_right_content .nav_right_module span.la-la-angle-down {\n\tcolor: rgba(255, 255, 255, .7)\n}\n\n.navbar-bg .nav_right_content .nav_right_module .search_trigger:hover,\n.navbar-bg .nav_right_content .nav_right_module span.la-la-angle-down:hover {\n\tcolor: #fff\n}\n\n@media (max-width:991.98px) {\n\t.navbar.navbar-dark .navbar-toggler {\n\t\tcolor: #fff\n\t}\n\n\t.navbar .navbar-toggler {\n\t\tpadding: .33333rem .66667rem;\n\t\tfont-size: 1.66667rem;\n\t\tcolor: #413aa4;\n\t\t-webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .1);\n\t\tbox-shadow: 0 0 4px rgba(0, 0, 0, .1);\n\t\tborder: 1px solid #f2f2f2\n\t}\n\n\t.navbar .navbar-brand {\n\t\twidth: 25%;\n\t\tmargin: 0\n\t}\n\n\t.navbar .navbar-brand img {\n\t\tmax-width: 100%\n\t}\n\n\t.navbar .navbar-collapse {\n\t\tposition: absolute;\n\t\ttop: 100%;\n\t\tleft: 0;\n\t\tbackground: #fff;\n\t\twidth: 100%;\n\t\tz-index: 100;\n\t\tmax-height: 300px;\n\t\toverflow: scroll;\n\t\t-webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, .1);\n\t\tbox-shadow: 0 1px 6px rgba(0, 0, 0, .1)\n\t}\n}\n\n.nav_right_content ul {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex\n}\n\n.nav_right_content .cart_module {\n\tposition: relative\n}\n\n.nav_right_content .cart_module .cart__icon {\n\tposition: relative\n}\n\n.nav_right_content .cart_module:hover .cart__items {\n\topacity: 1;\n\tvisibility: visible;\n\ttop: 100%\n}\n\n.nav_right_content .cart_module .cart__items {\n\tposition: absolute;\n\tright: -20px;\n\tmin-width: 350px;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tz-index: 2;\n\tbackground: #fff;\n\tvisibility: hidden;\n\topacity: 0;\n\ttop: calc(100% + 20px)\n}\n\n.nav_right_content .cart_module .cart__items .items {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tpadding: 15px 25px;\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.nav_right_content .cart_module .cart__items .items .item_thumb {\n\tmargin-right: 15px\n}\n\n.nav_right_content .cart_module .cart__items .items .item_info {\n\tmargin-right: 10px\n}\n\n.nav_right_content .cart_module .cart__items .items .item_info>a {\n\tcolor: #202428;\n\tline-height: 1.53333rem;\n\tdisplay: inline-block;\n\tmargin-bottom: 10px\n}\n\n.nav_right_content .cart_module .cart__items .items .item_info span {\n\tfont-weight: 500\n}\n\n.nav_right_content .cart_module .cart__items .items .item_remove {\n\tdisplay: inline-block;\n\t-webkit-transition: initial;\n\t-o-transition: initial;\n\ttransition: initial\n}\n\n.nav_right_content .cart_module .cart__items .items .item_remove span {\n\tfont-size: 14px;\n\tline-height: 30px;\n\twidth: 2rem;\n\tbackground: #f4f4f4;\n\ttext-align: center;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%\n}\n\n.nav_right_content .cart_module .cart__items .cart_info {\n\tpadding: 20px 25px\n}\n\n.nav_right_content .cart_module .cart__items .cart_info p {\n\tmargin-bottom: 15px\n}\n\n.nav_right_content .cart_module .cart__items .cart_info p span {\n\tfont-weight: 500;\n\tfont-size: 18px\n}\n\n.nav_right_content .cart_module .cart__items .cart_info a+a {\n\tmargin-left: 10px\n}\n\n.nav_right_content .cart_module span.la {\n\tfont-size: 1.66667rem;\n\tcolor: #202428\n}\n\n.nav_right_content .cart_module .cart_count {\n\tposition: absolute;\n\ttop: -.93333rem;\n\tleft: 3px;\n\tdisplay: inline-block;\n\tline-height: 1.33333rem;\n\twidth: 1.2rem;\n\ttext-align: center;\n\tfont-size: .8rem;\n\tcolor: #fff;\n\t-webkit-border-radius: 13.33333rem;\n\tborder-radius: 13.33333rem\n}\n\n.nav_right_content .search_module {\n\tposition: relative;\n\tz-index: 3\n}\n\n.nav_right_content .search_module .search_area {\n\tposition: absolute;\n\twidth: 300px;\n\tright: -10px;\n\topacity: 0;\n\tvisibility: hidden;\n\tpadding: 10px;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\ttop: calc(100% + 40px);\n\tbackground: #fff;\n\t-webkit-border-radius: 4px;\n\tborder-radius: 4px;\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .2);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .2)\n}\n\n.nav_right_content .search_module .search_area .input-group-light span.icon-left .la {\n\t-webkit-transform: rotate(0);\n\t-ms-transform: rotate(0);\n\ttransform: rotate(0);\n\tcolor: #969696\n}\n\n.nav_right_content .search_module .search_area.active {\n\ttop: calc(100% + 19px);\n\topacity: 1;\n\tvisibility: visible\n}\n\n.nav_right_content .search_module .search_area .search_field {\n\tborder: 0\n}\n\n.nav_right_content .search_module>span {\n\tfont-size: 1.33333rem;\n\tcolor: #202428;\n\tcursor: pointer;\n\tline-height: 2rem\n}\n\n.nav_right_content .social_module ul li {\n\tpadding: 0 .66667rem\n}\n\n.nav_right_content .social_module ul li a {\n\tcolor: #9192a3\n}\n\n.nav_right_content .social_module ul li a:hover {\n\tcolor: #413aa4\n}\n\n@media (max-width:1199.98px) {\n\t.nav_right_content .search_module {\n\t\tpadding: 0 .6rem 0 .33333rem\n\t}\n}\n\n.modal.search_modal {\n\tbackground: rgba(255, 255, 255, .9)\n}\n\n.modal.search_modal .searc__field input {\n\tbackground: 0 0;\n\tborder: 2px solid rgba(255, 255, 255, .36);\n\tcolor: #fff;\n\tpadding: 1.2rem 1.55rem\n}\n\n.modal.search_modal .searc__field input::-webkit-input-placeholder {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\n.modal.search_modal .searc__field input::-ms-input-placeholder {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\n.modal.search_modal .searc__field input::placeholder {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\n.modal.search_modal .input_with_embed button {\n\tfont-size: 1.6rem;\n\tcolor: rgba(255, 255, 255, .54);\n\tcursor: pointer;\n\t-webkit-transition: .3s;\n\t-o-transition: .3s;\n\ttransition: .3s\n}\n\n.modal.search_modal .input_with_embed button:hover {\n\tcolor: #fff\n}\n\n.modal.search_modal .modal-body {\n\tpadding: 2.68rem 3.34rem\n}\n\n.modal .modal-dialog.modal--fullwidth {\n\tmax-width: 1140px\n}\n\n.modal .modal-dialog .modal-content.transparent {\n\tbackground: #413aa4;\n\t-webkit-box-shadow: 0 .5rem 1.33rem rgba(65, 58, 164, .5);\n\tbox-shadow: 0 .5rem 1.33rem rgba(65, 58, 164, .5);\n\tborder: 0\n}\n\n.breadcrumb .breadcrumb-item+.breadcrumb-item::before {\n\tpadding: 0 8px;\n\tfont-size: .8rem\n}\n\n.breadcrumb li {\n\tfont-size: 14px\n}\n\n.breadcrumb li a {\n\tcolor: #202428;\n\tfont-weight: 500\n}\n\n.breadcrumb li a span {\n\tmargin-right: 5px\n}\n\n.breadcrumb li a:hover {\n\tcolor: #413aa4\n}\n\n.breadcrumb li::before {\n\tfont-family: LineAwesome, Poppins, sans-serif\n}\n\n.breadcrumb_area .page_title {\n\tline-height: 4.8rem;\n\tfont-weight: 600\n}\n\n.breadcrumb_area.breadcrumb1 {\n\tpadding: 3rem 0;\n\tbackground: #f5f7fc\n}\n\n.breadcrumb_area.breadcrumb1 .page_title {\n\tmargin: 0;\n\ttext-transform: capitalize;\n\tcolor: #202428\n}\n\n.breadcrumb_area.breadcrumb2 {\n\tpadding-top: 7.1rem\n}\n\n.breadcrumb_area.breadcrumb2 .page_title {\n\tcolor: #fff;\n\tmargin-bottom: 5.6rem;\n\ttext-align: center;\n\twidth: 50rem;\n\tline-height: 3.6rem\n}\n\n.breadcrumb_area.breadcrumb2 .breadcrumb li {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\n.breadcrumb_area.breadcrumb2 .breadcrumb li a {\n\tcolor: #fff\n}\n\n.breadcrumb_area.breadcrumb2 .breadcrumb li a:hover {\n\tcolor: #06b590\n}\n\n.breadcrumb_area.breadcrumb-colored .page_title,\n.breadcrumb_area.breadcrumb-gradient .page_title {\n\tcolor: #fff\n}\n\n.breadcrumb_area.breadcrumb-colored .breadcrumb li a,\n.breadcrumb_area.breadcrumb-gradient .breadcrumb li a {\n\tcolor: #fff\n}\n\n.breadcrumb_area.breadcrumb-colored .breadcrumb-item+.breadcrumb-item::before,\n.breadcrumb_area.breadcrumb-colored .breadcrumb-item.active,\n.breadcrumb_area.breadcrumb-gradient .breadcrumb-item+.breadcrumb-item::before,\n.breadcrumb_area.breadcrumb-gradient .breadcrumb-item.active {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\n.breadcrumb3 {\n\tpadding: 6.26667rem 0 10.46667rem\n}\n\n.breadcrumb3 .breadcrumb_wrapper .subtext {\n\tfont-size: 2rem\n}\n\n.breadcrumb3 .breadcrumb_wrapper .page_title {\n\twidth: 33.33333rem;\n\tmargin: 0 auto;\n\tcolor: #fff;\n\ttext-align: center;\n\tline-height: 3.6rem\n}\n\n.breadcrumb3 .breadcrumb_wrapper .breadcrumb {\n\tmargin-top: 5.33333rem\n}\n\n.breadcrumb3 .breadcrumb_wrapper .breadcrumb li a {\n\tcolor: #fff\n}\n\nfooter {\n\tbackground: #f4f4f4\n}\n\nfooter .footer__big {\n\tpadding: 7.33333rem 0 3.33333rem\n}\n\nfooter .footer__big .text_widget p {\n\tline-height: 2rem;\n\tmargin-bottom: 1.33333rem\n}\n\nfooter .footer__big .text_widget p .address,\nfooter .footer__big .text_widget p .mail,\nfooter .footer__big .text_widget p .tel {\n\tdisplay: block;\n\tcolor: #5a6671\n}\n\nfooter .footer__big .text_widget p .mail:hover,\nfooter .footer__big .text_widget p .tel:hover {\n\tcolor: #06b590\n}\n\nfooter .footer__big .text_widget .footer_logo {\n\tmargin-bottom: 2rem\n}\n\nfooter .footer__big .widget {\n\tmargin-bottom: 4rem\n}\n\nfooter .footer__big .widget .widget__title {\n\tfont-size: 1.06667rem;\n\ttext-transform: uppercase;\n\tline-height: normal;\n\tfont-weight: 600;\n\tposition: relative\n}\n\nfooter .footer__big .widget .widget__title2 {\n\tfont-size: 1.13333rem;\n\tcolor: #202428\n}\n\nfooter .footer__big .widget .widget__social {\n\tmargin-top: 30px\n}\n\nfooter .footer__big .widget.subcribe--widget .subscribe_form .embed_icon {\n\tfont-size: 1.33333rem;\n\tcolor: #5a6671\n}\n\nfooter .footer__big .widget.subcribe--widget .subscribe_form input {\n\twidth: 100%;\n\tfont-size: 1rem;\n\tcolor: #9192a3;\n\toutline: 0;\n\tpadding-left: 1.4rem;\n\tpadding-right: 1rem\n}\n\nfooter .footer__big .widget ul.links li {\n\tmargin-bottom: .66667rem\n}\n\nfooter .footer__big .widget ul.links li:last-child {\n\tmargin-bottom: 0\n}\n\nfooter .footer__big .widget ul.links li a {\n\tcolor: #5a6671\n}\n\nfooter .footer__big .widget ul.links li a:hover {\n\tcolor: #06b590\n}\n\nfooter .footer__big .widget--contact_info ul li {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-bottom: 31px\n}\n\nfooter .footer__big .widget--contact_info ul li span.la {\n\tfont-size: 28px;\n\tmargin-right: 12px\n}\n\nfooter .footer__big .widget--contact_info ul li .info p {\n\tmargin: 0;\n\tcolor: #fff;\n\tfont-size: 1.06667rem;\n\tline-height: 26px\n}\n\nfooter .footer__big .widget--contact_info ul li .info small {\n\tfont-size: 14px\n}\n\nfooter .footer__big .widget--latest-news ul li {\n\tmargin-bottom: 20px\n}\n\nfooter .footer__big .widget--latest-news ul li small {\n\tfont-size: 1rem;\n\tdisplay: block;\n\tline-height: 30px\n}\n\nfooter .footer__big .widget--latest-news ul li a {\n\tcolor: #fff;\n\tfont-weight: 500;\n\tline-height: 28px\n}\n\nfooter .footer__small {\n\tbackground: #000\n}\n\nfooter .footer__small p {\n\tcolor: rgba(255, 255, 255, .6);\n\tmargin: 0;\n\tpadding: 30px 0\n}\n\nfooter .footer__small a {\n\tcolor: #06b590\n}\n\nfooter .footer__bottom .footer__bottom-content {\n\tborder-top: 1px solid #eaeaea;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: justify;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: justify;\n\tjustify-content: space-between;\n\tpadding: 2.33333rem 0\n}\n\nfooter .footer__bottom .footer__bottom-content p {\n\tmargin: 0\n}\n\nfooter .footer__bottom .footer__bottom-content p>a {\n\tcolor: #06b590\n}\n\nfooter .footer__bottom .footer__bottom-content .social-basic li a {\n\tcolor: #9192a3\n}\n\nfooter .footer__bottom .footer__bottom-content .social-basic li a:hover {\n\tcolor: #06b590\n}\n\nfooter.footer--dark .footer__big .text_widget p a,\nfooter.footer--dark .footer__big .text_widget p span {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\nfooter.footer--dark .footer__big .widget.subcribe--widget p {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\nfooter.footer--dark .footer__big .widget .widget__title {\n\tcolor: #fff\n}\n\nfooter.footer--dark .footer__big .widget ul.links li a:hover {\n\tcolor: #06b590\n}\n\nfooter.footer--light .widget__social .social ul li a {\n\tbackground: #fff\n}\n\nfooter.footer--light .widget__social .social ul li a span {\n\tcolor: #9192a3\n}\n\nfooter.footer--light .widget__social .social ul li a:hover {\n\tbackground: #413aa4\n}\n\nfooter.footer--light .widget__social .social ul li a:hover span {\n\tcolor: #fff\n}\n\nfooter.footer--light .widget--contact_info ul li .info p {\n\tcolor: #202428;\n\tfont-weight: 500\n}\n\nfooter.footer--light .widget--latest-news ul li a {\n\tcolor: #202428\n}\n\nfooter.footer2.footer--light {\n\tbackground: #fff\n}\n\nfooter.footer2.footer--light .widget.twit--widget .user .name {\n\tcolor: #06b590\n}\n\nfooter.footer2.footer--light .widget.twit--widget .user .name+span {\n\tcolor: #9192a3\n}\n\nfooter.footer2.footer--light .footer__small {\n\tbackground: #fff;\n\tborder-top: 1px solid #e4e8ed\n}\n\nfooter.footer2.footer--light .footer__small p {\n\tcolor: #5a6671\n}\n\nfooter.footer2 .widget.twit--widget .user {\n\tmargin-top: 14px\n}\n\nfooter.footer2 .widget.twit--widget .user .name {\n\tcolor: #fff\n}\n\nfooter.footer2 .widget.twit--widget .user .name+span:before {\n\tcontent: \"-\";\n\tmargin: 0 3px\n}\n\nfooter.footer2 .widget.twit--widget a {\n\tdisplay: inline-block\n}\n\nfooter.footer2 .widget.twit--widget span.fab {\n\tmargin-right: 12px;\n\tfont-size: 18px\n}\n\nfooter.footer2 .widget.twit--widget .twit_wrapper>span {\n\tposition: relative;\n\ttop: .46667rem\n}\n\nfooter.footer2 .footer__small p {\n\tcolor: rgba(255, 255, 255, .7)\n}\n\nfooter.footer2 .footer__small p a:hover {\n\tcolor: #fff\n}\n\nfooter.footer3 .footer__small {\n\tbackground: #e4e8ed\n}\n\nfooter.footer3 .footer__small p {\n\tcolor: #5a6671\n}\n\nfooter.footer4 .footer__big {\n\tpadding: 7.33333rem 0\n}\n\nfooter.footer4 .footer_menu_items ul li {\n\tpadding: .94rem\n}\n\nfooter.footer4 .footer_menu_items ul li a {\n\tline-height: 2.14rem;\n\tcolor: rgba(255, 255, 255, .5)\n}\n\nfooter.footer4 .footer_menu_items ul li a:hover {\n\tcolor: #fff\n}\n\nfooter.footer4 .footer__small .info_links li+li {\n\tmargin-left: 17px\n}\n\nfooter.footer4 .footer__small .info_links:before {\n\tcontent: '|';\n\tmargin: 0 30px;\n\tcolor: rgba(255, 255, 255, .2)\n}\n\nfooter.footer4 .footer_menu_items {\n\tbackground: rgba(255, 255, 255, .1)\n}\n\nfooter.footer4 .footer__small {\n\tpadding: 1.66667rem 0;\n\tborder-top: 1px solid rgba(255, 255, 255, .1)\n}\n\nfooter.footer4 .footer__small p,\nfooter.footer4 .footer__small ul {\n\tpadding: 0;\n\tmargin: 0\n}\n\nfooter.footer4 .social.square ul li a {\n\tborder: 1px solid rgba(255, 255, 255, .2)\n}\n\nfooter.footer4 .social.square ul li a:hover {\n\tborder-color: transparent\n}\n\nfooter.footer4.footer--light .footer4_text {\n\tcolor: #5a6671\n}\n\nfooter.footer4.footer--light .footer_menu_items {\n\tbackground: #fff\n}\n\nfooter.footer4.footer--light .footer__small {\n\tbackground: #fff\n}\n\nfooter.footer4.footer--light .footer__small p {\n\tcolor: #5a6671\n}\n\nfooter.footer4.footer--light .footer__small .info_links li a {\n\tcolor: #5a6671\n}\n\nfooter.footer4.footer--light .footer__small .social.square li a {\n\tcolor: #9192a3;\n\tborder-color: #e4e8ed\n}\n\nfooter.footer4.footer--light .footer__small .social.square li a:hover {\n\tcolor: #fff;\n\tborder-color: transparent\n}\n\nfooter.footer4 .footer4_text {\n\tmargin: 3.33rem 0 4.66rem;\n\tline-height: 2rem\n}\n\nfooter.footer5.footer--bw .footer__big {\n\tbackground: #111115\n}\n\nfooter.footer5.footer--bw .footer__big .text_widget a {\n\tcolor: #fff\n}\n\nfooter.footer5.footer--bw .footer__big .text_widget a:hover {\n\tcolor: #413aa4\n}\n\nfooter.footer5.footer--bw .footer__big .widget ul.links a:hover {\n\tcolor: #fff\n}\n\nfooter.footer5.footer--bw .footer__big .widget .widget__title {\n\tcolor: #fff\n}\n\nfooter.footer5.footer--bw .footer_small {\n\tbackground: #000\n}\n\nfooter.footer--light-gradient {\n\tbackground: -webkit-gradient(linear, left top, left bottom, from(#fbfbfd), to(#f2f1fa));\n\tbackground: -webkit-linear-gradient(top, #fbfbfd, #f2f1fa);\n\tbackground: -o-linear-gradient(top, #fbfbfd, #f2f1fa);\n\tbackground: linear-gradient(to bottom, #fbfbfd, #f2f1fa)\n}\n\nfooter.footer6 {\n\tposition: relative;\n\toverflow: hidden;\n\tpadding-top: 4.33333rem\n}\n\nfooter.footer6:before {\n\tposition: absolute;\n\tcontent: \"\";\n\twidth: 180%;\n\theight: 150%;\n\tbackground: #fff;\n\tleft: -40%;\n\ttop: -137%;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%\n}\n\nfooter.footer6.footer--dark .widget .widget__title2 {\n\tcolor: #fff\n}\n\nfooter.footer6.footer--dark .footer__bottom .footer__bottom-content {\n\tborder-color: rgba(255, 255, 255, .1)\n}\n\nfooter.footer7 {\n\tposition: relative;\n\toverflow: hidden;\n\tbackground: url(https://snmtechnologies.in/startup/img/shape-wave3.png) center/100% 100% no-repeat;\n\tpadding-top: 4.66667rem\n}\n\nfooter.footer7.footer--dark .widget .widget__title2 {\n\tcolor: #fff\n}\n\nfooter.footer7.footer--dark .footer__bottom .footer__bottom-content {\n\tborder-color: rgba(255, 255, 255, .1)\n}\n\n.pricing {\n\ttext-align: center;\n\tpadding: 30px;\n\tmargin-bottom: 2rem\n}\n\n.pricing .pricing__title h4 {\n\tline-height: 2rem;\n\tmargin-bottom: 0;\n\tfont-weight: 600\n}\n\n.pricing .pricing__title span {\n\tcolor: #9192a3;\n\tline-height: 1.8rem;\n\tdisplay: inline-block\n}\n\n.pricing .pricing__price p {\n\tfont-size: 3.33rem;\n\tfont-weight: 600;\n\tcolor: #fff;\n\tmargin-bottom: 0;\n\tline-height: 4.93333rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center\n}\n\n.pricing .pricing__price p sup {\n\tfont-size: 1.63rem\n}\n\n.pricing .pricing__price p small {\n\tfont-size: 1rem;\n\tposition: relative;\n\ttop: .53333rem\n}\n\n.pricing.pricing--1 {\n\t-webkit-border-radius: 6px;\n\tborder-radius: 6px;\n\tpadding: 36px 30px 40px;\n\tbackground: #fff\n}\n\n.pricing.pricing--1 .pricing__title {\n\tmargin-bottom: 2rem\n}\n\n.pricing.pricing--1 .pricing__title h4 {\n\tfont-size: 1.6rem\n}\n\n.pricing.pricing--1 .pricing__price {\n\tmax-width: 231px;\n\tmargin: 0 auto\n}\n\n.pricing.pricing--1 .pricing__price p {\n\tmargin: 0\n}\n\n.pricing.pricing--1 .pricing__features {\n\tpadding: 2rem 0\n}\n\n.pricing.pricing--1 .pricing__features ul {\n\tmargin: 0\n}\n\n.pricing.pricing--1 .pricing__features ul li {\n\tmargin-bottom: 1rem\n}\n\n.pricing.pricing--1 .pricing__features ul li:last-child {\n\tmargin-bottom: 0\n}\n\n.pricing.pricing--2 {\n\tbackground: #fff;\n\tpadding: 0\n}\n\n.pricing.pricing--2 .pricing__features_list {\n\ttext-align: left;\n\tpadding: 5.86rem 3.33rem 3.33rem\n}\n\n.pricing.pricing--2 .pricing__features_list P {\n\tmargin: 0\n}\n\n.pricing.pricing--2 .pricing__features_list ul.list {\n\tmargin-top: 63px\n}\n\n.pricing.pricing--2 .pricing__features_list ul.list li {\n\tline-height: 3.2rem;\n\tfont-weight: 500;\n\tcolor: #202428;\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.pricing.pricing--2 .pricing__features_list ul.list li:first-child {\n\tborder-top: 1px solid #e4e8ed\n}\n\n.pricing.pricing--2 .pricing__wrapper {\n\t-webkit-box-flex: 2;\n\t-webkit-flex: 2;\n\t-ms-flex: 2;\n\tflex: 2;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.pricing.pricing--2 .pricing__wrapper .pricing_option {\n\tpadding: 3.2rem 2rem 3.33rem;\n\t-webkit-flex-basis: 0;\n\t-ms-flex-preferred-size: 0;\n\tflex-basis: 0;\n\t-webkit-box-flex: 1;\n\t-webkit-flex-grow: 1;\n\t-ms-flex-positive: 1;\n\tflex-grow: 1;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.pricing.pricing--2 .pricing__wrapper .pricing_option .pricing__title {\n\tmargin-bottom: 22px\n}\n\n.pricing.pricing--2 .pricing__wrapper .pricing_option ul.favail {\n\tmargin-bottom: 2.66rem\n}\n\n.pricing.pricing--2 .pricing__wrapper .pricing_option ul.favail li {\n\tline-height: 3.2rem;\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.pricing.pricing--2 .pricing__wrapper .pricing_option ul.favail li:first-child {\n\tborder-top: 1px solid #e4e8ed\n}\n\n.pricing.pricing--2 .pricing__wrapper .pricing_option ul.favail li i {\n\tfont-size: 18px\n}\n\n.pricing.pricing--2 .pricing__wrapper .pricing_option ul.favail li i.la-close {\n\tcolor: #e23636\n}\n\n.pricing.pricing--2 .pricing__wrapper .pricing_option:hover {\n\t-webkit-box-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\tbox-shadow: 0 5px 30px rgba(41, 41, 59, .1)\n}\n\n.pricing.pricing--2 .pricing__wrapper .pricing__price {\n\tmargin-bottom: 2.66rem\n}\n\n.timeline1 .happening:hover .happening__period .wrapper:before {\n\tborder-color: #06b590\n}\n\n.timeline1 .happening:hover .happening__period .wrapper:after {\n\tbackground: rgba(6, 181, 144, .1)\n}\n\n.timeline1 .happening .happening__period {\n\ttext-align: center;\n\tposition: relative\n}\n\n.timeline1 .happening .happening__period:before {\n\tcontent: \"\";\n\tposition: absolute;\n\theight: 100%;\n\twidth: 1px;\n\tbackground: #e2e1ea;\n\tright: -41px;\n\ttop: 0\n}\n\n.timeline1 .happening .happening__period .wrapper {\n\tbackground: #fff;\n\tpadding: 0;\n\tmargin-top: 0;\n\tposition: relative;\n\tmin-height: 8.33333rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center\n}\n\n.timeline1 .happening .happening__period .wrapper:before {\n\tcontent: \"\";\n\tposition: absolute;\n\t-webkit-transition: .3s;\n\t-o-transition: .3s;\n\ttransition: .3s;\n\theight: 10px;\n\twidth: 10px;\n\tbackground: #fff;\n\t-webkit-border-radius: 200px;\n\tborder-radius: 200px;\n\tright: -60.5px;\n\tz-index: 1;\n\tborder: 2px solid #afb0c3;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.timeline1 .happening .happening__period .wrapper:after {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 20px;\n\theight: 20px;\n\t-webkit-border-radius: 200px;\n\tborder-radius: 200px;\n\tright: -65.5px;\n\tz-index: 1;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\t-webkit-transition: .3s;\n\t-o-transition: .3s;\n\ttransition: .3s\n}\n\n.timeline1 .happening .happening__period .wrapper .date {\n\tmargin: 10px 0 0 0;\n\tline-height: normal\n}\n\n.timeline1 .happening .happening__period .wrapper .year {\n\tfont-size: 2.42rem;\n\tfont-weight: 600;\n\tline-height: normal;\n\tmargin: 0\n}\n\n.timeline1 .happening .happening__desc {\n\tpadding: 0 0 3.33333rem;\n\tposition: relative\n}\n\n.timeline1 .happening .happening__desc .happening_title {\n\tcolor: #202428;\n\tline-height: 3.2rem;\n\tmargin-bottom: .66rem;\n\tmargin-top: -10px\n}\n\n.timeline1 .happening p {\n\tmargin-bottom: 0\n}\n\n.timeline1 .happening:last-child .happening__desc {\n\tpadding-bottom: 0\n}\n\n.timeline2 {\n\tposition: relative\n}\n\n.timeline2:before {\n\tcontent: '';\n\theight: 100%;\n\twidth: 1px;\n\tbackground: #e4e8ed;\n\tposition: absolute;\n\tleft: 0\n}\n\n.timeline2 .happening2 {\n\tpadding-bottom: 2.66667rem;\n\tpadding-left: 3.2rem;\n\tposition: relative\n}\n\n.timeline2 .happening2:last-child {\n\tpadding-bottom: 0\n}\n\n.timeline2 .happening2:before {\n\tcontent: '';\n\tposition: absolute;\n\twidth: 12px;\n\ttop: 43px;\n\theight: 12px;\n\t-webkit-border-radius: 200px;\n\tborder-radius: 200px;\n\tborder: 2px solid #afb0c3;\n\tbackground: #fff;\n\tleft: 0;\n\t-webkit-transform: translateX(-50%);\n\t-ms-transform: translateX(-50%);\n\ttransform: translateX(-50%)\n}\n\n.timeline2 .happening2:hover:before {\n\tborder-color: #06b590\n}\n\n.timeline2 .happening2 .happening2__period {\n\tfont-size: 1rem;\n\tmargin: 0;\n\tfont-weight: 600;\n\tline-height: normal\n}\n\n.timeline2 .happening2 .happening2__title {\n\tcolor: #202428;\n\tfont-weight: 500;\n\tline-height: 3.2rem;\n\tmargin-bottom: 0\n}\n\n.timeline2 .happening2 p {\n\tmargin-bottom: 0\n}\n\n.arabic {\n\tfont-size: 1.46667rem\n}\n\n.counter.counter--1,\n.counter.counter--2 {\n\tpadding: 6.33333rem 0\n}\n\n.counter.counter--3 {\n\tpadding: 7.33333rem 0\n}\n\n.counter.counter--3 .counter_single .title {\n\tcolor: rgba(255, 255, 255, .7)\n}\n\n.counter.counter--4 .counter_single .title {\n\tcolor: #5a6671\n}\n\n.counter.counter--5 {\n\tpadding: 8rem 0 6rem\n}\n\n.counter.counter--5 .counter_single {\n\tpadding: 3rem 0;\n\t-webkit-border-radius: 4px;\n\tborder-radius: 4px;\n\tbackground: #fff;\n\tmargin-bottom: 2rem\n}\n\n.counter.counter--5 .counter_single .value {\n\tmargin-bottom: .33rem\n}\n\n.counter.counter--5 .counter_single .title {\n\tfont-weight: 500\n}\n\n.counter.counter--6 {\n\tpadding: 7.66667rem 0\n}\n\n.counter.counter--6 .icon span {\n\tcolor: #fff\n}\n\n.counter.counter--6 .title {\n\tcolor: rgba(255, 255, 255, .7)\n}\n\n.counter.counter--7 {\n\tpadding: 6.66667rem 0 4.66667rem\n}\n\n.counter.counter--7 .counter_left_content h4 {\n\tcolor: #fff;\n\tfont-size: 2.4rem;\n\tfont-weight: 600\n}\n\n.counter.counter--7 .counter_left_content p {\n\tcolor: #fff\n}\n\n.counter.counter--7 .counter_single {\n\tbackground: #fff;\n\tpadding: 1.93333rem 0;\n\tmargin-bottom: 30px;\n\t-webkit-border-radius: 6px;\n\tborder-radius: 6px\n}\n\n.counter.counter--7 .counter_single .title {\n\tcolor: #202428;\n\tfont-weight: 500\n}\n\n.counter_single {\n\ttext-align: center\n}\n\n.counter_single p {\n\tmargin: 0\n}\n\n.counter_single .icon {\n\tpadding-bottom: 2.33rem\n}\n\n.counter_single .icon span {\n\tcolor: #fff;\n\tfont-size: 3.47rem\n}\n\n.counter_single .value {\n\tfont-size: 3.2rem;\n\tline-height: 3.66rem;\n\tfont-weight: 600;\n\tcolor: #fff;\n\tmargin-bottom: 0\n}\n\n.counter_single .title {\n\tcolor: #fff\n}\n\n.shadow-lg-2 {\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .1) !important;\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .1) !important\n}\n\n.shadow_lg--bgwhite {\n\t-webkit-box-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\tbox-shadow: 0 5px 30px rgba(41, 41, 59, .1)\n}\n\n.shadow_lg2--bgwhite {\n\t-webkit-box-shadow: 0 10px 30px rgba(41, 41, 59, .1);\n\tbox-shadow: 0 10px 30px rgba(41, 41, 59, .1)\n}\n\n.dot-light,\n.owl-dots {\n\ttext-align: center;\n\tmargin-top: 2rem\n}\n\n.dot-light .owl-dot,\n.owl-dots .owl-dot {\n\tdisplay: inline-block;\n\tmargin-right: .66667rem\n}\n\n.dot-light .owl-dot:last-child,\n.owl-dots .owl-dot:last-child {\n\tmargin-right: 0\n}\n\n.dot-light .owl-dot:focus,\n.owl-dots .owl-dot:focus {\n\toutline: 0\n}\n\n.dot-light .owl-dot span,\n.owl-dots .owl-dot span {\n\twidth: .8rem;\n\theight: .8rem;\n\t-webkit-border-radius: 20rem;\n\tborder-radius: 20rem;\n\tbackground: rgba(65, 58, 164, .3);\n\tdisplay: inline-block\n}\n\n.dot-secondary.dot-light .owl-dot span,\n.owl-dots.dot-secondary .owl-dot span {\n\tborder: 0 none;\n\tbackground: rgba(6, 181, 144, .2)\n}\n\n.dot-light .owl-dot span {\n\tborder: 1px solid #fff\n}\n\n.dot-light .owl-dot.active span {\n\tbackground: #fff\n}\n\n.nav-circle button {\n\twidth: 3.06667rem;\n\theight: 3.06667rem;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tfont-size: 1.2rem;\n\tcolor: #fff;\n\tborder: 0 none;\n\tcursor: pointer;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.nav-circle button:focus {\n\toutline: 0\n}\n\n.nav-circle .owl-prev {\n\tmargin-left: -4rem;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.nav-circle .owl-next {\n\tmargin-right: -4rem;\n\tposition: absolute;\n\tright: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.nav-circle.nav-circle--light button {\n\twidth: 2.66667rem;\n\theight: 2.66667rem;\n\tbackground: #fff;\n\tcolor: #9192a3;\n\t-webkit-box-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\tbox-shadow: 0 5px 30px rgba(41, 41, 59, .1)\n}\n\n.nav-circle.nav-circle--light button:hover {\n\tcolor: #fff\n}\n\n.nav-circle.nav-circle--lighten button {\n\twidth: 2.66667rem;\n\theight: 2.66667rem;\n\tbackground: rgba(255, 255, 255, .1);\n\tcolor: #fff;\n\t-webkit-box-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\tbox-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\tfont-size: .86667rem\n}\n\n.nav-circle.nav-circle--lighten button:hover {\n\tcolor: #fff\n}\n\n.nav-square button {\n\twidth: 2.66667rem;\n\theight: 2.66667rem;\n\tcolor: #fff;\n\tfont-size: 1.06667rem;\n\tbackground: rgba(255, 255, 255, .4);\n\tborder: 0 none;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tcursor: pointer\n}\n\n.nav-square button:focus {\n\toutline: 0\n}\n\n.nav-square .owl-prev {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.nav-square .owl-next {\n\tposition: absolute;\n\tright: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.nav-square.nav-square-dark button {\n\t-webkit-border-radius: 3px;\n\tborder-radius: 3px\n}\n\n.nav-square.nav-square-dark .owl-prev {\n\tmargin-left: -5px\n}\n\n.nav-square.nav-square-dark .owl-next {\n\tmargin-right: -5px\n}\n\n.carousel-one .carousel-one-single {\n\ttext-align: center\n}\n\n.carousel-one .carousel-one-single figure {\n\tmargin-bottom: 2rem\n}\n\n.carousel-one .carousel-one-single figure img {\n\t-webkit-border-radius: 5px;\n\tborder-radius: 5px\n}\n\n.carousel-one .carousel-one-single h6 {\n\tmargin-bottom: 1rem\n}\n\n.carousel-one .carousel-one-single h6 a {\n\tcolor: #202428\n}\n\n.carousel-one .carousel-one-single h6 a:hover {\n\tcolor: #06b590\n}\n\n.carousel-one .carousel-one-single p {\n\tmargin-bottom: 0\n}\n\n.carousel-three {\n\tposition: relative\n}\n\n.carousel-three .carousel-single {\n\tpadding: 1rem\n}\n\n.carousel-four .carousel-single {\n\tpadding: 1rem\n}\n\n.portfolio-carousel .dot-circle,\n.portfolio-carousel .dot-light {\n\tmargin-top: 2rem\n}\n\n.portfolio-carousel-single {\n\tmargin-bottom: 2rem;\n\toverflow: hidden\n}\n\n.portfolio-carousel-single figure {\n\tposition: relative;\n\tmargin: 0\n}\n\n.portfolio-carousel-single figure figcaption {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tbackground: rgba(28, 28, 38, .85);\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tvisibility: hidden;\n\topacity: 0;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.portfolio-carousel-single figure figcaption h5 {\n\tmargin-bottom: 1rem;\n\tcolor: #fff\n}\n\n.portfolio-carousel-single figure figcaption h5,\n.portfolio-carousel-single figure figcaption span {\n\t-webkit-transform: scale(1.3);\n\t-ms-transform: scale(1.3);\n\ttransform: scale(1.3);\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.portfolio-carousel-single figure figcaption .link {\n\tposition: absolute;\n\tright: -3.33333rem;\n\ttop: -3.33333rem;\n\twidth: 3.33333rem;\n\theight: 3.33333rem;\n\tcolor: #fff;\n\tfont-size: 1.6rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-border-radius: 0 0 0 3px;\n\tborder-radius: 0 0 0 3px;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.portfolio-carousel-single figure:hover figcaption {\n\topacity: 1;\n\tvisibility: visible\n}\n\n.portfolio-carousel-single figure:hover figcaption h5,\n.portfolio-carousel-single figure:hover figcaption span {\n\t-webkit-transform: scale(1);\n\t-ms-transform: scale(1);\n\ttransform: scale(1)\n}\n\n.portfolio-carousel-single figure:hover figcaption .link {\n\ttop: 0;\n\tright: 0\n}\n\n.image-carousel-one figure {\n\tmargin: 0\n}\n\n.image-carousel-one .nav-circle .owl-prev {\n\tmargin-left: 2rem\n}\n\n.image-carousel-one .nav-circle .owl-next {\n\tmargin-right: 2rem\n}\n\n.image-carousel-two .carousel-single figure img {\n\twidth: 100%\n}\n\n.image-carousel-two .dot-light,\n.image-carousel-two .owl-dots {\n\tmargin-top: 1.06667rem\n}\n\n.testimonial-carousel-one .carousel-single {\n\ttext-align: center\n}\n\n.testimonial-carousel-one .carousel-single img {\n\twidth: auto;\n\tmargin: 0 auto\n}\n\n.testimonial-carousel-one .carousel-single h6 {\n\tmargin: 1.33333rem 0 .66667rem 0;\n\tcolor: #202428\n}\n\n.testimonial-carousel-one .carousel-single .sub-text {\n\tcolor: #06b590;\n\tdisplay: block;\n\tmargin-bottom: 1.33333rem\n}\n\n.testimonial-carousel-one .carousel-single p {\n\tfont-size: 1.2rem;\n\tline-height: 2.26667rem;\n\tmargin: 0\n}\n\n.carousel-bg .bg_image_holder:before {\n\tposition: absolute;\n\tcontent: \"\";\n\tbackground: rgba(27, 28, 57, .8);\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0\n}\n\n.testimonial-carousel-three .nav-circle {\n\tvisibility: hidden;\n\topacity: 0;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.testimonial-carousel-three:hover .nav-circle {\n\tvisibility: visible;\n\topacity: 1\n}\n\n.testimonial-carousel-three .carousel-single {\n\tpadding: 1rem\n}\n\n.testimonial-carousel-three .carousel-single .card img {\n\twidth: auto;\n\tmargin: 0 auto\n}\n\n.tc-four-wrapper.bg-grey {\n\tbackground: #f4f4f4\n}\n\n.tc-four-wrapper.bg-grey .testimonial-carousel-four .carousel-single .author-spec strong {\n\tcolor: #202428\n}\n\n.tc-four-wrapper.bg-grey .testimonial-carousel-four .carousel-single .author-text:before {\n\tcolor: #ededef\n}\n\n.tc-four-wrapper.bg-grey .testimonial-carousel-four .carousel-single .author-text p {\n\tcolor: #5a6671\n}\n\n.tc-four-wrapper.bg-grey .testimonial-carousel-four .nav-square button {\n\tbackground: #e1e1e7;\n\tcolor: #202428\n}\n\n.testimonial-carousel-four {\n\tpadding: 7.33333rem 0 6.93333rem\n}\n\n.testimonial-carousel-four .carousel-single img {\n\twidth: auto;\n\tmargin: 0 auto\n}\n\n.testimonial-carousel-four .carousel-single .author-spec {\n\tmargin: 1.33333rem 0 0 0\n}\n\n.testimonial-carousel-four .carousel-single .author-spec strong {\n\tfont-weight: 500;\n\tcolor: #fff;\n\tfont-size: 1.2rem\n}\n\n.testimonial-carousel-four .carousel-single .author-spec span {\n\tfont-size: 1.2rem;\n\tcolor: rgba(255, 255, 255, .6)\n}\n\n.testimonial-carousel-four .carousel-single .author-spec p {\n\tmargin: 0\n}\n\n.testimonial-carousel-four .carousel-single .author-text {\n\twidth: 50rem;\n\tmargin: 0 auto;\n\tpadding-top: 3.33333rem;\n\tposition: relative\n}\n\n.testimonial-carousel-four .carousel-single .author-text:before {\n\tposition: absolute;\n\tcontent: \"\\f2ce\";\n\tfont-family: LineAwesome;\n\tfont-size: 10rem;\n\tcolor: rgba(255, 255, 255, .05);\n\tleft: 50%;\n\ttop: 0;\n\tline-height: .8;\n\t-webkit-transform: translateX(-50%);\n\t-ms-transform: translateX(-50%);\n\ttransform: translateX(-50%);\n\tz-index: -1\n}\n\n.testimonial-carousel-four .carousel-single .author-text p {\n\tfont-size: 1.2rem;\n\tcolor: rgba(255, 255, 255, .7);\n\tline-height: 2.26667rem;\n\tmargin: 0\n}\n\n.testimonial-carousel-four .nav-circle .owl-prev {\n\tmargin-left: 0\n}\n\n.testimonial-carousel-four .nav-circle .owl-next {\n\tmargin-right: 0\n}\n\n.testimonial-carousel-four .nav-circle .owl-next,\n.testimonial-carousel-four .nav-circle .owl-prev {\n\tbackground: rgba(255, 255, 255, .05);\n\tfont-size: .86667rem;\n\tcolor: #fff\n}\n\n.testimonial-carousel-four .nav-circle .owl-next:hover,\n.testimonial-carousel-four .nav-circle .owl-prev:hover {\n\tbackground: #fff;\n\tcolor: #202428\n}\n\n.testimonial-carousel-five .carousel-single {\n\tpadding: 1rem\n}\n\n.testimonial-carousel-five .carousel-single .author-text {\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tpadding: 2.66667rem 2.66667rem;\n\tposition: relative\n}\n\n.testimonial-carousel-five .carousel-single .author-text:before {\n\tposition: absolute;\n\tcontent: \"\";\n\tborder-right: 1.33333rem solid transparent;\n\tborder-left: 1.33333rem solid transparent;\n\tborder-top: 1.33333rem solid #fff;\n\tbottom: -1.33333rem;\n\tleft: 4.66667rem\n}\n\n.testimonial-carousel-five .carousel-single .author-text p {\n\tmargin-bottom: 0\n}\n\n.testimonial-carousel-five .carousel-single .author-spec {\n\tmargin-top: 2.66667rem;\n\tmargin-left: 3.33333rem;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.testimonial-carousel-five .carousel-single .author-spec .author-img {\n\tmargin-right: 1.33333rem\n}\n\n.testimonial-carousel-five .carousel-single .author-spec .author-desc h6 {\n\tmargin: 0 0 5px 0;\n\tcolor: #202428\n}\n\n.testimonial-carousel-five .nav-square-dark {\n\ttop: 40%\n}\n\n.testimonial-carousel-five .nav-square-dark .owl-prev {\n\tmargin-left: 1rem\n}\n\n.testimonial-carousel-five .nav-square-dark .owl-next {\n\tmargin-right: 1rem\n}\n\n.testimonial-carousel-six-wrapper {\n\tbackground: url(https://snmtechnologies.in/startup/img/shape-wave.png);\n\t-webkit-background-size: cover;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\tpadding: 3.2rem 0 6.93333rem 0\n}\n\n.testimonial-carousel-six {\n\tposition: relative\n}\n\n.testimonial-carousel-six:before {\n\tposition: absolute;\n\tcontent: '\\f2ce';\n\tfont-family: LineAwesome;\n\tfont-size: 13.33333rem;\n\tcolor: rgba(6, 181, 144, .1);\n\tleft: 100px;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.testimonial-carousel-six .carousel-single {\n\ttext-align: center\n}\n\n.testimonial-carousel-six .carousel-single img {\n\tdisplay: inline-block;\n\twidth: auto\n}\n\n.testimonial-carousel-six .carousel-single h5 {\n\tcolor: #202428;\n\tmargin: 1.33333rem 0 .66667rem\n}\n\n.testimonial-carousel-six .carousel-single p {\n\tmargin: 2rem 0 0 0\n}\n\n.team-carousel-one .carousel-single {\n\tpadding: 1rem\n}\n\n.team-carousel-one .carousel-single img {\n\twidth: auto;\n\tmargin: 0 auto\n}\n\n.team-carousel-two .dot-light,\n.team-carousel-two .owl-dots {\n\tmargin-top: 1.33333rem\n}\n\n.team-carousel-three {\n\tbackground: #fff;\n\t-webkit-border-radius: .26667rem;\n\tborder-radius: .26667rem\n}\n\n.team-carousel-three .carousel-single {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.team-carousel-three .carousel-single .team-img {\n\twidth: 45%\n}\n\n.team-carousel-three .carousel-single .team-img img {\n\t-webkit-border-radius: .26667rem 0 0 .26667rem;\n\tborder-radius: .26667rem 0 0 .26667rem\n}\n\n.team-carousel-three .carousel-single .team-desc {\n\twidth: 55%;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tpadding: 0 3.33333rem\n}\n\n.team-carousel-three .carousel-single .team-desc h5 {\n\tcolor: #202428;\n\tmargin: 0 0 .53333rem\n}\n\n.team-carousel-three .carousel-single .team-desc span {\n\tcolor: #9192a3\n}\n\n.team-carousel-three .carousel-single .team-desc p {\n\tmargin: 1rem 0 2rem 0\n}\n\n.team-carousel-three .nav-circle .owl-prev {\n\tmargin-left: -1.33333rem;\n\tvisibility: hidden;\n\topacity: 0;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n/* Add this to your styles */\n.logo-carousel {\n  font-family: 'Helvetica Neue', Arial, sans-serif;\n  text-align: center;\n}\n\n.logo-carousel .logo-item:hover {\n  filter: grayscale(0%) !important;\n  opacity: 1 !important;\n}\n\n/* Optional: Add a subtle heading like in your reference image */\n.logo-carousel h3 {\n  font-weight: 300;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  margin-bottom: 30px;\n  color: #333;\n  font-size: 14px;\n}\n.faicons{float: left;margin:14px;}\n.team-carousel-three .nav-circle .owl-next {\n\tmargin-right: -1.33333rem;\n\tvisibility: hidden;\n\topacity: 0;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.team-carousel-three:hover .nav-circle .owl-next,\n.team-carousel-three:hover .nav-circle .owl-prev {\n\tvisibility: visible;\n\topacity: 1;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.logo-carousel-one .carousel-single img,\n.logo-carousel-two .carousel-single img {\n\twidth: auto;\n\tmargin: 0 auto\n}\n\n.logo-carousel-one .owl-stage,\n.logo-carousel-two .owl-stage {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.logo-carousel {\n\tpadding: 7.33333rem 0 7rem\n}\n\n.logo-carousel .content-left h1 {\n\tline-height: 3.73333rem\n}\n\n.logo-carousel-two .logo-box {\n\tbackground: #fff;\n\tmargin-bottom: 2rem;\n\tmin-height: 8rem;\n\tpadding-top:20px;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .05)\n}\n\n@media all and (-ms-high-contrast:none),\n(-ms-high-contrast:active) {\n\t.logo-carousel-two .logo-box {\n\t\theight: 8rem\n\t}\n}\n\n.logo-carousel-two .logo-box:last-child {\n\tmargin-bottom: 0\n}\n\n.logo-carousel-three .carousel-single {\n\tmin-height: 8rem\n}\n\n.logo-carousel-three .carousel-single .logo-box {\n\tborder: 1px solid #e4e8ed;\n\theight: 8rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.logo-carousel-three .carousel-single .logo-box img {\n\twidth: auto\n}\n\n.logo-carousel-three .nav-square-dark {\n\tvisibility: hidden;\n\topacity: 0;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.logo-carousel-three .nav-square-dark .owl-prev {\n\tmargin-left: -1.33333rem\n}\n\n.logo-carousel-three .nav-square-dark .owl-next {\n\tmargin-right: -1.33333rem\n}\n\n.logo-carousel-three:hover .nav-square-dark {\n\tvisibility: visible;\n\topacity: 1\n}\n\n.blog-carousel-one .post-single .post-meta ul {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.blog-carousel-one .post-single .post-meta ul li {\n\tmargin-right: 1rem\n}\n\n.blog-carousel-one .post-single .post-meta ul li:last-child {\n\tmargin-right: 0\n}\n\n.blog-carousel-one .post-single .post-meta ul li span {\n\tpadding: 0 1rem;\n\tline-height: 2rem;\n\tdisplay: inline-block;\n\tcolor: #fff;\n\t-webkit-border-radius: 2px;\n\tborder-radius: 2px\n}\n\n.blog-carousel-one .post-single h6 {\n\tmargin: 1.33333rem 0 1.06667rem 0\n}\n\n.blog-carousel-one .post-single h6 a:hover {\n\tcolor: #06b590\n}\n\n.blog-carousel-one .post-single .post-bottom {\n\tmargin: 1.66667rem 0 0 0;\n\tpadding-top: 2rem;\n\tborder-top: 1px solid #e4e8ed;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.blog-carousel-one .post-single .post-bottom img {\n\twidth: auto;\n\tmargin-right: .66667rem\n}\n\n.logo-grid-one {\n\t-webkit-box-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\tbox-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\toverflow: hidden\n}\n\n.logo-grid-one ul {\n\tmargin-right: -1px;\n\tmargin-bottom: -1px\n}\n\n.logo-grid-one li {\n\twidth: 25%;\n\tborder-right: 1px solid #dee2e6;\n\tborder-bottom: 1px solid #dee2e6;\n\tbackground: #fff;\n\tmin-height: 13.33333rem\n}\n\n.logo-grid-one li figure {\n\tmargin: 0\n}\n\n.logo-carousel-dark .single-slide img {\n\twidth: auto\n}\n\n.logo-grid-two .grid-single {\n\tbackground: #fff;\n\tmargin-bottom: 2rem;\n\tmin-height: 10rem\n}\n\n@media all and (-ms-high-contrast:none),\n(-ms-high-contrast:active) {\n\t.logo-grid-two .grid-single {\n\t\theight: 10rem\n\t}\n}\n\n.logo-grid-three ul {\n\tmargin: 0\n}\n\n.logo-grid-three li {\n\twidth: 25%;\n\tborder: 1px solid #dee2e6;\n\tbackground: #fff;\n\tmin-height: 13.33333rem;\n\tmargin-right: -1px;\n\tmargin-bottom: -1px\n}\n\n.logo-grid-three li figure {\n\tmargin: 0\n}\n\n.logo-details-wrapper {\n\tpadding: 6rem 0 0\n}\n\n.logo-details {\n\t-webkit-box-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\tbackground: #fff;\n\tpadding: 7rem 3rem 2rem;\n\tmargin-bottom: 7.33333rem;\n\tmargin-top: .66667rem;\n\tposition: relative;\n\t-webkit-border-radius: .26667rem;\n\tborder-radius: .26667rem\n}\n\n.logo-details .logo {\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\theight: 10.66667rem;\n\twidth: 18.66667rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 0;\n\t-webkit-transform: translate(-50%, -50%);\n\t-ms-transform: translate(-50%, -50%);\n\ttransform: translate(-50%, -50%);\n\tbackground: #fff;\n\t-webkit-border-radius: .26667rem;\n\tborder-radius: .26667rem\n}\n\n.logo-details h5 {\n\tcolor: #202428;\n\tmargin-bottom: .33333rem\n}\n\n.logo-details .sub-title {\n\tdisplay: block;\n\tmargin-bottom: .8rem\n}\n\n.logo-details p {\n\tmargin: 0\n}\n\n.logo-carousel-four .owl-stage {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: justify;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: justify;\n\tjustify-content: space-between\n}\n\n.logo-carousel-four .carousel-single {\n\ttext-align: center\n}\n\n.logo-carousel-four .carousel-single img {\n\tdisplay: inline-block;\n\twidth: auto\n}\n\n.dropdown .dropdown-toggle:focus {\n\t-webkit-box-shadow: none !important;\n\tbox-shadow: none !important\n}\n\n.dropdown .dropdown-caret {\n\tdisplay: inline-block;\n\tpadding-left: 1rem\n}\n\n.dropdown .dropdown-menu {\n\ttop: .66667rem !important;\n\tmin-width: 16.66667rem;\n\tmargin: 0;\n\tpadding: 0;\n\t-webkit-box-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\tbox-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\tborder: 0 none\n}\n\n.dropdown .dropdown-menu .dropdown-item:hover {\n\tbackground: 0 0;\n\tcolor: #413aa4;\n\t-webkit-border-radius: 0;\n\tborder-radius: 0\n}\n\n.dropdown .dropdown--btn .dropdown-item:hover {\n\tbackground: #413aa4;\n\tcolor: #fff;\n\t-webkit-border-radius: .2rem;\n\tborder-radius: .2rem\n}\n\n.dropdown .dropdown--text .dropdown-text-item {\n\tpadding: 30px;\n\tmargin: 0\n}\n\n.gallery-image-view .portfolio-carousel-single {\n\tmargin-bottom: .66667rem\n}\n\n.gallery-image-view .portfolio-carousel-single img {\n\twidth: auto\n}\n\n.gallery-image-view .carousel-thumbs ul {\n\tmargin: 0\n}\n\n.gallery-image-view .carousel-thumbs ul li {\n\tmargin: 0 .33333rem\n}\n\n.gallery-image-view .image-view-carousel .carousel-single figure img {\n\twidth: 100%\n}\n\n.gallery-fullwidth .portfolio-carousel-single {\n\twidth: 25%\n}\n\n.price-filter {\n\tmargin-top: 10px\n}\n\n.range-slider .slider-range {\n\tbackground: #e4e8ed;\n\t-webkit-border-radius: 1.66667rem;\n\tborder-radius: 1.66667rem;\n\theight: .4rem;\n\tmax-width: 13.33333rem\n}\n\n.range-slider .slider-range .ui-slider-range {\n\tbackground: #413aa4\n}\n\n.range-slider .slider-range .ui-slider-handle {\n\twidth: 1.2rem;\n\theight: 1.2rem;\n\tborder: .26667rem solid #413aa4;\n\tbackground: #fff;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\ttop: -.4rem;\n\tcursor: pointer\n}\n\n.range-slider .slider-range .ui-slider-handle:focus {\n\toutline: 0\n}\n\n.range-slider p {\n\tmargin: 1.66667rem 0 0 0\n}\n\n.range-slider .amounts {\n\tborder: 0 none;\n\tmargin-left: 1.33333rem;\n\tcolor: #5a6671;\n\tfont-size: 1.06667rem;\n\twidth: 6rem;\n\tbackground: 0 0\n}\n\n.range-slider-dark .slider-range {\n\tbackground: rgba(65, 58, 164, .2)\n}\n\n.video-single figure {\n\tposition: relative;\n\tmargin: 0\n}\n\n.video-single figure .v_img {\n\tposition: relative\n}\n\n.video-single figure .v_img:before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tbackground: rgba(15, 15, 30, .2)\n}\n\n.video-single figure figcaption {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%\n}\n\n.video-overlay figcaption {\n\tbackground: rgba(32, 36, 40, .3)\n}\n\n.video-banner {\n\tpadding: 5rem 2rem;\n\toverflow: hidden\n}\n\n.video-banner div a {\n\tcolor: #fff;\n\tfont-weight: 500;\n\tfont-size: 1.33333rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.video-banner div a .play-btn {\n\tmargin-right: 2rem\n}\n\n.video-bg {\n\tpadding: 7.33333rem 0\n}\n\n.video-bg.overlay:before {\n\tbackground: rgba(27, 28, 57, .8)\n}\n\n.video-bg .content_above a {\n\tcolor: #fff;\n\tfont-weight: 500;\n\tfont-size: 1.6rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.cta--one .sub-heading {\n\tfont-size: 1.6rem;\n\tfont-weight: 500\n}\n\n.cta--one h2 {\n\tcolor: #fff;\n\tmargin: 1.33333rem 0 3.33333rem;\n\tline-height: 3.2rem;\n\tfont-weight: 500\n}\n\n.splitted-banner {\n\tpadding: 10rem 0;\n\tposition: relative;\n\toverflow: hidden\n}\n\n.splitted-banner .split-bg {\n\tposition: absolute;\n\twidth: 53%;\n\theight: 46.66667rem;\n\tleft: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tbackground: #06b590;\n\tz-index: 1;\n\theight: 100%\n}\n\n.splitted-banner .split-bg:before {\n\tposition: absolute;\n\tcontent: '';\n\theight: 150%;\n\twidth: 26.66667rem;\n\tright: -28.66667rem;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\t-webkit-box-shadow: -6.66667rem 0 0 #06b590;\n\tbox-shadow: -6.66667rem 0 0 #06b590;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%\n}\n\n.splitted-banner h1 {\n\tcolor: #fff\n}\n\n.splitted-banner .btns a {\n\tmargin-right: 2rem\n}\n\n.splitted-banner .btns a:last-child {\n\tmargin-right: 0\n}\n\n.subscribe-wrapper {\n\tpadding: 6.33333rem 0\n}\n\n.subscribe-wrapper h2 {\n\tcolor: #fff;\n\tmargin: 0 0 1rem 0\n}\n\n.subscribe-wrapper p {\n\tfont-size: 1.13333rem;\n\tcolor: rgba(255, 255, 255, .7);\n\tmargin-bottom: 2.33333rem\n}\n\n.subscribe-wrapper .subscribe-form button {\n\tmargin-left: 2rem\n}\n\n.subscribe--two {\n\tposition: relative;\n\tbackground: -webkit-linear-gradient(310deg, #413aa4 0, #413aa4 25%, #06b590 100%);\n\tbackground: -o-linear-gradient(310deg, #413aa4 0, #413aa4 25%, #06b590 100%);\n\tbackground: linear-gradient(140deg, #413aa4 0, #413aa4 25%, #06b590 100%);\n\tpadding-bottom: 10rem;\n\toverflow: hidden\n}\n\n.subscribe--two:before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 100%;\n\theight: 5.06667rem;\n\tleft: 0;\n\tbottom: 0;\n\tbackground: url(https://snmtechnologies.in/startup/img/sb2.html);\n\tbackground-repeat: no-repeat;\n\t-webkit-background-size: cover;\n\tbackground-size: cover;\n\tbackground-position: center\n}\n\n.subscribe-six,\n.subscribe-three {\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .05);\n\tpadding: 4rem 0;\n\tposition: relative;\n\tz-index: 1\n}\n\n.subscribe-six h4,\n.subscribe-three h4 {\n\tmargin: 0\n}\n\n.subscribe-six .subscribe-form--inline input,\n.subscribe-three .subscribe-form--inline input {\n\tbackground: #f4f4f4\n}\n\n.subscribe-six .subscribe-form--inline button,\n.subscribe-three .subscribe-form--inline button {\n\tmargin-left: 2rem\n}\n\n.subscribe-four {\n\tpadding: 8.66667rem 0\n}\n\n.subscribe-four h3 {\n\tmargin: 0 0 .53333rem 0;\n\tcolor: #fff\n}\n\n.subscribe-four p {\n\tmargin: 0;\n\tcolor: rgba(255, 255, 255, .7);\n\tfont-size: 1.2rem\n}\n\n.subscribe-four form .input-group-subscribe button {\n\tbackground: #413aa4\n}\n\n.subscribe--five h2 {\n\tcolor: #fff;\n\tmargin-bottom: 1rem\n}\n\n.subscribe--five p {\n\tcolor: #fff;\n\tfont-size: 1.13333rem;\n\tmargin-bottom: 2.4rem\n}\n\n.subscribe--five .subscribe-form-two .form-control {\n\tpadding-top: .33333rem;\n\tpadding-bottom: .33333rem;\n\theight: 4rem\n}\n\n.subscribe--five .subscribe-form-two .btn {\n\tline-height: 2.66667rem;\n\tright: .33333rem\n}\n\n.subscribe-seven {\n\tpadding: 7.66667rem 0;\n\tbackground: url(https://snmtechnologies.in/startup/img/map-bg.png);\n\tbackground-repeat: no-repeat;\n\tbackground-position: center\n}\n\n.subscribe-form-two>div {\n\tposition: relative\n}\n\n.subscribe-form-two .form-control {\n\theight: 4.66667rem;\n\t-webkit-box-shadow: 0 10px 30px rgba(105, 106, 119, .15);\n\tbox-shadow: 0 10px 30px rgba(105, 106, 119, .15);\n\tborder: 0 none;\n\t-webkit-border-radius: .2rem;\n\tborder-radius: .2rem;\n\tpadding-right: 12.33333rem;\n\tpadding-left: 2rem\n}\n\n.subscribe-form-two .btn {\n\tposition: absolute;\n\tright: 1rem;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\t-webkit-box-shadow: none;\n\tbox-shadow: none\n}\n\n.subscribe-contents h2 {\n\tline-height: 3.2rem;\n\tcolor: #202428;\n\tfont-size: 1.6rem\n}\n\n.subscribe-contents h2 span {\n\tcolor: #06b590;\n\tfont-size: 2.4rem\n}\n\n.subscribe-contents img {\n\tmargin-top: 4.66667rem\n}\n\n.subscribe-eight {\n\tpadding: 6.33333rem 0 7.33333rem\n}\n\n.twitter-feeds {\n\tpadding: 7rem 0 7.2rem\n}\n\n.twitter-feeds .feed-single .feed-header {\n\tmargin-bottom: 2.66667rem\n}\n\n.twitter-feeds .feed-single .feed-header span i {\n\tfont-size: 2rem;\n\tcolor: #fff\n}\n\n.twitter-feeds .feed-single .feed-header .user {\n\tcolor: #fff\n}\n\n.twitter-feeds .feed-single .feed-header .time {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\n.twitter-feeds .feed-single .feed-header p {\n\tmargin: 0\n}\n\n.twitter-feeds .feed-single .feed-content {\n\twidth: 48.66667rem;\n\tmargin: 0 auto\n}\n\n.twitter-feeds .feed-single .feed-content p {\n\tfont-size: 1.2rem;\n\tline-height: 2.13333rem;\n\tcolor: rgba(255, 255, 255, .7);\n\tmargin-bottom: 1.33333rem\n}\n\n.twitter-feeds .feed-single .feed-content .twit-link {\n\tcolor: #fff\n}\n\n.twitter-feeds .feed-single .feed-content .twit-link:hover {\n\tcolor: #202428\n}\n\n.twitter-feeds--light .feed-single .feed-header .user {\n\tcolor: #413aa4\n}\n\n.twitter-feeds--light .feed-single .feed-header .time {\n\tcolor: rgba(32, 36, 40, .5)\n}\n\n.twitter-feeds--light .feed-single .feed-header span i {\n\tcolor: #06b590\n}\n\n.twitter-feeds--light .feed-single .feed-content p {\n\tcolor: inherit\n}\n\n.twitter-feeds--light .feed-single .feed-content .twit-link {\n\tcolor: #06b590\n}\n\n.follow-btn .btn {\n\ttext-transform: capitalize;\n\tdisplay: -webkit-inline-box;\n\tdisplay: -webkit-inline-flex;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.follow-btn .btn i {\n\tfont-size: 1.2rem;\n\tmargin-right: .66667rem\n}\n\n.cta-wrapper {\n\tpadding: 6.86667rem 0 7.33333rem\n}\n\n.cta-wrapper-sm {\n\tpadding: 4rem 0\n}\n\n.cta--two {\n\tposition: relative;\n\toverflow: hidden;\n\tpadding: 6.86667rem 0 10rem\n}\n\n.cta--two:after {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 100%;\n\theight: 5.06667rem;\n\tleft: 0;\n\tbottom: 0;\n\tbackground: url(https://snmtechnologies.in/startup/img/sb2.html);\n\tbackground-repeat: no-repeat;\n\t-webkit-background-size: cover;\n\tbackground-size: cover;\n\tbackground-position: bottom;\n\t-webkit-transform: rotateY(-180deg) translateY(.8%);\n\ttransform: rotateY(-180deg) translateY(.8%);\n\tz-index: 1\n}\n\n.cta--two .cta-content p {\n\tcolor: #fff;\n\tfont-size: 2.4rem;\n\tline-height: 3.6rem;\n\tfont-weight: 600;\n\tmargin: 0\n}\n\n.cta--two .action-btn {\n\ttext-align: right\n}\n\n.cta--eight .action-btn,\n.cta--five .action-btn,\n.cta--four .action-btn,\n.cta--seven .action-btn,\n.cta--six .action-btn {\n\ttext-align: right\n}\n\n.cta--three .cta-content p {\n\tcolor: #fff;\n\tfont-size: 2.4rem;\n\tline-height: 3.66667rem;\n\tfont-weight: 600;\n\tmargin: 0 0 3rem\n}\n\n.cta--four .cta-content h1 {\n\tcolor: #fff;\n\tfont-weight: 600\n}\n\n.cta--four .cta-content p {\n\tcolor: rgba(255, 255, 255, .8);\n\tfont-size: 1.2rem;\n\tline-height: 2.26667rem\n}\n\n.cta--four .cta-content .phone {\n\tfont-size: 2.4rem;\n\tdisplay: block;\n\tcolor: #fff;\n\tmargin-bottom: 3rem;\n\tfont-weight: 600\n}\n\n.cta--five {\n\t-webkit-box-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\tbox-shadow: 0 5px 30px rgba(41, 41, 59, .1)\n}\n\n.cta--five p {\n\tfont-size: 2rem;\n\tcolor: #202428;\n\tfont-weight: 600\n}\n\n.cta--six p {\n\tfont-weight: 600;\n\tfont-size: 2rem\n}\n\n.cta--seven {\n\tfont-weight: 600;\n\tfont-size: 2.4rem\n}\n\n.cta--seven p {\n\tfont-weight: 600;\n\tfont-size: 2rem\n}\n\n.cta--eight h1 {\n\tline-height: 3.66667rem\n}\n\n.cta--nine {\n\tposition: relative;\n\toverflow: hidden\n}\n\n.cta--nine .cta--none-contents {\n\tposition: relative\n}\n\n.cta--nine .cta--none-contents:before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 25.13333rem;\n\theight: 55.53333rem;\n\tright: 0;\n\ttop: 0;\n\tbackground: rgba(255, 255, 255, .03);\n\t-webkit-border-radius: 5.33333rem;\n\tborder-radius: 5.33333rem;\n\t-webkit-transform: rotate(-45deg) translateX(82%);\n\t-ms-transform: rotate(-45deg) translateX(82%);\n\ttransform: rotate(-45deg) translateX(82%)\n}\n\n.cta--nine .cta--none-contents:after {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 33.33333rem;\n\theight: 55.53333rem;\n\tright: 0;\n\ttop: 0;\n\tbackground: rgba(255, 255, 255, .03);\n\t-webkit-border-radius: 5.33333rem;\n\tborder-radius: 5.33333rem;\n\t-webkit-transform: rotate(-45deg) translate(59%, 20%);\n\t-ms-transform: rotate(-45deg) translate(59%, 20%);\n\ttransform: rotate(-45deg) translate(59%, 20%)\n}\n\n.cta--nine.cta-wrapper {\n\tpadding-top: 4.66667rem\n}\n\n.cta--nine h3 {\n\tcolor: #fff;\n\tfont-weight: 300;\n\tline-height: 3.06667rem;\n\tfont-size: 29px\n}\n\n.cta--nine h3 span {\n\tfont-weight: 600\n}\n\n.cta--nine:before {\n\tposition: absolute;\n\tcontent: \"\";\n\twidth: 180%;\n\theight: 150%;\n\tbackground: #fff;\n\tleft: -40%;\n\ttop: 87%;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%\n}\n\n.process-one {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap;\n\tmargin-left: -1rem;\n\tmargin-right: -1rem\n}\n\n.process-one .process-single {\n\twidth: 25%;\n\tmargin-bottom: 4.66667rem;\n\tpadding: 0 1rem\n}\n\n.process-one .process-single:nth-child(2n+1) .icon:before {\n\tcontent: url(https://snmtechnologies.in/startup/img/arrow-up.png)\n}\n\n.process-one .process-single .icon {\n\twidth: 9.33333rem;\n\theight: 9.33333rem;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tposition: relative;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin: 0 auto 2rem\n}\n\n.process-one .process-single .icon.gray-bg {\n\tbackground: rgba(6, 181, 144, .1)\n}\n\n.process-one .process-single .icon.light-bg {\n\tbackground: #fff\n}\n\n.process-one .process-single .icon .icon-la {\n\tfont-size: 3.2rem;\n\tcolor: #06b590\n}\n\n.process-one .process-single .icon .step {\n\tposition: absolute;\n\twidth: 2.33333rem;\n\theight: 2.33333rem;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tbackground: #fff;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tcolor: #202428;\n\tfont-weight: 500;\n\tleft: 0;\n\ttop: 0;\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .1)\n}\n\n.process-one .process-single .icon:before {\n\tposition: absolute;\n\tcontent: url(https://snmtechnologies.in/startup/img/arrow-down.png);\n\tright: -90%;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.process-one .process-single h6 {\n\tmargin-bottom: 1rem\n}\n\n.process-one .process-single p {\n\tmargin: 0\n}\n\n.process-one .process-single:last-child,\n.process-one .process-single:nth-child(4n) {\n\tmargin-right: 0\n}\n\n.process-one .process-single:last-child .icon:before,\n.process-one .process-single:nth-child(4n) .icon:before {\n\tcontent: none\n}\n\n.process-three {\n\tbackground: #fff;\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tpadding: 1.73333rem 2rem 1.6rem\n}\n\n.process-three span {\n\tdisplay: block;\n\tfont-size: 2.33333rem;\n\tfont-weight: 400;\n\tcolor: #06b590;\n\tmargin-bottom: 1.2rem;\n\tline-height: 1\n}\n\n.process-three h6 {\n\tmargin-bottom: 1.2rem\n}\n\n.process-three p {\n\tmargin: 0\n}\n\n.team-four {\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\t-webkit-box-shadow: 0 5px 20px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 20px rgba(105, 106, 119, .05)\n}\n\n.team-four .subtitle {\n\tmargin-bottom: 1.33333rem;\n\tdisplay: inline-block;\n\tfont-size: .93333rem\n}\n\n.team-four img {\n\t-webkit-border-radius: .26667rem .26667rem 0 0;\n\tborder-radius: .26667rem .26667rem 0 0;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.team-four .content {\n\tpadding: 1.8rem 2rem 2rem;\n\t-webkit-border-radius: 0 0 .26667rem .26667rem;\n\tborder-radius: 0 0 .26667rem .26667rem;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tbackground: #fff\n}\n\n.team-four .content h6 {\n\tmargin-bottom: .66667rem;\n\tfont-size: 1.06667rem\n}\n\n.team-five .content {\n\tmargin-top: 1.66667rem\n}\n\n.team-five .content h6 {\n\tmargin-bottom: .66667rem\n}\n\n.team-five .content span {\n\tdisplay: block\n}\n\n.counter.counter--4 .counter_single .team-five .content span.value,\n.nav_right_content .cart_module .cart__items .cart_info p .team-five .content span,\n.nav_right_content .cart_module .cart__items .items .item_remove .team-five .content span,\n.tab-content.tab--content2 .tab-pane .tab_text_module .team-five .content span.tab_text_module__subtitle,\n.tab.tab--8 .tab_nav7 .nav .nav-item .team-five .content span.nav-link.active,\n.team-five .content .counter.counter--4 .counter_single span.value,\n.team-five .content .nav_right_content .cart_module .cart__items .cart_info p span,\n.team-five .content .nav_right_content .cart_module .cart__items .items .item_remove span,\n.team-five .content .tab-content.tab--content2 .tab-pane .tab_text_module span.tab_text_module__subtitle,\n.team-five .content .tab.tab--8 .tab_nav7 .nav .nav-item span.nav-link.active,\n.team-five .content .timeline1 .happening .happening__period .wrapper span.year,\n.team-five .content span.color-primary,\n.timeline1 .happening .happening__period .wrapper .team-five .content span.year {\n\tfont-weight: 500\n}\n\n.faq-single {\n\tmargin-bottom: 40px\n}\n\n.faq-single h6 {\n\tmargin-bottom: .66667rem\n}\n\n.faq-single p {\n\tmargin: 0\n}\n\n.event-sidebar {\n\tborder: 1px solid #e4e8ed\n}\n\n.widget-wrapper .widget-default {\n\t-webkit-border-radius: .26667rem;\n\tborder-radius: .26667rem;\n\tborder: 1px solid #e4e8ed;\n\tmargin-bottom: 2rem\n}\n\n.widget-wrapper .widget-header .widget-title {\n\tmargin: 0;\n\tborder-bottom: 1px solid #e4e8ed;\n\tpadding: 1.33333rem 2rem 1.33333rem 2rem\n}\n\n.widget-wrapper .widget-content {\n\tpadding: 2rem 2rem 2rem\n}\n\n.widget-wrapper .widget-shadow {\n\tbackground: #fff;\n\t-webkit-box-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 10px rgba(105, 106, 119, .05);\n\t-webkit-border-radius: .4rem;\n\tborder-radius: .4rem\n}\n\n.signup-widget .form-group {\n\tmargin-bottom: 1.33333rem\n}\n\n.signup-widget .form-group:last-child {\n\tmargin-bottom: 0\n}\n\n.search-widget {\n\tmargin-bottom: 2rem\n}\n\n.search-widget .input-group {\n\tposition: relative\n}\n\n.search-widget .input-group input {\n\twidth: 100%;\n\t-webkit-border-radius: 1.66667rem;\n\tborder-radius: 1.66667rem;\n\tbackground: #f5f4f7;\n\tborder: 0 none;\n\theight: 3.33333rem;\n\tpadding: 0 4rem 0 1.66667rem\n}\n\n.search-widget .input-group input:focus {\n\toutline: 0\n}\n\n.search-widget .input-group button {\n\tpadding: 0 1.33333rem;\n\t-webkit-border-radius: 1.66667rem;\n\tborder-radius: 1.66667rem;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\theight: 3.33333rem;\n\tbackground: 0 0;\n\tborder: 0;\n\tcursor: pointer\n}\n\n.category-widget ul {\n\tmargin-top: -6px\n}\n\n.category-widget ul li a {\n\tcolor: #202428;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.category-widget ul li a:hover {\n\tcolor: #413aa4\n}\n\n.sidebar-post .post-single {\n\tmargin-bottom: 1.66667rem\n}\n\n.sidebar-post .post-single:last-child {\n\tmargin-bottom: 0\n}\n\n.sidebar-post .post-single img {\n\t-webkit-border-radius: 3px;\n\tborder-radius: 3px\n}\n\n.sidebar-post .post-single P {\n\tmargin: 0 0 0 1rem\n}\n\n.sidebar-post .post-single P span {\n\tdisplay: block;\n\tline-height: 1.46667rem\n}\n\n.sidebar-post .post-single .post-title {\n\tmargin-top: .66667rem;\n\tdisplay: block;\n\tfont-weight: 500;\n\tcolor: #202428\n}\n\n.tags-widget ul {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap;\n\tmargin-bottom: -10px\n}\n\n.tags-widget ul li {\n\tmargin-right: .66667rem;\n\tmargin-bottom: .66667rem\n}\n\n.tags-widget ul li:last-child {\n\tmargin-right: 0\n}\n\n.tags-widget ul li a {\n\tline-height: 1.73333rem;\n\tdisplay: block;\n\tborder: 1px solid #e4e8ed;\n\t-webkit-border-radius: 3px;\n\tborder-radius: 3px;\n\tpadding: 2px .66667rem;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tcolor: #5a6671;\n\tfont-size: .86667rem\n}\n\n.tags-widget ul li a:hover {\n\tcolor: #fff;\n\tbackground: #413aa4;\n\tborder-color: #413aa4\n}\n\n.addresses_carousel .adress img {\n\tmax-width: 100%;\n\twidth: auto;\n\tdisplay: inline-block\n}\n\n.addresses_carousel .dot-light,\n.addresses_carousel .owl-dots {\n\tmargin-top: 0\n}\n\n.adress {\n\tpadding: 0 2rem;\n\tmargin-bottom: 3.33333rem\n}\n\n.adress .nam {\n\tmargin-top: 1.66667rem;\n\tfont-size: 1.2rem;\n\tcolor: #202428;\n\tmargin-bottom: .66667rem;\n\tfont-weight: 600\n}\n\n.adress img {\n\tmax-width: 100%;\n\twidth: auto;\n\tdisplay: inline-block\n}\n\n.adress p {\n\tmargin: 0\n}\n\n.adress {\n\ttext-align: center\n}\n\n.map#map1,\n.map#map3,\n.map#map4 {\n\theight: 400px\n}\n\n.map#map2 {\n\theight: 500px\n}\n\nfooter {\n\tbackground: #f4f4f4\n}\n\nfooter .footer__big {\n\tpadding: 7.33333rem 0 3.33333rem\n}\n\nfooter .footer__big .text_widget p {\n\tline-height: 2rem;\n\tmargin-bottom: 1.33333rem\n}\n\nfooter .footer__big .text_widget p .address,\nfooter .footer__big .text_widget p .mail,\nfooter .footer__big .text_widget p .tel {\n\tdisplay: block;\n\tcolor: #5a6671\n}\n\nfooter .footer__big .text_widget p .mail:hover,\nfooter .footer__big .text_widget p .tel:hover {\n\tcolor: #06b590\n}\n\nfooter .footer__big .text_widget .footer_logo {\n\tmargin-bottom: 2rem\n}\n\nfooter .footer__big .widget {\n\tmargin-bottom: 4rem\n}\n\nfooter .footer__big .widget .widget__title {\n\tfont-size: 1.06667rem;\n\ttext-transform: uppercase;\n\tline-height: normal;\n\tfont-weight: 600;\n\tposition: relative\n}\n\nfooter .footer__big .widget .widget__title2 {\n\tfont-size: 1.13333rem;\n\tcolor: #202428\n}\n\nfooter .footer__big .widget .widget__social {\n\tmargin-top: 30px\n}\n\nfooter .footer__big .widget.subcribe--widget .subscribe_form .embed_icon {\n\tfont-size: 1.33333rem;\n\tcolor: #5a6671\n}\n\nfooter .footer__big .widget.subcribe--widget .subscribe_form input {\n\twidth: 100%;\n\tfont-size: 1rem;\n\tcolor: #9192a3;\n\toutline: 0;\n\tpadding-left: 1.4rem;\n\tpadding-right: 1rem\n}\n\nfooter .footer__big .widget ul.links li {\n\tmargin-bottom: .66667rem\n}\n\nfooter .footer__big .widget ul.links li:last-child {\n\tmargin-bottom: 0\n}\n\nfooter .footer__big .widget ul.links li a {\n\tcolor: #5a6671\n}\n\nfooter .footer__big .widget ul.links li a:hover {\n\tcolor: #06b590\n}\n\nfooter .footer__big .widget--contact_info ul li {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-bottom: 31px\n}\n\nfooter .footer__big .widget--contact_info ul li span.la {\n\tfont-size: 28px;\n\tmargin-right: 12px\n}\n\nfooter .footer__big .widget--contact_info ul li .info p {\n\tmargin: 0;\n\tcolor: #fff;\n\tfont-size: 1.06667rem;\n\tline-height: 26px\n}\n\nfooter .footer__big .widget--contact_info ul li .info small {\n\tfont-size: 14px\n}\n\nfooter .footer__big .widget--latest-news ul li {\n\tmargin-bottom: 20px\n}\n\nfooter .footer__big .widget--latest-news ul li small {\n\tfont-size: 1rem;\n\tdisplay: block;\n\tline-height: 30px\n}\n\nfooter .footer__big .widget--latest-news ul li a {\n\tcolor: #fff;\n\tfont-weight: 500;\n\tline-height: 28px\n}\n\nfooter .footer__small {\n\tbackground: #000\n}\n\nfooter .footer__small p {\n\tcolor: rgba(255, 255, 255, .6);\n\tmargin: 0;\n\tpadding: 30px 0\n}\n\nfooter .footer__small a {\n\tcolor: #06b590\n}\n\nfooter .footer__bottom .footer__bottom-content {\n\tborder-top: 1px solid #eaeaea;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: justify;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: justify;\n\tjustify-content: space-between;\n\tpadding: 2.33333rem 0\n}\n\nfooter .footer__bottom .footer__bottom-content p {\n\tmargin: 0\n}\n\nfooter .footer__bottom .footer__bottom-content p>a {\n\tcolor: #06b590\n}\n\nfooter .footer__bottom .footer__bottom-content .social-basic li a {\n\tcolor: #9192a3\n}\n\nfooter .footer__bottom .footer__bottom-content .social-basic li a:hover {\n\tcolor: #06b590\n}\n\nfooter.footer--dark .footer__big .text_widget p a,\nfooter.footer--dark .footer__big .text_widget p span {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\nfooter.footer--dark .footer__big .widget.subcribe--widget p {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\nfooter.footer--dark .footer__big .widget .widget__title {\n\tcolor: #fff\n}\n\nfooter.footer--dark .footer__big .widget ul.links li a:hover {\n\tcolor: #06b590\n}\n\nfooter.footer--light .widget__social .social ul li a {\n\tbackground: #fff\n}\n\nfooter.footer--light .widget__social .social ul li a span {\n\tcolor: #9192a3\n}\n\nfooter.footer--light .widget__social .social ul li a:hover {\n\tbackground: #413aa4\n}\n\nfooter.footer--light .widget__social .social ul li a:hover span {\n\tcolor: #fff\n}\n\nfooter.footer--light .widget--contact_info ul li .info p {\n\tcolor: #202428;\n\tfont-weight: 500\n}\n\nfooter.footer--light .widget--latest-news ul li a {\n\tcolor: #202428\n}\n\nfooter.footer2.footer--light {\n\tbackground: #fff\n}\n\nfooter.footer2.footer--light .widget.twit--widget .user .name {\n\tcolor: #06b590\n}\n\nfooter.footer2.footer--light .widget.twit--widget .user .name+span {\n\tcolor: #9192a3\n}\n\nfooter.footer2.footer--light .footer__small {\n\tbackground: #fff;\n\tborder-top: 1px solid #e4e8ed\n}\n\nfooter.footer2.footer--light .footer__small p {\n\tcolor: #5a6671\n}\n\nfooter.footer2 .widget.twit--widget .user {\n\tmargin-top: 14px\n}\n\nfooter.footer2 .widget.twit--widget .user .name {\n\tcolor: #fff\n}\n\nfooter.footer2 .widget.twit--widget .user .name+span:before {\n\tcontent: \"-\";\n\tmargin: 0 3px\n}\n\nfooter.footer2 .widget.twit--widget a {\n\tdisplay: inline-block\n}\n\nfooter.footer2 .widget.twit--widget span.fab {\n\tmargin-right: 12px;\n\tfont-size: 18px\n}\n\nfooter.footer2 .widget.twit--widget .twit_wrapper>span {\n\tposition: relative;\n\ttop: .46667rem\n}\n\nfooter.footer2 .footer__small p {\n\tcolor: rgba(255, 255, 255, .7)\n}\n\nfooter.footer2 .footer__small p a:hover {\n\tcolor: #fff\n}\n\nfooter.footer3 .footer__small {\n\tbackground: #e4e8ed\n}\n\nfooter.footer3 .footer__small p {\n\tcolor: #5a6671\n}\n\nfooter.footer4 .footer__big {\n\tpadding: 7.33333rem 0\n}\n\nfooter.footer4 .footer_menu_items ul li {\n\tpadding: .94rem\n}\n\nfooter.footer4 .footer_menu_items ul li a {\n\tline-height: 2.14rem;\n\tcolor: rgba(255, 255, 255, .5)\n}\n\nfooter.footer4 .footer_menu_items ul li a:hover {\n\tcolor: #fff\n}\n\nfooter.footer4 .footer__small .info_links li+li {\n\tmargin-left: 17px\n}\n\nfooter.footer4 .footer__small .info_links:before {\n\tcontent: '|';\n\tmargin: 0 30px;\n\tcolor: rgba(255, 255, 255, .2)\n}\n\nfooter.footer4 .footer_menu_items {\n\tbackground: rgba(255, 255, 255, .1)\n}\n\nfooter.footer4 .footer__small {\n\tpadding: 1.66667rem 0;\n\tborder-top: 1px solid rgba(255, 255, 255, .1)\n}\n\nfooter.footer4 .footer__small p,\nfooter.footer4 .footer__small ul {\n\tpadding: 0;\n\tmargin: 0\n}\n\nfooter.footer4 .social.square ul li a {\n\tborder: 1px solid rgba(255, 255, 255, .2)\n}\n\nfooter.footer4 .social.square ul li a:hover {\n\tborder-color: transparent\n}\n\nfooter.footer4.footer--light .footer4_text {\n\tcolor: #5a6671\n}\n\nfooter.footer4.footer--light .footer_menu_items {\n\tbackground: #fff\n}\n\nfooter.footer4.footer--light .footer__small {\n\tbackground: #fff\n}\n\nfooter.footer4.footer--light .footer__small p {\n\tcolor: #5a6671\n}\n\nfooter.footer4.footer--light .footer__small .info_links li a {\n\tcolor: #5a6671\n}\n\nfooter.footer4.footer--light .footer__small .social.square li a {\n\tcolor: #9192a3;\n\tborder-color: #e4e8ed\n}\n\nfooter.footer4.footer--light .footer__small .social.square li a:hover {\n\tcolor: #fff;\n\tborder-color: transparent\n}\n\nfooter.footer4 .footer4_text {\n\tmargin: 3.33rem 0 4.66rem;\n\tline-height: 2rem\n}\n\nfooter.footer5.footer--bw .footer__big {\n\tbackground: #111115\n}\n\nfooter.footer5.footer--bw .footer__big .text_widget a {\n\tcolor: #fff\n}\n\nfooter.footer5.footer--bw .footer__big .text_widget a:hover {\n\tcolor: #413aa4\n}\n\nfooter.footer5.footer--bw .footer__big .widget ul.links a:hover {\n\tcolor: #fff\n}\n\nfooter.footer5.footer--bw .footer__big .widget .widget__title {\n\tcolor: #fff\n}\n\nfooter.footer5.footer--bw .footer_small {\n\tbackground: #000\n}\n\nfooter.footer--light-gradient {\n\tbackground: -webkit-gradient(linear, left top, left bottom, from(#fbfbfd), to(#f2f1fa));\n\tbackground: -webkit-linear-gradient(top, #fbfbfd, #f2f1fa);\n\tbackground: -o-linear-gradient(top, #fbfbfd, #f2f1fa);\n\tbackground: linear-gradient(to bottom, #fbfbfd, #f2f1fa)\n}\n\nfooter.footer6 {\n\tposition: relative;\n\toverflow: hidden;\n\tpadding-top: 4.33333rem\n}\n\nfooter.footer6:before {\n\tposition: absolute;\n\tcontent: \"\";\n\twidth: 180%;\n\theight: 150%;\n\tbackground: #fff;\n\tleft: -40%;\n\ttop: -137%;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%\n}\n\nfooter.footer6.footer--dark .widget .widget__title2 {\n\tcolor: #fff\n}\n\nfooter.footer6.footer--dark .footer__bottom .footer__bottom-content {\n\tborder-color: rgba(255, 255, 255, .1)\n}\n\nfooter.footer7 {\n\tposition: relative;\n\toverflow: hidden;\n\tbackground: url(https://snmtechnologies.in/startup/img/shape-wave3.png) center/100% 100% no-repeat;\n\tpadding-top: 4.66667rem\n}\n\nfooter.footer7.footer--dark .widget .widget__title2 {\n\tcolor: #fff\n}\n\nfooter.footer7.footer--dark .footer__bottom .footer__bottom-content {\n\tborder-color: rgba(255, 255, 255, .1)\n}\n\n.nav-tabs {\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\tborder: 0 none\n}\n\n.nav-tabs .nav-item .nav-link {\n\tbackground: #413aa4;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tcolor: #fff;\n\tfont-size: 1.06667rem;\n\tfont-weight: 500;\n\tline-height: 3.2rem;\n\tpadding: 0 1.86667rem\n}\n\n.nav-tabs .nav-item .nav-link.active {\n\tbackground: #fff\n}\n\n.nav-tabs .nav-item {\n\tposition: relative;\n\ttop: 1px;\n\tz-index: 1;\n\tmargin: 0\n}\n\n.nav-tabs .nav-item:first-child .nav-link {\n\t-webkit-border-radius: 4px 0 0 0;\n\tborder-radius: 4px 0 0 0\n}\n\n.nav-tabs .nav-item:last-child .nav-link {\n\t-webkit-border-radius: 0 4px 0 0;\n\tborder-radius: 0 4px 0 0\n}\n\n.nav-pills .nav-item {\n\tmargin-right: 10px\n}\n\n.nav-pills .nav-item:last-child {\n\tmargin-right: 0\n}\n\n.nav-pills .nav-item .nav-link {\n\tbackground: rgba(65, 58, 164, .1);\n\tfont-weight: 400;\n\tfont-size: .93333rem;\n\tline-height: 3.06667rem;\n\tpadding: 0 30px\n}\n\n.nav-pills .nav-item .nav-link:hover {\n\tcolor: #fff\n}\n\n.tab.tab--1 .tab_nav {\n\tpadding: 1.66rem 2.66rem;\n\t-webkit-border-radius: .26667rem;\n\tborder-radius: .26667rem\n}\n\n.tab.tab--1 .tab_nav .nav ul {\n\tmargin-bottom: 0\n}\n\n.tab.tab--1 .tab_nav .nav ul li {\n\tline-height: 2rem\n}\n\n.tab.tab--1 .tab_nav .nav .nav-link {\n\tfont-weight: 500;\n\ttext-transform: capitalize;\n\tpadding: 15px 0;\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.tab.tab--1 .tab_nav .nav .nav-link:last-child {\n\tborder-bottom: 0\n}\n\n.tab.tab--1 .tab_nav .nav .nav-link.active {\n\tbackground: 0 0\n}\n\n.tab.tab--1 .tab-content {\n\tpadding-left: 30px\n}\n\n.tab.tab--1 .tab-content .tab-pane {\n\tbackground: #fff;\n\t-webkit-border-radius: .26667rem;\n\tborder-radius: .26667rem;\n\toverflow: hidden;\n\t-webkit-box-shadow: 0 5px 20px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 20px rgba(105, 106, 119, .05)\n}\n\n.tab.tab--1 .tab-content .tab-pane figure {\n\tmargin: 0\n}\n\n.tab.tab--1 .tab-content .tab-pane figure figcaption {\n\tpadding: 2.13333rem 2.33333rem 2.33333rem\n}\n\n.tab.tab--1 .tab-content .tab-pane figure figcaption h5 {\n\tline-height: 30px;\n\tfont-weight: 600;\n\tmargin-bottom: 1rem\n}\n\n.tab.tab--1 .tab-content .tab-pane figure figcaption a.btn {\n\tmargin-top: 8px\n}\n\n.tab.tab--2 .tab_nav2 .nav,\n.tab.tab--6 .tab_nav2 .nav {\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link,\n.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link {\n\tfont-size: 1.2rem;\n\tfont-weight: 500;\n\tline-height: 4rem;\n\tposition: relative;\n\tcolor: rgba(32, 36, 40, .5);\n\tpadding-left: 2rem;\n\tpadding-right: 2rem\n}\n\n.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link:before,\n.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link:before {\n\tcontent: \"\";\n\tposition: absolute;\n\theight: 8px;\n\twidth: 8px;\n\tbackground: #9d9ebc;\n\t-webkit-border-radius: 200px;\n\tborder-radius: 200px;\n\tbottom: 0;\n\tleft: 50%;\n\t-webkit-transform: translate(-50%, 50%);\n\t-ms-transform: translate(-50%, 50%);\n\ttransform: translate(-50%, 50%)\n}\n\n.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link.active:after,\n.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link.active:after {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 1.33333rem;\n\theight: 1.33333rem;\n\tbackground: rgba(6, 181, 144, .1);\n\t-webkit-border-radius: 200px;\n\tborder-radius: 200px;\n\tbottom: 0;\n\tleft: 50%;\n\t-webkit-transform: translate(-50%, 50%);\n\t-ms-transform: translate(-50%, 50%);\n\ttransform: translate(-50%, 50%)\n}\n\n.tab.tab--3 .tab_nav3 {\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.tab.tab--3 .tab_nav3 .nav li {\n\t-webkit-flex-basis: 0;\n\t-ms-flex-preferred-size: 0;\n\tflex-basis: 0;\n\t-webkit-box-flex: 1;\n\t-webkit-flex-grow: 1;\n\t-ms-flex-positive: 1;\n\tflex-grow: 1;\n\ttext-align: center\n}\n\n.tab.tab--3 .tab_nav3 .nav li a {\n\tfont-size: 1.06667rem;\n\tcolor: #5a6671;\n\tfont-weight: 500;\n\t-webkit-transition: .3s;\n\t-o-transition: .3s;\n\ttransition: .3s;\n\tpadding: 1.4rem 0\n}\n\n.tab.tab--4 .tab--content4 {\n\tpadding: 50px 50px 50px 0;\n\tborder: 1px solid #e4e8ed;\n\t-webkit-border-radius: 4px;\n\tborder-radius: 4px;\n\toverflow: hidden\n}\n\n.tab.tab--4 .tab--content9 {\n\tpadding: 2.66667rem\n}\n\n.tab.tab--4 .tab-content .tab-pane .graph_area {\n\tmargin-right: 35px\n}\n\n.tab.tab--4 .tab-content .tab-pane .text_content p {\n\tmargin-bottom: 0\n}\n\n.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link {\n\tfont-size: 1.2rem\n}\n\n.tab.tab--7 .tab_nav7,\n.tab.tab--8 .tab_nav7 {\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.tab.tab--7 .tab_nav7 .nav .nav-item .nav-link,\n.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link {\n\tfont-size: 1rem;\n\tline-height: 3.33333rem;\n\tpadding: 0rem 2rem;\n\tposition: relative;\n\tcolor: #9192a3\n}\n\n.tab.tab--7 .tab_nav7 .nav .nav-item .nav-link span,\n.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link span {\n\tmargin-right: 10px;\n\tfont-size: 1.2rem\n}\n\n.tab.tab--7 .tab_nav7 .nav .nav-item .nav-link.active:before,\n.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link.active:before {\n\tcontent: \"\";\n\twidth: 100%;\n\theight: 2px;\n\tposition: absolute;\n\tbottom: -1px;\n\tleft: 0\n}\n\n.tab.tab--7 .tab--content7,\n.tab.tab--8 .tab--content7 {\n\tmargin-top: 35px\n}\n\n.tab.tab--7 .tab--content7 h5,\n.tab.tab--8 .tab--content7 h5 {\n\tmargin-bottom: 20px\n}\n\n.tab.tab--8 .tab_nav7 {\n\tborder-bottom: 0;\n\tborder-left: 1px solid #e4e8ed\n}\n\n.tab.tab--8 .tab_nav7 .nav {\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column\n}\n\n.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link {\n\tpadding: 0rem 1.66667rem\n}\n\n.tab.tab--8 .tab_nav7 .nav .nav-item .nav-link.active:before {\n\theight: 100%;\n\twidth: 1px;\n\tleft: -1px\n}\n\n.tab.tab--8 .tab-content h5 {\n\tmargin-bottom: 1.33333rem\n}\n\n.tab-content.tab--content2 {\n\tmargin-top: 3.33333rem\n}\n\n.tab-content.tab--content2 .tab-pane .tab_text_module .tab_text_module__subtitle {\n\tfont-size: 1.06667rem;\n\tfont-weight: 400;\n\tmargin-bottom: 5px;\n\tcolor: #06b590\n}\n\n.tab-content.tab--content2 .tab-pane .tab_text_module h2 {\n\tfont-weight: 600;\n\tfont-size: 2.4rem;\n\tline-height: 2.8rem;\n\tmargin-bottom: 2rem\n}\n\n.tab-content.tab--content2 .tab-pane .tab_text_module .btn {\n\tmargin-top: 1.26667rem\n}\n\n.tab-content.tab--content2 .tab-pane .tab_text_module ul li {\n\tcolor: #202428;\n\tfont-weight: 500;\n\tline-height: 2.13333rem;\n\tmargin: 0\n}\n\n.tab-content.tab--content2 .tab-pane .tab_image_module--left,\n.tab-content.tab--content2 .tab-pane .tab_image_module--right {\n\tmargin-bottom: 0\n}\n\n.tab-content.tab--content2 .tab-pane .tab_image_module--left img,\n.tab-content.tab--content2 .tab-pane .tab_image_module--right img {\n\t-webkit-border-radius: 4px;\n\tborder-radius: 4px\n}\n\n.tab_nav4 .nav-tabs li a {\n\tbackground: #00008b\n}\n\n.tab_nav5 {\n\tmargin-bottom: 2rem\n}\n\n.tab_event>p {\n\tcolor: #413aa4;\n\tfont-weight: 500;\n\tline-height: 2.53333rem;\n\tmargin-top: 16px;\n\tmargin-bottom: 15px\n}\n\n.tab_event .tab_event__module {\n\tpadding: 32px 40px 2.46667rem;\n\t-webkit-border-radius: .266rem;\n\tborder-radius: .266rem\n}\n\n.tab_event .tab_event__module .event_meta {\n\tmargin-bottom: 10px;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.tab_event .tab_event__module .event_meta p {\n\tmargin-right: 1.46667rem;\n\tfont-size: 1rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin-bottom: 0\n}\n\n.tab_event .tab_event__module .event_meta p span.la {\n\tfont-size: 1.2rem;\n\tvertical-align: middle;\n\tmargin-right: 8px\n}\n\n.tab_event .tab_event__module h5 {\n\tcolor: #202428;\n\tline-height: 2.53333rem;\n\tmargin-bottom: .66667rem\n}\n\n.tab_event .tab_event__module .speakers {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-bottom: 0;\n\tpadding-top: 11px\n}\n\n.tab_event .tab_event__module .speakers li {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.tab_event .tab_event__module .speakers li>div {\n\tmargin-left: 20px\n}\n\n.tab_event .tab_event__module .speakers li+li {\n\tmargin-left: 30px\n}\n\n.tab_event .tab_event__module .speakers li img {\n\t-webkit-border-radius: 200px;\n\tborder-radius: 200px;\n\theight: 50px;\n\twidth: 50px\n}\n\n.tab_event .tab_event__module .speakers li h6,\n.tab_event .tab_event__module .speakers li p {\n\tmargin: 0;\n\tline-height: 1.86667rem\n}\n\n.tab_event .tab_event__module .speakers li p {\n\tfont-size: 14px\n}\n\n.tab_event .tab_event__module .speakers li h5 {\n\tfont-size: 1.2rem\n}\n\n.service--tabs .tab_nav2 .nav {\n\tpadding: 0\n}\n\n.service--tabs .tab_nav2 .nav .nav-link {\n\tpadding: .86667rem 1.33333rem;\n\tcolor: #202428;\n\tbackground: rgba(65, 58, 164, .05);\n\tmargin-bottom: 5px;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tfont-size: 1.06667rem;\n\tfont-weight: 500\n}\n\n.service--tabs .tab_nav2 .nav .nav-link:last-child {\n\tmargin-bottom: 0\n}\n\n.service--tabs .tab_nav2 .nav .nav-link.active {\n\tbackground: #06b590;\n\tcolor: #fff\n}\n\n.testimonial2 .carousel-single .author-spec .author-desc h5 {\n\tcolor: #202428\n}\n\n.testimonial6 {\n\tpadding: 5.33333rem 0\n}\n\n.single_testimonial .big--quote {\n\tfont-size: 7.33333rem;\n\tcolor: rgba(255, 255, 255, .1);\n\tposition: relative;\n\tleft: -13px\n}\n\n.single_testimonial p {\n\tcolor: rgba(255, 255, 255, .7);\n\tfont-size: 1.33333rem;\n\tline-height: 2.4rem;\n\tmargin: 0\n}\n\n.single_testimonial .single_testimonial_meta {\n\tpadding-top: 35px;\n\tcolor: #fff;\n\tfont-weight: 500;\n\tmargin-bottom: 0\n}\n\n.single_testimonial .single_testimonial_meta span {\n\tfont-size: 1.2rem;\n\tfont-weight: 400;\n\tcolor: rgba(255, 255, 255, .5);\n\tmargin-left: .66667rem\n}\n\n.intro-area-11 {\n\tbackground-image: url(https://snmtechnologies.in/startup/img/intro-bg.png);\n\t-webkit-background-size: 100% 100%;\n\tbackground-size: 100% 100%;\n\tbackground-repeat: no-repeat;\n\tpadding-bottom: 3.33333rem;\n\tposition: relative\n}\n\n.intro-area-11:before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tbackground: #fff;\n\tbackground: -webkit-linear-gradient(to right, #fff, #f3f2fa);\n\tbackground: -o-linear-gradient(to right, #fff, #f3f2fa);\n\tbackground: -webkit-gradient(linear, left top, right top, from(#fff), to(#f3f2fa));\n\tbackground: -webkit-linear-gradient(left, #fff, #f3f2fa);\n\tbackground: -o-linear-gradient(left, #fff, #f3f2fa);\n\tbackground: linear-gradient(to right, #fff, #f3f2fa);\n\tfilter: progid:DXImageTransform.Microsoft.gradient(GradientType=0, startColorstr=#ffffff, endColorstr=#f3f2fa);\n\tz-index: -1\n}\n\n.intro-area-11 .menu_area.menu8 {\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\tbackground: 0 0\n}\n\n.intro-area-two {\n\tbackground-image: -webkit-gradient(linear, left top, right top, from(#413aa4), to(#06b590));\n\tbackground-image: -webkit-linear-gradient(left, #413aa4, #06b590);\n\tbackground-image: -o-linear-gradient(left, #413aa4, #06b590);\n\tbackground-image: linear-gradient(to right, #413aa4, #06b590);\n\tposition: relative;\n\tpadding-bottom: 4rem\n}\n\n.intro-area-two:before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tbackground-image: url(https://snmtechnologies.in/startup/img/svg/shape2.svg), -webkit-gradient(linear, left top, right top, from(#413aa4), to(#06b590));\n\tbackground-image: url(https://snmtechnologies.in/startup/img/svg/shape2.svg), -webkit-linear-gradient(left, #413aa4, #06b590);\n\tbackground-image: url(https://snmtechnologies.in/startup/img/svg/shape2.svg), -o-linear-gradient(left, #413aa4, #06b590);\n\tbackground-image: url(https://snmtechnologies.in/startup/img/svg/shape2.svg), linear-gradient(to right, #413aa4, #06b590);\n\tbackground-repeat: no-repeat;\n\tbackground-position: right;\n\topacity: .15\n}\n\n.intro-area-two .menu_area.menu8 {\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\tbackground: 0 0\n}\n\n.intro-one {\n\tposition: relative;\n\tmin-height: 47.46667rem\n}\n\n.intro-one .intro-one--contents {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.intro-one h1 {\n\tcolor: #202428;\n\tfont-weight: 600\n}\n\n.intro-one p {\n\tfont-size: 17px;\n\tmargin: 0;\n\tline-height: 2.13333rem\n}\n\n.intro-one .btn {\n\tmargin-top: 2.66667rem\n}\n\n.intro-one .intro-one--img {\n\tposition: absolute;\n\twidth: 50%;\n\theight: 100%;\n\tright: 0;\n\ttop: 0;\n\tbackground: -webkit-linear-gradient(135deg, #06b590, #413aa4);\n\tbackground: -o-linear-gradient(135deg, #06b590, #413aa4);\n\tbackground: linear-gradient(-45deg, #06b590, #413aa4);\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center\n}\n\n.intro-two {\n\tmin-height: 53.33333rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tposition: relative;\n\toverflow: hidden\n}\n\n@media all and (-ms-high-contrast:none),\n(-ms-high-contrast:active) {\n\t.intro-two {\n\t\theight: 53.33333rem\n\t}\n}\n\n.intro-two:before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 89%;\n\theight: 100%;\n\tborder-top: 800px solid #06b590;\n\tborder-right: 836px solid transparent;\n\tborder-left: 0 solid transparent;\n\tleft: 0;\n\ttop: 0\n}\n\n.intro-two h1 {\n\tline-height: 4rem;\n\tcolor: #fff;\n\tfont-weight: 600;\n\tmargin-bottom: 1.66667rem\n}\n\n.intro-two p {\n\tcolor: #fff;\n\tmargin: 0;\n\tfont-size: 1.13333rem;\n\tline-height: 2.13333rem\n}\n\n.intro-two ul {\n\tmargin: 2.66667rem 0 0 0;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.intro-two ul li {\n\tmargin-right: 2rem\n}\n\n.intro-two ul li:last-child {\n\tmargin-right: 0\n}\n\n.intro-three {\n\tmin-height: 53.33333rem;\n\tposition: relative;\n\tbackground: -webkit-linear-gradient(135deg, #f7f6fc, #fff);\n\tbackground: -o-linear-gradient(135deg, #f7f6fc, #fff);\n\tbackground: linear-gradient(-45deg, #f7f6fc, #fff);\n\toverflow: hidden\n}\n\n.intro-three:before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 80rem;\n\theight: 93.33333rem;\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tleft: -520px;\n\tbottom: -900px\n}\n\n.intro-three:after {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 100%;\n\theight: 100%;\n\tbackground: url(https://snmtechnologies.in/startup/img/shape2.png) top right/auto no-repeat\n}\n\n.intro-three .intro-three--img {\n\tposition: absolute;\n\twidth: 50%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tpadding-left: 16.66667rem\n}\n\n.intro-three .intro-three--contents {\n\tposition: absolute;\n\twidth: 100%;\n\tleft: 0;\n\theight: 100%;\n\ttop: 0;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tz-index: 1\n}\n\n.intro-three .intro-three--contents h1 {\n\tfont-weight: 600\n}\n\n.intro-three .intro-three--contents p {\n\tfont-size: 1.13333rem;\n\tmargin: 0;\n\tline-height: 2.13333rem\n}\n\n.intro-three .intro-three--contents .btn {\n\tmargin-top: 2.33333rem\n}\n\n.intro-four {\n\tposition: relative;\n\tmin-height: 53.33333rem\n}\n\n.intro-four:before {\n\tposition: absolute;\n\tcontent: \"\";\n\twidth: 80%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tbackground: -webkit-gradient(linear, left top, right top, color-stop(50%, #f1f2f7), to(rgba(241, 242, 247, 0)));\n\tbackground: -webkit-linear-gradient(left, #f1f2f7 50%, rgba(241, 242, 247, 0));\n\tbackground: -o-linear-gradient(left, #f1f2f7 50%, rgba(241, 242, 247, 0));\n\tbackground: linear-gradient(to right, #f1f2f7 50%, rgba(241, 242, 247, 0));\n\tz-index: 1\n}\n\n.intro-four .intro-four--contents {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.intro-four .intro-four--contents h1 {\n\tfont-weight: 600;\n\tmargin-bottom: 1.66667rem\n}\n\n.intro-four .intro-four--contents p {\n\tmargin: 0;\n\tfont-size: 1.13333rem;\n\tcolor: #202428;\n\tline-height: 2.13333rem\n}\n\n.intro-four .intro-four--contents ul {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-top: 2.66667rem\n}\n\n.intro-four .intro-four--contents ul li {\n\tmargin-right: 2rem\n}\n\n.intro-four .intro-four--contents ul li:last-child {\n\tmargin-right: 0\n}\n\n.intro-five h1 {\n\tfont-weight: 600\n}\n\n.intro-five p {\n\tfont-size: 1.13333rem;\n\tmargin: 0;\n\tline-height: 2.13333rem\n}\n\n.intro-five .btn {\n\tmargin-top: 2.33333rem\n}\n\n.shape-wrapper {\n\tposition: relative\n}\n\n.shape-wrapper:before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0\n}\n\n.shape-wrapper img {\n\twidth: 100%\n}\n\n.shape-wrapper.img-shape-one:before {\n\tbackground: url(https://snmtechnologies.in/startup/img/img_shape1.png);\n\t-webkit-background-size: 100% 100%;\n\tbackground-size: 100% 100%;\n\tbackground-repeat: no-repeat\n}\n\n.shape-wrapper.img-shape-two:before {\n\tbackground: url(https://snmtechnologies.in/startup/img/img_shape2.png);\n\t-webkit-background-size: 100% 101%;\n\tbackground-size: 100% 101%;\n\tbackground-repeat: no-repeat\n}\n\n.shape-wrapper.img-shape-three:before {\n\tbackground: url(https://snmtechnologies.in/startup/img/img_shape3.png);\n\t-webkit-background-size: 100% 101%;\n\tbackground-size: 100% 101%;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center\n}\n\n.intro_area9 {\n\tmin-height: 56.66667rem;\n\tposition: relative\n}\n\n.intro_area9 .intro_area9--contents {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.intro_area9 .intro_area9--contents:before {\n\tposition: absolute;\n\twidth: 50%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tcontent: '';\n\tbackground: -webkit-linear-gradient(310deg, #413aa4 0, #413aa4 25%, #06b590 100%);\n\tbackground: -o-linear-gradient(310deg, #413aa4 0, #413aa4 25%, #06b590 100%);\n\tbackground: linear-gradient(140deg, #413aa4 0, #413aa4 25%, #06b590 100%)\n}\n\n.intro_area9 .intro_area9--contents h1 {\n\tfont-size: 3.6rem;\n\tline-height: 4rem;\n\tcolor: #fff;\n\tfont-weight: 600;\n\tmargin: 0 0 2.66667rem\n}\n\n.intro_area9 .intro_area9--contents p {\n\tfont-size: 1.13333rem;\n\tline-height: 2.13333rem;\n\tcolor: rgba(255, 255, 255, .8);\n\tmargin: 0 0 2.66667rem\n}\n\n.intro_area9 .intro_area9--contents .btn {\n\ttext-transform: uppercase\n}\n\n.intro_area9 .intro_area9--slides {\n\tposition: absolute;\n\twidth: 50%;\n\tright: 0;\n\ttop: 0;\n\theight: 100%;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.intro_area9 .intro_area9--slides .intro_area9-carousel {\n\ttext-align: center\n}\n\n.intro_area9 .intro_area9--slides .intro_area9-carousel img {\n\tdisplay: inline-block;\n\twidth: auto\n}\n\n.intro_area9 .intro_area9--slides .intro_area9-carousel .dot-light,\n.intro_area9 .intro_area9--slides .intro_area9-carousel .owl-dots {\n\theight: 2.13333rem;\n\tbackground: rgba(6, 181, 144, .1);\n\t-webkit-border-radius: 20rem;\n\tborder-radius: 20rem;\n\tpadding: 0 1.33333rem;\n\tdisplay: -webkit-inline-box;\n\tdisplay: -webkit-inline-flex;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex\n}\n\n.intro_area9 .intro_area9--slides .intro_area9-carousel .dot-light .owl-dot span,\n.intro_area9 .intro_area9--slides .intro_area9-carousel .owl-dots .owl-dot span {\n\tborder: 0 none;\n\tbackground: #fff\n}\n\n.intro_area9 .intro_area9--slides .intro_area9-carousel .dot-light .owl-dot.active span,\n.intro_area9 .intro_area9--slides .intro_area9-carousel .owl-dots .owl-dot.active span {\n\tbackground: #06b590\n}\n\n.intro-area-four {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: end;\n\t-webkit-align-items: flex-end;\n\t-ms-flex-align: end;\n\talign-items: flex-end;\n\tborder-bottom: 1px solid #e4e8ed;\n\tmin-height: 56.66667rem;\n\tposition: relative\n}\n\n.intro-area-four .img-left,\n.intro-area-four .img-right {\n\tposition: absolute;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.intro-area-four .img-left {\n\tleft: 0\n}\n\n.intro-area-four .img-right {\n\tright: 0\n}\n\n.intro-area-four .intro-area-four--contents {\n\ttext-align: center\n}\n\n.intro-area-four .intro-area-four--contents h1 {\n\tfont-weight: 300;\n\tfont-size: 3.6rem;\n\tline-height: 4.13333rem;\n\tmargin-bottom: 1.33333rem\n}\n\n.intro-area-four .intro-area-four--contents h1 span {\n\tcolor: #06b590;\n\tfont-weight: 600\n}\n\n.intro-area-four .intro-area-four--contents p {\n\tfont-size: 1.13333rem;\n\tline-height: 2.13333rem;\n\tmargin: 0\n}\n\n.intro-form {\n\tmargin: 2.53333rem 0 3.33333rem 0;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.intro-form .input-group {\n\twidth: auto;\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.intro-form .input-group span.icon-left {\n\tleft: 1.33333rem\n}\n\n.intro-form .input-group input {\n\t-webkit-border-radius: 3px 0 0 3px !important;\n\tborder-radius: 3px 0 0 3px !important;\n\t-webkit-box-shadow: 0 .33333rem .66667rem rgba(145, 142, 187, .1);\n\tbox-shadow: 0 .33333rem .66667rem rgba(145, 142, 187, .1);\n\tpadding-left: 3.33333rem\n}\n\n.intro-form button {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: auto;\n\t-ms-flex: auto;\n\tflex: auto;\n\t-webkit-border-radius: 0 3px 3px 0;\n\tborder-radius: 0 3px 3px 0;\n\t-webkit-box-shadow: 0 .33333rem .66667rem rgba(145, 142, 187, .1);\n\tbox-shadow: 0 .33333rem .66667rem rgba(145, 142, 187, .1)\n}\n\n.rev_slider {\n\tdirection: lTr\n}\n\n.rev_slider .slotholder:before {\n\tposition: absolute;\n\tcontent: \"\";\n\theight: 100%;\n\twidth: 100%;\n\tbackground: rgba(65, 58, 164, .7);\n\tz-index: 99\n}\n\n#rev_slider_15_1_wrapper .slotholder:before,\n#rev_slider_15_2_wrapper .slotholder:before,\n#rev_slider_17_1_wrapper .slotholder:before {\n\tposition: absolute;\n\tcontent: \"\";\n\theight: 100%;\n\twidth: 100%;\n\tbackground: rgba(32, 36, 40, .6);\n\tz-index: 99;\n\tleft: 0;\n\ttop: 0\n}\n\n.overlay_blue.rev_slider .slotholder:before {\n\tbackground: rgba(59, 62, 121, .7)\n}\n\n.rev_slider_17_1_wrapper .form-wrapper .btn {\n\ttext-align: center\n}\n\n.rev_slider.without_overlay .slotholder:before {\n\tdisplay: none\n}\n\n#rev_slider_7_1_wrapper .slotholder:before,\n#rev_slider_9_1_wrapper .slotholder:before {\n\tcontent: none\n}\n\n.custom.tparrows:before,\n.hephaistos.tparrows:before,\n.hesperiden.tparrows:before,\n.tparrows:before {\n\tfont-family: LineAwesome, sans-serif;\n\tfont-size: 20px\n}\n\n.custom.tparrows.tp-leftarrow:before {\n\tcontent: \"\\f120\"\n}\n\n.custom.tparrows.tp-rightarrow:before {\n\tcontent: \"\\f121\"\n}\n\n.hephaistos.tparrows.tp-leftarrow:before,\n.hesperiden.tparrows.tp-leftarrow:before {\n\tcontent: \"\\f111\"\n}\n\n.hephaistos.tparrows.tp-rightarrow:before,\n.hesperiden.tparrows.tp-rightarrow:before {\n\tcontent: \"\\f112\"\n}\n\n#rev_slider_27_1_wrapper .hero_btn {\n\tborder-color: #fff;\n\tcolor: #fff\n}\n\n#rev_slider_27_1_wrapper .hero_btn:hover {\n\tborder-color: #413aa4\n}\n\n.rev_slider .btn-icon i,\n.rev_slider .btn-icon span {\n\tfont-size: 20px\n}\n\n.tp-caption .form-wrapper {\n\tmin-width: 21.33333rem\n}\n\n.erinyen .tp-bullet {\n\tbackground: #fff;\n\tborder: 0 none;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\twidth: 12px;\n\theight: 12px\n}\n\n.erinyen .tp-bullet.selected,\n.erinyen .tp-bullet:hover {\n\tbackground: rgba(255, 255, 255, .4);\n\tborder: 0 none\n}\n\n.erinyen.tp-bullets:before {\n\tcontent: \"\";\n\tbackground: rgba(255, 255, 255, .15);\n\t-webkit-border-radius: 300px;\n\tborder-radius: 300px;\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\tleft: 0\n}\n\n.zeus.tparrows:before {\n\tfont-family: LineAwesome\n}\n\n.zeus.tparrows.tp-rightarrow:before {\n\tcontent: '\\f112'\n}\n\n.zeus.tparrows.tp-leftarrow:before {\n\tcontent: '\\f111'\n}\n\n.hades .tp-thumb-img-wrap {\n\tbackground: rgba(255, 255, 255, .2);\n\t-webkit-box-shadow: none;\n\tbox-shadow: none\n}\n\n.hades .tp-thumb-image {\n\t-webkit-box-shadow: none;\n\tbox-shadow: none\n}\n\n.hades .tp-thumb.selected .tp-thumb-img-wrap,\n.hades .tp-thumb:hover .tp-thumb-img-wrap {\n\tbackground: #06b590\n}\n\n.trumbowyg-box .trumbowyg-editor {\n\tmin-height: 13.33333rem\n}\n\n.separator {\n\tmargin-top: 5.33333rem;\n\theight: 1px;\n\tbackground: #e4e8ed;\n\tmargin-bottom: 5.33333rem\n}\n\n.case_studies {\n\tposition: relative\n}\n\n.bt1 {\n\tborder-top: 1px solid #e4e8ed\n}\n\n.services_area .section_title {\n\tmargin-bottom: 0\n}\n\n.services_area .section_title h1 {\n\tmargin-bottom: 10px\n}\n\n.features-area .section-title {\n\ttext-align: center;\n\tmargin-bottom: 2.66667rem\n}\n\n.features-area .section-title h3 {\n\tcolor: #202428;\n\tmargin-bottom: 1.66667rem\n}\n\n.features-area .section-title p {\n\tcolor: #202428;\n\tmargin: 0\n}\n\n.service-two {\n\tpadding: 7.33333rem 0 5.33333rem;\n\tbackground: url(https://snmtechnologies.in/startup/img/shape-wave2.png) center/100% 100% no-repeat\n}\n\n.p-box {\n\tpadding: 2rem 2.66667rem 2.33333rem;\n\tbackground: #377dff;\n\t-webkit-border-radius: .4rem;\n\tborder-radius: .4rem\n}\n\n.p-box p {\n\tmargin: 0;\n\tfont-size: 1.13333rem;\n\tline-height: 2.26667rem\n}\n\n.p-box h4 {\n\tfont-weight: 500;\n\tline-height: 2.66667rem;\n\tmargin: 0;\n\tcolor: #fff\n}\n\n.about-links,\n.event-types {\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tposition: relative;\n\tz-index: 1\n}\n\n.about-links ul li,\n.event-types ul li {\n\tmargin: 0 15px\n}\n\n.about-links ul li a,\n.event-types ul li a {\n\tfont-size: 1.06667rem;\n\tcolor: #5a6671;\n\tpadding: 2rem 0;\n\tdisplay: block;\n\tfont-weight: 500;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.about-links ul li a.active,\n.event-types ul li a.active {\n\tcolor: #413aa4;\n\tborder-bottom: 2px solid #413aa4\n}\n\n.about-links ul li a:hover,\n.event-types ul li a:hover {\n\tcolor: #413aa4\n}\n\n.event-types {\n\tbackground: #fff\n}\n\n.event-types ul li a {\n\tpadding-left: 50px;\n\tpadding-right: 50px\n}\n\n.search-wrapper form {\n\tpadding: 2.66667rem;\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .1);\n\tbackground: #fff;\n\t-webkit-border-radius: .4rem;\n\tborder-radius: .4rem\n}\n\n.search-wrapper form h4 {\n\tfont-weight: 600;\n\tcolor: #413aa4;\n\tmargin-bottom: 1rem\n}\n\n.search-wrapper .form-group .form-control {\n\twidth: auto;\n\tborder: 1px solid #ecf1f7 !important;\n\theight: 3.66667rem;\n\tbackground: #fff;\n\tmargin-right: -1px\n}\n\n.search-wrapper .form-group .form-control:first-child {\n\t-webkit-box-flex: 3;\n\t-webkit-flex: 3;\n\t-ms-flex: 3;\n\tflex: 3\n}\n\n.search-wrapper .form-group .form-control:nth-child(2) {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.search-wrapper .form-group .select-basic {\n\t-webkit-box-flex: 2;\n\t-webkit-flex: 2;\n\t-ms-flex: 2;\n\tflex: 2\n}\n\n.search-wrapper .form-group .select-basic .form-control {\n\twidth: 100%;\n\theight: 3.66667rem\n}\n\n.career-search {\n\tposition: relative\n}\n\n.career-search .search-wrapper {\n\tposition: absolute;\n\twidth: 100%;\n\tleft: 0;\n\ttop: 0;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tz-index: 1\n}\n\n.job-categories .card {\n\tmargin-bottom: 2rem\n}\n\n.information-box {\n\tposition: relative\n}\n\n.information-wrapper {\n\tposition: absolute;\n\twidth: 100%;\n\tleft: 0;\n\ttop: -80px;\n\tz-index: 1\n}\n\n.information-wrapper .card-header {\n\tpadding: 1.8rem 2.13333rem 1.66667rem\n}\n\n.information-wrapper ul li {\n\tmargin-bottom: 2rem\n}\n\n.information-wrapper ul li:last-child {\n\tmargin-bottom: 0\n}\n\n.information-wrapper ul li span {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.information-wrapper ul li span i {\n\tcolor: #413aa4;\n\tpadding-right: .53333rem;\n\tfont-size: 1.06667rem\n}\n\n.information-wrapper ul li span:first-child {\n\tcolor: #202428;\n\tfont-weight: 500\n}\n\n.apply-form .apply-form--header {\n\tmargin-bottom: 3.33333rem;\n\ttext-align: center\n}\n\n.apply-form .apply-form--header h3 {\n\tmargin-bottom: 1rem\n}\n\n.apply-form .apply-form--header p {\n\tfont-size: 1.2rem\n}\n\n.apply-form .form-group {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin-bottom: 1.33333rem\n}\n\n.apply-form .form-group label {\n\tmin-width: 13.33333rem;\n\tcolor: #202428\n}\n\n.apply-form .form-group label .sup {\n\tcolor: #413aa4\n}\n\n.apply-form .form-group label .optional {\n\tcolor: #8c96a0\n}\n\n.apply-form .form-group .select-basic {\n\twidth: 100%\n}\n\n.apply-form form h4 .optional {\n\tcolor: #9192a3;\n\tfont-weight: 400\n}\n\n.team-profile .team-details h4 {\n\tmargin-bottom: .66667rem\n}\n\n.team-profile .team-details span {\n\tdisplay: block;\n\tline-height: 1.7\n}\n\n.team-profile .team-details span strong {\n\tfont-weight: 500\n}\n\n.service-tab-wrapper .download-widget {\n\toverflow: hidden\n}\n\n.service-tab-wrapper .download-widget .header {\n\tpadding: 1rem;\n\ttext-align: center;\n\tborder-width: 1px 1px 0 1px;\n\tborder-color: #e4e8ed;\n\tborder-style: solid\n}\n\n.service-tab-wrapper .download-widget .header h6 {\n\tfont-weight: 500;\n\tmargin: 0\n}\n\n.service-tab-wrapper .download-widget .content {\n\tpadding: 2rem 2rem 1.13333rem;\n\tborder: 1px solid #e4e8ed;\n\t-webkit-border-radius: 0 0 .4rem .4rem;\n\tborder-radius: 0 0 .4rem .4rem\n}\n\n.service-tab-wrapper .download-widget .content p {\n\tmargin: 1.66667rem 0 0 0;\n\ttext-align: center\n}\n\n.service-tab-wrapper .download-widget .content p span {\n\tdisplay: block;\n\tmargin-top: 5px;\n\tfont-size: 13px;\n\tcolor: #9192a3\n}\n\n.service-tab-wrapper .cta-widget {\n\tborder: 1px solid #e4e8ed\n}\n\n.service-tab-wrapper .cta-widget h6 {\n\tpadding: 1rem;\n\tfont-weight: 500;\n\ttext-align: center;\n\tborder-bottom: 1px solid #e4e8ed;\n\tmargin: 0\n}\n\n.service-tab-wrapper .cta-widget .content {\n\ttext-align: center;\n\tpadding: 1.33333rem 2rem 2rem\n}\n\n.service-tab-wrapper .cta-widget .content p {\n\tmargin: 0\n}\n\n.service-tab-wrapper .cta-widget .content p>span {\n\tdisplay: block\n}\n\n.service-tab-wrapper .cta-widget .content p.call-us span:last-child {\n\tfont-weight: 500;\n\tcolor: #202428\n}\n\n.service-tab-wrapper .cta-widget .content p.call-us span:last-child i {\n\tcolor: #413aa4\n}\n\n.event-details-intro .subtext {\n\tmargin-bottom: 1rem\n}\n\n.event-details-intro h1 {\n\tline-height: 4rem\n}\n\n.event-details-intro .countdown {\n\tmargin-top: 3.33333rem\n}\n\n.event-overview h4 {\n\tmargin-bottom: 13px\n}\n\n.countdown {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.countdown li {\n\twidth: 8rem;\n\theight: 8rem;\n\tbackground: rgba(255, 255, 255, .1);\n\t-webkit-border-radius: 50%;\n\tborder-radius: 50%;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\tmargin-right: 1.33333rem;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column\n}\n\n.countdown li:last-child {\n\tmargin-right: 0\n}\n\n.countdown li span:first-child {\n\tfont-size: 2.66667rem;\n\tfont-weight: 600;\n\tcolor: #fff;\n\tline-height: 3.33333rem\n}\n\n.countdown li span:last-child {\n\tcolor: rgba(255, 255, 255, .5)\n}\n\n.error-wrapper {\n\tpadding: 7.33333rem 0\n}\n\n.error-wrapper .error-contents figure {\n\tmargin-bottom: 2.26667rem\n}\n\n.error-wrapper .error-contents figure img {\n\twidth: 26.66667rem\n}\n\n.error-wrapper .error-contents h3 {\n\tcolor: #202428\n}\n\n.error-wrapper .error-contents p {\n\tmargin: 0 auto;\n\twidth: 33.33333rem\n}\n\n.login-register {\n\theight: 100%;\n\tposition: relative\n}\n\n.login-register .login-form .form-wrapper,\n.login-register .signup-form .form-wrapper {\n\tpadding: 0 2rem\n}\n\n.login-register .login-form .form-wrapper .card .card-header h4,\n.login-register .signup-form .form-wrapper .card .card-header h4 {\n\tmargin: 1.33333rem 0\n}\n\n.login-register .login-form .form-wrapper .card .card-body,\n.login-register .signup-form .form-wrapper .card .card-body {\n\tpadding-bottom: 4rem\n}\n\n.login-register .login-form .form-wrapper .card .card-body .form-group,\n.login-register .signup-form .form-wrapper .card .card-body .form-group {\n\tmargin-bottom: 1.66667rem\n}\n\n.login-register .login-form .form-wrapper .card .card-body .custom-control,\n.login-register .signup-form .form-wrapper .card .card-body .custom-control {\n\tpadding-left: 0\n}\n\n.login-register .login-form .form-wrapper .other-logins a,\n.login-register .signup-form .form-wrapper .other-logins a {\n\tline-height: 2.66667rem;\n\tpadding: 0 1.33333rem;\n\tfont-size: .93333rem;\n\tmargin-right: 1.33333rem;\n\t-webkit-border-radius: .2rem;\n\tborder-radius: .2rem\n}\n\n.login-register .login-form .form-wrapper .other-logins a:first-child,\n.login-register .signup-form .form-wrapper .other-logins a:first-child {\n\tcolor: #06b590;\n\tborder: 1px solid #06b590\n}\n\n.login-register .login-form .form-wrapper .other-logins a:last-child,\n.login-register .signup-form .form-wrapper .other-logins a:last-child {\n\tmargin-right: 0;\n\tcolor: #413aa4;\n\tborder: 1px solid #413aa4\n}\n\n.login-register .login-form {\n\tpadding-top: 11.66667rem;\n\tpadding-bottom: 11.66667rem\n}\n\n.login-register .signup-form {\n\tpadding-top: 5.66667rem;\n\tpadding-bottom: 7.33333rem\n}\n\n.coming-soon {\n\tmin-height: 65.33333rem\n}\n\n.coming-soon .cs-contents {\n\tpadding: 10rem 0\n}\n\n.coming-soon .cs-contents .cs-text {\n\tdisplay: block;\n\tfont-size: 3.33333rem;\n\tfont-weight: 600;\n\tcolor: #fff;\n\tmargin: 3.33333rem 0 2.26667rem\n}\n\n.coming-soon .cs-contents p {\n\twidth: 33.33333rem;\n\tmargin: 0 auto 3rem auto;\n\tcolor: rgba(255, 255, 255, .8);\n\tfont-size: 1.2rem\n}\n\n.project-list {\n\tmargin-bottom: 2rem\n}\n\n.project-list .card {\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t-webkit-flex-direction: row;\n\t-ms-flex-direction: row;\n\tflex-direction: row\n}\n\n.project-list .card figure {\n\t-webkit-box-flex: 2;\n\t-webkit-flex: 2;\n\t-ms-flex: 2;\n\tflex: 2\n}\n\n.project-list .card .card-body {\n\t-webkit-box-flex: 2;\n\t-webkit-flex: 2;\n\t-ms-flex: 2;\n\tflex: 2;\n\tpadding: 2.93333rem 3.33333rem\n}\n\n.project-list .card .card-body h5 {\n\tmargin-bottom: 1.66667rem\n}\n\n.project-list .card .card-body h5 a {\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.project-list .card .card-body h5 a:hover {\n\tcolor: #413aa4\n}\n\n.project-masonry .filtr-container-masonry .filtr-item {\n\tmargin-bottom: 2rem\n}\n\n.project-single .project-info .info-box {\n\tpadding: 2.33333rem;\n\tborder: 1px solid #e4e8ed;\n\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .05);\n\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .05)\n}\n\n.project-single .project-info .info-box h6 {\n\tmargin-bottom: 25px\n}\n\n.project-single .project-info .info-box ul li {\n\tmargin-bottom: 1rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex\n}\n\n.project-single .project-info .info-box ul li:last-child {\n\tmargin-bottom: 0\n}\n\n.project-single .project-info .info-box ul li span {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.project-single .project-info .info-box ul li span:last-child {\n\tfont-weight: 500;\n\tcolor: #202428\n}\n\n.project-desc h4 {\n\tmargin-bottom: 20px\n}\n\n.project-gallery figure {\n\tmargin-bottom: 2rem\n}\n\n.project-gallery figure img {\n\twidth: 100%\n}\n\n.products-wrapper .product-sort {\n\tmargin-bottom: 2.33333rem\n}\n\n.products-wrapper .product-sort .sort,\n.products-wrapper .product-sort .total-pages {\n\t-webkit-flex-basis: 0;\n\t-ms-flex-preferred-size: 0;\n\tflex-basis: 0;\n\t-webkit-box-flex: 1;\n\t-webkit-flex-grow: 1;\n\t-ms-flex-positive: 1;\n\tflex-grow: 1\n}\n\n.products-wrapper .product-sort .sort span {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.products-wrapper .product-sort .sort .form-group {\n\t-webkit-box-flex: 4;\n\t-webkit-flex: 4;\n\t-ms-flex: 4;\n\tflex: 4\n}\n\n.products-wrapper .product-sort .total-pages p {\n\tmargin-bottom: 0\n}\n\n.product-details .product-info h4 {\n\tmargin-bottom: 1rem\n}\n\n.product-details .product-info .product-price {\n\tfont-size: 1.6rem;\n\tfont-weight: 600;\n\tcolor: #413aa4;\n\tdisplay: block;\n\tmargin-bottom: .33333rem\n}\n\n.product-details .product-info .product-ratings {\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin-bottom: 1rem\n}\n\n.product-details .product-info .product-ratings p {\n\tmargin: 0\n}\n\n.product-details .product-info .product-ratings p span {\n\tcolor: #ffaf00\n}\n\n.product-details .product-info .product-ratings .total-reviews {\n\tmargin-left: 1rem\n}\n\n.product-details .product-info .product-actions {\n\tmargin: 1.33333rem 0;\n\tpadding: 2rem 0;\n\tborder-top: 1px solid #e4e8ed;\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.product-details .product-info .product-actions form {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.product-details .product-info .product-actions form .total-item {\n\tmargin-right: 2rem\n}\n\n.product-details .product-info .product-actions form .total-item .pcount {\n\tfont-size: 16px;\n\tcursor: pointer\n}\n\n.product-details .product-info .product-actions form .total-item input {\n\twidth: 3rem;\n\theight: 3rem;\n\ttext-align: center;\n\tborder: 1px solid #9192a3\n}\n\n.product-details .product-info .product-actions form ul li {\n\tmargin-right: 1.33333rem\n}\n\n.product-details .product-info .product-actions form ul li:last-child {\n\tmargin-right: 0\n}\n\n.product-details .product-info .product-category {\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center\n}\n\n.product-details .product-info .product-category span {\n\tmargin-right: 1.33333rem\n}\n\n.product-details .product-info .product-category p {\n\tmargin: 0\n}\n\n.product-info-tab .review-wrapper .reviews {\n\tmargin-bottom: 1.66667rem;\n\tmargin-top: 3.33333rem;\n\tpadding: 0 2.66667rem\n}\n\n.product-info-tab .review-wrapper .reviews .review-single {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tpadding-bottom: 2.33333rem;\n\tmargin-bottom: 2.33333rem;\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.product-info-tab .review-wrapper .reviews .review-single .review-details {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.product-info-tab .review-wrapper .reviews .review-single .review-details ul li {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-bottom: .86667rem\n}\n\n.product-info-tab .review-wrapper .reviews .review-single .review-details ul li:last-child {\n\tmargin-bottom: 0\n}\n\n.product-info-tab .review-wrapper .reviews .review-single .review-details ul li span {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.product-info-tab .review-wrapper .reviews .review-single .review-details ul li .strong {\n\t-webkit-box-flex: 3;\n\t-webkit-flex: 3;\n\t-ms-flex: 3;\n\tflex: 3;\n\tcolor: #202428;\n\tfont-weight: 500\n}\n\n.product-info-tab .review-wrapper .reviews .review-single .review-details ul li .strong span {\n\tcolor: #ffaf00;\n\tfont-size: 12px\n}\n\n.product-info-tab .review-wrapper .reviews .review-single .review-text {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.product-info-tab .review-wrapper .review-form {\n\tpadding: 4rem\n}\n\n.product-info-tab .review-wrapper .review-form h4 {\n\tcolor: #202428;\n\tmargin-bottom: .66667rem\n}\n\n.product-info-tab .review-wrapper .review-form p {\n\tmargin: 0\n}\n\n.product-info-tab .review-wrapper .review-form p a {\n\tcolor: #5a6671;\n\tfont-size: 1.2rem\n}\n\n.product-info-tab .review-wrapper .review-form form {\n\tmargin-top: 3rem\n}\n\n.product-info-tab .review-wrapper .review-form form input,\n.product-info-tab .review-wrapper .review-form form textarea {\n\tmargin-bottom: 2rem\n}\n\n.product-info-tab .review-wrapper .review-form form .rating span {\n\tpadding-bottom: .6rem;\n\tmargin-right: 1rem;\n\tcolor: #202428;\n\tfont-weight: 500\n}\n\n.br-theme-fontawesome-stars .br-widget {\n\theight: 28px;\n\twhite-space: nowrap\n}\n\n.br-theme-fontawesome-stars .br-widget a {\n\tfont-family: LineAwesome, sans-serif;\n\ttext-rendering: auto;\n\t-webkit-font-smoothing: antialiased;\n\ttext-decoration: none;\n\tmargin-right: 2px\n}\n\n.br-theme-fontawesome-stars .br-widget a:after {\n\tcontent: \"\\f318\";\n\tcolor: #d2d2d2\n}\n\n.br-theme-fontawesome-stars .br-widget a.br-active:after {\n\tcolor: #f2b01e\n}\n\n.br-theme-fontawesome-stars .br-widget a.br-selected:after {\n\tcolor: #f2b01e\n}\n\n.br-theme-fontawesome-stars .br-widget .br-current-rating {\n\tdisplay: none\n}\n\n.br-theme-fontawesome-stars .br-readonly a {\n\tcursor: default\n}\n\n@media print {\n\t.br-theme-fontawesome-stars .br-widget a:after {\n\t\tcontent: '\\f318';\n\t\tcolor: #000\n\t}\n\n\t.br-theme-fontawesome-stars .br-widget a.br-active:after,\n\t.br-theme-fontawesome-stars .br-widget a.br-selected:after {\n\t\tcontent: '\\f318';\n\t\tcolor: #000\n\t}\n}\n\n.cart-table thead th {\n\tborder-top: 1px solid #e4e8ed;\n\tvertical-align: middle;\n\tpadding: 1rem 0\n}\n\n.cart-table thead th+th {\n\tpadding-left: 4.66667rem\n}\n\n.cart-table thead th span {\n\tfont-size: 1.06667rem;\n\tfont-weight: 500;\n\tcolor: #202428\n}\n\n.cart-table thead th span:last-child {\n\ttext-align: right\n}\n\n.cart-table .cart-single td,\n.cart-table .cart-single th {\n\tvertical-align: middle;\n\tpadding: 1.33333rem 0\n}\n\n.cart-table .cart-single td+td {\n\tpadding-left: 4.66667rem\n}\n\n.cart-table .cart-single .name {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.cart-table .cart-single .name a {\n\tfont-size: 1.2rem;\n\tfont-weight: 500;\n\tline-height: 1.73333rem;\n\tcolor: #202428;\n\tmargin-left: 2rem;\n\t-webkit-box-flex: 2;\n\t-webkit-flex: 2;\n\t-ms-flex: 2;\n\tflex: 2\n}\n\n.cart-table .cart-single .total-item input {\n\twidth: 3rem;\n\theight: 3rem;\n\tborder: 1px solid #9192a3;\n\ttext-align: center\n}\n\n.cart-table .cart-single .total-item input[type=number]::-webkit-inner-spin-button,\n.cart-table .cart-single .total-item input[type=number]::-webkit-outer-spin-button {\n\t-webkit-appearance: none;\n\tmargin: 0\n}\n\n.cart-table .cart-single .remove a {\n\tfont-size: 1.33333rem\n}\n\n.cart-table .cart-bottom {\n\tpadding-bottom: 2rem\n}\n\n.cart-table .cart-bottom td {\n\tpadding: 2rem 0;\n\tborder-bottom: 1px solid #e4e8ed;\n\tvertical-align: middle\n}\n\n.cart-table .cart-bottom form {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmax-width: 24.66667rem\n}\n\n.cart-table .cart-bottom form button {\n\tmargin-left: 2rem\n}\n\n.cart-table .cart-bottom .total-amount span {\n\tcolor: #202428;\n\tfont-weight: 500\n}\n\n.cart-table .cart-actions {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap\n}\n\n.cart-table .cart-actions .ml-auto a:last-child {\n\tmargin-left: .46667rem\n}\n\n.cart-table.cart-table--2 thead th {\n\tpadding: 1.66667rem 0\n}\n\n.cart-table.cart-table--2 thead th:last-child {\n\tpadding-left: 4rem\n}\n\n.cart-table.cart-table--2 .cart-bottom td {\n\tborder-bottom: 0\n}\n\n.ukm .filter-item {\n\tpadding-bottom: 30px\n}\n\n.checkout-wrapper .nav-item {\n\tposition: relative\n}\n\n.checkout-wrapper .nav-item:before {\n\tposition: absolute;\n\tcontent: \"\\f186\";\n\tfont-family: LineAwesome, sans-serif;\n\tfont-size: 20px;\n\tright: -75px;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tcolor: rgba(59, 62, 121, .5)\n}\n\n.checkout-wrapper .nav-item:last-child {\n\tmargin-right: 0\n}\n\n.checkout-wrapper .nav-item:last-child:before {\n\tcontent: none\n}\n\n.checkout-wrapper .nav-item .nav-link {\n\tpadding: 0\n}\n\n.checkout-wrapper .tab-content h4 {\n\tpadding-bottom: 1.53333rem;\n\tmargin-bottom: 3.33333rem;\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.checkout-wrapper .tab-content form .form-group {\n\tmargin-bottom: 1.66667rem\n}\n\n.checkout-wrapper .tab-content form .shipping-method .custom-control {\n\tpadding-left: 0\n}\n\n.checkout-wrapper .tab-content .method-1 {\n\tborder: 1px solid #e4e8ed;\n\tmargin-bottom: 2rem\n}\n\n.checkout-wrapper .tab-content .method-1 .header {\n\tbackground: #f5f5f7;\n\tpadding: 1.66667rem 2rem\n}\n\n.checkout-wrapper .tab-content .method-1 .body {\n\tpadding: 2.66667rem\n}\n\n.checkout-wrapper .tab-content .method-1 .body p {\n\tmargin-bottom: 3.33333rem\n}\n\n.checkout-wrapper .tab-content .method-1 .body p img {\n\tmargin-left: 1.33333rem\n}\n\n.checkout-wrapper .tab-content .method-1 .body input {\n\tmargin-bottom: 2rem\n}\n\n.checkout-wrapper .tab-content .method-2 {\n\tmargin-bottom: 2rem\n}\n\n.checkout-wrapper .tab-content .method-2 .header {\n\tbackground: #f5f5f7;\n\tpadding: 1.66667rem 2rem\n}\n\n.checkout-wrapper .tab-content .order-info {\n\tborder: 1px solid #e4e8ed\n}\n\n.checkout-wrapper .tab-content .order-info h6 {\n\tmargin: 0 0 2rem 0;\n\tpadding-bottom: 1.33333rem;\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.checkout-wrapper .tab-content .order-info ul li {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-bottom: 1rem\n}\n\n.checkout-wrapper .tab-content .order-info ul li:last-child {\n\tmargin-bottom: 0\n}\n\n.checkout-wrapper .tab-content .order-info ul li span {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.checkout-wrapper .tab-content .order-info ul li span:last-child {\n\tcolor: #202428\n}\n\n.checkout-confirm h2 {\n\tmargin-bottom: 1.66667rem\n}\n\n.checkout-confirm p {\n\tmargin-bottom: 2.66667rem\n}\n\n.checkout-confirm form {\n\tmargin-bottom: 3.33333rem\n}\n\n.blog-grid-wrapper .post--card {\n\tmargin-bottom: 2rem\n}\n\n.blog-wrapper .blog-single {\n\tmargin-bottom: 3.33333rem\n}\n\n.blog-grid-masonry .filtr-item {\n\tmargin-bottom: 2rem\n}\n\n.blog-single-wrapper .post-gallery {\n\tmargin-bottom: -2rem\n}\n\n.blog-single-wrapper .post-gallery figure {\n\tmargin-bottom: 2rem\n}\n\n.blog-single-wrapper .post-details img {\n\twidth: 100%\n}\n\n.blog-single-wrapper .post-details .post-head {\n\tmargin-bottom: 2.46667rem\n}\n\n.blog-single-wrapper .post-details .post-content .post-header {\n\tmargin-bottom: 2rem\n}\n\n.blog-single-wrapper .post-details .post-content .post-header h3 {\n\tcolor: #202428;\n\tmargin-bottom: 1.33333rem\n}\n\n.blog-single-wrapper .post-details .post-content .post-header ul {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tpadding-bottom: 2rem;\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.blog-single-wrapper .post-details .post-content .post-header ul li {\n\tmargin-right: 1.33333rem\n}\n\n.blog-single-wrapper .post-details .post-content .post-header ul li:last-child {\n\tmargin-right: 0\n}\n\n.blog-single-wrapper .post-details .post-content .post-header ul li a {\n\tcolor: #202428\n}\n\n.blog-single-wrapper .post-bottom {\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tpadding: 2rem 0;\n\tborder-top: 1px solid #e4e8ed;\n\tborder-bottom: 1px solid #e4e8ed;\n\tmargin: 3rem 0 4.66667rem 0\n}\n\n.blog-single-wrapper .post-bottom .tags {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.blog-single-wrapper .post-bottom .tags ul li {\n\tmargin-right: .66667rem\n}\n\n.blog-single-wrapper .post-bottom .tags ul li:last-child {\n\tmargin-right: 0\n}\n\n.blog-single-wrapper .post-bottom .tags ul li a {\n\tline-height: 1.86667rem;\n\tdisplay: block;\n\tborder: 1px solid #e4e8ed;\n\t-webkit-border-radius: .2rem;\n\tborder-radius: .2rem;\n\tpadding: 0 .8rem;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease;\n\tcolor: #5a6671;\n\tfont-size: .93333rem\n}\n\n.blog-single-wrapper .post-bottom .tags ul li a:hover {\n\tcolor: #fff;\n\tbackground: #413aa4;\n\tborder-color: #413aa4\n}\n\n.blog-single-wrapper .post-bottom .social-share {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1;\n\t-webkit-box-pack: end;\n\t-webkit-justify-content: flex-end;\n\t-ms-flex-pack: end;\n\tjustify-content: flex-end\n}\n\n.blog-single-wrapper .post-author {\n\tpadding: 2.66667rem;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-bottom: 4rem\n}\n\n.blog-single-wrapper .post-author .author-thumb {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.blog-single-wrapper .post-author .author-info {\n\t-webkit-box-flex: 4;\n\t-webkit-flex: 4;\n\t-ms-flex: 4;\n\tflex: 4\n}\n\n.blog-single-wrapper .post-author .author-info h5 {\n\tcolor: #202428;\n\tmargin-bottom: 1rem\n}\n\n.blog-single-wrapper .post-author .author-info h5 span {\n\tcolor: #413aa4\n}\n\n.blog-single-wrapper .post-pagination {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: justify;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: justify;\n\tjustify-content: space-between;\n\tborder-bottom: 1px solid #e4e8ed;\n\tpadding-bottom: 4rem\n}\n\n.blog-single-wrapper .post-pagination .next-post,\n.blog-single-wrapper .post-pagination .prev-post {\n\t-webkit-box-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1\n}\n\n.blog-single-wrapper .post-pagination .next-post>span,\n.blog-single-wrapper .post-pagination .prev-post>span {\n\tdisplay: block\n}\n\n.blog-single-wrapper .post-pagination .next-post .title,\n.blog-single-wrapper .post-pagination .prev-post .title {\n\tfont-size: 16px;\n\tcolor: #202428;\n\tfont-weight: 500;\n\tmargin: .66667rem 0;\n\tdisplay: block;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.blog-single-wrapper .post-pagination .next-post .title:hover,\n.blog-single-wrapper .post-pagination .prev-post .title:hover {\n\tcolor: #413aa4\n}\n\n.blog-single-wrapper .post-pagination .next-post p,\n.blog-single-wrapper .post-pagination .prev-post p {\n\tmargin: 0\n}\n\n.blog-single-wrapper .post-pagination .next-post {\n\ttext-align: right\n}\n\n.blog-single-wrapper .related-post {\n\tborder-bottom: 1px solid #e4e8ed\n}\n\n.blog-single-wrapper .related-post .related-post--title {\n\tmargin-bottom: 1.8rem;\n\ttext-align: center\n}\n\n.blog-single-wrapper .related-post .related-post--title h4 {\n\tmargin: 0\n}\n\n.blog-single-wrapper .related-post .single-post {\n\tmargin-bottom: 3.33333rem\n}\n\n.blog-single-wrapper .related-post .single-post h6 {\n\tmargin: 1.2rem 0 .33333rem;\n\tfont-size: 1rem\n}\n\n.blog-single-wrapper .related-post .single-post h6 a {\n\tcolor: #202428\n}\n\n.blog-single-wrapper .related-post .single-post p {\n\tfont-size: .93333rem\n}\n\n.comments-area .comment-title {\n\tmargin-bottom: 1.66667rem;\n\ttext-align: center\n}\n\n.comments-area .comment-title h3 {\n\tposition: relative;\n\tmargin-bottom: 0\n}\n\n.comments-area .comment-lists ul .depth-1 {\n\tpadding: 2rem 2rem 1.6rem;\n\tborder: 1px solid #e4e8ed;\n\t-webkit-border-radius: .26667rem;\n\tborder-radius: .26667rem;\n\tmargin-bottom: 2rem\n}\n\n.comments-area .comment-lists ul .depth-1:last-child {\n\tmargin-bottom: 0\n}\n\n.comments-area .comment-lists ul .depth-1 .media {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex\n}\n\n.comments-area .comment-lists ul .depth-1 .media .media-body {\n\tmargin-left: 1.66667rem\n}\n\n.comments-area .comment-lists ul .depth-1 .media .media-body .media_top {\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: justify;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: justify;\n\tjustify-content: space-between;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin-bottom: 1rem\n}\n\n.comments-area .comment-lists ul .depth-1 .media .media-body .media_top h6 {\n\tmargin-bottom: .46667rem\n}\n\n.comments-area .comment-lists ul .depth-1 .media .media-body .media_top .reply {\n\tborder: 1px solid #e4e8ed;\n\tcolor: #5a6671;\n\tline-height: 2.26667rem;\n\t-webkit-border-radius: 1.66667rem;\n\tborder-radius: 1.66667rem;\n\tdisplay: inline-block;\n\tfont-weight: 500;\n\tfont-size: .86667rem;\n\tpadding: 0 1rem;\n\t-webkit-transition: all .3s ease;\n\t-o-transition: all .3s ease;\n\ttransition: all .3s ease\n}\n\n.comments-area .comment-lists ul .depth-1 .media .media-body .media_top .reply:hover {\n\tcolor: #fff;\n\tbackground: #413aa4;\n\tborder-color: #413aa4\n}\n\n.comments-area .comment-lists ul .depth-1 .media p {\n\tmargin: 0\n}\n\n.comments-area .comment-lists ul .depth-1 .depth-2 {\n\tpadding-left: 2.66667rem;\n\tmargin-top: 2rem;\n\tpadding-top: 2rem;\n\tborder-top: 1px solid #e4e8ed\n}\n\n.comment-form {\n\tpadding: 3rem 2.66667rem\n}\n\n.comment-form .comment-title h5 {\n\tcolor: #202428;\n\tmargin-bottom: .66667rem\n}\n\n.comment-form form textarea {\n\theight: 8.33333rem\n}\n\n.video-background {\n\theight: 500px !important;\n\tpadding-bottom: 0 !important\n}\n\n.video-background .video-content {\n\tposition: absolute;\n\twidth: 100%;\n\tleft: 0;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ttransform: translateY(-50%)\n}\n\n.video-background .video-content h2 {\n\tcolor: #fff;\n\tmargin-bottom: 0\n}\n\n.news-area .section-title {\n\ttext-align: center;\n\tmargin-bottom: 2.06667rem\n}\n\n.news-area .section-title h2 {\n\tcolor: #202428;\n\tmargin-bottom: 1.06667rem\n}\n\n.news-area .section-title p {\n\tcolor: #202428\n}\n\n.about-wrapper .about-contents h3 {\n\tcolor: #202428;\n\tline-height: 2.8rem;\n\tmargin-bottom: 1rem\n}\n\n.about-wrapper .about-contents p {\n\tmargin: 1.33333rem 0 0 0\n}\n\n.about-wrapper .about-contents .sub-title {\n\tfont-size: 1.33333rem;\n\tfont-weight: 500\n}\n\n.team-wrapper {\n\tbackground: url(https://snmtechnologies.in/startup/img/shape1.png) center/100% 100% no-repeat;\n\tpadding: 7.33333rem 0;\n\tposition: relative\n}\n\n.team-wrapper:before {\n\tcontent: '';\n\tposition: absolute;\n\twidth: 30%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tbackground: #f7f6fc;\n\tz-index: -1\n}\n\n.team-wrapper:after {\n\tcontent: '';\n\tposition: absolute;\n\twidth: 70%;\n\theight: 100%;\n\tright: 0;\n\ttop: 0;\n\tbackground: -webkit-linear-gradient(135deg, #06b590, #413aa4);\n\tbackground: -o-linear-gradient(135deg, #06b590, #413aa4);\n\tbackground: linear-gradient(-45deg, #06b590, #413aa4);\n\tz-index: -1\n}\n\n.team-wrapper .title-box {\n\tbackground: #fff;\n\tpadding: 4rem;\n\theight: 100%;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-border-radius: .26667rem;\n\tborder-radius: .26667rem;\n\t-webkit-box-shadow: 0 5px 30px rgba(41, 41, 59, .1);\n\tbox-shadow: 0 5px 30px rgba(41, 41, 59, .1)\n}\n\n.team-wrapper .title-box h2 {\n\tcolor: #202428;\n\tline-height: 3.2rem;\n\tmargin: 0\n}\n\n.testimonials .owl-carousel {\n\tmargin-top: -1rem\n}\n\n@media (min-width:992px) and (max-width:1199px) {\n\t.menu_area.menu1 .nav_right_content .search_module {\n\t\tdisplay: none\n\t}\n\n\t.top_bar .infos .infos--single {\n\t\t-webkit-flex-basis: 0;\n\t\t-ms-flex-preferred-size: 0;\n\t\tflex-basis: 0;\n\t\t-webkit-box-flex: 1;\n\t\t-webkit-flex-grow: 1;\n\t\t-ms-flex-positive: 1;\n\t\tflex-grow: 1\n\t}\n\n\t.top_bar .infos .infos--single+.infos--single {\n\t\tmargin-left: 25px\n\t}\n\n\t.footer__small .content-left,\n\t.footer__small .content-right {\n\t\t-webkit-box-flex: 1;\n\t\t-webkit-flex: 1;\n\t\t-ms-flex: 1;\n\t\tflex: 1\n\t}\n\n\t.footer__small .content-right {\n\t\t-webkit-box-pack: end;\n\t\t-webkit-justify-content: flex-end;\n\t\t-ms-flex-pack: end;\n\t\tjustify-content: flex-end;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -webkit-flex;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex\n\t}\n\n\tfooter.footer4 .footer__small .info_links:before {\n\t\tcontent: none\n\t}\n\n\t.process-one .process-single:nth-child(2n+1) .icon:before {\n\t\tcontent: url(https://snmtechnologies.in/startup/img/arrow-up-sm.png)\n\t}\n\n\t.process-one .process-single .icon:before {\n\t\tcontent: url(https://snmtechnologies.in/startup/img/arrow-down-sm.png)\n\t}\n\n\t.process-one .process-single .icon:before {\n\t\tright: -58%\n\t}\n\n\t.pricing.pricing--2 {\n\t\tdisplay: block !important\n\t}\n\n\t.event-single {\n\t\theight: auto\n\t}\n\n\t.event-single .event-info .view-btn {\n\t\tmargin-left: 0;\n\t\tmargin-top: 1.33333rem\n\t}\n\n\t.testimonial-carousel-three .card--testimonial2 {\n\t\tmargin-bottom: 0\n\t}\n\n\t.testimonials {\n\t\tpadding-bottom: 3rem\n\t}\n\n\t.search-wrapper form .form-group button {\n\t\tmargin: 1rem 0 0 0\n\t}\n\n\t.service-tab-wrapper .cta-widget {\n\t\tpadding: 2rem 1rem\n\t}\n\n\t.other-logins {\n\t\t-webkit-box-pack: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tjustify-content: center\n\t}\n\n\t.project-list .card figure {\n\t\t-webkit-align-self: center;\n\t\t-ms-flex-item-align: center;\n\t\talign-self: center\n\t}\n\n\t.cart-table .cart-single .name a {\n\t\tmargin-left: 1.33333rem\n\t}\n\n\t.card-body {\n\t\tpadding: 2.3rem\n\t}\n\n\t.card--testimonial {\n\t\tpadding: 2.33333rem\n\t}\n\n\t.card .card-footer {\n\t\tpadding: 2rem\n\t}\n\n\t.address-blocks .adress {\n\t\tpadding: 0\n\t}\n\n\t.team-wrapper .title-box {\n\t\tpadding: 2rem\n\t}\n\n\t.service-tab-wrapper .cta-widget .content {\n\t\tpadding: 0\n\t}\n\n\t.pricing.pricing--2 .pricing__features_list {\n\t\tpadding: 30px\n\t}\n\n\t.pricing.pricing--2 .pricing__features_list ul.list {\n\t\tmargin-top: 30px\n\t}\n\n\tsection.intro-area {\n\t\toverflow-x: hidden\n\t}\n}\n\n@media (max-width:991px) {\n\t.margin-md-60 {\n\t\tmargin-bottom: 4rem\n\t}\n\n\t.margin-md-60 p {\n\t\tmargin-bottom: 0\n\t}\n\n\t.menu_area .navbar .navbar-nav .nav-item.dropdown .nav-link:before {\n\t\tright: 20px;\n\t\tfont-size: 13px\n\t}\n\n\t.menu_area .navbar .navbar-nav .nav-item .nav-link {\n\t\tpadding: 10px 20px;\n\t\tcolor: #202428\n\t}\n\n\t.menu_area .navbar.navbar-bg .navbar-nav .nav-item.dropdown .nav-link:before {\n\t\tcolor: inherit\n\t}\n\n\t.menu_area .navbar-nav .nav-item>.nav-link {\n\t\tcolor: #202428\n\t}\n\n\t.menu_area .navbar-nav .nav-item>.nav-link.active {\n\t\tcolor: #413aa4\n\t}\n\n\t.menu_area .dropdown-menu a.dropdown-item {\n\t\tpadding: 4px 15px\n\t}\n\n\t.menu_area .dropdown-menu,\n\t.menu_area .mega-menu {\n\t\twidth: 100%;\n\t\t-webkit-box-shadow: 0 0 0;\n\t\tbox-shadow: 0 0 0;\n\t\tbackground: #f9f9f9;\n\t\tleft: auto;\n\t\tposition: initial;\n\t\tpadding: 10px 20px\n\t}\n\n\t.menu_area .dropdown-menu ul,\n\t.menu_area .mega-menu ul {\n\t\t-webkit-box-flex: initial;\n\t\t-webkit-flex: initial;\n\t\t-ms-flex: initial;\n\t\tflex: initial;\n\t\tpadding: 0 15px\n\t}\n\n\t.menu_area .dropdown-menu ul+ul,\n\t.menu_area .mega-menu ul+ul {\n\t\tmargin-top: 7px\n\t}\n\n\t.menu_area .dropdown-menu ul+ul>li>h6,\n\t.menu_area .mega-menu ul+ul>li>h6 {\n\t\tmargin-top: 24px\n\t}\n\n\t.menu_area .dropdown-menu ul li,\n\t.menu_area .mega-menu ul li {\n\t\tmargin-bottom: 8px\n\t}\n\n\t.top_bar .infos {\n\t\tdisplay: none !important\n\t}\n\n\t.top_bar .infos .infos--single span {\n\t\tdisplay: none\n\t}\n\n\t.carousel-four .owl-item img,\n\t.team-carousel-two .owl-item img {\n\t\twidth: 100%\n\t}\n\n\t.testimonial-carousel-four .carousel-single .author-text {\n\t\twidth: 100%\n\t}\n\n\t.logo-grid-one li,\n\t.logo-grid-three li {\n\t\twidth: 33.33%\n\t}\n\n\t.dropdowns-wrapper .dropdown {\n\t\tmargin-bottom: 2rem\n\t}\n\n\t.tab-content.tab--content2 .tab-pane .tab_image_module--left {\n\t\tmargin: 0 0 2rem 0\n\t}\n\n\t.tab-content.tab--content2 .tab-pane .tab_image_module--right {\n\t\tmargin: 2rem 0 0 0\n\t}\n\n\t.video-single figure img {\n\t\twidth: 100%\n\t}\n\n\t.video-wrapper.video--three .video-banner figure figcaption {\n\t\tpadding: 2rem\n\t}\n\n\t.accordion-styles.accordion--two .form-box {\n\t\tmargin-top: 3.33333rem\n\t}\n\n\t.card--team1 figure img,\n\t.card--team2 figure img {\n\t\twidth: 100%\n\t}\n\n\t.divider.text-center p {\n\t\twidth: 100%\n\t}\n\n\t.splitted-banner:after {\n\t\tposition: absolute;\n\t\tcontent: '';\n\t\twidth: 50%;\n\t\tright: 0;\n\t\ttop: 0;\n\t\theight: 100%;\n\t\tbackground: rgba(0, 0, 0, .3)\n\t}\n\n\t.subscribe-four form,\n\t.subscribe-six form,\n\t.subscribe-three form {\n\t\tmargin-top: 2rem\n\t}\n\n\t.twitter-feeds .feed-single .feed-content {\n\t\twidth: 100%\n\t}\n\n\t.quotes-with-image {\n\t\tpadding-top: 5.33333rem\n\t}\n\n\t.blockquote5 .author-sign {\n\t\tmargin-bottom: 1rem\n\t}\n\n\t.cta--eight p,\n\t.cta--five p,\n\t.cta--four p,\n\t.cta--seven p,\n\t.cta--six p,\n\t.cta--two p {\n\t\ttext-align: center\n\t}\n\n\t.cta--eight .action-btn,\n\t.cta--five .action-btn,\n\t.cta--four .action-btn,\n\t.cta--seven .action-btn,\n\t.cta--six .action-btn,\n\t.cta--two .action-btn {\n\t\ttext-align: center;\n\t\tmargin-top: 2rem\n\t}\n\n\t.cta--five p,\n\t.cta--seven p,\n\t.cta--six p {\n\t\tline-height: 3rem\n\t}\n\n\t.cta--seven p {\n\t\tline-height: 3.66667rem\n\t}\n\n\t.contact-split {\n\t\tdisplay: block !important;\n\t\theight: auto\n\t}\n\n\t.contact-split .g-maps {\n\t\tposition: relative;\n\t\twidth: 100%\n\t}\n\n\t.contact-split .g-maps #map2 {\n\t\theight: 33.33333rem\n\t}\n\n\t.contact-split .form-wrapper {\n\t\tmargin-top: 4rem;\n\t\tmargin-bottom: 4rem\n\t}\n\n\t.contact--four .form-wrapper {\n\t\tmargin-bottom: 4rem\n\t}\n\n\t.block-full-width2:before,\n\t.block-full-width:before {\n\t\tposition: absolute;\n\t\tcontent: '';\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tbackground: rgba(255, 255, 255, .9);\n\t\tz-index: 1\n\t}\n\n\t.block-full-width .img,\n\t.block-full-width2 .img {\n\t\twidth: 100%\n\t}\n\n\t.content-block--12 .highlighted-text .content {\n\t\tpadding: 0 3rem\n\t}\n\n\t.section-split:before {\n\t\twidth: 100%\n\t}\n\n\t.section-split .skills {\n\t\tmargin-top: 4rem\n\t}\n\n\t.contact--from8 .form-wrapper .select-basic,\n\t.contact--from8 .form-wrapper input {\n\t\t-webkit-box-shadow: 0 5px 30px rgba(105, 106, 119, .05);\n\t\tbox-shadow: 0 5px 30px rgba(105, 106, 119, .05)\n\t}\n\n\t.footer__small .content-left,\n\t.footer__small .content-right {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -webkit-flex;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-pack: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tjustify-content: center;\n\t\twidth: 100%\n\t}\n\n\t.footer__small .content-left {\n\t\t-webkit-flex-wrap: wrap;\n\t\t-ms-flex-wrap: wrap;\n\t\tflex-wrap: wrap;\n\t\ttext-align: center\n\t}\n\n\t.footer__small .content-left p,\n\t.footer__small .content-left ul {\n\t\twidth: 100%\n\t}\n\n\t.footer__small .content-left ul {\n\t\t-webkit-box-pack: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tjustify-content: center\n\t}\n\n\t.footer__small .content-right {\n\t\tmargin-top: 1rem\n\t}\n\n\tfooter.footer4 .footer__small .info_links:before {\n\t\tcontent: none\n\t}\n\n\t.process-one .process-single {\n\t\twidth: 50%\n\t}\n\n\t.process-one .process-single .icon:before,\n\t.process-one .process-single:nth-child(2n+1) .icon:before {\n\t\tcontent: none\n\t}\n\n\t.process-three {\n\t\tmargin-bottom: 2rem\n\t}\n\n\t.team-single.team-five,\n\t.team-single.team-four {\n\t\tmargin-bottom: 2rem\n\t}\n\n\t.team-single.team-five img,\n\t.team-single.team-four img {\n\t\twidth: 100%\n\t}\n\n\t.pricing.pricing--2 {\n\t\tdisplay: block !important\n\t}\n\n\t.event-single {\n\t\theight: auto\n\t}\n\n\t.event-single .event-info .view-btn {\n\t\tmargin-left: 0;\n\t\tmargin-top: 1.33333rem\n\t}\n\n\t#accordion_one,\n\t#accordion_two {\n\t\tpadding: 2rem 2.66667rem\n\t}\n\n\t.section-news {\n\t\tpadding-bottom: 6rem\n\t}\n\n\t.services {\n\t\tpadding-bottom: 4rem\n\t}\n\n\t.testimonials {\n\t\tpadding-bottom: 5rem\n\t}\n\n\t.section-split2:before {\n\t\tcontent: none\n\t}\n\n\t.about-links ul,\n\t.event-types ul {\n\t\t-webkit-flex-wrap: wrap;\n\t\t-ms-flex-wrap: wrap;\n\t\tflex-wrap: wrap;\n\t\t-webkit-box-pack: center !important;\n\t\t-webkit-justify-content: center !important;\n\t\t-ms-flex-pack: center !important;\n\t\tjustify-content: center !important;\n\t\tpadding: 1rem 0\n\t}\n\n\t.about-links ul li,\n\t.event-types ul li {\n\t\tmargin: 0 2rem\n\t}\n\n\t.about-links ul li a,\n\t.event-types ul li a {\n\t\tpadding: 1rem 0\n\t}\n\n\t.timeline1 .happening .happening__period:before {\n\t\tright: -20px\n\t}\n\n\t.timeline1 .happening .happening__period .wrapper:before {\n\t\tright: -39px\n\t}\n\n\t.values-info .value-desc p {\n\t\tpadding-left: 0;\n\t\tmargin-bottom: 0\n\t}\n\n\t.search-wrapper form .form-group button {\n\t\tmargin: 1rem 0 0 0\n\t}\n\n\t.search-wrapper .form-group .form-control:first-child {\n\t\t-webkit-box-flex: 1;\n\t\t-webkit-flex: 1;\n\t\t-ms-flex: 1;\n\t\tflex: 1;\n\t\tborder-right: 1px solid #e4e8ed !important\n\t}\n\n\t.search-wrapper .form-group .select-basic {\n\t\tmin-width: 100%;\n\t\t-webkit-box-flex: 1;\n\t\t-webkit-flex: 1;\n\t\t-ms-flex: 1;\n\t\tflex: 1;\n\t\tmargin-top: 1rem\n\t}\n\n\t.search-wrapper .form-group .form-control,\n\t.search-wrapper .form-group .select-basic .form-control {\n\t\tborder-right: 0 !important\n\t}\n\n\t.career-search .search-wrapper {\n\t\tposition: relative;\n\t\t-webkit-transform: none;\n\t\t-ms-transform: none;\n\t\ttransform: none\n\t}\n\n\t.information-box {\n\t\tpadding: 8rem 0 4rem !important\n\t}\n\n\t.information-wrapper {\n\t\tposition: relative;\n\t\t-webkit-transform: none;\n\t\t-ms-transform: none;\n\t\ttransform: none;\n\t\ttop: 0\n\t}\n\n\t.information-wrapper ul {\n\t\tmargin-bottom: 1rem\n\t}\n\n\t.information-wrapper ul li {\n\t\tmargin-bottom: 1rem\n\t}\n\n\t.information-wrapper .card {\n\t\tborder: 1px solid #e4e8ed !important\n\t}\n\n\t.information-wrapper .card .card-body {\n\t\tpadding-bottom: 1.66667rem\n\t}\n\n\t.action-btns ul {\n\t\t-webkit-flex-wrap: wrap;\n\t\t-ms-flex-wrap: wrap;\n\t\tflex-wrap: wrap\n\t}\n\n\t.card.card--team4 {\n\t\t-webkit-flex-wrap: wrap;\n\t\t-ms-flex-wrap: wrap;\n\t\tflex-wrap: wrap\n\t}\n\n\t.card.card--team4 .team-info {\n\t\t-webkit-flex-wrap: wrap;\n\t\t-ms-flex-wrap: wrap;\n\t\tflex-wrap: wrap\n\t}\n\n\t.card.card--team4 .team-info .m-bottom-25 {\n\t\tmargin-bottom: 15px\n\t}\n\n\t.card.card--team4 .team-info .social-basic {\n\t\tmargin-bottom: 25px\n\t}\n\n\t.card.card--team4 .team-image {\n\t\t-webkit-align-self: center;\n\t\t-ms-flex-item-align: center;\n\t\talign-self: center;\n\t\t-webkit-box-flex: 1;\n\t\t-webkit-flex: 1 0 100%;\n\t\t-ms-flex: 1 0 100%;\n\t\tflex: 1 0 100%\n\t}\n\n\t.card.card--team4 .team-image img {\n\t\twidth: 100%\n\t}\n\n\t.team-profile .team-details {\n\t\tmargin-left: 0\n\t}\n\n\t.service-tab-wrapper .service--tabs .sidebar {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -webkit-flex;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-flex-wrap: wrap;\n\t\t-ms-flex-wrap: wrap;\n\t\tflex-wrap: wrap;\n\t\t-webkit-box-align: start;\n\t\t-webkit-align-items: flex-start;\n\t\t-ms-flex-align: start;\n\t\talign-items: flex-start\n\t}\n\n\t.service-tab-wrapper .service--tabs .sidebar .tab_nav2 {\n\t\twidth: 100%;\n\t\t-webkit-box-ordinal-group: 3;\n\t\t-webkit-order: 2;\n\t\t-ms-flex-order: 2;\n\t\torder: 2\n\t}\n\n\t.service-tab-wrapper .service--tabs .sidebar .cta-widget,\n\t.service-tab-wrapper .service--tabs .sidebar .download-widget {\n\t\twidth: 45%;\n\t\tmargin-right: 20px\n\t}\n\n\t.event-share {\n\t\tmargin-bottom: 2rem\n\t}\n\n\t.other-logins {\n\t\t-webkit-box-pack: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tjustify-content: center\n\t}\n\n\t.project-list .card {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column\n\t}\n\n\t.project-list .card figure img {\n\t\twidth: 100%\n\t}\n\n\t.filter-wrapper .filter-sort2 ul li {\n\t\tmargin-bottom: 1rem\n\t}\n\n\t.checkout-wrapper .nav-item {\n\t\tmargin: 0 3.33333rem !important\n\t}\n\n\t.checkout-wrapper .nav-item:before {\n\t\tcontent: none\n\t}\n\n\t.widget-wrapper:last-child .widget-default {\n\t\tmargin-bottom: 0\n\t}\n\n\t.cart-table .cart-single .name a {\n\t\tmargin-left: 0;\n\t\tmargin-top: .66667rem\n\t}\n\n\t.cart-table--2 .cart-single .name a {\n\t\tmargin-left: 1.33333rem\n\t}\n\n\t.hr-divider-gray {\n\t\tmargin-top: 3.66667rem\n\t}\n\n\t.products-wrapper .product-sort .sort .form-group {\n\t\t-webkit-box-flex: 1;\n\t\t-webkit-flex: 1;\n\t\t-ms-flex: 1;\n\t\tflex: 1\n\t}\n\n\t.total-pages {\n\t\tdisplay: none\n\t}\n\n\t.products-wrapper .product-grid {\n\t\tmargin-bottom: 50px\n\t}\n\n\t.content_block3_wrapper {\n\t\t-webkit-box-align: center;\n\t\t-webkit-align-items: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center\n\t}\n\n\t.team-wrapper .title-box {\n\t\tpadding: 2rem\n\t}\n\n\t.team-carousel-three {\n\t\tmargin-top: 2rem\n\t}\n\n\t.intro-one .intro-one--contents {\n\t\tmargin-bottom: 3.33333rem\n\t}\n\n\t.intro-one .intro-one--contents,\n\t.intro-one .intro-one--img,\n\t.intro-three .intro-three--contents,\n\t.intro-three .intro-three--img {\n\t\tposition: static;\n\t\twidth: 100%\n\t}\n\n\t.intro-three .intro-three--img {\n\t\tz-index: 1;\n\t\tposition: relative;\n\t\tmargin-top: 3.33333rem\n\t}\n\n\t.intro_area9 .intro_area9--contents,\n\t.intro_area9 .intro_area9--slides {\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\tright: auto;\n\t\ttop: auto;\n\t\tpadding: 6.66667rem 0\n\t}\n\n\t.intro_area9 .intro_area9--contents:before {\n\t\twidth: 100%\n\t}\n\n\t.shape-wrapper.img-shape-one:before {\n\t\t-webkit-background-size: 100% 100.2%;\n\t\tbackground-size: 100% 100.2%\n\t}\n\n\t.intro-area-four {\n\t\tmin-height: 46.66667rem\n\t}\n\n\t.intro_area9 .intro_area9--contents h1 br {\n\t\tdisplay: none\n\t}\n\n\t.tp-caption .form-wrapper {\n\t\tdisplay: none\n\t}\n\n\t.intro-four {\n\t\tmin-height: 33.33333rem\n\t}\n\n\t.intro-area-four .img-left,\n\t.intro-area-four .img-right {\n\t\tmax-width: 10rem\n\t}\n\n\t.intro-two {\n\t\tmin-height: 550px\n\t}\n\n\t.navbar.navbar-bg .navbar-toggler {\n\t\tcolor: #fff\n\t}\n\n\t.breadcrumb3 {\n\t\tpadding: 80px 0\n\t}\n\n\t.search-wrapper form {\n\t\tborder: 1px solid #e4e8ed\n\t}\n\n\t.search-wrapper .form-group .form-control,\n\t.search-wrapper .form-group .select-basic .form-control {\n\t\tborder: 1px solid #e4e8ed !important\n\t}\n\n\t.subscribe--five h2 {\n\t\tmargin-top: 2rem\n\t}\n\n\t.pricing.pricing--2 .pricing__features_list {\n\t\tpadding: 30px\n\t}\n\n\t.pricing.pricing--2 .pricing__features_list ul.list {\n\t\tmargin-top: 30px\n\t}\n\n\t.subscribe-six h4,\n\t.subscribe-three h4 {\n\t\tmargin-bottom: 30px\n\t}\n\n\t.subscribe-six h4 {\n\t\tmargin-bottom: 0\n\t}\n\n\t.tab.tab--1 .tab_nav {\n\t\tpadding: 10px 20px\n\t}\n\n\t.menu6 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before,\n\t.menu7 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before,\n\t.menu8 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link,\n\t.menu8 .navbar.navbar-dark .navbar-nav .nav-item.dropdown .nav-link:before {\n\t\tcolor: #202428\n\t}\n}\n\n@media (min-width:768px) and (max-width:991px) {\n\thtml {\n\t\tfont-size: 14.5px\n\t}\n\n\t.gallery-fullwidth .portfolio-carousel-single {\n\t\twidth: 33.33%\n\t}\n\n\t.content-block .content-list--one,\n\t.content-block .content-list--two {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -webkit-flex;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex\n\t}\n\n\t.content-block .content-list--one .content-list,\n\t.content-block .content-list--two .content-list {\n\t\twidth: 50%\n\t}\n\n\t.content-block .content-list--one .content-list:nth-child(2n+2),\n\t.content-block .content-list--two .content-list:nth-child(2n+2) {\n\t\tpadding-left: 15px\n\t}\n\n\t.content-block .content-list--one .content-list:nth-child(2n+1),\n\t.content-block .content-list--two .content-list:nth-child(2n+1) {\n\t\tpadding-right: 15px\n\t}\n\n\t.content-block--12 .highlighted-text .content {\n\t\tmin-height: 20rem\n\t}\n\n\t.content-block--12 .highlighted-text .content p {\n\t\tfont-size: 1.66667rem;\n\t\tline-height: 2.66667rem\n\t}\n}\n\n@media screen and (max-width:767px) {\n\t.margin-sm-60 {\n\t\tmargin-bottom: 4rem\n\t}\n\n\t.margin-sm-60 p {\n\t\tmargin-bottom: 0\n\t}\n\n\t.card-body {\n\t\tpadding: 2rem\n\t}\n\n\t.blog-carousel-two .owl-item img,\n\t.carousel-one .owl-item img,\n\t.carousel-two .owl-item img {\n\t\twidth: 100%\n\t}\n\n\t.carousel-three .nav-circle .owl-prev {\n\t\tmargin-left: 0\n\t}\n\n\t.carousel-three .nav-circle .owl-next {\n\t\tmargin-right: 0\n\t}\n\n\t.logo-carousel-three .nav-square-dark .owl-prev {\n\t\tmargin-left: 0\n\t}\n\n\t.logo-carousel-three .nav-square-dark .owl-next {\n\t\tmargin-right: 0\n\t}\n\n\t.logo-grid-one li,\n\t.logo-grid-three li {\n\t\twidth: 50%\n\t}\n\n\t.gallery-fullwidth .portfolio-carousel-single {\n\t\twidth: 50%\n\t}\n\n\t.gallery-grid figure img {\n\t\twidth: 100%\n\t}\n\n\t.tab.tab--1 .tab-content {\n\t\tpadding-left: 0;\n\t\tmargin-top: 2rem\n\t}\n\n\t.tab-content.tab--content2 .tab-pane .tab_image_module {\n\t\tmargin-top: 2rem\n\t}\n\n\t.tab.tab--4 .tab--content4 {\n\t\tpadding: 2.66667rem\n\t}\n\n\t.tab.tab--4 .tab--content4 .text_content {\n\t\tmargin-top: 2rem;\n\t\tpadding-left: 0\n\t}\n\n\t.tab.tab--4 .nav-tabs li {\n\t\twidth: 100%;\n\t\tmargin-bottom: 1px\n\t}\n\n\t.tab.tab--8 .tab_nav7 {\n\t\tmargin-bottom: 2rem\n\t}\n\n\t.card figure img,\n\t.card--ten figure img {\n\t\twidth: 100%\n\t}\n\n\t.section-title-simple {\n\t\twidth: 100%\n\t}\n\n\t.social-btns li {\n\t\tmargin-bottom: 1.33333rem\n\t}\n\n\t.counter--1,\n\t.counter--2,\n\t.counter--3,\n\t.counter--4,\n\t.counter--6 {\n\t\tpadding-bottom: 4.66667rem !important\n\t}\n\n\t.counter--1 .counter_single,\n\t.counter--2 .counter_single,\n\t.counter--3 .counter_single,\n\t.counter--4 .counter_single,\n\t.counter--6 .counter_single {\n\t\twidth: 50%;\n\t\tmargin-bottom: 3.33333rem\n\t}\n\n\t.breadcrumb_area.breadcrumb1 .page_title {\n\t\tline-height: 3rem;\n\t\tmargin-bottom: 1rem\n\t}\n\n\t.breadcrumb3 .breadcrumb_wrapper .page_title,\n\t.breadcrumb_area.breadcrumb2 .page_title {\n\t\twidth: 100%\n\t}\n\n\t.breadcrumb_area.breadcrumb1 .breadcrumb_wrapper {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column\n\t}\n\n\t.content-block--12 .highlighted-text {\n\t\tposition: relative;\n\t\ttop: 0;\n\t\t-webkit-transform: none;\n\t\t-ms-transform: none;\n\t\ttransform: none;\n\t\tpadding: 5.33333rem 0\n\t}\n\n\t.content-block--12 .clients-logo {\n\t\tpadding-top: 0\n\t}\n\n\t.event-single {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column\n\t}\n\n\t.event-single .event-date {\n\t\tpadding: 2rem 0\n\t}\n\n\t.event-single .event-date,\n\t.event-single .event-info {\n\t\twidth: 100%;\n\t\t-webkit-box-flex: 1;\n\t\t-webkit-flex: 1;\n\t\t-ms-flex: 1;\n\t\tflex: 1\n\t}\n\n\t.header--6 .nav_right_content .cart_module,\n\t.header--6 .nav_right_content .search_module {\n\t\t-webkit-box-ordinal-group: 2;\n\t\t-webkit-order: 1;\n\t\t-ms-flex-order: 1;\n\t\torder: 1\n\t}\n\n\t.header--6 .nav_right_content .ctabtn {\n\t\t-webkit-box-ordinal-group: 1;\n\t\t-webkit-order: 0;\n\t\t-ms-flex-order: 0;\n\t\torder: 0;\n\t\tpadding-left: 0 !important;\n\t\tpadding-right: 20px !important\n\t}\n\n\t.nav_right_content .cart_module .cart__items {\n\t\twidth: 250px;\n\t\tmin-width: auto;\n\t\tright: 0\n\t}\n\n\t.nav_right_content .cart_module .cart__items .cart_info a+a {\n\t\tmargin-left: 0;\n\t\tmargin-top: 10px\n\t}\n\n\t.error-wrapper .error-contents p {\n\t\twidth: 100%\n\t}\n\n\t.home8-counter {\n\t\tpadding-bottom: 0\n\t}\n\n\t.timeline1 .happening .happening__period:before {\n\t\tcontent: none\n\t}\n\n\t.timeline1 .happening .happening__period .wrapper:before {\n\t\tcontent: none\n\t}\n\n\t.timeline1 .happening .happening__desc {\n\t\tmargin-top: 2rem;\n\t\tpadding-left: 1rem;\n\t\tpadding-right: 1rem\n\t}\n\n\t.timeline1 .happening:last-child .happening__desc {\n\t\tpadding-bottom: 0\n\t}\n\n\t.search-wrapper .form-group .form-control:first-child {\n\t\tborder-right: 0 !important;\n\t\tmargin-bottom: 1rem\n\t}\n\n\t.action-btns ul li {\n\t\tmargin-bottom: .66667rem\n\t}\n\n\t.career-search .search-wrapper .form-group .form-control:first-child {\n\t\tborder-right: 1px solid #e4e8ed !important\n\t}\n\n\t.career-search .search-wrapper form {\n\t\tpadding: 30px\n\t}\n\n\t.service-tab-wrapper .service--tabs .sidebar .cta-widget,\n\t.service-tab-wrapper .service--tabs .sidebar .download-widget {\n\t\twidth: 100%\n\t}\n\n\t.service-tab-wrapper .service--tabs .sidebar .download-widget {\n\t\ttext-align: center\n\t}\n\n\t.service-tab-wrapper .service--tabs .sidebar .download-widget .content p {\n\t\t-webkit-box-pack: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tjustify-content: center\n\t}\n\n\t.login-register .login-form .form-wrapper .other-logins,\n\t.login-register .signup-form .form-wrapper .other-logins {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column;\n\t\t-webkit-box-align: center;\n\t\t-webkit-align-items: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center\n\t}\n\n\t.login-register .login-form .form-wrapper .other-logins a,\n\t.login-register .signup-form .form-wrapper .other-logins a {\n\t\tmargin: 10px 0\n\t}\n\n\t.project-single .project-info .info-box {\n\t\tmargin-top: 3rem\n\t}\n\n\t.blog-single-wrapper .post-bottom {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column;\n\t\t-webkit-box-pack: start !important;\n\t\t-webkit-justify-content: flex-start !important;\n\t\t-ms-flex-pack: start !important;\n\t\tjustify-content: flex-start !important;\n\t\t-webkit-box-align: start;\n\t\t-webkit-align-items: start;\n\t\t-ms-flex-align: start;\n\t\talign-items: start\n\t}\n\n\t.blog-single-wrapper .post-bottom .social-share {\n\t\tmargin-top: 1.33333rem\n\t}\n\n\t.cart-table .cart-actions .ml-auto {\n\t\tmargin-left: 0 !important;\n\t\tmargin-top: 1rem\n\t}\n\n\t.checkout-wrapper .nav-item {\n\t\twidth: 100%;\n\t\tmargin: 0 !important\n\t}\n\n\t.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link:before {\n\t\tbottom: auto;\n\t\ttop: 50%;\n\t\t-webkit-transform: translate(0, -50%);\n\t\t-ms-transform: translate(0, -50%);\n\t\ttransform: translate(0, -50%);\n\t\tleft: auto;\n\t\tright: 0\n\t}\n\n\t.gallery-image-view .portfolio-carousel-single img {\n\t\twidth: 100%\n\t}\n\n\t.product-info-tab .review-wrapper .reviews {\n\t\tpadding: 0\n\t}\n\n\t.nav-circle button {\n\t\twidth: 3rem;\n\t\theight: 3rem\n\t}\n\n\ttextarea.form-control {\n\t\theight: 200px\n\t}\n\n\thtml {\n\t\tfont-size: 14px\n\t}\n\n\t.mb-sm-50 {\n\t\tmargin-bottom: 50px\n\t}\n\n\t.services_area .icon-box-five {\n\t\tpadding: 0;\n\t\t-webkit-box-shadow: 0 0 0;\n\t\tbox-shadow: 0 0 0\n\t}\n\n\t.event-single .event-info {\n\t\tpadding: 2rem 2.33333rem\n\t}\n\n\t.nav_right_content .search_module {\n\t\tposition: initial\n\t}\n\n\t.nav_right_content .search_module .search_area {\n\t\twidth: 100%;\n\t\tright: 0\n\t}\n\n\t.nav_right_content .search_module .search_area.active {\n\t\ttop: 100%\n\t}\n\n\t.cta--nine .cta--none-contents {\n\t\ttext-align: center\n\t}\n\n\t.cta--nine .cta--none-contents h3 {\n\t\tmargin-top: 2rem\n\t}\n\n\t.about-wrapper img {\n\t\tmargin-bottom: 2rem\n\t}\n\n\t.about-wrapper .line-chart_wrap {\n\t\tmargin-top: 2rem\n\t}\n\n\t.team-carousel-three .carousel-single .team-desc {\n\t\tpadding: 2rem\n\t}\n\n\t.team-carousel-three .carousel-single .team-img {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -webkit-flex;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-webkit-align-items: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center\n\t}\n\n\t.intro-three,\n\t.intro-two {\n\t\tpadding: 5.33333rem 0\n\t}\n\n\t.intro-two .form-wrapper {\n\t\tmargin-top: 3.33333rem\n\t}\n\n\t.image-carousel-one .nav-circle button {\n\t\twidth: 2.33333rem;\n\t\theight: 2.33333rem;\n\t\tfont-size: .86667rem\n\t}\n\n\t.text-box {\n\t\tmargin-top: 0\n\t}\n\n\t.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link,\n\t.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link {\n\t\tline-height: 2rem\n\t}\n\n\t.tab.tab--2 .tab_nav2 .nav .nav-item .nav-link.active:after,\n\t.tab.tab--6 .tab_nav2 .nav .nav-item .nav-link.active:after {\n\t\tcontent: none\n\t}\n\n\t.checkout-wrapper .tab-content .method-1 .body p img {\n\t\tmargin-left: 0;\n\t\tmargin-top: 10px\n\t}\n\n\t.quotes-with-image .blockquote5 {\n\t\tmargin-top: 80px\n\t}\n\n\t.quotes-with-image .blockquote5 .author-sign {\n\t\tmargin-bottom: 0\n\t}\n\n\t.nav-circle .owl-next,\n\t.nav-circle .owl-prev {\n\t\tmargin: 0\n\t}\n\n\t.timeline1 .happening .happening__period .wrapper:after {\n\t\tcontent: none\n\t}\n}\n\n@media (min-width:320px) and (max-width:575.98px) {\n\n\t.logo-grid-one li,\n\t.logo-grid-three li {\n\t\twidth: 100%\n\t}\n\n\t.gallery-fullwidth .portfolio-carousel-single {\n\t\twidth: 100%\n\t}\n\n\t.tab.tab--4 .nav-tabs li {\n\t\twidth: 100%\n\t}\n\n\t.tab.tab--4 .nav-pills li {\n\t\tmargin-top: 1rem\n\t}\n\n\t.tab.tab--7 .tab_nav7 .nav .nav-item,\n\t.tab.tab--8 .tab_nav7 .nav .nav-item {\n\t\twidth: 100%\n\t}\n\n\t.tab.tab--3 ul.nav {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column\n\t}\n\n\t.tab.tab--3 .tab_nav3 {\n\t\tpadding-bottom: 1rem\n\t}\n\n\t.tab.tab--3 .tab_nav3 .nav li a {\n\t\tpadding: 0 0 1rem 0\n\t}\n\n\t.breadcrumb {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column;\n\t\t-webkit-box-align: center;\n\t\t-webkit-align-items: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center\n\t}\n\n\t.breadcrumb li {\n\t\tmargin-bottom: .66667rem\n\t}\n\n\t.breadcrumb li:last-child {\n\t\tmargin-bottom: 0\n\t}\n\n\t.counter--1 .counter_single,\n\t.counter--2 .counter_single,\n\t.counter--3 .counter_single,\n\t.counter--4 .counter_single,\n\t.counter--6 .counter_single {\n\t\twidth: 100%\n\t}\n\n\t.subscribe--two .subscribe-form,\n\t.subscribe-six .subscribe-form,\n\t.subscribe-three .subscribe-form {\n\t\tdisplay: block !important\n\t}\n\n\t.subscribe--two .subscribe-form button,\n\t.subscribe-six .subscribe-form button,\n\t.subscribe-three .subscribe-form button {\n\t\tmargin: 1.33333rem 0 0 0\n\t}\n\n\t.process-one .process-single {\n\t\twidth: 100%\n\t}\n\n\t.portfolio-carousel .owl-item img {\n\t\twidth: 100%\n\t}\n\n\t.pagination-area .pagination {\n\t\t-webkit-flex-wrap: wrap;\n\t\t-ms-flex-wrap: wrap;\n\t\tflex-wrap: wrap\n\t}\n\n\t.filter-wrapper .filter-sort ul {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column\n\t}\n\n\t.error-wrapper {\n\t\tpadding: 8rem 0\n\t}\n\n\t.error-wrapper .error-contents .error-404 {\n\t\tfont-size: 8rem\n\t}\n\n\t.error-wrapper .error-contents h2 {\n\t\tfont-size: 1.66667rem;\n\t\tline-height: 2.33333rem\n\t}\n\n\t.apply-form form .form-group {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -webkit-flex;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column\n\t}\n\n\t.apply-form form .form-group label {\n\t\tmin-width: 100%\n\t}\n\n\t.countdown {\n\t\t-webkit-flex-wrap: wrap;\n\t\t-ms-flex-wrap: wrap;\n\t\tflex-wrap: wrap;\n\t\t-webkit-box-pack: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tjustify-content: center\n\t}\n\n\t.countdown li {\n\t\tmargin: 0 .66667rem 1.33333rem !important\n\t}\n\n\t.tab_event .tab_event__module .speakers {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column\n\t}\n\n\t.tab_event .tab_event__module .speakers li {\n\t\tmargin-bottom: 1.33333rem\n\t}\n\n\t.tab_event .tab_event__module .speakers li:last-child {\n\t\tmargin-bottom: 0\n\t}\n\n\t.tab_event .tab_event__module .speakers li+li {\n\t\tmargin-left: 0\n\t}\n\n\t.login-register .login-form .form-wrapper .form-action {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column;\n\t\t-webkit-box-align: center;\n\t\t-webkit-align-items: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tmargin-bottom: 20px\n\t}\n\n\t.login-register .login-form .form-wrapper .form-action .custom-control {\n\t\tpadding-left: 0;\n\t\tmargin-bottom: 1rem\n\t}\n\n\t.coming-soon .cs-contents p {\n\t\twidth: 100%\n\t}\n\n\t.coming-soon .cs-contents form .subscribe-form {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column;\n\t\t-webkit-flex-wrap: wrap;\n\t\t-ms-flex-wrap: wrap;\n\t\tflex-wrap: wrap\n\t}\n\n\t.coming-soon .cs-contents form .subscribe-form button {\n\t\tmargin-left: 0;\n\t\tmargin-top: 1rem\n\t}\n\n\t.related-post .single-post img {\n\t\twidth: 100%\n\t}\n\n\t.blog-single-wrapper .post-pagination {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column\n\t}\n\n\t.blog-single-wrapper .post-pagination .next-post {\n\t\tmargin-top: 1rem\n\t}\n\n\t.product-info-tab .review-wrapper .reviews .review-single {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column\n\t}\n\n\t.product-info-tab .review-wrapper .reviews .review-single .review-text {\n\t\tmargin-top: 2rem\n\t}\n\n\t.product-details .product-info .product-share {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column;\n\t\t-webkit-box-align: start !important;\n\t\t-webkit-align-items: start !important;\n\t\t-ms-flex-align: start !important;\n\t\talign-items: start !important\n\t}\n\n\t.product-details .product-info .product-share>span {\n\t\tmargin-bottom: 1rem\n\t}\n\n\t.rev_column {\n\t\tpadding: 0 15px !important\n\t}\n\n\t.go_top {\n\t\tline-height: 30px;\n\t\twidth: 30px;\n\t\tfont-size: 13px\n\t}\n\n\t.services_area .icon-box-five {\n\t\ttext-align: center;\n\t\tmargin-bottom: 50px\n\t}\n\n\t.intro-one .intro-one--contents {\n\t\tpadding-top: 40px\n\t}\n\n\t.display-3 {\n\t\tfont-size: 2.5rem\n\t}\n\n\t.login-register .login-form .form-wrapper .other-logins a,\n\t.login-register .signup-form .form-wrapper .other-logins a {\n\t\twidth: 100%;\n\t\ttext-align: center\n\t}\n\n\t.list-inline-wrapper .list--inline {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column\n\t}\n\n\t.p-top-70 {\n\t\tpadding-top: 50px\n\t}\n\n\t.p-bottom-70 {\n\t\tpadding-bottom: 50px\n\t}\n\n\t.p-top-105 {\n\t\tpadding-top: 75px\n\t}\n\n\t.p-bottom-75 {\n\t\tpadding-bottom: 50px\n\t}\n\n\t.content-block--15 {\n\t\tpadding: 73px 0 62px\n\t}\n\n\t.testimonial-carousel-six-wrapper {\n\t\tpadding: 6.06667rem 0 5.86667rem 0\n\t}\n\n\t.p-top-100 {\n\t\tpadding-top: 70px\n\t}\n\n\t.subscribe-seven {\n\t\tpadding: 50px 0\n\t}\n\n\tfooter .footer__big {\n\t\tpadding: 75px 0 20px\n\t}\n\n\t.service-two {\n\t\tpadding: 80px 0 50px\n\t}\n\n\t.p-top-110,\n\t.p-top-115,\n\t.p-top-120 {\n\t\tpadding-top: 80px\n\t}\n\n\t.p-bottom-100,\n\t.p-bottom-105,\n\t.p-bottom-110,\n\t.p-bottom-120,\n\t.p-bottom-95 {\n\t\tpadding-bottom: 80px\n\t}\n\n\t.team-wrapper+.p-top-50 {\n\t\tpadding-top: 0\n\t}\n\n\t.subscribe-eight {\n\t\tpadding: 80px 0 0\n\t}\n\n\t.services_area.p-bottom-70 {\n\t\tpadding-bottom: 30px\n\t}\n\n\t.section-padding {\n\t\tpadding: 80px 0\n\t}\n\n\t.testimonials {\n\t\tpadding-bottom: 40px\n\t}\n\n\t.p-bottom-90 {\n\t\tpadding-bottom: 70px\n\t}\n\n\t.p-bottom-80 {\n\t\tpadding-bottom: 50px\n\t}\n\n\t.block-full-width,\n\t.block-full-width2 {\n\t\tmin-height: auto;\n\t\tpadding-bottom: 50px\n\t}\n\n\t.block-full-width2 {\n\t\tpadding-top: 50px\n\t}\n\n\t.counter.counter--3 {\n\t\tpadding: 80px 0 30px !important\n\t}\n\n\t.testimonial-carousel-four {\n\t\tpadding: 80px 0 70px\n\t}\n\n\t.counter--1,\n\t.counter--2,\n\t.counter--3,\n\t.counter--4,\n\t.counter--6 {\n\t\tpadding-bottom: 28px !important\n\t}\n\n\t.subscribe-four {\n\t\tpadding: 80px 0\n\t}\n\n\t.testimonial6 .single_testimonial.p-bottom-50 {\n\t\tpadding-bottom: 0\n\t}\n\n\t.accordion-styles .accordion_four {\n\t\tmargin-top: 50px\n\t}\n\n\t.counter.counter--5 {\n\t\tpadding: 80px 0 55px\n\t}\n\n\t.splitted-banner {\n\t\tpadding: 80px 0\n\t}\n\n\t.p-bottom-55 {\n\t\tpadding-bottom: 25px\n\t}\n\n\t.logo-carousel {\n\t\tpadding: 80px 0\n\t}\n\n\t.m-top-110 {\n\t\tmargin-top: 80px\n\t}\n\n\t.section-padding2 {\n\t\tpadding: 80px 0 50px\n\t}\n\n\t.project-grid-3.section-padding2 {\n\t\tpadding-bottom: 50px\n\t}\n\n\t.m-bottom-120 {\n\t\tmargin-bottom: 80px\n\t}\n\n\t.information-box {\n\t\tpadding: 80px 0 60px !important\n\t}\n\n\t.action-btns ul li {\n\t\tmargin-bottom: 0\n\t}\n\n\t.action-btns ul li.share-btn {\n\t\tpadding-bottom: 0\n\t}\n\n\t.checkout-confirm {\n\t\tpadding: 72px 0 80px\n\t}\n}\n\n@media screen and (max-width:479px) {\n\thtml {\n\t\tfont-size: 13px\n\t}\n\n\tbody {\n\t\tfont-size: 14px\n\t}\n\n\t.top_bar .top_bar--lang {\n\t\tdisplay: none\n\t}\n\n\t.top_bar .topbar_content {\n\t\t-webkit-box-pack: center !important;\n\t\t-webkit-justify-content: center !important;\n\t\t-ms-flex-pack: center !important;\n\t\tjustify-content: center !important\n\t}\n\n\t.menu6 .ctabtn,\n\t.menu6 .search_module {\n\t\tdisplay: none\n\t}\n\n\t.menu1 .navbar-brand {\n\t\t-webkit-box-ordinal-group: 1 !important;\n\t\t-webkit-order: 0 !important;\n\t\t-ms-flex-order: 0 !important;\n\t\torder: 0 !important\n\t}\n\n\t.menu1 .nav_right_content {\n\t\tdisplay: none !important\n\t}\n\n\t.menu5 {\n\t\tpadding: 12px 0\n\t}\n\n\t.menu5 .navbar-brand {\n\t\t-webkit-box-ordinal-group: 1 !important;\n\t\t-webkit-order: 0 !important;\n\t\t-ms-flex-order: 0 !important;\n\t\torder: 0 !important;\n\t\twidth: 50%\n\t}\n\n\t.menu5 .nav_right_content {\n\t\tdisplay: none !important\n\t}\n\n\t.navbar .navbar-brand {\n\t\twidth: 40%\n\t}\n\n\t.breadcrumb_area.breadcrumb2 {\n\t\tpadding-top: 4rem\n\t}\n\n\t.breadcrumb_area.breadcrumb2 .page_title {\n\t\tmargin-bottom: 3rem\n\t}\n\n\t.showcase-box .showcase-body,\n\t.showcase-box .showcase-header {\n\t\tpadding: 2rem\n\t}\n\n\t.cta-wrapper {\n\t\tpadding: 6rem 0\n\t}\n\n\t.card .card-body {\n\t\tpadding: 2rem\n\t}\n\n\t.card .card-footer {\n\t\tpadding: 1.66rem\n\t}\n\n\t.cta--nine:before,\n\tfooter.footer6:before {\n\t\tcontent: none\n\t}\n\n\tfooter.footer6 {\n\t\tpadding-top: 0\n\t}\n\n\tfooter .footer__bottom .footer__bottom-content {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column;\n\t\t-webkit-box-align: center;\n\t\t-webkit-align-items: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\t-webkit-box-pack: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tjustify-content: center\n\t}\n\n\tfooter .footer__bottom .footer__bottom-content p {\n\t\ttext-align: center;\n\t\tmargin-bottom: 1rem\n\t}\n\n\t.play-btn.play-btn--lg {\n\t\twidth: 3.33333rem;\n\t\theight: 3.33333rem\n\t}\n\n\t.play-btn.play-btn--lg .svg {\n\t\twidth: 15px\n\t}\n\n\t.nav-pills .nav-item {\n\t\tmargin-bottom: 10px\n\t}\n\n\t.coming-soon .cs-contents .cs-text {\n\t\tfont-size: 2.33333rem\n\t}\n\n\t.content-block--12 .highlighted-text .content {\n\t\tpadding: 15px 20px\n\t}\n\n\t.subscribe-form-two {\n\t\tpadding: 0\n\t}\n\n\t.subscribe-form-two .btn {\n\t\tposition: static;\n\t\ttop: 0;\n\t\t-webkit-transform: none;\n\t\t-ms-transform: none;\n\t\ttransform: none;\n\t\tmargin-top: 15px\n\t}\n\n\t.subscribe-form-two .form-control {\n\t\tpadding: 0 15px\n\t}\n}\n\n@media (min-width:480px) and (max-width:575px) {\n\thtml {\n\t\tfont-size: 14px\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
